// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from "@tanstack/react-query";

import { client } from "../client.gen";
import {
  add_secrets_vault_secret_version_v1,
  add_secrets_vault_secret_version_v2,
  append_conversation_messages_v2,
  append_finalized_conversation_messages_v1,
  append_inference_conversation_messages_v2,
  backfill_index_v1,
  background_task_error_v1,
  complete_work_claim_v1,
  confluence_add_comment_v1,
  confluence_callback_tenant_v1,
  confluence_check_connection_v1,
  confluence_connect_tenant_v1,
  confluence_create_page_v1,
  confluence_create_tenant_v1,
  confluence_delete_tenant_v1,
  confluence_get_attachment_content_v1,
  confluence_get_comments_v1,
  confluence_get_oauth_scopes_v1,
  confluence_get_page_attachments_v1,
  confluence_get_page_content_v1,
  confluence_get_page_labels_v1,
  confluence_get_pages_v1,
  confluence_get_spaces_v1,
  confluence_get_tenant_v1,
  confluence_get_tenants_v1,
  confluence_patch_tenant_v1,
  confluence_update_page_v1,
  create_agent_session_inference_v1,
  create_agent_session_v1,
  create_api_key_v1,
  create_article_line_range_comment_thread_comment_v1,
  create_article_line_range_comment_thread_v1,
  create_bot_user_v1,
  create_branding_logo_upload_url_v1,
  create_calibration_feedback_dimension_v1,
  create_calibration_feedback_inference_datapoints_v1,
  create_calibration_feedback_queue_items_v1,
  create_calibration_feedback_verdict_v1,
  create_change_request_line_range_comment_thread_comment_v1,
  create_change_request_line_range_comment_thread_v1,
  create_change_request_v1,
  create_conversation_feedback_v2,
  create_data_dump_conversation_v1,
  create_datapoints_v3,
  create_external_inferences_v1,
  create_feedback_label_v1,
  create_finalized_conversations_v2,
  create_image_upload_url_v1,
  create_inference_datapoint_v2,
  create_inference_datapoints_dequeue_v1,
  create_inference_datapoints_enqueue_v1,
  create_inference_datapoints_input_v1,
  create_inference_datapoints_output_v1,
  create_inference_feedback_label_v1,
  create_inference_feedback_v1,
  create_invitation_v1,
  create_judge_v1,
  create_judge_v2,
  create_judgements_v2,
  create_judgements_v3,
  create_judges_v2,
  create_kanonical_datapoints_v2,
  create_kb_access_request_v1,
  create_kb_ingestion_files_v1,
  create_kb_simulation_datapoint_v1,
  create_kb_simulation_datapoints_v1,
  create_kb_simulation_result_judgements_batch_v1,
  create_kb_simulation_result_judgements_v1,
  create_kb_simulation_result_v1,
  create_kb_simulation_results_v1,
  create_kb_upload_url_v1,
  create_knowledge_base_v1,
  create_machine_user_api_key_v1,
  create_machine_user_v1,
  create_oauth_application_v1,
  create_prod_evals_dequeue_v1,
  create_prod_evals_enqueue_v1,
  create_prod_evals_input_v1,
  create_prod_evals_output_v1,
  create_prompt_v1,
  create_secrets_vault_secret_v1,
  create_secrets_vault_secret_v2,
  create_stateful_conversation_inference_v2,
  create_stateful_inference_conversation_inference_v2,
  create_stateless_conversation_inference_v2,
  create_stateless_inference_conversation_inference_v2,
  create_support_ingestion_files_v1,
  create_task_v2,
  create_team_v1,
  create_upload_url_v1,
  create_upload_url_v2,
  create_work_claim_v1,
  create_work_event_v1,
  create_workflow_analytics_event_v1,
  create_workspace_v1,
  delete_agent_session_v1,
  delete_api_key_v1,
  delete_article_line_range_comment_thread_v1,
  delete_calibration_feedback_dimension_v1,
  delete_calibration_feedback_inference_datapoint_v1,
  delete_calibration_feedback_queue_item_v1,
  delete_calibration_feedback_verdict_v1,
  delete_change_request_line_range_comment_thread_v1,
  delete_change_request_v1,
  delete_comment_v1,
  delete_data_dump_conversation_v1,
  delete_datapoint_v2,
  delete_external_inference_v1,
  delete_finalized_conversation_v1,
  delete_inference_conversation_v2,
  delete_inference_datapoint_v1,
  delete_invitation_v1,
  delete_judge_v1,
  delete_judge_v2,
  delete_judgement_v2,
  delete_judgement_v3,
  delete_kanonical_datapoint_v1,
  delete_kb_simulation_datapoint_v1,
  delete_kb_simulation_result_v1,
  delete_knowledge_base_v3,
  delete_machine_user_api_key_v1,
  delete_machine_user_v1,
  delete_oauth_application_v1,
  delete_org_member_v1,
  delete_secrets_vault_secret_v1,
  delete_secrets_vault_secret_version_v1,
  delete_task_v2,
  delete_team_v1,
  delete_user_v1,
  delete_work_claim_v1,
  delete_workspace_v1,
  download_image_attachment_v1,
  download_kb_attachment_v1,
  embed_datapoints_v1,
  embed_v2,
  embedding_search_v1,
  entra_approve_proposed_action_v1,
  entra_check_connection_v1,
  entra_create_proposed_action_v1,
  entra_create_tenant_v1,
  entra_delete_tenant_v1,
  entra_get_directory_role_members_v1,
  entra_get_directory_roles_v1,
  entra_get_full_tenants_v1,
  entra_get_group_members_v1,
  entra_get_group_v1,
  entra_get_groups_v1,
  entra_get_proposed_action_v1,
  entra_get_proposed_actions_v1,
  entra_get_subscribed_skus_v1,
  entra_get_tenant_v1,
  entra_get_tenants_v1,
  entra_get_user_direct_reports_v1,
  entra_get_user_groups_v1,
  entra_get_user_licenses_v1,
  entra_get_user_manager_v1,
  entra_get_user_sign_in_state_v1,
  entra_get_user_v1,
  entra_get_users_v1,
  entra_patch_tenant_v1,
  entra_permission_preflight_v1,
  entra_reject_proposed_action_v1,
  entra_resolve_caller_v1,
  extract_data_dump_conversations_dequeue_v1,
  extract_data_dump_conversations_enqueue_v1,
  extract_data_dump_conversations_input_v1,
  extract_data_dump_conversations_output_v1,
  extract_datapoints_dequeue_v1,
  extract_datapoints_enqueue_v1,
  extract_datapoints_input_v1,
  extract_datapoints_output_v1,
  extract_incoming_knowledge_bases_dequeue_v1,
  extract_incoming_knowledge_bases_enqueue_v1,
  extract_incoming_knowledge_bases_input_v1,
  extract_incoming_knowledge_bases_output_v1,
  finalize_conversations_dequeue_v1,
  finalize_conversations_enqueue_v1,
  finalize_conversations_input_v1,
  finalize_conversations_output_v1,
  finetune_knowledge_bases_dequeue_v1,
  finetune_knowledge_bases_enqueue_v1,
  finetune_knowledge_bases_input_v1,
  finetune_knowledge_bases_output_v1,
  freshservice_add_note_to_ticket_v1,
  freshservice_check_connection_v1,
  freshservice_create_article_v1,
  freshservice_create_folder_v1,
  freshservice_create_tenant_v1,
  freshservice_create_ticket_v1,
  freshservice_delete_tenant_v1,
  freshservice_get_agent_v1,
  freshservice_get_agents_v1,
  freshservice_get_article_v1,
  freshservice_get_articles_v1,
  freshservice_get_categories_v1,
  freshservice_get_folders_v1,
  freshservice_get_full_tenants_v1,
  freshservice_get_requester_v1,
  freshservice_get_requesters_v1,
  freshservice_get_tenant_v1,
  freshservice_get_tenants_v1,
  freshservice_get_ticket_conversations_v1,
  freshservice_get_ticket_v1,
  freshservice_get_tickets_v1,
  freshservice_ingest_webhook_v1,
  freshservice_patch_tenant_v1,
  freshservice_provision_webhook_v1,
  freshservice_reply_to_ticket_v1,
  freshservice_update_article_v1,
  freshservice_update_ticket_v1,
  get_a2a_agent_card_v1,
  get_a2a_agents_v1,
  get_agent_session_inferences_v1,
  get_agent_sessions_v1,
  get_agent_usage_stats_v1,
  get_agent_v1,
  get_agents_v1,
  get_article_line_range_comment_thread_v1,
  get_article_tags_v1,
  get_attachment_data_v1,
  get_attachment_data_v2,
  get_branding_v1,
  get_calibration_feedback_dimension_v1,
  get_calibration_feedback_dimensions_v1,
  get_calibration_feedback_inference_datapoint_tags_v1,
  get_calibration_feedback_inference_datapoint_v1,
  get_calibration_feedback_inference_datapoints_v1,
  get_calibration_feedback_queue_item_tags_v1,
  get_calibration_feedback_queue_item_v1,
  get_calibration_feedback_queue_items_v1,
  get_calibration_feedback_verdict_v1,
  get_calibration_feedback_verdicts_v1,
  get_change_counts_v2,
  get_change_request_line_range_comment_thread_v1,
  get_change_request_possible_assignees_v1,
  get_change_request_tags_v1,
  get_change_request_v1,
  get_change_requests_v1,
  get_change_users_v2,
  get_comment_v1,
  get_conversations_grouped_by_external_id_v1,
  get_conversations_v1,
  get_current_user_v1,
  get_data_dump_conversations_v1,
  get_datapoint_evidence_v1,
  get_datapoint_v3,
  get_edra_access_v1,
  get_edra_pb_openapi,
  get_embedding_summary_v2,
  get_evaluated_inference_datapoints_v1,
  get_external_inference_v1,
  get_external_inferences_v1,
  get_feedback_labels_v1,
  get_finalized_conversations_v2,
  get_frontend_config_v1,
  get_full_agent_session_v1,
  get_full_agent_sessions_v1,
  get_full_api_keys_v1,
  get_full_article_line_range_comment_threads_v1,
  get_full_calibration_feedback_dimensions_v1,
  get_full_calibration_feedback_queue_items_v1,
  get_full_calibration_feedback_verdicts_v1,
  get_full_change_request_line_range_comment_threads_v1,
  get_full_change_requests_v1,
  get_full_comments_v1,
  get_full_data_dump_conversations_v1,
  get_full_datapoints_v1,
  get_full_finalized_conversation_v2,
  get_full_finalized_conversations_v2,
  get_full_inference_conversation_inferences_v2,
  get_full_inference_conversations_v2,
  get_full_inference_datapoint_v1,
  get_full_inference_datapoints_v1,
  get_full_invitations_v1,
  get_full_kb_simulation_compare_v1,
  get_full_kb_simulation_datapoint_v1,
  get_full_kb_simulation_datapoints_v1,
  get_full_kb_simulation_result_judgements_v1,
  get_full_kb_simulation_result_v1,
  get_full_kb_simulation_results_v1,
  get_full_kb_simulation_run_v1,
  get_full_oauth_applications_v1,
  get_full_user_agent_sessions_v1,
  get_full_work_events_v1,
  get_inference_conversation_inference_v2,
  get_inference_conversation_v2,
  get_inference_conversations_v2,
  get_inference_feedback_v1,
  get_invitation_v1,
  get_invitations_v1,
  get_judge_v1,
  get_judge_v2,
  get_judgements_full_v3,
  get_judgements_v2,
  get_judges_v1,
  get_judges_v2,
  get_kanonical_datapoint_v2,
  get_kanonical_datapoints_v2,
  get_kb_access_requests_v1,
  get_kb_analytics_chart_content_v1,
  get_kb_child_judgement_metrics_v1,
  get_kb_simulation_branch_breakdown_stats_v1,
  get_kb_simulation_commits_v1,
  get_kb_simulation_compare_summary_v1,
  get_kb_simulation_datapoint_v1,
  get_kb_simulation_datapoints_v1,
  get_kb_simulation_result_v1,
  get_kb_simulation_results_v1,
  get_kb_top_article_judgement_metrics_v2,
  get_knowledge_base_v2,
  get_knowledge_bases_v4,
  get_machine_user_api_keys_v1,
  get_machine_user_v1,
  get_machine_users_v1,
  get_mcp_toolsets_v1,
  get_my_kb_access_request_v1,
  get_notification_settings_v1,
  get_oauth_application_v1,
  get_oauth_applications_v1,
  get_object_article_v1,
  get_org_members_v1,
  get_organization_v1,
  get_organizations_v1,
  get_overview_analytics_chart_content_v1,
  get_overview_analytics_charts_v1,
  get_owned_knowledge_bases_v1,
  get_pool_stats_v1,
  get_prompt_v1,
  get_prompts_v1,
  get_requester_teams_v1,
  get_roles_v1,
  get_sdk_openapi,
  get_secrets_vault_full_secrets_v1,
  get_secrets_vault_secret_v1,
  get_secrets_vault_secret_value_v1,
  get_secrets_vault_secret_value_v2,
  get_secrets_vault_secrets_v1,
  get_section_analytics_chart_content_v1,
  get_section_analytics_charts_v1,
  get_task_v2,
  get_tasks_v2,
  get_team_article_permissions_v1,
  get_team_kb_assignments_v1,
  get_team_v1,
  get_teams_v1,
  get_teams_with_access_v1,
  get_tree_analytics_chart_content_v1,
  get_user_v1,
  get_users_v1,
  get_valkey_value_v1,
  get_verification_metrics_v2,
  get_work_event_v1,
  get_workflow_analytics_chart_content_v1,
  get_workflow_analytics_charts_v1,
  get_workflow_run_analytics_events_v1,
  get_workflow_run_v1,
  get_workflow_runs_v1,
  get_workflows_v1,
  get_workspace_v1,
  get_workspaces_v1,
  git_amend_v1,
  git_branch_create_v1,
  git_branch_delete_v1,
  git_branch_get_v1,
  git_branch_list_v1,
  git_branch_restore_v1,
  git_branch_update_v1,
  git_cherry_pick_v1,
  git_commit_v1,
  git_diff_blame_v1,
  git_diff_v1,
  git_log_v1,
  git_ls_tree_v1,
  git_merge_v1,
  git_rebase_preview_v1,
  git_rebase_v1,
  git_show_article_v1,
  git_show_blob_v1,
  git_show_v1,
  grant_edra_access_v1,
  health,
  hubspot_add_note_v2,
  hubspot_check_connection_v1,
  hubspot_create_tenant_v1,
  hubspot_create_thread_on_ticket_v1,
  hubspot_delete_tenant_v1,
  hubspot_download_manifest_v1,
  hubspot_get_attachment_content_v1,
  hubspot_get_attachment_metadata_v1,
  hubspot_get_company_v1,
  hubspot_get_full_tenants_v1,
  hubspot_get_tenant_v1,
  hubspot_get_tenants_v1,
  hubspot_get_thread_v1,
  hubspot_get_ticket_v1,
  hubspot_ingest_webhook_v1,
  hubspot_list_thread_messages_v1,
  hubspot_list_ticket_notes_v1,
  hubspot_list_tickets_v1,
  hubspot_patch_tenant_v1,
  hubspot_reply_to_thread_v1,
  hubspot_set_ticket_owner_v1,
  hubspot_set_ticket_status_v1,
  hubspot_update_note_v1,
  hubspot_update_ticket_properties_v1,
  hybrid_search_v1,
  jira_check_connection_v1,
  jira_create_tenant_v1,
  jira_delete_tenant_v1,
  jira_get_attachment_content_v2,
  jira_get_custom_field_options_v1,
  jira_get_full_tenants_v1,
  jira_get_issue_v1,
  jira_get_issues_v1,
  jira_get_tenant_v1,
  jira_get_tenants_v1,
  jira_handle_webhook_event_v1,
  jira_patch_tenant_v1,
  jira_post_comment_v2,
  jira_set_custom_field_v1,
  jira_update_issue_labels_v1,
  judgement_filter_options_v1,
  kanonicalize_datapoints_dequeue_v1,
  kanonicalize_datapoints_enqueue_v1,
  kanonicalize_datapoints_input_v1,
  kanonicalize_datapoints_output_v1,
  key_error_v1,
  log_error_v1,
  log_sentry_alert_v1,
  notion_callback_tenant_v1,
  notion_check_connection_v1,
  notion_connect_tenant_v1,
  notion_create_blocks_v1,
  notion_create_page_v1,
  notion_create_tenant_v1,
  notion_delete_block_v1,
  notion_delete_page_v1,
  notion_delete_tenant_v1,
  notion_get_comments_v1,
  notion_get_database_v1,
  notion_get_databases_v1,
  notion_get_page_content_v1,
  notion_get_pages_v1,
  notion_get_tenant_v1,
  notion_get_tenants_v1,
  notion_ingest_webhook_v1,
  notion_query_database_v1,
  notion_reveal_webhook_token_v1,
  notion_update_block_v1,
  notion_update_page_v1,
  oauth_application_authorize_v1,
  oauth_authorization_server_metadata_v1,
  oauth_authorize_v1,
  oauth_openid_configuration_v1,
  oauth_protected_resource_metadata_v1,
  openfga_check_v1,
  openfga_read_tuples_v1,
  openfga_write_tuples_v1,
  type Options,
  outlook_add_email_attachment_v1,
  outlook_copy_email_v1,
  outlook_create_draft_v1,
  outlook_create_subscriptions_v2,
  outlook_delete_email_v1,
  outlook_delete_subscription_v2,
  outlook_forward_email_v1,
  outlook_get_email_attachment_v1,
  outlook_get_subscriptions_v2,
  outlook_mark_email_read_v1,
  outlook_move_email_v1,
  outlook_remove_email_attachment_v1,
  outlook_reply_email_v1,
  outlook_send_email_v1,
  outlook_set_email_categories_v1,
  outlook_set_email_flag_v1,
  outlook_set_email_importance_v1,
  outlook_subscription_event_v2,
  outlook_subscription_lifecycle_v2,
  patch_article_v1,
  patch_commit_v1,
  patch_judge_v2,
  patch_knowledge_base_review_sla_v3,
  patch_knowledge_base_v3,
  patch_notification_settings_v1,
  plain_add_customer_to_groups_v1,
  plain_add_customer_to_plain_tenants_v1,
  plain_add_thread_labels_v1,
  plain_assign_thread_to_self_v1,
  plain_assign_thread_v1,
  plain_change_thread_priority_v1,
  plain_check_connection_v1,
  plain_create_note_v1,
  plain_create_tenant_v1,
  plain_create_thread_v1,
  plain_delete_customer_v1,
  plain_delete_plain_tenant_v1,
  plain_delete_tenant_v1,
  plain_get_companies_v1,
  plain_get_customer_groups_v1,
  plain_get_customer_v1,
  plain_get_customers_v1,
  plain_get_full_tenants_v1,
  plain_get_plain_tenants_v1,
  plain_get_tenant_v1,
  plain_get_tenants_v1,
  plain_get_thread_timeline_v1,
  plain_get_thread_v1,
  plain_get_threads_v1,
  plain_ingest_webhook_v1,
  plain_mark_thread_as_done_v1,
  plain_mark_thread_as_todo_v1,
  plain_patch_tenant_v1,
  plain_remove_thread_labels_v1,
  plain_send_message_v1,
  plain_set_customer_company_v1,
  plain_snooze_thread_v1,
  plain_unassign_thread_v1,
  plain_update_thread_agent_status_v1,
  plain_upsert_company_v1,
  plain_upsert_customer_v1,
  plain_upsert_plain_tenant_v1,
  plain_upsert_thread_field_v1,
  print_logs_v1,
  proxy_oauth_application_introspect_v1,
  proxy_oauth_application_openid_configuration_v1,
  proxy_oauth_application_token_v1,
  proxy_oauth_application_userinfo_v1,
  proxy_oauth_token_v1,
  reader_pool_check_v1,
  regex_search_articles_v1,
  regex_search_datapoints_v1,
  resolve_kb_access_request_v1,
  restore_article_line_range_comment_thread_v1,
  restore_calibration_feedback_dimension_v1,
  restore_calibration_feedback_inference_datapoint_v1,
  restore_calibration_feedback_queue_item_v1,
  restore_calibration_feedback_verdict_v1,
  restore_change_request_line_range_comment_thread_v1,
  restore_change_request_v1,
  restore_comment_v1,
  restore_data_dump_conversation_v1,
  restore_datapoint_v2,
  restore_finalized_conversation_v1,
  restore_inference_conversation_v1,
  restore_inference_datapoint_v1,
  restore_judge_v1,
  restore_kanonical_datapoint_v1,
  restore_kb_simulation_datapoint_v1,
  restore_kb_simulation_result_v1,
  restore_knowledge_base_v3,
  restore_secrets_vault_secret_v1,
  restore_secrets_vault_secret_version_v1,
  restore_task_v2,
  restore_user_v1,
  restore_workspace_v1,
  return_500_v1,
  revoke_edra_access_v1,
  rotate_oauth_application_secret_v1,
  salesforce_callback_tenant_v1,
  salesforce_check_connection_v1,
  salesforce_check_ready_v1,
  salesforce_connect_tenant_v1,
  salesforce_create_article_v1,
  salesforce_create_case_email_draft_v1,
  salesforce_create_case_v1,
  salesforce_create_tenant_v1,
  salesforce_delete_article_v1,
  salesforce_delete_ingest_client_v1,
  salesforce_delete_tenant_v1,
  salesforce_get_account_v1,
  salesforce_get_accounts_v1,
  salesforce_get_articles_v1,
  salesforce_get_case_messages_v1,
  salesforce_get_case_v1,
  salesforce_get_cases_v1,
  salesforce_get_contact_v1,
  salesforce_get_contacts_v1,
  salesforce_get_default_language_v1,
  salesforce_get_entitlement_v1,
  salesforce_get_entitlements_v1,
  salesforce_get_full_tenants_v1,
  salesforce_get_oauth_redirect_uri_v1,
  salesforce_get_queue_v1,
  salesforce_get_queues_v1,
  salesforce_get_record_type_v1,
  salesforce_get_record_types_v1,
  salesforce_get_tenant_v1,
  salesforce_get_tenants_v1,
  salesforce_get_user_v1,
  salesforce_get_users_v1,
  salesforce_ingest_webhook_v1,
  salesforce_oauth_token_v1,
  salesforce_patch_tenant_v1,
  salesforce_post_case_comment_v1,
  salesforce_put_ingest_client_v1,
  salesforce_send_case_email_v1,
  salesforce_update_article_v1,
  salesforce_update_case_v1,
  search_datapoint_evidence_v1,
  search_datapoints_v1,
  search_full_evaluated_inference_datapoints_v1,
  search_reindex_v1,
  search_v1,
  send_agent_session_message_sync_v1,
  send_agent_session_message_v1,
  service_now_add_attachment_v1,
  service_now_add_record_attachment_v1,
  service_now_aggregate_records_v1,
  service_now_attach_tag_v1,
  service_now_change_approval_state_v1,
  service_now_change_assignment_group_v1,
  service_now_change_incident_state_v1,
  service_now_change_request_item_state_v2,
  service_now_change_request_state_v2,
  service_now_change_task_state_v2,
  service_now_create_article_v1,
  service_now_create_catalog_request_v1,
  service_now_create_change_task_v1,
  service_now_create_change_v1,
  service_now_create_incident_v1,
  service_now_create_knowledge_base_v1,
  service_now_create_record_v1,
  service_now_create_tag_v1,
  service_now_create_tenant_v1,
  service_now_delete_tenant_v1,
  service_now_get_approval_state_choices_v1,
  service_now_get_article_v1,
  service_now_get_attachment_content_v1,
  service_now_get_attachments_v1,
  service_now_get_catalog_item_v1,
  service_now_get_catalog_variable_lookup_metadata_v1,
  service_now_get_catalog_variable_values_v1,
  service_now_get_incident_state_choices_v1,
  service_now_get_knowledge_base_v1,
  service_now_get_request_item_v1,
  service_now_get_tenant_v1,
  service_now_get_tenants_v1,
  service_now_get_ticket_v1,
  service_now_get_user_profile_v1,
  service_now_handle_webhook_v1,
  service_now_list_approvals_v1,
  service_now_list_articles_v1,
  service_now_list_assignment_groups_v1,
  service_now_list_catalog_items_v1,
  service_now_list_knowledge_bases_v1,
  service_now_list_request_items_v1,
  service_now_list_tags_v1,
  service_now_list_tasks_v1,
  service_now_list_tickets_v1,
  service_now_list_users_v1,
  service_now_reply_tenant_v1,
  service_now_reply_v1,
  service_now_restore_tenant_v1,
  service_now_run_batch_v1,
  service_now_search_records_v1,
  service_now_setup_tenant_v1,
  service_now_submit_record_producer_v1,
  service_now_update_article_v1,
  service_now_update_change_v1,
  service_now_update_knowledge_base_v1,
  service_now_update_record_v1,
  service_now_update_tenant_v1,
  set_org_member_role_v1,
  set_org_membership_v1,
  set_team_article_permission_v1,
  set_team_article_permissions_v1,
  set_team_kb_role_v1,
  set_valkey_value_v1,
  sharepoint_callback_tenant_v1,
  sharepoint_check_access_v1,
  sharepoint_check_connection_v1,
  sharepoint_connect_tenant_v1,
  sharepoint_create_download_url_v1,
  sharepoint_create_folder_scope_v1,
  sharepoint_create_item_upload_session_v1,
  sharepoint_create_site_v1,
  sharepoint_create_tenant_v1,
  sharepoint_create_upload_session_v1,
  sharepoint_delete_folder_scope_v1,
  sharepoint_delete_item_v1,
  sharepoint_delete_site_v1,
  sharepoint_delete_tenant_v1,
  sharepoint_get_admin_access_v1,
  sharepoint_get_children_v1,
  sharepoint_get_drives_v1,
  sharepoint_get_folder_scopes_v1,
  sharepoint_get_full_tenants_v1,
  sharepoint_get_item_v1,
  sharepoint_get_sites_v1,
  sharepoint_get_tenant_v1,
  sharepoint_get_tenants_v1,
  sharepoint_grant_site_v1,
  sharepoint_lifecycle_v1,
  sharepoint_notifications_v1,
  sharepoint_patch_tenant_v1,
  sharepoint_update_item_v1,
  slack_add_reaction_v2,
  slack_callback_tenant_v1,
  slack_check_connection_v1,
  slack_connect_tenant_v1,
  slack_create_tenant_v1,
  slack_delete_tenant_v1,
  slack_download_file_v2,
  slack_download_manifest_v1,
  slack_get_channel_messages_v2,
  slack_get_full_tenants_v1,
  slack_get_oauth_scopes_v1,
  slack_get_reactions_v2,
  slack_get_tenant_v1,
  slack_get_tenants_v1,
  slack_get_user_group_users_v1,
  slack_get_user_groups_v1,
  slack_get_user_info_v2,
  slack_list_users_v2,
  slack_open_view_v1,
  slack_patch_tenant_v1,
  slack_post_chat_message_v2,
  slack_publish_home_view_v1,
  slack_push_view_v1,
  slack_receive_event_v2,
  slack_receive_interactivity_v2,
  slack_set_assistant_status_v2,
  slack_set_assistant_title_v1,
  slack_set_channel_description_v2,
  slack_set_channel_topic_v2,
  slack_set_suggested_prompts_v1,
  slack_update_chat_message_v2,
  slack_update_user_group_users_v1,
  slack_update_user_group_v1,
  slack_update_view_v1,
  slack_upload_content_v2,
  slack_upload_files_v2,
  stop_agent_session_v1,
  sync_articles_to_openfga_v1,
  sync_judges_v1,
  sync_kb_owners_v1,
  teams_check_connection_v1,
  teams_create_tenant_v1,
  teams_delete_message_v1,
  teams_delete_tenant_v1,
  teams_download_file_v1,
  teams_download_manifest_v1,
  teams_get_conversation_member_v1,
  teams_get_full_tenants_v1,
  teams_get_icon_v1,
  teams_get_installs_v1,
  teams_get_tenant_v1,
  teams_get_tenants_v1,
  teams_jwks_v1,
  teams_list_conversation_activities_v1,
  teams_list_conversation_members_v1,
  teams_openid_configuration_v1,
  teams_patch_tenant_v1,
  teams_post_message_v1,
  teams_receive_message_v1,
  teams_send_proactive_message_v1,
  teams_update_message_v1,
  teams_upload_icon_v1,
  unwrap_error_v1,
  update_agent_session_v1,
  update_api_key_v1,
  update_article_line_range_comment_thread_v1,
  update_calibration_feedback_verdict_v1,
  update_change_request_line_range_comment_thread_v1,
  update_change_request_v1,
  update_comment_v1,
  update_conversation_v2,
  update_current_user_v1,
  update_data_dump_conversation_v1,
  update_datapoint_by_external_id_v3,
  update_datapoint_v3,
  update_edra_access_v1,
  update_external_inference_v1,
  update_finalized_conversation_message_v1,
  update_finalized_conversation_v1,
  update_index_text_v3,
  update_inference_conversation_inference_v1,
  update_inference_datapoint_v1,
  update_invitation_v1,
  update_judge_v1,
  update_kanonical_datapoint_v1,
  update_kb_simulation_datapoint_v1,
  update_kb_simulation_result_v1,
  update_machine_user_v1,
  update_oauth_application_v1,
  update_org_member_v1,
  update_organization_v1,
  update_secrets_vault_secret_v1,
  update_secrets_vault_secret_version_v1,
  update_task_v2,
  update_team_v1,
  update_workflow_run_v1,
  upsert_external_user_v1,
  upsert_inference_conversation_v2,
  upsert_organization_v1,
  valkey_ping_v1,
  zendesk_callback_tenant_v1,
  zendesk_check_connection_v1,
  zendesk_connect_tenant_v1,
  zendesk_create_tenant_v1,
  zendesk_delete_tenant_v1,
  zendesk_deprovision_webhook_v1,
  zendesk_download_article_attachment_v1,
  zendesk_download_ticket_attachment_v1,
  zendesk_get_categories_v1,
  zendesk_get_oauth_redirect_uri_v1,
  zendesk_get_sections_v1,
  zendesk_get_tenant_v1,
  zendesk_get_tenants_v1,
  zendesk_get_ticket_attachment_content_v1,
  zendesk_get_ticket_v1,
  zendesk_get_user_v1,
  zendesk_get_users_v1,
  zendesk_ingest_webhook_v1,
  zendesk_list_article_attachments_v1,
  zendesk_list_articles_v1,
  zendesk_list_tickets_v1,
  zendesk_patch_tenant_v1,
  zendesk_provision_webhook_v1,
  zendesk_reply_to_ticket_v1,
  zendesk_search_tickets_v1,
  zendesk_update_ticket_tags_v1,
} from "../sdk.gen";
import type {
  DeleteApiConfluenceV1TenantsByTenantIdData,
  DeleteApiConfluenceV1TenantsByTenantIdError,
  DeleteApiConfluenceV1TenantsByTenantIdResponse,
  DeleteApiEntraV1TenantsByTenantIdData,
  DeleteApiEntraV1TenantsByTenantIdError,
  DeleteApiEntraV1TenantsByTenantIdResponse,
  DeleteApiFreshserviceV1TenantsByTenantIdData,
  DeleteApiFreshserviceV1TenantsByTenantIdError,
  DeleteApiFreshserviceV1TenantsByTenantIdResponse,
  DeleteApiJiraV1TenantsByTenantIdData,
  DeleteApiJiraV1TenantsByTenantIdError,
  DeleteApiJiraV1TenantsByTenantIdResponse,
  DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData,
  DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdError,
  DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponse,
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdData,
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdError,
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponse,
  DeleteApiNotionV1TenantsByTenantIdData,
  DeleteApiNotionV1TenantsByTenantIdError,
  DeleteApiNotionV1TenantsByTenantIdResponse,
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdData,
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdError,
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponse,
  DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData,
  DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdError,
  DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponse,
  DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdData,
  DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdError,
  DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponse,
  DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData,
  DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeError,
  DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponse,
  DeleteApiPlainV1TenantsByTenantIdData,
  DeleteApiPlainV1TenantsByTenantIdError,
  DeleteApiPlainV1TenantsByTenantIdResponse,
  DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdData,
  DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdError,
  DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponse,
  DeleteApiSalesforceV1TenantsByTenantIdData,
  DeleteApiSalesforceV1TenantsByTenantIdError,
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientData,
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientError,
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponse,
  DeleteApiSalesforceV1TenantsByTenantIdResponse,
  DeleteApiSecretsVaultV1SecretsBySecretIdData,
  DeleteApiSecretsVaultV1SecretsBySecretIdError,
  DeleteApiSecretsVaultV1SecretsBySecretIdResponse,
  DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData,
  DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdError,
  DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponse,
  DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
  DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError,
  DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
  DeleteApiSharepointV1TenantsByTenantIdData,
  DeleteApiSharepointV1TenantsByTenantIdError,
  DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdData,
  DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdError,
  DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponse,
  DeleteApiSharepointV1TenantsByTenantIdResponse,
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdData,
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdError,
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponse,
  DeleteApiSlackV1TenantsByTenantIdData,
  DeleteApiSlackV1TenantsByTenantIdError,
  DeleteApiSlackV1TenantsByTenantIdResponse,
  DeleteApiTeamsV1TenantsByTenantIdData,
  DeleteApiTeamsV1TenantsByTenantIdError,
  DeleteApiTeamsV1TenantsByTenantIdResponse,
  DeleteApiV1AgentSessionsByAgentSessionIdData,
  DeleteApiV1AgentSessionsByAgentSessionIdError,
  DeleteApiV1AgentSessionsByAgentSessionIdResponse,
  DeleteApiV1ApiKeysByApiKeyIdData,
  DeleteApiV1ApiKeysByApiKeyIdError,
  DeleteApiV1ApiKeysByApiKeyIdResponse,
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdData,
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdError,
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
  DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
  DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError,
  DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdData,
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdError,
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponse,
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError,
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdData,
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdError,
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponse,
  DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData,
  DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdError,
  DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponse,
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdData,
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdError,
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponse,
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdData,
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdError,
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
  DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
  DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError,
  DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
  DeleteApiV1ChangeRequestsByChangeRequestIdData,
  DeleteApiV1ChangeRequestsByChangeRequestIdError,
  DeleteApiV1ChangeRequestsByChangeRequestIdResponse,
  DeleteApiV1CommentsByCommentIdData,
  DeleteApiV1CommentsByCommentIdError,
  DeleteApiV1CommentsByCommentIdResponse,
  DeleteApiV1DataDumpConversationsByDataDumpConversationIdData,
  DeleteApiV1DataDumpConversationsByDataDumpConversationIdError,
  DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponse,
  DeleteApiV1ExternalInferencesByInferenceIdData,
  DeleteApiV1ExternalInferencesByInferenceIdError,
  DeleteApiV1ExternalInferencesByInferenceIdResponse,
  DeleteApiV1FinalizedConversationsByFinalizedConversationIdData,
  DeleteApiV1FinalizedConversationsByFinalizedConversationIdError,
  DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponse,
  DeleteApiV1HubspotTenantsByTenantIdData,
  DeleteApiV1HubspotTenantsByTenantIdError,
  DeleteApiV1HubspotTenantsByTenantIdResponse,
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdData,
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdError,
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponse,
  DeleteApiV1JudgesByJudgeIdData,
  DeleteApiV1JudgesByJudgeIdError,
  DeleteApiV1JudgesByJudgeIdResponse,
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdData,
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdError,
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponse,
  DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdData,
  DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdError,
  DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
  DeleteApiV1KbSimulationResultsBySimulationResultIdData,
  DeleteApiV1KbSimulationResultsBySimulationResultIdError,
  DeleteApiV1KbSimulationResultsBySimulationResultIdResponse,
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdData,
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdError,
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponse,
  DeleteApiV1MachineUsersByMachineUserIdData,
  DeleteApiV1MachineUsersByMachineUserIdError,
  DeleteApiV1MachineUsersByMachineUserIdResponse,
  DeleteApiV1OauthApplicationsByOauthApplicationIdData,
  DeleteApiV1OauthApplicationsByOauthApplicationIdError,
  DeleteApiV1OauthApplicationsByOauthApplicationIdResponse,
  DeleteApiV1ReposByRepositoryIdBranchesByNameData,
  DeleteApiV1ReposByRepositoryIdBranchesByNameError,
  DeleteApiV1ReposByRepositoryIdBranchesByNameResponse,
  DeleteApiV1ServiceNowTenantsByTenantIdData,
  DeleteApiV1ServiceNowTenantsByTenantIdError,
  DeleteApiV1ServiceNowTenantsByTenantIdResponse,
  DeleteApiV1SesameEdraAccessData,
  DeleteApiV1SesameEdraAccessError,
  DeleteApiV1SesameEdraAccessResponse,
  DeleteApiV1UsersByUserIdData,
  DeleteApiV1UsersByUserIdError,
  DeleteApiV1UsersByUserIdResponse,
  DeleteApiV1WorkClaimsByClaimIdData,
  DeleteApiV1WorkClaimsByClaimIdError,
  DeleteApiV1WorkClaimsByClaimIdResponse,
  DeleteApiV1WorkspacesByWorkspaceIdData,
  DeleteApiV1WorkspacesByWorkspaceIdError,
  DeleteApiV1WorkspacesByWorkspaceIdResponse,
  DeleteApiV1ZendeskTenantsByTenantIdData,
  DeleteApiV1ZendeskTenantsByTenantIdError,
  DeleteApiV1ZendeskTenantsByTenantIdResponse,
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionData,
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionError,
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponse,
  DeleteApiV2DatapointsByDatapointIdData,
  DeleteApiV2DatapointsByDatapointIdError,
  DeleteApiV2DatapointsByDatapointIdResponse,
  DeleteApiV2InferenceConversationsByExternalIdData,
  DeleteApiV2InferenceConversationsByExternalIdError,
  DeleteApiV2InferenceConversationsByExternalIdResponse,
  DeleteApiV2JudgementsByJudgementIdData,
  DeleteApiV2JudgementsByJudgementIdError,
  DeleteApiV2JudgementsByJudgementIdResponse,
  DeleteApiV2JudgesByJudgeIdData,
  DeleteApiV2JudgesByJudgeIdError,
  DeleteApiV2JudgesByJudgeIdResponse,
  DeleteApiV2TasksByTaskIdData,
  DeleteApiV2TasksByTaskIdError,
  DeleteApiV2TasksByTaskIdResponse,
  DeleteApiV3JudgementsByJudgementIdData,
  DeleteApiV3JudgementsByJudgementIdError,
  DeleteApiV3JudgementsByJudgementIdResponse,
  DeleteApiV3KbsByKbIdData,
  DeleteApiV3KbsByKbIdError,
  DeleteApiV3KbsByKbIdResponse,
  GetApiConfluenceV1OauthScopesData,
  GetApiConfluenceV1OauthScopesResponse,
  GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentData,
  GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentError,
  GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponse,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsError,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponse,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentData,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentError,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponse,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsError,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponse,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesData,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesError,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesResponse,
  GetApiConfluenceV1TenantsByTenantIdActionsSpacesData,
  GetApiConfluenceV1TenantsByTenantIdActionsSpacesError,
  GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponse,
  GetApiConfluenceV1TenantsByTenantIdCheckConnectionData,
  GetApiConfluenceV1TenantsByTenantIdCheckConnectionError,
  GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponse,
  GetApiConfluenceV1TenantsByTenantIdData,
  GetApiConfluenceV1TenantsByTenantIdError,
  GetApiConfluenceV1TenantsByTenantIdResponse,
  GetApiConfluenceV1TenantsData,
  GetApiConfluenceV1TenantsError,
  GetApiConfluenceV1TenantsResponse,
  GetApiDebugV1GetPoolStatsData,
  GetApiDebugV1GetPoolStatsResponse,
  GetApiDebugV1KeyErrorData,
  GetApiDebugV1LogErrorData,
  GetApiDebugV1LogSentryAlertData,
  GetApiDebugV1PrintLogsData,
  GetApiDebugV1ReaderPoolCheckData,
  GetApiDebugV1ReaderPoolCheckResponse,
  GetApiDebugV1Return500Data,
  GetApiDebugV1UnwrapErrorData,
  GetApiDebugV1ValkeyPingData,
  GetApiDebugV1ValkeyPingResponse,
  GetApiDebugV1ValkeyValuesByKeyData,
  GetApiDebugV1ValkeyValuesByKeyError,
  GetApiDebugV1ValkeyValuesByKeyResponse,
  GetApiEntraV1FullTenantsData,
  GetApiEntraV1FullTenantsError,
  GetApiEntraV1FullTenantsResponse,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersError,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponse,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesData,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesError,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponse,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdData,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdError,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersError,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponse,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponse,
  GetApiEntraV1TenantsByTenantIdActionsGroupsData,
  GetApiEntraV1TenantsByTenantIdActionsGroupsError,
  GetApiEntraV1TenantsByTenantIdActionsGroupsResponse,
  GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusData,
  GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusError,
  GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponse,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsError,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponse,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyError,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsError,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponse,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesError,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponse,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerError,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponse,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponse,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateError,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponse,
  GetApiEntraV1TenantsByTenantIdActionsUsersData,
  GetApiEntraV1TenantsByTenantIdActionsUsersError,
  GetApiEntraV1TenantsByTenantIdActionsUsersResponse,
  GetApiEntraV1TenantsByTenantIdCheckConnectionData,
  GetApiEntraV1TenantsByTenantIdCheckConnectionError,
  GetApiEntraV1TenantsByTenantIdCheckConnectionResponse,
  GetApiEntraV1TenantsByTenantIdData,
  GetApiEntraV1TenantsByTenantIdError,
  GetApiEntraV1TenantsByTenantIdPermissionPreflightData,
  GetApiEntraV1TenantsByTenantIdPermissionPreflightError,
  GetApiEntraV1TenantsByTenantIdPermissionPreflightResponse,
  GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdData,
  GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdError,
  GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponse,
  GetApiEntraV1TenantsByTenantIdProposedActionsData,
  GetApiEntraV1TenantsByTenantIdProposedActionsError,
  GetApiEntraV1TenantsByTenantIdProposedActionsResponse,
  GetApiEntraV1TenantsByTenantIdResponse,
  GetApiEntraV1TenantsData,
  GetApiEntraV1TenantsError,
  GetApiEntraV1TenantsResponse,
  GetApiFreshserviceV1FullTenantsData,
  GetApiFreshserviceV1FullTenantsError,
  GetApiFreshserviceV1FullTenantsResponse,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdData,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdError,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponse,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsError,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponse,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdData,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdError,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponse,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersError,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponse,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdError,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponse,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesError,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponse,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesData,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesError,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponse,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersError,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponse,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsData,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsError,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponse,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdError,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponse,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsError,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse,
  GetApiFreshserviceV1TenantsByTenantIdCheckConnectionData,
  GetApiFreshserviceV1TenantsByTenantIdCheckConnectionError,
  GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponse,
  GetApiFreshserviceV1TenantsByTenantIdData,
  GetApiFreshserviceV1TenantsByTenantIdError,
  GetApiFreshserviceV1TenantsByTenantIdResponse,
  GetApiFreshserviceV1TenantsData,
  GetApiFreshserviceV1TenantsError,
  GetApiFreshserviceV1TenantsResponse,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentData,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentError,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponse,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataData,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataError,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponse,
  GetApiJiraV1FullTenantsData,
  GetApiJiraV1FullTenantsError,
  GetApiJiraV1FullTenantsResponse,
  GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsData,
  GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsError,
  GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponse,
  GetApiJiraV1TenantsByTenantIdActionsGetIssueData,
  GetApiJiraV1TenantsByTenantIdActionsGetIssueError,
  GetApiJiraV1TenantsByTenantIdActionsGetIssueResponse,
  GetApiJiraV1TenantsByTenantIdActionsGetIssuesData,
  GetApiJiraV1TenantsByTenantIdActionsGetIssuesError,
  GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponse,
  GetApiJiraV1TenantsByTenantIdCheckConnectionData,
  GetApiJiraV1TenantsByTenantIdCheckConnectionError,
  GetApiJiraV1TenantsByTenantIdCheckConnectionResponse,
  GetApiJiraV1TenantsByTenantIdData,
  GetApiJiraV1TenantsByTenantIdError,
  GetApiJiraV1TenantsByTenantIdResponse,
  GetApiJiraV1TenantsData,
  GetApiJiraV1TenantsError,
  GetApiJiraV1TenantsResponse,
  GetApiJiraV2TenantsByTenantIdActionsAttachmentContentData,
  GetApiJiraV2TenantsByTenantIdActionsAttachmentContentError,
  GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponse,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdData,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdError,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponse,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesData,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesError,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesResponse,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentData,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentError,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponse,
  GetApiNotionV1TenantsByTenantIdActionsPagesData,
  GetApiNotionV1TenantsByTenantIdActionsPagesError,
  GetApiNotionV1TenantsByTenantIdActionsPagesResponse,
  GetApiNotionV1TenantsByTenantIdCheckConnectionData,
  GetApiNotionV1TenantsByTenantIdCheckConnectionError,
  GetApiNotionV1TenantsByTenantIdCheckConnectionResponse,
  GetApiNotionV1TenantsByTenantIdData,
  GetApiNotionV1TenantsByTenantIdError,
  GetApiNotionV1TenantsByTenantIdResponse,
  GetApiNotionV1TenantsData,
  GetApiNotionV1TenantsError,
  GetApiNotionV1TenantsResponse,
  GetApiOutlookV2SubscriptionsData,
  GetApiOutlookV2SubscriptionsError,
  GetApiOutlookV2SubscriptionsResponse,
  GetApiPlainV1FullTenantsData,
  GetApiPlainV1FullTenantsError,
  GetApiPlainV1FullTenantsResponse,
  GetApiPlainV1TenantsByTenantIdActionsCompaniesData,
  GetApiPlainV1TenantsByTenantIdActionsCompaniesError,
  GetApiPlainV1TenantsByTenantIdActionsCompaniesResponse,
  GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsData,
  GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsError,
  GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponse,
  GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData,
  GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdError,
  GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponse,
  GetApiPlainV1TenantsByTenantIdActionsCustomersData,
  GetApiPlainV1TenantsByTenantIdActionsCustomersError,
  GetApiPlainV1TenantsByTenantIdActionsCustomersResponse,
  GetApiPlainV1TenantsByTenantIdActionsPlainTenantsData,
  GetApiPlainV1TenantsByTenantIdActionsPlainTenantsError,
  GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponse,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdData,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdError,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponse,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineData,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineError,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponse,
  GetApiPlainV1TenantsByTenantIdActionsThreadsData,
  GetApiPlainV1TenantsByTenantIdActionsThreadsError,
  GetApiPlainV1TenantsByTenantIdActionsThreadsResponse,
  GetApiPlainV1TenantsByTenantIdCheckConnectionData,
  GetApiPlainV1TenantsByTenantIdCheckConnectionError,
  GetApiPlainV1TenantsByTenantIdCheckConnectionResponse,
  GetApiPlainV1TenantsByTenantIdData,
  GetApiPlainV1TenantsByTenantIdError,
  GetApiPlainV1TenantsByTenantIdResponse,
  GetApiPlainV1TenantsData,
  GetApiPlainV1TenantsError,
  GetApiPlainV1TenantsResponse,
  GetApiPublicOauthV1AuthorizeData,
  GetApiPublicOauthV1AuthorizeError,
  GetApiPublicOauthV1ByOauthApplicationIdAuthorizeData,
  GetApiPublicOauthV1ByOauthApplicationIdAuthorizeError,
  GetApiPublicOauthV1ByOauthApplicationIdUserinfoData,
  GetApiPublicOauthV1ByOauthApplicationIdUserinfoError,
  GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationData,
  GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationError,
  GetApiPublicOauthV1WellKnownOauthAuthorizationServerData,
  GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponse,
  GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyData,
  GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyError,
  GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponse,
  GetApiPublicOauthV1WellKnownOpenidConfigurationData,
  GetApiPublicOauthV1WellKnownOpenidConfigurationResponse,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonData,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonError,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponse,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationData,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationError,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponse,
  GetApiPublicV1AgentA2aByAgentKeyAgentData,
  GetApiPublicV1AgentA2aByAgentKeyAgentError,
  GetApiPublicV1AgentA2aByAgentKeyAgentResponse,
  GetApiSalesforceV1FullTenantsData,
  GetApiSalesforceV1FullTenantsError,
  GetApiSalesforceV1FullTenantsResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdError,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsData,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsError,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsArticlesData,
  GetApiSalesforceV1TenantsByTenantIdActionsArticlesError,
  GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdError,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesError,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesData,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesError,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdError,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsData,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsError,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageData,
  GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageError,
  GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdError,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsError,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdError,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesData,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesError,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdError,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesError,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdError,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponse,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersData,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersError,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersResponse,
  GetApiSalesforceV1TenantsByTenantIdCheckConnectionData,
  GetApiSalesforceV1TenantsByTenantIdCheckConnectionError,
  GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponse,
  GetApiSalesforceV1TenantsByTenantIdCheckReadyData,
  GetApiSalesforceV1TenantsByTenantIdCheckReadyError,
  GetApiSalesforceV1TenantsByTenantIdCheckReadyResponse,
  GetApiSalesforceV1TenantsByTenantIdData,
  GetApiSalesforceV1TenantsByTenantIdError,
  GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriData,
  GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriError,
  GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponse,
  GetApiSalesforceV1TenantsByTenantIdResponse,
  GetApiSalesforceV1TenantsData,
  GetApiSalesforceV1TenantsError,
  GetApiSalesforceV1TenantsResponse,
  GetApiSecretsVaultV1FullSecretsData,
  GetApiSecretsVaultV1FullSecretsError,
  GetApiSecretsVaultV1FullSecretsResponse,
  GetApiSecretsVaultV1SecretsBySecretIdData,
  GetApiSecretsVaultV1SecretsBySecretIdError,
  GetApiSecretsVaultV1SecretsBySecretIdResponse,
  GetApiSecretsVaultV1SecretsData,
  GetApiSecretsVaultV1SecretsError,
  GetApiSecretsVaultV1SecretsResponse,
  GetApiSecretsVaultV1SecretsValueData,
  GetApiSecretsVaultV1SecretsValueError,
  GetApiSecretsVaultV1SecretsValueResponse,
  GetApiSecretsVaultV2SecretsValueData,
  GetApiSecretsVaultV2SecretsValueError,
  GetApiSecretsVaultV2SecretsValueResponse,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataData,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataError,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponse,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesError,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponse,
  GetApiServiceNowV1TenantsByTenantIdActionsUserProfileData,
  GetApiServiceNowV1TenantsByTenantIdActionsUserProfileError,
  GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponse,
  GetApiSharepointV1FullTenantsData,
  GetApiSharepointV1FullTenantsError,
  GetApiSharepointV1FullTenantsResponse,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenError,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponse,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
  GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData,
  GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesError,
  GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponse,
  GetApiSharepointV1TenantsByTenantIdAdminAccessData,
  GetApiSharepointV1TenantsByTenantIdAdminAccessError,
  GetApiSharepointV1TenantsByTenantIdAdminAccessResponse,
  GetApiSharepointV1TenantsByTenantIdCheckAccessData,
  GetApiSharepointV1TenantsByTenantIdCheckAccessError,
  GetApiSharepointV1TenantsByTenantIdCheckAccessResponse,
  GetApiSharepointV1TenantsByTenantIdCheckConnectionData,
  GetApiSharepointV1TenantsByTenantIdCheckConnectionError,
  GetApiSharepointV1TenantsByTenantIdCheckConnectionResponse,
  GetApiSharepointV1TenantsByTenantIdData,
  GetApiSharepointV1TenantsByTenantIdError,
  GetApiSharepointV1TenantsByTenantIdFolderScopesData,
  GetApiSharepointV1TenantsByTenantIdFolderScopesError,
  GetApiSharepointV1TenantsByTenantIdFolderScopesResponse,
  GetApiSharepointV1TenantsByTenantIdResponse,
  GetApiSharepointV1TenantsByTenantIdSitesData,
  GetApiSharepointV1TenantsByTenantIdSitesError,
  GetApiSharepointV1TenantsByTenantIdSitesResponse,
  GetApiSharepointV1TenantsData,
  GetApiSharepointV1TenantsError,
  GetApiSharepointV1TenantsResponse,
  GetApiSlackV1FullTenantsData,
  GetApiSlackV1FullTenantsError,
  GetApiSlackV1FullTenantsResponse,
  GetApiSlackV1OauthScopesData,
  GetApiSlackV1OauthScopesResponse,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersData,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersError,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponse,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsData,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsError,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponse,
  GetApiSlackV1TenantsByTenantIdCheckConnectionData,
  GetApiSlackV1TenantsByTenantIdCheckConnectionError,
  GetApiSlackV1TenantsByTenantIdCheckConnectionResponse,
  GetApiSlackV1TenantsByTenantIdData,
  GetApiSlackV1TenantsByTenantIdError,
  GetApiSlackV1TenantsByTenantIdManifestData,
  GetApiSlackV1TenantsByTenantIdManifestError,
  GetApiSlackV1TenantsByTenantIdManifestResponse,
  GetApiSlackV1TenantsByTenantIdResponse,
  GetApiSlackV1TenantsData,
  GetApiSlackV1TenantsError,
  GetApiSlackV1TenantsResponse,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsData,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsError,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponse,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesData,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesError,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponse,
  GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdData,
  GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdError,
  GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponse,
  GetApiSlackV2TenantsByTenantIdActionsUsersData,
  GetApiSlackV2TenantsByTenantIdActionsUsersError,
  GetApiSlackV2TenantsByTenantIdActionsUsersResponse,
  GetApiTeamsV1FullTenantsData,
  GetApiTeamsV1FullTenantsError,
  GetApiTeamsV1FullTenantsResponse,
  GetApiTeamsV1TenantsByTenantIdData,
  GetApiTeamsV1TenantsByTenantIdError,
  GetApiTeamsV1TenantsByTenantIdIconsData,
  GetApiTeamsV1TenantsByTenantIdIconsError,
  GetApiTeamsV1TenantsByTenantIdInstallsData,
  GetApiTeamsV1TenantsByTenantIdInstallsError,
  GetApiTeamsV1TenantsByTenantIdInstallsResponse,
  GetApiTeamsV1TenantsByTenantIdManifestData,
  GetApiTeamsV1TenantsByTenantIdManifestError,
  GetApiTeamsV1TenantsByTenantIdResponse,
  GetApiTeamsV1TenantsData,
  GetApiTeamsV1TenantsError,
  GetApiTeamsV1TenantsResponse,
  GetApiV1A2aAgentsData,
  GetApiV1A2aAgentsResponse,
  GetApiV1AgentsByAgentKeyData,
  GetApiV1AgentsByAgentKeyError,
  GetApiV1AgentsByAgentKeyResponse,
  GetApiV1AgentsData,
  GetApiV1AgentSessionInferenceByAgentSessionIdData,
  GetApiV1AgentSessionInferenceByAgentSessionIdError,
  GetApiV1AgentSessionInferenceByAgentSessionIdResponse,
  GetApiV1AgentSessionsByAgentSessionIdData,
  GetApiV1AgentSessionsByAgentSessionIdError,
  GetApiV1AgentSessionsByAgentSessionIdResponse,
  GetApiV1AgentSessionsData,
  GetApiV1AgentSessionsError,
  GetApiV1AgentSessionsResponse,
  GetApiV1AgentsResponse,
  GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentData,
  GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentError,
  GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponse,
  GetApiV1AnalyticsOverviewsChartsData,
  GetApiV1AnalyticsOverviewsChartsResponse,
  GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentData,
  GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentError,
  GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponse,
  GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentData,
  GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentError,
  GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponse,
  GetApiV1AnalyticsSectionsChartsData,
  GetApiV1AnalyticsSectionsChartsError,
  GetApiV1AnalyticsSectionsChartsResponse,
  GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentData,
  GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentError,
  GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponse,
  GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentData,
  GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentError,
  GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponse,
  GetApiV1AnalyticsWorkflowsChartsData,
  GetApiV1AnalyticsWorkflowsChartsError,
  GetApiV1AnalyticsWorkflowsChartsResponse,
  GetApiV1ArticleLineRangeCommentThreadsByThreadIdData,
  GetApiV1ArticleLineRangeCommentThreadsByThreadIdError,
  GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
  GetApiV1ArticleTagsData,
  GetApiV1ArticleTagsError,
  GetApiV1ArticleTagsResponse,
  GetApiV1AttachmentsDataByFilePathData,
  GetApiV1AttachmentsDataByFilePathError,
  GetApiV1AuthzOrganizationsByOrgIdData,
  GetApiV1AuthzOrganizationsByOrgIdError,
  GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData,
  GetApiV1AuthzOrganizationsByOrgIdFullInvitationsError,
  GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponse,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsData,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsError,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsResponse,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsData,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsError,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponse,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessData,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessError,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponse,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsError,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse,
  GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineData,
  GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineError,
  GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponse,
  GetApiV1AuthzOrganizationsByOrgIdMembersData,
  GetApiV1AuthzOrganizationsByOrgIdMembersError,
  GetApiV1AuthzOrganizationsByOrgIdMembersResponse,
  GetApiV1AuthzOrganizationsByOrgIdResponse,
  GetApiV1AuthzOrganizationsByOrgIdRolesData,
  GetApiV1AuthzOrganizationsByOrgIdRolesError,
  GetApiV1AuthzOrganizationsByOrgIdRolesResponse,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesError,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponse,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesData,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesError,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponse,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
  GetApiV1AuthzOrganizationsByOrgIdTeamsData,
  GetApiV1AuthzOrganizationsByOrgIdTeamsError,
  GetApiV1AuthzOrganizationsByOrgIdTeamsResponse,
  GetApiV1AuthzOrganizationsData,
  GetApiV1AuthzOrganizationsError,
  GetApiV1AuthzOrganizationsResponse,
  GetApiV1BrandingData,
  GetApiV1BrandingResponse,
  GetApiV1CalibrationFeedbackDimensionsByDimensionIdData,
  GetApiV1CalibrationFeedbackDimensionsByDimensionIdError,
  GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponse,
  GetApiV1CalibrationFeedbackDimensionsData,
  GetApiV1CalibrationFeedbackDimensionsError,
  GetApiV1CalibrationFeedbackDimensionsResponse,
  GetApiV1CalibrationFeedbackFullDimensionsData,
  GetApiV1CalibrationFeedbackFullDimensionsError,
  GetApiV1CalibrationFeedbackFullDimensionsResponse,
  GetApiV1CalibrationFeedbackFullQueueItemsData,
  GetApiV1CalibrationFeedbackFullQueueItemsError,
  GetApiV1CalibrationFeedbackFullQueueItemsResponse,
  GetApiV1CalibrationFeedbackFullVerdictsData,
  GetApiV1CalibrationFeedbackFullVerdictsError,
  GetApiV1CalibrationFeedbackFullVerdictsResponse,
  GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData,
  GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdError,
  GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponse,
  GetApiV1CalibrationFeedbackInferenceDatapointsData,
  GetApiV1CalibrationFeedbackInferenceDatapointsError,
  GetApiV1CalibrationFeedbackInferenceDatapointsResponse,
  GetApiV1CalibrationFeedbackInferenceDatapointsTagsData,
  GetApiV1CalibrationFeedbackInferenceDatapointsTagsError,
  GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponse,
  GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdData,
  GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdError,
  GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponse,
  GetApiV1CalibrationFeedbackQueueItemsData,
  GetApiV1CalibrationFeedbackQueueItemsError,
  GetApiV1CalibrationFeedbackQueueItemsResponse,
  GetApiV1CalibrationFeedbackQueueItemsTagsData,
  GetApiV1CalibrationFeedbackQueueItemsTagsError,
  GetApiV1CalibrationFeedbackQueueItemsTagsResponse,
  GetApiV1CalibrationFeedbackVerdictsByVerdictIdData,
  GetApiV1CalibrationFeedbackVerdictsByVerdictIdError,
  GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
  GetApiV1CalibrationFeedbackVerdictsData,
  GetApiV1CalibrationFeedbackVerdictsError,
  GetApiV1CalibrationFeedbackVerdictsResponse,
  GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
  GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError,
  GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
  GetApiV1ChangeRequestsByChangeRequestIdData,
  GetApiV1ChangeRequestsByChangeRequestIdError,
  GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesData,
  GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesError,
  GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponse,
  GetApiV1ChangeRequestsByChangeRequestIdResponse,
  GetApiV1ChangeRequestsData,
  GetApiV1ChangeRequestsError,
  GetApiV1ChangeRequestsResponse,
  GetApiV1ChangeRequestTagsData,
  GetApiV1ChangeRequestTagsError,
  GetApiV1ChangeRequestTagsResponse,
  GetApiV1CommentsByCommentIdData,
  GetApiV1CommentsByCommentIdError,
  GetApiV1CommentsByCommentIdResponse,
  GetApiV1ConversationsData,
  GetApiV1ConversationsError,
  GetApiV1ConversationsGroupByExternalIdData,
  GetApiV1ConversationsGroupByExternalIdError,
  GetApiV1ConversationsGroupByExternalIdResponse,
  GetApiV1ConversationsResponse,
  GetApiV1DataDumpConversationsData,
  GetApiV1DataDumpConversationsError,
  GetApiV1DataDumpConversationsResponse,
  GetApiV1DatapointEvidenceData,
  GetApiV1DatapointEvidenceError,
  GetApiV1DatapointEvidenceResponse,
  GetApiV1EvaluatedInferenceDatapointsData,
  GetApiV1EvaluatedInferenceDatapointsError,
  GetApiV1EvaluatedInferenceDatapointsResponse,
  GetApiV1ExternalInferencesByInferenceIdData,
  GetApiV1ExternalInferencesByInferenceIdError,
  GetApiV1ExternalInferencesByInferenceIdResponse,
  GetApiV1ExternalInferencesData,
  GetApiV1ExternalInferencesError,
  GetApiV1ExternalInferencesResponse,
  GetApiV1FrontendConfigData,
  GetApiV1FrontendConfigResponse,
  GetApiV1FullAgentSessionsData,
  GetApiV1FullAgentSessionsError,
  GetApiV1FullAgentSessionsResponse,
  GetApiV1FullApiKeysData,
  GetApiV1FullApiKeysError,
  GetApiV1FullApiKeysResponse,
  GetApiV1FullArticleLineRangeCommentThreadsData,
  GetApiV1FullArticleLineRangeCommentThreadsError,
  GetApiV1FullArticleLineRangeCommentThreadsResponse,
  GetApiV1FullChangeRequestLineRangeCommentThreadsData,
  GetApiV1FullChangeRequestLineRangeCommentThreadsError,
  GetApiV1FullChangeRequestLineRangeCommentThreadsResponse,
  GetApiV1FullChangeRequestsData,
  GetApiV1FullChangeRequestsError,
  GetApiV1FullChangeRequestsResponse,
  GetApiV1FullCommentsData,
  GetApiV1FullCommentsError,
  GetApiV1FullCommentsResponse,
  GetApiV1FullDataDumpConversationsData,
  GetApiV1FullDataDumpConversationsError,
  GetApiV1FullDataDumpConversationsResponse,
  GetApiV1FullDatapointsData,
  GetApiV1FullDatapointsError,
  GetApiV1FullDatapointsResponse,
  GetApiV1FullInferenceDatapointsByInferenceDatapointIdData,
  GetApiV1FullInferenceDatapointsByInferenceDatapointIdError,
  GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponse,
  GetApiV1FullInferenceDatapointsData,
  GetApiV1FullInferenceDatapointsError,
  GetApiV1FullInferenceDatapointsResponse,
  GetApiV1FullKbSimulationCompareData,
  GetApiV1FullKbSimulationCompareError,
  GetApiV1FullKbSimulationCompareResponse,
  GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdData,
  GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdError,
  GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponse,
  GetApiV1FullKbSimulationDatapointsData,
  GetApiV1FullKbSimulationDatapointsError,
  GetApiV1FullKbSimulationDatapointsResponse,
  GetApiV1FullKbSimulationResultJudgementsData,
  GetApiV1FullKbSimulationResultJudgementsError,
  GetApiV1FullKbSimulationResultJudgementsResponse,
  GetApiV1FullKbSimulationResultsBySimulationResultIdData,
  GetApiV1FullKbSimulationResultsBySimulationResultIdError,
  GetApiV1FullKbSimulationResultsBySimulationResultIdResponse,
  GetApiV1FullKbSimulationResultsData,
  GetApiV1FullKbSimulationResultsError,
  GetApiV1FullKbSimulationResultsResponse,
  GetApiV1FullKbSimulationRunData,
  GetApiV1FullKbSimulationRunError,
  GetApiV1FullKbSimulationRunResponse,
  GetApiV1FullOauthApplicationsData,
  GetApiV1FullOauthApplicationsError,
  GetApiV1FullOauthApplicationsResponse,
  GetApiV1FullUserAgentSessionsData,
  GetApiV1FullUserAgentSessionsError,
  GetApiV1FullUserAgentSessionsResponse,
  GetApiV1FullWorkEventsData,
  GetApiV1FullWorkEventsError,
  GetApiV1FullWorkEventsResponse,
  GetApiV1FullWorkflowRunsData,
  GetApiV1FullWorkflowRunsError,
  GetApiV1FullWorkflowRunsResponse,
  GetApiV1HubspotFullTenantsData,
  GetApiV1HubspotFullTenantsError,
  GetApiV1HubspotFullTenantsResponse,
  GetApiV1HubspotTenantsByTenantIdCheckConnectionData,
  GetApiV1HubspotTenantsByTenantIdCheckConnectionError,
  GetApiV1HubspotTenantsByTenantIdCheckConnectionResponse,
  GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdData,
  GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdError,
  GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponse,
  GetApiV1HubspotTenantsByTenantIdData,
  GetApiV1HubspotTenantsByTenantIdError,
  GetApiV1HubspotTenantsByTenantIdManifestData,
  GetApiV1HubspotTenantsByTenantIdManifestError,
  GetApiV1HubspotTenantsByTenantIdResponse,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdData,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdError,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesData,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesError,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponse,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponse,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdData,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdError,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesData,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesError,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponse,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponse,
  GetApiV1HubspotTenantsByTenantIdTicketsData,
  GetApiV1HubspotTenantsByTenantIdTicketsError,
  GetApiV1HubspotTenantsByTenantIdTicketsResponse,
  GetApiV1HubspotTenantsData,
  GetApiV1HubspotTenantsError,
  GetApiV1HubspotTenantsResponse,
  GetApiV1ImageAttachmentsDownloadByFilePathData,
  GetApiV1ImageAttachmentsDownloadByFilePathError,
  GetApiV1InferenceFeedbackData,
  GetApiV1InferenceFeedbackError,
  GetApiV1InferenceFeedbackResponse,
  GetApiV1JudgesByJudgeIdData,
  GetApiV1JudgesByJudgeIdError,
  GetApiV1JudgesByJudgeIdResponse,
  GetApiV1JudgesData,
  GetApiV1JudgesError,
  GetApiV1JudgesResponse,
  GetApiV1KbAttachmentsDownloadByFilePathData,
  GetApiV1KbAttachmentsDownloadByFilePathError,
  GetApiV1KbSimulationBranchBreakdownStatsData,
  GetApiV1KbSimulationBranchBreakdownStatsError,
  GetApiV1KbSimulationBranchBreakdownStatsResponse,
  GetApiV1KbSimulationCommitsData,
  GetApiV1KbSimulationCommitsError,
  GetApiV1KbSimulationCommitsResponse,
  GetApiV1KbSimulationCompareSummaryData,
  GetApiV1KbSimulationCompareSummaryError,
  GetApiV1KbSimulationCompareSummaryResponse,
  GetApiV1KbSimulationDatapointsBySimulationDatapointIdData,
  GetApiV1KbSimulationDatapointsBySimulationDatapointIdError,
  GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
  GetApiV1KbSimulationDatapointsData,
  GetApiV1KbSimulationDatapointsError,
  GetApiV1KbSimulationDatapointsResponse,
  GetApiV1KbSimulationResultsBySimulationResultIdData,
  GetApiV1KbSimulationResultsBySimulationResultIdError,
  GetApiV1KbSimulationResultsBySimulationResultIdResponse,
  GetApiV1KbSimulationResultsData,
  GetApiV1KbSimulationResultsError,
  GetApiV1KbSimulationResultsResponse,
  GetApiV1KbsOwnedData,
  GetApiV1KbsOwnedError,
  GetApiV1KbsOwnedResponse,
  GetApiV1MachineUsersByMachineUserIdApiKeysData,
  GetApiV1MachineUsersByMachineUserIdApiKeysError,
  GetApiV1MachineUsersByMachineUserIdApiKeysResponse,
  GetApiV1MachineUsersByMachineUserIdData,
  GetApiV1MachineUsersByMachineUserIdError,
  GetApiV1MachineUsersByMachineUserIdResponse,
  GetApiV1MachineUsersData,
  GetApiV1MachineUsersError,
  GetApiV1MachineUsersResponse,
  GetApiV1McpToolsetsData,
  GetApiV1McpToolsetsResponse,
  GetApiV1MetricsChildJudgementData,
  GetApiV1MetricsChildJudgementError,
  GetApiV1MetricsChildJudgementResponse,
  GetApiV1OauthApplicationsByOauthApplicationIdData,
  GetApiV1OauthApplicationsByOauthApplicationIdError,
  GetApiV1OauthApplicationsByOauthApplicationIdResponse,
  GetApiV1OauthApplicationsData,
  GetApiV1OauthApplicationsError,
  GetApiV1OauthApplicationsResponse,
  GetApiV1ObjectArticleByObjectArticleIdData,
  GetApiV1ObjectArticleByObjectArticleIdError,
  GetApiV1ObjectArticleByObjectArticleIdResponse,
  GetApiV1ReposByRepositoryIdArticleByRefData,
  GetApiV1ReposByRepositoryIdArticleByRefError,
  GetApiV1ReposByRepositoryIdArticleByRefResponse,
  GetApiV1ReposByRepositoryIdBlobByRefData,
  GetApiV1ReposByRepositoryIdBlobByRefError,
  GetApiV1ReposByRepositoryIdBlobByRefResponse,
  GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewData,
  GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewError,
  GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponse,
  GetApiV1ReposByRepositoryIdBranchesByNameData,
  GetApiV1ReposByRepositoryIdBranchesByNameError,
  GetApiV1ReposByRepositoryIdBranchesByNameResponse,
  GetApiV1ReposByRepositoryIdBranchesData,
  GetApiV1ReposByRepositoryIdBranchesError,
  GetApiV1ReposByRepositoryIdBranchesResponse,
  GetApiV1ReposByRepositoryIdCommitByRefData,
  GetApiV1ReposByRepositoryIdCommitByRefError,
  GetApiV1ReposByRepositoryIdCommitByRefResponse,
  GetApiV1ReposByRepositoryIdCommitsByRefData,
  GetApiV1ReposByRepositoryIdCommitsByRefError,
  GetApiV1ReposByRepositoryIdCommitsByRefResponse,
  GetApiV1ReposByRepositoryIdCompareByBaseheadData,
  GetApiV1ReposByRepositoryIdCompareByBaseheadError,
  GetApiV1ReposByRepositoryIdCompareByBaseheadResponse,
  GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadData,
  GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadError,
  GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponse,
  GetApiV1ReposByRepositoryIdTreeByRefData,
  GetApiV1ReposByRepositoryIdTreeByRefError,
  GetApiV1ReposByRepositoryIdTreeByRefResponse,
  GetApiV1SearchData,
  GetApiV1SearchError,
  GetApiV1SearchResponse,
  GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesData,
  GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesError,
  GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponse,
  GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData,
  GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdError,
  GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponse,
  GetApiV1ServiceNowTenantsByTenantIdArticlesData,
  GetApiV1ServiceNowTenantsByTenantIdArticlesError,
  GetApiV1ServiceNowTenantsByTenantIdArticlesResponse,
  GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData,
  GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsError,
  GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponse,
  GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentData,
  GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentError,
  GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponse,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdData,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdError,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponse,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsError,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponse,
  GetApiV1ServiceNowTenantsByTenantIdData,
  GetApiV1ServiceNowTenantsByTenantIdError,
  GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesData,
  GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesError,
  GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponse,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdError,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponse,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesError,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsError,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponse,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksError,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponse,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdData,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdError,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponse,
  GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData,
  GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsError,
  GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponse,
  GetApiV1ServiceNowTenantsByTenantIdResponse,
  GetApiV1ServiceNowTenantsByTenantIdTagsData,
  GetApiV1ServiceNowTenantsByTenantIdTagsError,
  GetApiV1ServiceNowTenantsByTenantIdTagsResponse,
  GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdData,
  GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdError,
  GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponse,
  GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData,
  GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsError,
  GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponse,
  GetApiV1ServiceNowTenantsByTenantIdTicketsData,
  GetApiV1ServiceNowTenantsByTenantIdTicketsError,
  GetApiV1ServiceNowTenantsByTenantIdTicketsResponse,
  GetApiV1ServiceNowTenantsByTenantIdUsersData,
  GetApiV1ServiceNowTenantsByTenantIdUsersError,
  GetApiV1ServiceNowTenantsByTenantIdUsersResponse,
  GetApiV1ServiceNowTenantsData,
  GetApiV1ServiceNowTenantsError,
  GetApiV1ServiceNowTenantsResponse,
  GetApiV1SesameEdraAccessData,
  GetApiV1SesameEdraAccessError,
  GetApiV1SesameEdraAccessResponse,
  GetApiV1TasksByTaskIdFeedbackLabelsData,
  GetApiV1TasksByTaskIdFeedbackLabelsError,
  GetApiV1TasksByTaskIdFeedbackLabelsResponse,
  GetApiV1TasksByTaskIdPromptsByPromptIdData,
  GetApiV1TasksByTaskIdPromptsByPromptIdError,
  GetApiV1TasksByTaskIdPromptsByPromptIdResponse,
  GetApiV1TasksByTaskIdPromptsData,
  GetApiV1TasksByTaskIdPromptsError,
  GetApiV1TasksByTaskIdPromptsResponse,
  GetApiV1UsageStatsAgentsData,
  GetApiV1UsageStatsAgentsError,
  GetApiV1UsageStatsAgentsResponse,
  GetApiV1UsersByUserIdData,
  GetApiV1UsersByUserIdError,
  GetApiV1UsersByUserIdNotificationSettingsData,
  GetApiV1UsersByUserIdNotificationSettingsError,
  GetApiV1UsersByUserIdNotificationSettingsResponse,
  GetApiV1UsersByUserIdResponse,
  GetApiV1UsersData,
  GetApiV1UsersError,
  GetApiV1UsersMeData,
  GetApiV1UsersMeResponse,
  GetApiV1UsersResponse,
  GetApiV1WorkEventsByEventIdData,
  GetApiV1WorkEventsByEventIdError,
  GetApiV1WorkEventsByEventIdResponse,
  GetApiV1WorkflowAnalyticsEventsData,
  GetApiV1WorkflowAnalyticsEventsError,
  GetApiV1WorkflowAnalyticsEventsResponse,
  GetApiV1WorkflowRunsByWorkflowRunIdData,
  GetApiV1WorkflowRunsByWorkflowRunIdError,
  GetApiV1WorkflowRunsByWorkflowRunIdResponse,
  GetApiV1WorkflowsData,
  GetApiV1WorkflowsError,
  GetApiV1WorkflowsResponse,
  GetApiV1WorkspacesByWorkspaceIdData,
  GetApiV1WorkspacesByWorkspaceIdError,
  GetApiV1WorkspacesByWorkspaceIdResponse,
  GetApiV1WorkspacesData,
  GetApiV1WorkspacesError,
  GetApiV1WorkspacesResponse,
  GetApiV1ZendeskOauthRedirectUriData,
  GetApiV1ZendeskOauthRedirectUriResponse,
  GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentData,
  GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentError,
  GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsData,
  GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsError,
  GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponse,
  GetApiV1ZendeskTenantsByTenantIdArticlesData,
  GetApiV1ZendeskTenantsByTenantIdArticlesError,
  GetApiV1ZendeskTenantsByTenantIdArticlesResponse,
  GetApiV1ZendeskTenantsByTenantIdCheckConnectionData,
  GetApiV1ZendeskTenantsByTenantIdCheckConnectionError,
  GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponse,
  GetApiV1ZendeskTenantsByTenantIdData,
  GetApiV1ZendeskTenantsByTenantIdError,
  GetApiV1ZendeskTenantsByTenantIdResponse,
  GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdData,
  GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdError,
  GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponse,
  GetApiV1ZendeskTenantsByTenantIdTicketsData,
  GetApiV1ZendeskTenantsByTenantIdTicketsError,
  GetApiV1ZendeskTenantsByTenantIdTicketsResponse,
  GetApiV1ZendeskTenantsByTenantIdUsersByUserIdData,
  GetApiV1ZendeskTenantsByTenantIdUsersByUserIdError,
  GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponse,
  GetApiV1ZendeskTenantsByTenantIdUsersData,
  GetApiV1ZendeskTenantsByTenantIdUsersError,
  GetApiV1ZendeskTenantsByTenantIdUsersResponse,
  GetApiV1ZendeskTenantsData,
  GetApiV1ZendeskTenantsError,
  GetApiV1ZendeskTenantsResponse,
  GetApiV2AttachmentsDataByAttachmentIdByFilenameData,
  GetApiV2AttachmentsDataByAttachmentIdByFilenameError,
  GetApiV2FinalizedConversationsData,
  GetApiV2FinalizedConversationsError,
  GetApiV2FinalizedConversationsResponse,
  GetApiV2FullFinalizedConversationsByFinalizedConversationIdData,
  GetApiV2FullFinalizedConversationsByFinalizedConversationIdError,
  GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponse,
  GetApiV2FullFinalizedConversationsData,
  GetApiV2FullFinalizedConversationsError,
  GetApiV2FullFinalizedConversationsResponse,
  GetApiV2FullInferenceConversationInferencesData,
  GetApiV2FullInferenceConversationInferencesError,
  GetApiV2FullInferenceConversationInferencesResponse,
  GetApiV2FullInferenceConversationsData,
  GetApiV2FullInferenceConversationsError,
  GetApiV2FullInferenceConversationsResponse,
  GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdData,
  GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdError,
  GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponse,
  GetApiV2InferenceConversationsByExternalIdData,
  GetApiV2InferenceConversationsByExternalIdError,
  GetApiV2InferenceConversationsByExternalIdResponse,
  GetApiV2InferenceConversationsData,
  GetApiV2InferenceConversationsError,
  GetApiV2InferenceConversationsResponse,
  GetApiV2JudgementsData,
  GetApiV2JudgementsError,
  GetApiV2JudgementsResponse,
  GetApiV2JudgesByJudgeIdData,
  GetApiV2JudgesByJudgeIdError,
  GetApiV2JudgesByJudgeIdResponse,
  GetApiV2JudgesData,
  GetApiV2JudgesError,
  GetApiV2JudgesResponse,
  GetApiV2KanonicalDatapointsByKanonicalDatapointIdData,
  GetApiV2KanonicalDatapointsByKanonicalDatapointIdError,
  GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponse,
  GetApiV2KanonicalDatapointsData,
  GetApiV2KanonicalDatapointsError,
  GetApiV2KanonicalDatapointsResponse,
  GetApiV2KbsByKbIdData,
  GetApiV2KbsByKbIdEmbeddingSummaryData,
  GetApiV2KbsByKbIdEmbeddingSummaryError,
  GetApiV2KbsByKbIdEmbeddingSummaryResponse,
  GetApiV2KbsByKbIdError,
  GetApiV2KbsByKbIdResponse,
  GetApiV2MetricsChangeCountsData,
  GetApiV2MetricsChangeCountsError,
  GetApiV2MetricsChangeCountsResponse,
  GetApiV2MetricsChangeUsersData,
  GetApiV2MetricsChangeUsersError,
  GetApiV2MetricsChangeUsersResponse,
  GetApiV2MetricsTopArticleJudgementData,
  GetApiV2MetricsTopArticleJudgementError,
  GetApiV2MetricsTopArticleJudgementResponse,
  GetApiV2MetricsVerificationData,
  GetApiV2MetricsVerificationError,
  GetApiV2MetricsVerificationResponse,
  GetApiV2TasksByTaskIdData,
  GetApiV2TasksByTaskIdError,
  GetApiV2TasksByTaskIdResponse,
  GetApiV2TasksData,
  GetApiV2TasksError,
  GetApiV2TasksResponse,
  GetApiV3DatapointsByDatapointIdData,
  GetApiV3DatapointsByDatapointIdError,
  GetApiV3DatapointsByDatapointIdResponse,
  GetApiV3FullJudgementsData,
  GetApiV3FullJudgementsError,
  GetApiV3FullJudgementsResponse,
  GetApiV4KbsData,
  GetApiV4KbsError,
  GetApiV4KbsResponse,
  GetApiZendeskV1TenantsByTenantIdActionsCategoriesData,
  GetApiZendeskV1TenantsByTenantIdActionsCategoriesError,
  GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponse,
  GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdData,
  GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdError,
  GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsData,
  GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsError,
  GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponse,
  GetApiZendeskV1TenantsByTenantIdActionsSectionsData,
  GetApiZendeskV1TenantsByTenantIdActionsSectionsError,
  GetApiZendeskV1TenantsByTenantIdActionsSectionsResponse,
  GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdData,
  GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdError,
  GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponse,
  GetEdraPbOpenapiJsonData,
  GetEdraPbOpenapiJsonResponse,
  GetPublicHealthData,
  GetPublicHealthResponse,
  GetSdkOpenapiJsonData,
  GetSdkOpenapiJsonResponse,
  PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdData,
  PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdError,
  PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponse,
  PatchApiConfluenceV1TenantsByTenantIdData,
  PatchApiConfluenceV1TenantsByTenantIdError,
  PatchApiConfluenceV1TenantsByTenantIdResponse,
  PatchApiEntraV1TenantsByTenantIdData,
  PatchApiEntraV1TenantsByTenantIdError,
  PatchApiEntraV1TenantsByTenantIdResponse,
  PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData,
  PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdError,
  PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponse,
  PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData,
  PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdError,
  PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponse,
  PatchApiFreshserviceV1TenantsByTenantIdData,
  PatchApiFreshserviceV1TenantsByTenantIdError,
  PatchApiFreshserviceV1TenantsByTenantIdResponse,
  PatchApiJiraV1TenantsByTenantIdData,
  PatchApiJiraV1TenantsByTenantIdError,
  PatchApiJiraV1TenantsByTenantIdResponse,
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData,
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdError,
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponse,
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdData,
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdError,
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponse,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusData,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusError,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponse,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityData,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityError,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponse,
  PatchApiPlainV1TenantsByTenantIdData,
  PatchApiPlainV1TenantsByTenantIdError,
  PatchApiPlainV1TenantsByTenantIdResponse,
  PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdData,
  PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdError,
  PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponse,
  PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData,
  PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdError,
  PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponse,
  PatchApiSalesforceV1TenantsByTenantIdData,
  PatchApiSalesforceV1TenantsByTenantIdError,
  PatchApiSalesforceV1TenantsByTenantIdResponse,
  PatchApiSecretsVaultV1SecretsBySecretIdData,
  PatchApiSecretsVaultV1SecretsBySecretIdError,
  PatchApiSecretsVaultV1SecretsBySecretIdResponse,
  PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData,
  PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdError,
  PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponse,
  PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdData,
  PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdError,
  PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponse,
  PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdData,
  PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdError,
  PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponse,
  PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
  PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError,
  PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
  PatchApiSharepointV1TenantsByTenantIdData,
  PatchApiSharepointV1TenantsByTenantIdError,
  PatchApiSharepointV1TenantsByTenantIdResponse,
  PatchApiSlackV1TenantsByTenantIdData,
  PatchApiSlackV1TenantsByTenantIdError,
  PatchApiSlackV1TenantsByTenantIdResponse,
  PatchApiTeamsV1TenantsByTenantIdData,
  PatchApiTeamsV1TenantsByTenantIdError,
  PatchApiTeamsV1TenantsByTenantIdResponse,
  PatchApiV1AgentSessionsByAgentSessionIdData,
  PatchApiV1AgentSessionsByAgentSessionIdError,
  PatchApiV1AgentSessionsByAgentSessionIdResponse,
  PatchApiV1ApiKeysByApiKeyIdData,
  PatchApiV1ApiKeysByApiKeyIdError,
  PatchApiV1ApiKeysByApiKeyIdResponse,
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdData,
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdError,
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
  PatchApiV1AuthzOrganizationsByOrgIdData,
  PatchApiV1AuthzOrganizationsByOrgIdError,
  PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
  PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError,
  PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdData,
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdError,
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponse,
  PatchApiV1AuthzOrganizationsByOrgIdResponse,
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError,
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdData,
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdError,
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
  PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
  PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError,
  PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
  PatchApiV1ChangeRequestsByChangeRequestIdData,
  PatchApiV1ChangeRequestsByChangeRequestIdError,
  PatchApiV1ChangeRequestsByChangeRequestIdResponse,
  PatchApiV1CommentsByCommentIdData,
  PatchApiV1CommentsByCommentIdError,
  PatchApiV1CommentsByCommentIdResponse,
  PatchApiV1DataDumpConversationsByDataDumpConversationIdData,
  PatchApiV1DataDumpConversationsByDataDumpConversationIdError,
  PatchApiV1DataDumpConversationsByDataDumpConversationIdResponse,
  PatchApiV1ExternalInferencesByInferenceIdData,
  PatchApiV1ExternalInferencesByInferenceIdError,
  PatchApiV1ExternalInferencesByInferenceIdResponse,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdData,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdError,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdData,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdError,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponse,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdResponse,
  PatchApiV1HubspotTenantsByTenantIdData,
  PatchApiV1HubspotTenantsByTenantIdError,
  PatchApiV1HubspotTenantsByTenantIdResponse,
  PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdData,
  PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdError,
  PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponse,
  PatchApiV1InferenceDatapointsByInferenceDatapointIdData,
  PatchApiV1InferenceDatapointsByInferenceDatapointIdError,
  PatchApiV1InferenceDatapointsByInferenceDatapointIdResponse,
  PatchApiV1JudgesByJudgeIdData,
  PatchApiV1JudgesByJudgeIdError,
  PatchApiV1JudgesByJudgeIdResponse,
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdData,
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdError,
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponse,
  PatchApiV1KbsByKbIdArticlesByArticleIdData,
  PatchApiV1KbsByKbIdArticlesByArticleIdError,
  PatchApiV1KbsByKbIdArticlesByArticleIdResponse,
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdData,
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdError,
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
  PatchApiV1KbSimulationResultsBySimulationResultIdData,
  PatchApiV1KbSimulationResultsBySimulationResultIdError,
  PatchApiV1KbSimulationResultsBySimulationResultIdResponse,
  PatchApiV1MachineUsersByMachineUserIdData,
  PatchApiV1MachineUsersByMachineUserIdError,
  PatchApiV1MachineUsersByMachineUserIdResponse,
  PatchApiV1OauthApplicationsByOauthApplicationIdData,
  PatchApiV1OauthApplicationsByOauthApplicationIdError,
  PatchApiV1OauthApplicationsByOauthApplicationIdResponse,
  PatchApiV1ReposByRepositoryIdBranchesByNameData,
  PatchApiV1ReposByRepositoryIdBranchesByNameError,
  PatchApiV1ReposByRepositoryIdBranchesByNameResponse,
  PatchApiV1ReposByRepositoryIdCommitByCommitIdData,
  PatchApiV1ReposByRepositoryIdCommitByCommitIdError,
  PatchApiV1ReposByRepositoryIdCommitByCommitIdResponse,
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData,
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdError,
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponse,
  PatchApiV1ServiceNowTenantsByTenantIdData,
  PatchApiV1ServiceNowTenantsByTenantIdError,
  PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData,
  PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdError,
  PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponse,
  PatchApiV1ServiceNowTenantsByTenantIdResponse,
  PatchApiV1SesameEdraAccessData,
  PatchApiV1SesameEdraAccessError,
  PatchApiV1SesameEdraAccessResponse,
  PatchApiV1UsersByUserIdNotificationSettingsData,
  PatchApiV1UsersByUserIdNotificationSettingsError,
  PatchApiV1UsersByUserIdNotificationSettingsResponse,
  PatchApiV1UsersMeData,
  PatchApiV1UsersMeError,
  PatchApiV1UsersMeResponse,
  PatchApiV1WorkflowRunsByWorkflowRunIdData,
  PatchApiV1WorkflowRunsByWorkflowRunIdError,
  PatchApiV1WorkflowRunsByWorkflowRunIdResponse,
  PatchApiV1ZendeskTenantsByTenantIdData,
  PatchApiV1ZendeskTenantsByTenantIdError,
  PatchApiV1ZendeskTenantsByTenantIdResponse,
  PatchApiV2JudgesByJudgeIdData,
  PatchApiV2JudgesByJudgeIdError,
  PatchApiV2JudgesByJudgeIdResponse,
  PatchApiV2TasksByTaskIdData,
  PatchApiV2TasksByTaskIdError,
  PatchApiV2TasksByTaskIdResponse,
  PatchApiV3DatapointsByDatapointIdData,
  PatchApiV3DatapointsByDatapointIdError,
  PatchApiV3DatapointsByDatapointIdResponse,
  PatchApiV3DatapointsData,
  PatchApiV3DatapointsError,
  PatchApiV3DatapointsResponse,
  PatchApiV3KbsByKbIdCrReviewSlaData,
  PatchApiV3KbsByKbIdCrReviewSlaError,
  PatchApiV3KbsByKbIdCrReviewSlaResponse,
  PatchApiV3KbsByKbIdData,
  PatchApiV3KbsByKbIdError,
  PatchApiV3KbsByKbIdResponse,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesData,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesError,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesResponse,
  PostApiConfluenceV1TenantsByTenantIdCallbackData,
  PostApiConfluenceV1TenantsByTenantIdCallbackError,
  PostApiConfluenceV1TenantsByTenantIdCallbackResponse,
  PostApiConfluenceV1TenantsByTenantIdConnectData,
  PostApiConfluenceV1TenantsByTenantIdConnectError,
  PostApiConfluenceV1TenantsByTenantIdConnectResponse,
  PostApiConfluenceV1TenantsData,
  PostApiConfluenceV1TenantsError,
  PostApiConfluenceV1TenantsResponse,
  PostApiDebugV1BackgroundTaskErrorData,
  PostApiDebugV1BackgroundTaskErrorResponse,
  PostApiDebugV1OpenfgaCheckData,
  PostApiDebugV1OpenfgaCheckError,
  PostApiDebugV1OpenfgaCheckResponse,
  PostApiDebugV1OpenfgaReadTuplesData,
  PostApiDebugV1OpenfgaReadTuplesError,
  PostApiDebugV1OpenfgaReadTuplesResponse,
  PostApiDebugV1OpenfgaWriteTuplesData,
  PostApiDebugV1OpenfgaWriteTuplesError,
  PostApiDebugV1OpenfgaWriteTuplesResponse,
  PostApiDebugV1SearchReindexData,
  PostApiDebugV1SearchReindexError,
  PostApiDebugV1SearchReindexResponse,
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerData,
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerError,
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponse,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveData,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveError,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponse,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectData,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectError,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponse,
  PostApiEntraV1TenantsByTenantIdProposedActionsData,
  PostApiEntraV1TenantsByTenantIdProposedActionsError,
  PostApiEntraV1TenantsByTenantIdProposedActionsResponse,
  PostApiEntraV1TenantsData,
  PostApiEntraV1TenantsError,
  PostApiEntraV1TenantsResponse,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesError,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponse,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersError,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponse,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesData,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesError,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponse,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyData,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyError,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponse,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsData,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsError,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse,
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookData,
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookError,
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponse,
  PostApiFreshserviceV1TenantsData,
  PostApiFreshserviceV1TenantsError,
  PostApiFreshserviceV1TenantsResponse,
  PostApiHubspotV1ActionsCreateThreadOnTicketData,
  PostApiHubspotV1ActionsCreateThreadOnTicketError,
  PostApiHubspotV1ActionsCreateThreadOnTicketResponse,
  PostApiHubspotV1ActionsReplyToThreadData,
  PostApiHubspotV1ActionsReplyToThreadError,
  PostApiHubspotV1ActionsReplyToThreadResponse,
  PostApiHubspotV1ActionsUpdateNoteData,
  PostApiHubspotV1ActionsUpdateNoteError,
  PostApiHubspotV1ActionsUpdateNoteResponse,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerData,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerError,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponse,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusData,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusError,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponse,
  PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesData,
  PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesError,
  PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponse,
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteData,
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteError,
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponse,
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldData,
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldError,
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponse,
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsData,
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsError,
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponse,
  PostApiJiraV1TenantsData,
  PostApiJiraV1TenantsError,
  PostApiJiraV1TenantsResponse,
  PostApiJiraV2TenantsByTenantIdActionsPostCommentData,
  PostApiJiraV2TenantsByTenantIdActionsPostCommentError,
  PostApiJiraV2TenantsByTenantIdActionsPostCommentResponse,
  PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryData,
  PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryError,
  PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponse,
  PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksData,
  PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksError,
  PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponse,
  PostApiNotionV1TenantsByTenantIdActionsPagesData,
  PostApiNotionV1TenantsByTenantIdActionsPagesError,
  PostApiNotionV1TenantsByTenantIdActionsPagesResponse,
  PostApiNotionV1TenantsByTenantIdCallbackData,
  PostApiNotionV1TenantsByTenantIdCallbackError,
  PostApiNotionV1TenantsByTenantIdCallbackResponse,
  PostApiNotionV1TenantsByTenantIdConnectData,
  PostApiNotionV1TenantsByTenantIdConnectError,
  PostApiNotionV1TenantsByTenantIdConnectResponse,
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenData,
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenError,
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponse,
  PostApiNotionV1TenantsData,
  PostApiNotionV1TenantsError,
  PostApiNotionV1TenantsResponse,
  PostApiOutlookV1ActionsAddEmailAttachmentData,
  PostApiOutlookV1ActionsAddEmailAttachmentError,
  PostApiOutlookV1ActionsAddEmailAttachmentResponse,
  PostApiOutlookV1ActionsCopyEmailData,
  PostApiOutlookV1ActionsCopyEmailError,
  PostApiOutlookV1ActionsCopyEmailResponse,
  PostApiOutlookV1ActionsCreateDraftData,
  PostApiOutlookV1ActionsCreateDraftError,
  PostApiOutlookV1ActionsCreateDraftResponse,
  PostApiOutlookV1ActionsDeleteEmailData,
  PostApiOutlookV1ActionsDeleteEmailError,
  PostApiOutlookV1ActionsDeleteEmailResponse,
  PostApiOutlookV1ActionsForwardEmailData,
  PostApiOutlookV1ActionsForwardEmailError,
  PostApiOutlookV1ActionsForwardEmailResponse,
  PostApiOutlookV1ActionsGetEmailAttachmentData,
  PostApiOutlookV1ActionsGetEmailAttachmentError,
  PostApiOutlookV1ActionsGetEmailAttachmentResponse,
  PostApiOutlookV1ActionsMarkEmailReadData,
  PostApiOutlookV1ActionsMarkEmailReadError,
  PostApiOutlookV1ActionsMarkEmailReadResponse,
  PostApiOutlookV1ActionsMoveEmailData,
  PostApiOutlookV1ActionsMoveEmailError,
  PostApiOutlookV1ActionsMoveEmailResponse,
  PostApiOutlookV1ActionsRemoveEmailAttachmentData,
  PostApiOutlookV1ActionsRemoveEmailAttachmentError,
  PostApiOutlookV1ActionsRemoveEmailAttachmentResponse,
  PostApiOutlookV1ActionsReplyEmailData,
  PostApiOutlookV1ActionsReplyEmailError,
  PostApiOutlookV1ActionsReplyEmailResponse,
  PostApiOutlookV1ActionsSendEmailData,
  PostApiOutlookV1ActionsSendEmailError,
  PostApiOutlookV1ActionsSendEmailResponse,
  PostApiOutlookV1ActionsSetEmailCategoriesData,
  PostApiOutlookV1ActionsSetEmailCategoriesError,
  PostApiOutlookV1ActionsSetEmailCategoriesResponse,
  PostApiOutlookV1ActionsSetEmailFlagData,
  PostApiOutlookV1ActionsSetEmailFlagError,
  PostApiOutlookV1ActionsSetEmailFlagResponse,
  PostApiOutlookV1ActionsSetEmailImportanceData,
  PostApiOutlookV1ActionsSetEmailImportanceError,
  PostApiOutlookV1ActionsSetEmailImportanceResponse,
  PostApiOutlookV2SubscriptionsData,
  PostApiOutlookV2SubscriptionsError,
  PostApiOutlookV2SubscriptionsResponse,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsData,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsError,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponse,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsData,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsError,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponse,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneError,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponse,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteError,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponse,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsError,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponse,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesError,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponse,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesError,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponse,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeError,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponse,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoError,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponse,
  PostApiPlainV1TenantsByTenantIdActionsThreadsData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsError,
  PostApiPlainV1TenantsByTenantIdActionsThreadsResponse,
  PostApiPlainV1TenantsData,
  PostApiPlainV1TenantsError,
  PostApiPlainV1TenantsResponse,
  PostApiPublicFreshserviceV1WebhooksByTenantIdData,
  PostApiPublicFreshserviceV1WebhooksByTenantIdError,
  PostApiPublicFreshserviceV1WebhooksByTenantIdResponse,
  PostApiPublicHubspotV1EventsByTenantIdData,
  PostApiPublicHubspotV1EventsByTenantIdError,
  PostApiPublicHubspotV1EventsByTenantIdResponse,
  PostApiPublicJiraV1EventsData,
  PostApiPublicJiraV1EventsResponse,
  PostApiPublicNotionV1WebhooksIngestByTenantIdData,
  PostApiPublicNotionV1WebhooksIngestByTenantIdError,
  PostApiPublicNotionV1WebhooksIngestByTenantIdResponse,
  PostApiPublicOauthV1ByOauthApplicationIdIntrospectData,
  PostApiPublicOauthV1ByOauthApplicationIdIntrospectError,
  PostApiPublicOauthV1ByOauthApplicationIdTokenData,
  PostApiPublicOauthV1ByOauthApplicationIdTokenError,
  PostApiPublicOauthV1TokenData,
  PostApiPublicOutlookV2SubscriptionsEventsData,
  PostApiPublicOutlookV2SubscriptionsEventsError,
  PostApiPublicOutlookV2SubscriptionsLifecycleData,
  PostApiPublicOutlookV2SubscriptionsLifecycleError,
  PostApiPublicPlainV1WebhooksIngestByTenantIdData,
  PostApiPublicPlainV1WebhooksIngestByTenantIdError,
  PostApiPublicPlainV1WebhooksIngestByTenantIdResponse,
  PostApiPublicServiceNowV1WebhooksData,
  PostApiPublicServiceNowV1WebhooksError,
  PostApiPublicServiceNowV1WebhooksResponse,
  PostApiPublicSharepointV1LifecycleByTenantIdData,
  PostApiPublicSharepointV1LifecycleByTenantIdError,
  PostApiPublicSharepointV1NotificationsByTenantIdData,
  PostApiPublicSharepointV1NotificationsByTenantIdError,
  PostApiPublicSlackV2TenantsByTenantIdEventsData,
  PostApiPublicSlackV2TenantsByTenantIdEventsError,
  PostApiPublicSlackV2TenantsByTenantIdEventsResponse,
  PostApiPublicSlackV2TenantsByTenantIdInteractivityData,
  PostApiPublicSlackV2TenantsByTenantIdInteractivityError,
  PostApiPublicSlackV2TenantsByTenantIdInteractivityResponse,
  PostApiPublicV1SalesforceOauthTokenByTenantIdData,
  PostApiPublicV1SalesforceOauthTokenByTenantIdError,
  PostApiPublicV1SalesforceOauthTokenByTenantIdResponse,
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdData,
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdError,
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponse,
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesData,
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesError,
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponse,
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdData,
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdError,
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponse,
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesData,
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesError,
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponse,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsData,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsError,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponse,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsData,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsError,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponse,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsData,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsError,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponse,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesData,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesError,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesResponse,
  PostApiSalesforceV1TenantsByTenantIdCallbackData,
  PostApiSalesforceV1TenantsByTenantIdCallbackError,
  PostApiSalesforceV1TenantsByTenantIdCallbackResponse,
  PostApiSalesforceV1TenantsByTenantIdConnectData,
  PostApiSalesforceV1TenantsByTenantIdConnectError,
  PostApiSalesforceV1TenantsByTenantIdConnectResponse,
  PostApiSalesforceV1TenantsData,
  PostApiSalesforceV1TenantsError,
  PostApiSalesforceV1TenantsResponse,
  PostApiSecretsVaultV1SecretsBySecretIdRestoreData,
  PostApiSecretsVaultV1SecretsBySecretIdRestoreError,
  PostApiSecretsVaultV1SecretsBySecretIdRestoreResponse,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreData,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreError,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponse,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsData,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsError,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsResponse,
  PostApiSecretsVaultV1SecretsData,
  PostApiSecretsVaultV1SecretsError,
  PostApiSecretsVaultV1SecretsResponse,
  PostApiSecretsVaultV2SecretsBySecretIdVersionsData,
  PostApiSecretsVaultV2SecretsBySecretIdVersionsError,
  PostApiSecretsVaultV2SecretsBySecretIdVersionsResponse,
  PostApiSecretsVaultV2SecretsData,
  PostApiSecretsVaultV2SecretsError,
  PostApiSecretsVaultV2SecretsResponse,
  PostApiServiceNowV1ActionsChangeAssignmentGroupData,
  PostApiServiceNowV1ActionsChangeAssignmentGroupError,
  PostApiServiceNowV1ActionsChangeAssignmentGroupResponse,
  PostApiServiceNowV1ActionsChangeIncidentStateData,
  PostApiServiceNowV1ActionsChangeIncidentStateError,
  PostApiServiceNowV1ActionsChangeIncidentStateResponse,
  PostApiServiceNowV1ActionsReplyData,
  PostApiServiceNowV1ActionsReplyError,
  PostApiServiceNowV1ActionsReplyResponse,
  PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentData,
  PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentError,
  PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponse,
  PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsData,
  PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsError,
  PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponse,
  PostApiServiceNowV1TenantsByTenantIdActionsBatchData,
  PostApiServiceNowV1TenantsByTenantIdActionsBatchError,
  PostApiServiceNowV1TenantsByTenantIdActionsBatchResponse,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksData,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksError,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponse,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesData,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesError,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesResponse,
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsData,
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsError,
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponse,
  PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsData,
  PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsError,
  PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponse,
  PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerData,
  PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerError,
  PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponse,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionData,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionError,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponse,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlData,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlError,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponse,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionData,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionError,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponse,
  PostApiSharepointV1TenantsByTenantIdCallbackData,
  PostApiSharepointV1TenantsByTenantIdCallbackError,
  PostApiSharepointV1TenantsByTenantIdCallbackResponse,
  PostApiSharepointV1TenantsByTenantIdConnectData,
  PostApiSharepointV1TenantsByTenantIdConnectError,
  PostApiSharepointV1TenantsByTenantIdConnectResponse,
  PostApiSharepointV1TenantsByTenantIdFolderScopesData,
  PostApiSharepointV1TenantsByTenantIdFolderScopesError,
  PostApiSharepointV1TenantsByTenantIdFolderScopesResponse,
  PostApiSharepointV1TenantsByTenantIdSitesData,
  PostApiSharepointV1TenantsByTenantIdSitesError,
  PostApiSharepointV1TenantsByTenantIdSitesGrantData,
  PostApiSharepointV1TenantsByTenantIdSitesGrantError,
  PostApiSharepointV1TenantsByTenantIdSitesGrantResponse,
  PostApiSharepointV1TenantsByTenantIdSitesResponse,
  PostApiSharepointV1TenantsData,
  PostApiSharepointV1TenantsError,
  PostApiSharepointV1TenantsResponse,
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleData,
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleError,
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponse,
  PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsData,
  PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsError,
  PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponse,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupData,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupError,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponse,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersData,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersError,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponse,
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenData,
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenError,
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponse,
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeData,
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeError,
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponse,
  PostApiSlackV1TenantsByTenantIdActionsViewsPushData,
  PostApiSlackV1TenantsByTenantIdActionsViewsPushError,
  PostApiSlackV1TenantsByTenantIdActionsViewsPushResponse,
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateData,
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateError,
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponse,
  PostApiSlackV1TenantsByTenantIdCallbackData,
  PostApiSlackV1TenantsByTenantIdCallbackError,
  PostApiSlackV1TenantsByTenantIdCallbackResponse,
  PostApiSlackV1TenantsByTenantIdConnectData,
  PostApiSlackV1TenantsByTenantIdConnectError,
  PostApiSlackV1TenantsByTenantIdConnectResponse,
  PostApiSlackV1TenantsData,
  PostApiSlackV1TenantsError,
  PostApiSlackV1TenantsResponse,
  PostApiSlackV2TenantsByTenantIdActionsAddReactionData,
  PostApiSlackV2TenantsByTenantIdActionsAddReactionError,
  PostApiSlackV2TenantsByTenantIdActionsAddReactionResponse,
  PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadData,
  PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadError,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentData,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentError,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponse,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadData,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadError,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponse,
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageData,
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageError,
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponse,
  PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusData,
  PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusError,
  PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponse,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionData,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionError,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponse,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicData,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicError,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponse,
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageData,
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageError,
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponse,
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionData,
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionError,
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponse,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListData,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListError,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponse,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetData,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetError,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponse,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListData,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListError,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponse,
  PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadData,
  PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadError,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteData,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteError,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponse,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostData,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostError,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponse,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveData,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveError,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponse,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateData,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateError,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponse,
  PostApiTeamsV1TenantsByTenantIdIconsData,
  PostApiTeamsV1TenantsByTenantIdIconsError,
  PostApiTeamsV1TenantsByTenantIdIconsResponse,
  PostApiTeamsV1TenantsData,
  PostApiTeamsV1TenantsError,
  PostApiTeamsV1TenantsResponse,
  PostApiV1AgentSessionInferenceByAgentSessionIdData,
  PostApiV1AgentSessionInferenceByAgentSessionIdError,
  PostApiV1AgentSessionInferenceByAgentSessionIdResponse,
  PostApiV1AgentSessionsByAgentSessionIdMessagesData,
  PostApiV1AgentSessionsByAgentSessionIdMessagesError,
  PostApiV1AgentSessionsByAgentSessionIdMessagesResponse,
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncData,
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncError,
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponse,
  PostApiV1AgentSessionsByAgentSessionIdStopData,
  PostApiV1AgentSessionsByAgentSessionIdStopError,
  PostApiV1AgentSessionsByAgentSessionIdStopResponse,
  PostApiV1AgentSessionsData,
  PostApiV1AgentSessionsError,
  PostApiV1AgentSessionsResponse,
  PostApiV1ApiKeysData,
  PostApiV1ApiKeysError,
  PostApiV1ApiKeysResponse,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsData,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsError,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponse,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreData,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreError,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponse,
  PostApiV1ArticleLineRangeCommentThreadsData,
  PostApiV1ArticleLineRangeCommentThreadsError,
  PostApiV1ArticleLineRangeCommentThreadsResponse,
  PostApiV1AttachmentsUploadUrlData,
  PostApiV1AttachmentsUploadUrlError,
  PostApiV1AttachmentsUploadUrlResponse,
  PostApiV1AuthzKbOwnersSyncData,
  PostApiV1AuthzKbOwnersSyncResponse,
  PostApiV1AuthzOrganizationsByOrgIdInvitationsData,
  PostApiV1AuthzOrganizationsByOrgIdInvitationsError,
  PostApiV1AuthzOrganizationsByOrgIdInvitationsResponse,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveData,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveError,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponse,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsError,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse,
  PostApiV1AuthzOrganizationsByOrgIdTeamsData,
  PostApiV1AuthzOrganizationsByOrgIdTeamsError,
  PostApiV1AuthzOrganizationsByOrgIdTeamsResponse,
  PostApiV1AuthzSyncArticlesToOpenfgaData,
  PostApiV1AuthzSyncArticlesToOpenfgaError,
  PostApiV1AuthzSyncArticlesToOpenfgaResponse,
  PostApiV1BrandingLogoUploadUrlData,
  PostApiV1BrandingLogoUploadUrlError,
  PostApiV1BrandingLogoUploadUrlResponse,
  PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreData,
  PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreError,
  PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponse,
  PostApiV1CalibrationFeedbackDimensionsData,
  PostApiV1CalibrationFeedbackDimensionsError,
  PostApiV1CalibrationFeedbackDimensionsResponse,
  PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreData,
  PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreError,
  PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponse,
  PostApiV1CalibrationFeedbackInferenceDatapointsData,
  PostApiV1CalibrationFeedbackInferenceDatapointsError,
  PostApiV1CalibrationFeedbackInferenceDatapointsResponse,
  PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreData,
  PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreError,
  PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponse,
  PostApiV1CalibrationFeedbackQueueItemsData,
  PostApiV1CalibrationFeedbackQueueItemsError,
  PostApiV1CalibrationFeedbackQueueItemsResponse,
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreData,
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreError,
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponse,
  PostApiV1CalibrationFeedbackVerdictsData,
  PostApiV1CalibrationFeedbackVerdictsError,
  PostApiV1CalibrationFeedbackVerdictsResponse,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsData,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsError,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponse,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreData,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreError,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponse,
  PostApiV1ChangeRequestLineRangeCommentThreadsData,
  PostApiV1ChangeRequestLineRangeCommentThreadsError,
  PostApiV1ChangeRequestLineRangeCommentThreadsResponse,
  PostApiV1ChangeRequestsByChangeRequestIdRestoreData,
  PostApiV1ChangeRequestsByChangeRequestIdRestoreError,
  PostApiV1ChangeRequestsByChangeRequestIdRestoreResponse,
  PostApiV1ChangeRequestsData,
  PostApiV1ChangeRequestsError,
  PostApiV1ChangeRequestsResponse,
  PostApiV1CommentsByCommentIdRestoreData,
  PostApiV1CommentsByCommentIdRestoreError,
  PostApiV1CommentsByCommentIdRestoreResponse,
  PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreData,
  PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreError,
  PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponse,
  PostApiV1DataDumpConversationsData,
  PostApiV1DataDumpConversationsError,
  PostApiV1DataDumpConversationsResponse,
  PostApiV1DatapointEvidenceSearchData,
  PostApiV1DatapointEvidenceSearchError,
  PostApiV1DatapointEvidenceSearchResponse,
  PostApiV1DatapointsBackfillIndexData,
  PostApiV1DatapointsBackfillIndexError,
  PostApiV1DatapointsBackfillIndexResponse,
  PostApiV1DatapointsEmbedData,
  PostApiV1DatapointsEmbedError,
  PostApiV1DatapointsEmbedResponse,
  PostApiV1DatapointsRegexSearchData,
  PostApiV1DatapointsRegexSearchError,
  PostApiV1DatapointsRegexSearchResponse,
  PostApiV1DatapointsSearchData,
  PostApiV1DatapointsSearchError,
  PostApiV1DatapointsSearchResponse,
  PostApiV1ExternalInferencesData,
  PostApiV1ExternalInferencesError,
  PostApiV1ExternalInferencesResponse,
  PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesData,
  PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesError,
  PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponse,
  PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreData,
  PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreError,
  PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponse,
  PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsData,
  PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsError,
  PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponse,
  PostApiV1FullEvaluatedInferenceDatapointsSearchData,
  PostApiV1FullEvaluatedInferenceDatapointsSearchError,
  PostApiV1FullEvaluatedInferenceDatapointsSearchResponse,
  PostApiV1HubspotTenantsData,
  PostApiV1HubspotTenantsError,
  PostApiV1HubspotTenantsResponse,
  PostApiV1ImageAttachmentsUploadUrlData,
  PostApiV1ImageAttachmentsUploadUrlError,
  PostApiV1ImageAttachmentsUploadUrlResponse,
  PostApiV1InferenceConversationsByExternalIdRestoreData,
  PostApiV1InferenceConversationsByExternalIdRestoreError,
  PostApiV1InferenceConversationsByExternalIdRestoreResponse,
  PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreData,
  PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreError,
  PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponse,
  PostApiV1IngestionKnowledgeBasesIngestionFilesData,
  PostApiV1IngestionKnowledgeBasesIngestionFilesError,
  PostApiV1IngestionKnowledgeBasesIngestionFilesResponse,
  PostApiV1IngestionSupportIngestionFilesData,
  PostApiV1IngestionSupportIngestionFilesError,
  PostApiV1IngestionSupportIngestionFilesResponse,
  PostApiV1JudgesByJudgeIdRestoreData,
  PostApiV1JudgesByJudgeIdRestoreError,
  PostApiV1JudgesByJudgeIdRestoreResponse,
  PostApiV1JudgesData,
  PostApiV1JudgesError,
  PostApiV1JudgesResponse,
  PostApiV1JudgesSyncData,
  PostApiV1JudgesSyncResponse,
  PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreData,
  PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreError,
  PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponse,
  PostApiV1KbAttachmentsUploadUrlData,
  PostApiV1KbAttachmentsUploadUrlError,
  PostApiV1KbAttachmentsUploadUrlResponse,
  PostApiV1KbsByKbIdEmbeddingSearchData,
  PostApiV1KbsByKbIdEmbeddingSearchError,
  PostApiV1KbsByKbIdEmbeddingSearchResponse,
  PostApiV1KbsByKbIdHybridSearchData,
  PostApiV1KbsByKbIdHybridSearchError,
  PostApiV1KbsByKbIdHybridSearchResponse,
  PostApiV1KbsByKbIdRegexSearchData,
  PostApiV1KbsByKbIdRegexSearchError,
  PostApiV1KbsByKbIdRegexSearchResponse,
  PostApiV1KbsData,
  PostApiV1KbsError,
  PostApiV1KbSimulationDatapointsBatchData,
  PostApiV1KbSimulationDatapointsBatchError,
  PostApiV1KbSimulationDatapointsBatchResponse,
  PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreData,
  PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreError,
  PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponse,
  PostApiV1KbSimulationDatapointsData,
  PostApiV1KbSimulationDatapointsError,
  PostApiV1KbSimulationDatapointsResponse,
  PostApiV1KbSimulationResultJudgementsBatchData,
  PostApiV1KbSimulationResultJudgementsBatchError,
  PostApiV1KbSimulationResultJudgementsBatchResponse,
  PostApiV1KbSimulationResultsBatchData,
  PostApiV1KbSimulationResultsBatchError,
  PostApiV1KbSimulationResultsBatchResponse,
  PostApiV1KbSimulationResultsBySimulationResultIdJudgementsData,
  PostApiV1KbSimulationResultsBySimulationResultIdJudgementsError,
  PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponse,
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreData,
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreError,
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponse,
  PostApiV1KbSimulationResultsData,
  PostApiV1KbSimulationResultsError,
  PostApiV1KbSimulationResultsResponse,
  PostApiV1KbsResponse,
  PostApiV1MachineUsersByMachineUserIdApiKeysData,
  PostApiV1MachineUsersByMachineUserIdApiKeysError,
  PostApiV1MachineUsersByMachineUserIdApiKeysResponse,
  PostApiV1MachineUsersData,
  PostApiV1MachineUsersError,
  PostApiV1MachineUsersResponse,
  PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretData,
  PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretError,
  PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponse,
  PostApiV1OauthApplicationsData,
  PostApiV1OauthApplicationsError,
  PostApiV1OauthApplicationsResponse,
  PostApiV1PipelinesCreateInferenceDatapointsDequeueData,
  PostApiV1PipelinesCreateInferenceDatapointsDequeueError,
  PostApiV1PipelinesCreateInferenceDatapointsDequeueResponse,
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueData,
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueError,
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponse,
  PostApiV1PipelinesCreateInferenceDatapointsInputData,
  PostApiV1PipelinesCreateInferenceDatapointsInputError,
  PostApiV1PipelinesCreateInferenceDatapointsInputResponse,
  PostApiV1PipelinesCreateInferenceDatapointsOutputData,
  PostApiV1PipelinesCreateInferenceDatapointsOutputError,
  PostApiV1PipelinesCreateInferenceDatapointsOutputResponse,
  PostApiV1PipelinesCreateProdEvalsDequeueData,
  PostApiV1PipelinesCreateProdEvalsDequeueError,
  PostApiV1PipelinesCreateProdEvalsDequeueResponse,
  PostApiV1PipelinesCreateProdEvalsEnqueueData,
  PostApiV1PipelinesCreateProdEvalsEnqueueError,
  PostApiV1PipelinesCreateProdEvalsEnqueueResponse,
  PostApiV1PipelinesCreateProdEvalsInputData,
  PostApiV1PipelinesCreateProdEvalsInputError,
  PostApiV1PipelinesCreateProdEvalsInputResponse,
  PostApiV1PipelinesCreateProdEvalsOutputData,
  PostApiV1PipelinesCreateProdEvalsOutputError,
  PostApiV1PipelinesCreateProdEvalsOutputResponse,
  PostApiV1PipelinesExtractDataDumpConversationsDequeueData,
  PostApiV1PipelinesExtractDataDumpConversationsDequeueError,
  PostApiV1PipelinesExtractDataDumpConversationsDequeueResponse,
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueData,
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueError,
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponse,
  PostApiV1PipelinesExtractDataDumpConversationsInputData,
  PostApiV1PipelinesExtractDataDumpConversationsInputError,
  PostApiV1PipelinesExtractDataDumpConversationsInputResponse,
  PostApiV1PipelinesExtractDataDumpConversationsOutputData,
  PostApiV1PipelinesExtractDataDumpConversationsOutputError,
  PostApiV1PipelinesExtractDataDumpConversationsOutputResponse,
  PostApiV1PipelinesExtractDatapointsDequeueData,
  PostApiV1PipelinesExtractDatapointsDequeueError,
  PostApiV1PipelinesExtractDatapointsDequeueResponse,
  PostApiV1PipelinesExtractDatapointsEnqueueData,
  PostApiV1PipelinesExtractDatapointsEnqueueError,
  PostApiV1PipelinesExtractDatapointsEnqueueResponse,
  PostApiV1PipelinesExtractDatapointsInputData,
  PostApiV1PipelinesExtractDatapointsInputError,
  PostApiV1PipelinesExtractDatapointsInputResponse,
  PostApiV1PipelinesExtractDatapointsOutputData,
  PostApiV1PipelinesExtractDatapointsOutputError,
  PostApiV1PipelinesExtractDatapointsOutputResponse,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueData,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueError,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponse,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueData,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueError,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponse,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputData,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputError,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponse,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputData,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputError,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponse,
  PostApiV1PipelinesFinalizeConversationsDequeueData,
  PostApiV1PipelinesFinalizeConversationsDequeueError,
  PostApiV1PipelinesFinalizeConversationsDequeueResponse,
  PostApiV1PipelinesFinalizeConversationsEnqueueData,
  PostApiV1PipelinesFinalizeConversationsEnqueueError,
  PostApiV1PipelinesFinalizeConversationsEnqueueResponse,
  PostApiV1PipelinesFinalizeConversationsInputData,
  PostApiV1PipelinesFinalizeConversationsInputError,
  PostApiV1PipelinesFinalizeConversationsInputResponse,
  PostApiV1PipelinesFinalizeConversationsOutputData,
  PostApiV1PipelinesFinalizeConversationsOutputError,
  PostApiV1PipelinesFinalizeConversationsOutputResponse,
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueData,
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueError,
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponse,
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueData,
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueError,
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponse,
  PostApiV1PipelinesFinetuneKnowledgeBasesInputData,
  PostApiV1PipelinesFinetuneKnowledgeBasesInputError,
  PostApiV1PipelinesFinetuneKnowledgeBasesInputResponse,
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputData,
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputError,
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponse,
  PostApiV1PipelinesKanonicalizeDatapointsDequeueData,
  PostApiV1PipelinesKanonicalizeDatapointsDequeueError,
  PostApiV1PipelinesKanonicalizeDatapointsDequeueResponse,
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueData,
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueError,
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponse,
  PostApiV1PipelinesKanonicalizeDatapointsInputData,
  PostApiV1PipelinesKanonicalizeDatapointsInputError,
  PostApiV1PipelinesKanonicalizeDatapointsInputResponse,
  PostApiV1PipelinesKanonicalizeDatapointsOutputData,
  PostApiV1PipelinesKanonicalizeDatapointsOutputError,
  PostApiV1PipelinesKanonicalizeDatapointsOutputResponse,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendData,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendError,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponse,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickData,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickError,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponse,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitData,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitError,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponse,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeData,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeError,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponse,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseData,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseError,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponse,
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreData,
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreError,
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponse,
  PostApiV1ReposByRepositoryIdBranchesData,
  PostApiV1ReposByRepositoryIdBranchesError,
  PostApiV1ReposByRepositoryIdBranchesResponse,
  PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentData,
  PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentError,
  PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponse,
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagData,
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagError,
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponse,
  PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateData,
  PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateError,
  PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponse,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestData,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestError,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponse,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentData,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentError,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponse,
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyData,
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyError,
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponse,
  PostApiV1ServiceNowTenantsByTenantIdArticlesData,
  PostApiV1ServiceNowTenantsByTenantIdArticlesError,
  PostApiV1ServiceNowTenantsByTenantIdArticlesResponse,
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData,
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesError,
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse,
  PostApiV1ServiceNowTenantsByTenantIdRestoreData,
  PostApiV1ServiceNowTenantsByTenantIdRestoreError,
  PostApiV1ServiceNowTenantsByTenantIdRestoreResponse,
  PostApiV1ServiceNowTenantsByTenantIdSetupData,
  PostApiV1ServiceNowTenantsByTenantIdSetupError,
  PostApiV1ServiceNowTenantsByTenantIdSetupResponse,
  PostApiV1ServiceNowTenantsByTenantIdTagsData,
  PostApiV1ServiceNowTenantsByTenantIdTagsError,
  PostApiV1ServiceNowTenantsByTenantIdTagsResponse,
  PostApiV1ServiceNowTenantsData,
  PostApiV1ServiceNowTenantsError,
  PostApiV1ServiceNowTenantsResponse,
  PostApiV1SesameEdraAccessData,
  PostApiV1SesameEdraAccessError,
  PostApiV1SesameEdraAccessResponse,
  PostApiV1TasksByTaskIdFeedbackLabelsData,
  PostApiV1TasksByTaskIdFeedbackLabelsError,
  PostApiV1TasksByTaskIdFeedbackLabelsResponse,
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackData,
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackError,
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponse,
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsData,
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsError,
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponse,
  PostApiV1TasksByTaskIdPromptsData,
  PostApiV1TasksByTaskIdPromptsError,
  PostApiV1TasksByTaskIdPromptsResponse,
  PostApiV1UsersBotData,
  PostApiV1UsersBotError,
  PostApiV1UsersBotResponse,
  PostApiV1UsersByUserIdRestoreData,
  PostApiV1UsersByUserIdRestoreError,
  PostApiV1UsersByUserIdRestoreResponse,
  PostApiV1WorkClaimsByClaimIdCompleteData,
  PostApiV1WorkClaimsByClaimIdCompleteError,
  PostApiV1WorkClaimsByClaimIdCompleteResponse,
  PostApiV1WorkClaimsData,
  PostApiV1WorkClaimsError,
  PostApiV1WorkClaimsResponse,
  PostApiV1WorkEventsData,
  PostApiV1WorkEventsError,
  PostApiV1WorkEventsResponse,
  PostApiV1WorkflowAnalyticsEventsData,
  PostApiV1WorkflowAnalyticsEventsError,
  PostApiV1WorkflowAnalyticsEventsResponse,
  PostApiV1WorkspacesByWorkspaceIdRestoreData,
  PostApiV1WorkspacesByWorkspaceIdRestoreError,
  PostApiV1WorkspacesByWorkspaceIdRestoreResponse,
  PostApiV1WorkspacesData,
  PostApiV1WorkspacesResponse,
  PostApiV1ZendeskTenantsByTenantIdCallbackData,
  PostApiV1ZendeskTenantsByTenantIdCallbackError,
  PostApiV1ZendeskTenantsByTenantIdCallbackResponse,
  PostApiV1ZendeskTenantsByTenantIdConnectData,
  PostApiV1ZendeskTenantsByTenantIdConnectError,
  PostApiV1ZendeskTenantsByTenantIdConnectResponse,
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionData,
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionError,
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponse,
  PostApiV1ZendeskTenantsData,
  PostApiV1ZendeskTenantsError,
  PostApiV1ZendeskTenantsResponse,
  PostApiV2AttachmentsUploadUrlData,
  PostApiV2AttachmentsUploadUrlError,
  PostApiV2AttachmentsUploadUrlResponse,
  PostApiV2ConversationsByExternalIdFeedbackData,
  PostApiV2ConversationsByExternalIdFeedbackError,
  PostApiV2ConversationsByExternalIdFeedbackResponse,
  PostApiV2ConversationsByExternalIdMessagesData,
  PostApiV2ConversationsByExternalIdMessagesError,
  PostApiV2ConversationsByExternalIdMessagesResponse,
  PostApiV2ConversationsByExternalIdStatefulInferenceData,
  PostApiV2ConversationsByExternalIdStatefulInferenceError,
  PostApiV2ConversationsByExternalIdStatefulInferenceResponse,
  PostApiV2ConversationsByExternalIdStatelessInferenceData,
  PostApiV2ConversationsByExternalIdStatelessInferenceError,
  PostApiV2ConversationsByExternalIdStatelessInferenceResponse,
  PostApiV2DatapointsByDatapointIdRestoreData,
  PostApiV2DatapointsByDatapointIdRestoreError,
  PostApiV2DatapointsByDatapointIdRestoreResponse,
  PostApiV2FinalizedConversationsData,
  PostApiV2FinalizedConversationsError,
  PostApiV2FinalizedConversationsResponse,
  PostApiV2InferenceConversationsByExternalIdMessagesData,
  PostApiV2InferenceConversationsByExternalIdMessagesError,
  PostApiV2InferenceConversationsByExternalIdMessagesResponse,
  PostApiV2InferenceConversationsByExternalIdStatefulInferenceData,
  PostApiV2InferenceConversationsByExternalIdStatefulInferenceError,
  PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponse,
  PostApiV2InferenceConversationsByExternalIdStatelessInferenceData,
  PostApiV2InferenceConversationsByExternalIdStatelessInferenceError,
  PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponse,
  PostApiV2InferenceDatapointsData,
  PostApiV2InferenceDatapointsError,
  PostApiV2InferenceDatapointsResponse,
  PostApiV2JudgementsData,
  PostApiV2JudgementsError,
  PostApiV2JudgementsResponse,
  PostApiV2JudgesBulkData,
  PostApiV2JudgesBulkError,
  PostApiV2JudgesBulkResponse,
  PostApiV2JudgesData,
  PostApiV2JudgesError,
  PostApiV2JudgesResponse,
  PostApiV2KanonicalDatapointsData,
  PostApiV2KanonicalDatapointsError,
  PostApiV2KanonicalDatapointsResponse,
  PostApiV2KbsByKbIdEmbedData,
  PostApiV2KbsByKbIdEmbedError,
  PostApiV2KbsByKbIdEmbedResponse,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateData,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateError,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponse,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateData,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateError,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponse,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateData,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateError,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponse,
  PostApiV2TasksByTaskIdRestoreData,
  PostApiV2TasksByTaskIdRestoreError,
  PostApiV2TasksByTaskIdRestoreResponse,
  PostApiV2TasksData,
  PostApiV2TasksError,
  PostApiV2TasksResponse,
  PostApiV3DatapointsData,
  PostApiV3DatapointsError,
  PostApiV3DatapointsResponse,
  PostApiV3JudgementsData,
  PostApiV3JudgementsError,
  PostApiV3JudgementsResponse,
  PostApiV3KbsByKbIdRestoreData,
  PostApiV3KbsByKbIdRestoreError,
  PostApiV3KbsByKbIdRestoreResponse,
  PostApiZendeskV1ActionsReplyToTicketData,
  PostApiZendeskV1ActionsReplyToTicketError,
  PostApiZendeskV1ActionsReplyToTicketResponse,
  PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsData,
  PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsError,
  PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponse,
  PutApiDebugV1ValkeyValuesByKeyData,
  PutApiDebugV1ValkeyValuesByKeyError,
  PutApiDebugV1ValkeyValuesByKeyResponse,
  PutApiPlainV1TenantsByTenantIdActionsCompaniesData,
  PutApiPlainV1TenantsByTenantIdActionsCompaniesError,
  PutApiPlainV1TenantsByTenantIdActionsCompaniesResponse,
  PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyData,
  PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyError,
  PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponse,
  PutApiPlainV1TenantsByTenantIdActionsCustomersData,
  PutApiPlainV1TenantsByTenantIdActionsCustomersError,
  PutApiPlainV1TenantsByTenantIdActionsCustomersResponse,
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsData,
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsError,
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponse,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeError,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponse,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfData,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfError,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponse,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyData,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyError,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponse,
  PutApiSalesforceV1TenantsByTenantIdIngestClientData,
  PutApiSalesforceV1TenantsByTenantIdIngestClientError,
  PutApiSalesforceV1TenantsByTenantIdIngestClientResponse,
  PutApiV1AuthzOrganizationsByExternalIdData,
  PutApiV1AuthzOrganizationsByExternalIdError,
  PutApiV1AuthzOrganizationsByExternalIdResponse,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdData,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdError,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponse,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesError,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponse,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdData,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdError,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponse,
  PutApiV1SesameOrgMemberRolesData,
  PutApiV1SesameOrgMemberRolesError,
  PutApiV1SesameOrgMemberRolesResponse,
  PutApiV1SesameOrgMembershipsData,
  PutApiV1SesameOrgMembershipsError,
  PutApiV1SesameOrgMembershipsResponse,
  PutApiV1UsersExternalByExternalIdData,
  PutApiV1UsersExternalByExternalIdError,
  PutApiV1UsersExternalByExternalIdResponse,
  PutApiV2ConversationsByExternalIdData,
  PutApiV2ConversationsByExternalIdError,
  PutApiV2ConversationsByExternalIdResponse,
  PutApiV2InferenceConversationsByExternalIdData,
  PutApiV2InferenceConversationsByExternalIdError,
  PutApiV2InferenceConversationsByExternalIdResponse,
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextData,
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextError,
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponse,
} from "../types.gen";

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl:
      options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getApiV1AgentSessionInferenceByAgentSessionIdQueryKey = (
  options: Options<GetApiV1AgentSessionInferenceByAgentSessionIdData>,
) =>
  createQueryKey(
    "get_api_v1_agent_session_inference_by_agent_session_id",
    options,
  );

/**
 * Get Agent Session Inferences V1
 */
export const getApiV1AgentSessionInferenceByAgentSessionIdOptions = (
  options: Options<GetApiV1AgentSessionInferenceByAgentSessionIdData>,
) =>
  queryOptions<
    GetApiV1AgentSessionInferenceByAgentSessionIdResponse,
    GetApiV1AgentSessionInferenceByAgentSessionIdError,
    GetApiV1AgentSessionInferenceByAgentSessionIdResponse,
    ReturnType<typeof getApiV1AgentSessionInferenceByAgentSessionIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_agent_session_inferences_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AgentSessionInferenceByAgentSessionIdQueryKey(options),
  });

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">,
>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const getApiV1AgentSessionInferenceByAgentSessionIdInfiniteQueryKey = (
  options: Options<GetApiV1AgentSessionInferenceByAgentSessionIdData>,
): QueryKey<Options<GetApiV1AgentSessionInferenceByAgentSessionIdData>> =>
  createQueryKey(
    "get_api_v1_agent_session_inference_by_agent_session_id",
    options,
    true,
  );

/**
 * Get Agent Session Inferences V1
 */
export const getApiV1AgentSessionInferenceByAgentSessionIdInfiniteOptions = (
  options: Options<GetApiV1AgentSessionInferenceByAgentSessionIdData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1AgentSessionInferenceByAgentSessionIdResponse,
    GetApiV1AgentSessionInferenceByAgentSessionIdError,
    InfiniteData<GetApiV1AgentSessionInferenceByAgentSessionIdResponse>,
    QueryKey<Options<GetApiV1AgentSessionInferenceByAgentSessionIdData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1AgentSessionInferenceByAgentSessionIdData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiV1AgentSessionInferenceByAgentSessionIdData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_agent_session_inferences_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AgentSessionInferenceByAgentSessionIdInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Agent Session Inference V1
 */
export const postApiV1AgentSessionInferenceByAgentSessionIdMutation = (
  options?: Partial<
    Options<PostApiV1AgentSessionInferenceByAgentSessionIdData>
  >,
): UseMutationOptions<
  PostApiV1AgentSessionInferenceByAgentSessionIdResponse,
  PostApiV1AgentSessionInferenceByAgentSessionIdError,
  Options<PostApiV1AgentSessionInferenceByAgentSessionIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1AgentSessionInferenceByAgentSessionIdResponse,
    PostApiV1AgentSessionInferenceByAgentSessionIdError,
    Options<PostApiV1AgentSessionInferenceByAgentSessionIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_agent_session_inference_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1AgentSessionsQueryKey = (
  options?: Options<GetApiV1AgentSessionsData>,
) => createQueryKey("get_api_v1_agent_sessions", options);

/**
 * Get Agent Sessions V1
 */
export const getApiV1AgentSessionsOptions = (
  options?: Options<GetApiV1AgentSessionsData>,
) =>
  queryOptions<
    GetApiV1AgentSessionsResponse,
    GetApiV1AgentSessionsError,
    GetApiV1AgentSessionsResponse,
    ReturnType<typeof getApiV1AgentSessionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_agent_sessions_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AgentSessionsQueryKey(options),
  });

export const getApiV1AgentSessionsInfiniteQueryKey = (
  options?: Options<GetApiV1AgentSessionsData>,
): QueryKey<Options<GetApiV1AgentSessionsData>> =>
  createQueryKey("get_api_v1_agent_sessions", options, true);

/**
 * Get Agent Sessions V1
 */
export const getApiV1AgentSessionsInfiniteOptions = (
  options?: Options<GetApiV1AgentSessionsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1AgentSessionsResponse,
    GetApiV1AgentSessionsError,
    InfiniteData<GetApiV1AgentSessionsResponse>,
    QueryKey<Options<GetApiV1AgentSessionsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1AgentSessionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1AgentSessionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_agent_sessions_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1AgentSessionsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Agent Session V1
 */
export const postApiV1AgentSessionsMutation = (
  options?: Partial<Options<PostApiV1AgentSessionsData>>,
): UseMutationOptions<
  PostApiV1AgentSessionsResponse,
  PostApiV1AgentSessionsError,
  Options<PostApiV1AgentSessionsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1AgentSessionsResponse,
    PostApiV1AgentSessionsError,
    Options<PostApiV1AgentSessionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_agent_session_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1FullAgentSessionsQueryKey = (
  options?: Options<GetApiV1FullAgentSessionsData>,
) => createQueryKey("get_api_v1_full_agent_sessions", options);

/**
 * Get Full Agent Sessions V1
 */
export const getApiV1FullAgentSessionsOptions = (
  options?: Options<GetApiV1FullAgentSessionsData>,
) =>
  queryOptions<
    GetApiV1FullAgentSessionsResponse,
    GetApiV1FullAgentSessionsError,
    GetApiV1FullAgentSessionsResponse,
    ReturnType<typeof getApiV1FullAgentSessionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_agent_sessions_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullAgentSessionsQueryKey(options),
  });

export const getApiV1FullAgentSessionsInfiniteQueryKey = (
  options?: Options<GetApiV1FullAgentSessionsData>,
): QueryKey<Options<GetApiV1FullAgentSessionsData>> =>
  createQueryKey("get_api_v1_full_agent_sessions", options, true);

/**
 * Get Full Agent Sessions V1
 */
export const getApiV1FullAgentSessionsInfiniteOptions = (
  options?: Options<GetApiV1FullAgentSessionsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullAgentSessionsResponse,
    GetApiV1FullAgentSessionsError,
    InfiniteData<GetApiV1FullAgentSessionsResponse>,
    QueryKey<Options<GetApiV1FullAgentSessionsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullAgentSessionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullAgentSessionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_agent_sessions_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullAgentSessionsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Agent Session V1
 */
export const deleteApiV1AgentSessionsByAgentSessionIdMutation = (
  options?: Partial<Options<DeleteApiV1AgentSessionsByAgentSessionIdData>>,
): UseMutationOptions<
  DeleteApiV1AgentSessionsByAgentSessionIdResponse,
  DeleteApiV1AgentSessionsByAgentSessionIdError,
  Options<DeleteApiV1AgentSessionsByAgentSessionIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1AgentSessionsByAgentSessionIdResponse,
    DeleteApiV1AgentSessionsByAgentSessionIdError,
    Options<DeleteApiV1AgentSessionsByAgentSessionIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_agent_session_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1AgentSessionsByAgentSessionIdQueryKey = (
  options: Options<GetApiV1AgentSessionsByAgentSessionIdData>,
) => createQueryKey("get_api_v1_agent_sessions_by_agent_session_id", options);

/**
 * Get Full Agent Session V1
 */
export const getApiV1AgentSessionsByAgentSessionIdOptions = (
  options: Options<GetApiV1AgentSessionsByAgentSessionIdData>,
) =>
  queryOptions<
    GetApiV1AgentSessionsByAgentSessionIdResponse,
    GetApiV1AgentSessionsByAgentSessionIdError,
    GetApiV1AgentSessionsByAgentSessionIdResponse,
    ReturnType<typeof getApiV1AgentSessionsByAgentSessionIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_agent_session_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AgentSessionsByAgentSessionIdQueryKey(options),
  });

/**
 * Update Agent Session V1
 */
export const patchApiV1AgentSessionsByAgentSessionIdMutation = (
  options?: Partial<Options<PatchApiV1AgentSessionsByAgentSessionIdData>>,
): UseMutationOptions<
  PatchApiV1AgentSessionsByAgentSessionIdResponse,
  PatchApiV1AgentSessionsByAgentSessionIdError,
  Options<PatchApiV1AgentSessionsByAgentSessionIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1AgentSessionsByAgentSessionIdResponse,
    PatchApiV1AgentSessionsByAgentSessionIdError,
    Options<PatchApiV1AgentSessionsByAgentSessionIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_agent_session_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1FullUserAgentSessionsQueryKey = (
  options?: Options<GetApiV1FullUserAgentSessionsData>,
) => createQueryKey("get_api_v1_full_user_agent_sessions", options);

/**
 * Get Full User Agent Sessions V1
 */
export const getApiV1FullUserAgentSessionsOptions = (
  options?: Options<GetApiV1FullUserAgentSessionsData>,
) =>
  queryOptions<
    GetApiV1FullUserAgentSessionsResponse,
    GetApiV1FullUserAgentSessionsError,
    GetApiV1FullUserAgentSessionsResponse,
    ReturnType<typeof getApiV1FullUserAgentSessionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_user_agent_sessions_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullUserAgentSessionsQueryKey(options),
  });

export const getApiV1FullUserAgentSessionsInfiniteQueryKey = (
  options?: Options<GetApiV1FullUserAgentSessionsData>,
): QueryKey<Options<GetApiV1FullUserAgentSessionsData>> =>
  createQueryKey("get_api_v1_full_user_agent_sessions", options, true);

/**
 * Get Full User Agent Sessions V1
 */
export const getApiV1FullUserAgentSessionsInfiniteOptions = (
  options?: Options<GetApiV1FullUserAgentSessionsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullUserAgentSessionsResponse,
    GetApiV1FullUserAgentSessionsError,
    InfiniteData<GetApiV1FullUserAgentSessionsResponse>,
    QueryKey<Options<GetApiV1FullUserAgentSessionsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullUserAgentSessionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullUserAgentSessionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_user_agent_sessions_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullUserAgentSessionsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Send Agent Session Message V1
 */
export const postApiV1AgentSessionsByAgentSessionIdMessagesMutation = (
  options?: Partial<
    Options<PostApiV1AgentSessionsByAgentSessionIdMessagesData>
  >,
): UseMutationOptions<
  PostApiV1AgentSessionsByAgentSessionIdMessagesResponse,
  PostApiV1AgentSessionsByAgentSessionIdMessagesError,
  Options<PostApiV1AgentSessionsByAgentSessionIdMessagesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1AgentSessionsByAgentSessionIdMessagesResponse,
    PostApiV1AgentSessionsByAgentSessionIdMessagesError,
    Options<PostApiV1AgentSessionsByAgentSessionIdMessagesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await send_agent_session_message_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Send Agent Session Message Sync V1
 *
 * Experimental endpoint that runs the agent synchronously and returns when the run completes. Currently returns only the final response message from the agent. Behaviour may change as the endpoint evolves.
 */
export const postApiV1AgentSessionsByAgentSessionIdMessagesSyncMutation = (
  options?: Partial<
    Options<PostApiV1AgentSessionsByAgentSessionIdMessagesSyncData>
  >,
): UseMutationOptions<
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponse,
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncError,
  Options<PostApiV1AgentSessionsByAgentSessionIdMessagesSyncData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponse,
    PostApiV1AgentSessionsByAgentSessionIdMessagesSyncError,
    Options<PostApiV1AgentSessionsByAgentSessionIdMessagesSyncData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await send_agent_session_message_sync_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Stop Agent Session V1
 */
export const postApiV1AgentSessionsByAgentSessionIdStopMutation = (
  options?: Partial<Options<PostApiV1AgentSessionsByAgentSessionIdStopData>>,
): UseMutationOptions<
  PostApiV1AgentSessionsByAgentSessionIdStopResponse,
  PostApiV1AgentSessionsByAgentSessionIdStopError,
  Options<PostApiV1AgentSessionsByAgentSessionIdStopData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1AgentSessionsByAgentSessionIdStopResponse,
    PostApiV1AgentSessionsByAgentSessionIdStopError,
    Options<PostApiV1AgentSessionsByAgentSessionIdStopData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await stop_agent_session_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1AgentsQueryKey = (options?: Options<GetApiV1AgentsData>) =>
  createQueryKey("get_api_v1_agents", options);

/**
 * Get Agents V1
 */
export const getApiV1AgentsOptions = (options?: Options<GetApiV1AgentsData>) =>
  queryOptions<
    GetApiV1AgentsResponse,
    DefaultError,
    GetApiV1AgentsResponse,
    ReturnType<typeof getApiV1AgentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_agents_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AgentsQueryKey(options),
  });

export const getApiV1McpToolsetsQueryKey = (
  options?: Options<GetApiV1McpToolsetsData>,
) => createQueryKey("get_api_v1_mcp_toolsets", options);

/**
 * Get Mcp Toolsets V1
 */
export const getApiV1McpToolsetsOptions = (
  options?: Options<GetApiV1McpToolsetsData>,
) =>
  queryOptions<
    GetApiV1McpToolsetsResponse,
    DefaultError,
    GetApiV1McpToolsetsResponse,
    ReturnType<typeof getApiV1McpToolsetsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_mcp_toolsets_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1McpToolsetsQueryKey(options),
  });

export const getApiV1A2aAgentsQueryKey = (
  options?: Options<GetApiV1A2aAgentsData>,
) => createQueryKey("get_api_v1_a2a_agents", options);

/**
 * Get A2A Agents V1
 */
export const getApiV1A2aAgentsOptions = (
  options?: Options<GetApiV1A2aAgentsData>,
) =>
  queryOptions<
    GetApiV1A2aAgentsResponse,
    DefaultError,
    GetApiV1A2aAgentsResponse,
    ReturnType<typeof getApiV1A2aAgentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_a2a_agents_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1A2aAgentsQueryKey(options),
  });

export const getApiV1AgentsByAgentKeyQueryKey = (
  options: Options<GetApiV1AgentsByAgentKeyData>,
) => createQueryKey("get_api_v1_agents_by_agent_key", options);

/**
 * Get Agent V1
 */
export const getApiV1AgentsByAgentKeyOptions = (
  options: Options<GetApiV1AgentsByAgentKeyData>,
) =>
  queryOptions<
    GetApiV1AgentsByAgentKeyResponse,
    GetApiV1AgentsByAgentKeyError,
    GetApiV1AgentsByAgentKeyResponse,
    ReturnType<typeof getApiV1AgentsByAgentKeyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_agent_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AgentsByAgentKeyQueryKey(options),
  });

export const getApiV1AnalyticsSectionsChartsQueryKey = (
  options?: Options<GetApiV1AnalyticsSectionsChartsData>,
) => createQueryKey("get_api_v1_analytics_sections_charts", options);

/**
 * Get Section Analytics Charts V1
 */
export const getApiV1AnalyticsSectionsChartsOptions = (
  options?: Options<GetApiV1AnalyticsSectionsChartsData>,
) =>
  queryOptions<
    GetApiV1AnalyticsSectionsChartsResponse,
    GetApiV1AnalyticsSectionsChartsError,
    GetApiV1AnalyticsSectionsChartsResponse,
    ReturnType<typeof getApiV1AnalyticsSectionsChartsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_section_analytics_charts_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AnalyticsSectionsChartsQueryKey(options),
  });

export const getApiV1AnalyticsWorkflowsChartsQueryKey = (
  options?: Options<GetApiV1AnalyticsWorkflowsChartsData>,
) => createQueryKey("get_api_v1_analytics_workflows_charts", options);

/**
 * Get Workflow Analytics Charts V1
 */
export const getApiV1AnalyticsWorkflowsChartsOptions = (
  options?: Options<GetApiV1AnalyticsWorkflowsChartsData>,
) =>
  queryOptions<
    GetApiV1AnalyticsWorkflowsChartsResponse,
    GetApiV1AnalyticsWorkflowsChartsError,
    GetApiV1AnalyticsWorkflowsChartsResponse,
    ReturnType<typeof getApiV1AnalyticsWorkflowsChartsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_workflow_analytics_charts_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AnalyticsWorkflowsChartsQueryKey(options),
  });

export const getApiV1AnalyticsOverviewsChartsQueryKey = (
  options?: Options<GetApiV1AnalyticsOverviewsChartsData>,
) => createQueryKey("get_api_v1_analytics_overviews_charts", options);

/**
 * Get Overview Analytics Charts V1
 */
export const getApiV1AnalyticsOverviewsChartsOptions = (
  options?: Options<GetApiV1AnalyticsOverviewsChartsData>,
) =>
  queryOptions<
    GetApiV1AnalyticsOverviewsChartsResponse,
    DefaultError,
    GetApiV1AnalyticsOverviewsChartsResponse,
    ReturnType<typeof getApiV1AnalyticsOverviewsChartsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_overview_analytics_charts_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AnalyticsOverviewsChartsQueryKey(options),
  });

export const getApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentQueryKey =
  (
    options: Options<GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentData>,
  ) =>
    createQueryKey(
      "get_api_v1_analytics_sections_by_section_id_charts_by_chart_key_content",
      options,
    );

/**
 * Get Section Analytics Chart Content V1
 */
export const getApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentOptions =
  (
    options: Options<GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentData>,
  ) =>
    queryOptions<
      GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponse,
      GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentError,
      GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponse,
      ReturnType<
        typeof getApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_section_analytics_chart_content_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentQueryKey(
          options,
        ),
    });

export const getApiV1AnalyticsTreesByKbIdChartsByChartKeyContentQueryKey = (
  options: Options<GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentData>,
) =>
  createQueryKey(
    "get_api_v1_analytics_trees_by_kb_id_charts_by_chart_key_content",
    options,
  );

/**
 * Get Tree Analytics Chart Content V1
 */
export const getApiV1AnalyticsTreesByKbIdChartsByChartKeyContentOptions = (
  options: Options<GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentData>,
) =>
  queryOptions<
    GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponse,
    GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentError,
    GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponse,
    ReturnType<
      typeof getApiV1AnalyticsTreesByKbIdChartsByChartKeyContentQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_tree_analytics_chart_content_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1AnalyticsTreesByKbIdChartsByChartKeyContentQueryKey(options),
  });

export const getApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentQueryKey =
  (
    options: Options<GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentData>,
  ) =>
    createQueryKey(
      "get_api_v1_analytics_knowledge_bases_by_kb_id_charts_by_chart_key_content",
      options,
    );

/**
 * Get Kb Analytics Chart Content V1
 */
export const getApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentOptions =
  (
    options: Options<GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentData>,
  ) =>
    queryOptions<
      GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponse,
      GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentError,
      GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponse,
      ReturnType<
        typeof getApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_kb_analytics_chart_content_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentQueryKey(
          options,
        ),
    });

export const getApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentQueryKey =
  (
    options: Options<GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentData>,
  ) =>
    createQueryKey(
      "get_api_v1_analytics_workflows_by_workflow_id_charts_by_chart_key_content",
      options,
    );

/**
 * Get Workflow Analytics Chart Content V1
 */
export const getApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentOptions =
  (
    options: Options<GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentData>,
  ) =>
    queryOptions<
      GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponse,
      GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentError,
      GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponse,
      ReturnType<
        typeof getApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_workflow_analytics_chart_content_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentQueryKey(
          options,
        ),
    });

export const getApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentQueryKey =
  (
    options: Options<GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentData>,
  ) =>
    createQueryKey(
      "get_api_v1_analytics_overviews_knowledge_bases_by_kb_id_charts_by_chart_key_content",
      options,
    );

/**
 * Get Overview Analytics Chart Content V1
 */
export const getApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentOptions =
  (
    options: Options<GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentData>,
  ) =>
    queryOptions<
      GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponse,
      GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentError,
      GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponse,
      ReturnType<
        typeof getApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_overview_analytics_chart_content_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentQueryKey(
          options,
        ),
    });

/**
 * Create Api Key V1
 */
export const postApiV1ApiKeysMutation = (
  options?: Partial<Options<PostApiV1ApiKeysData>>,
): UseMutationOptions<
  PostApiV1ApiKeysResponse,
  PostApiV1ApiKeysError,
  Options<PostApiV1ApiKeysData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ApiKeysResponse,
    PostApiV1ApiKeysError,
    Options<PostApiV1ApiKeysData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_api_key_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1FullApiKeysQueryKey = (
  options?: Options<GetApiV1FullApiKeysData>,
) => createQueryKey("get_api_v1_full_api_keys", options);

/**
 * Get Full Api Keys V1
 */
export const getApiV1FullApiKeysOptions = (
  options?: Options<GetApiV1FullApiKeysData>,
) =>
  queryOptions<
    GetApiV1FullApiKeysResponse,
    GetApiV1FullApiKeysError,
    GetApiV1FullApiKeysResponse,
    ReturnType<typeof getApiV1FullApiKeysQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_api_keys_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullApiKeysQueryKey(options),
  });

export const getApiV1FullApiKeysInfiniteQueryKey = (
  options?: Options<GetApiV1FullApiKeysData>,
): QueryKey<Options<GetApiV1FullApiKeysData>> =>
  createQueryKey("get_api_v1_full_api_keys", options, true);

/**
 * Get Full Api Keys V1
 */
export const getApiV1FullApiKeysInfiniteOptions = (
  options?: Options<GetApiV1FullApiKeysData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullApiKeysResponse,
    GetApiV1FullApiKeysError,
    InfiniteData<GetApiV1FullApiKeysResponse>,
    QueryKey<Options<GetApiV1FullApiKeysData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullApiKeysData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullApiKeysData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_api_keys_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullApiKeysInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Api Key V1
 */
export const deleteApiV1ApiKeysByApiKeyIdMutation = (
  options?: Partial<Options<DeleteApiV1ApiKeysByApiKeyIdData>>,
): UseMutationOptions<
  DeleteApiV1ApiKeysByApiKeyIdResponse,
  DeleteApiV1ApiKeysByApiKeyIdError,
  Options<DeleteApiV1ApiKeysByApiKeyIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1ApiKeysByApiKeyIdResponse,
    DeleteApiV1ApiKeysByApiKeyIdError,
    Options<DeleteApiV1ApiKeysByApiKeyIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_api_key_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Api Key V1
 */
export const patchApiV1ApiKeysByApiKeyIdMutation = (
  options?: Partial<Options<PatchApiV1ApiKeysByApiKeyIdData>>,
): UseMutationOptions<
  PatchApiV1ApiKeysByApiKeyIdResponse,
  PatchApiV1ApiKeysByApiKeyIdError,
  Options<PatchApiV1ApiKeysByApiKeyIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1ApiKeysByApiKeyIdResponse,
    PatchApiV1ApiKeysByApiKeyIdError,
    Options<PatchApiV1ApiKeysByApiKeyIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_api_key_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1FullArticleLineRangeCommentThreadsQueryKey = (
  options?: Options<GetApiV1FullArticleLineRangeCommentThreadsData>,
) =>
  createQueryKey("get_api_v1_full_article_line_range_comment_threads", options);

/**
 * Get Full Article Line Range Comment Threads V1
 */
export const getApiV1FullArticleLineRangeCommentThreadsOptions = (
  options?: Options<GetApiV1FullArticleLineRangeCommentThreadsData>,
) =>
  queryOptions<
    GetApiV1FullArticleLineRangeCommentThreadsResponse,
    GetApiV1FullArticleLineRangeCommentThreadsError,
    GetApiV1FullArticleLineRangeCommentThreadsResponse,
    ReturnType<typeof getApiV1FullArticleLineRangeCommentThreadsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_article_line_range_comment_threads_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullArticleLineRangeCommentThreadsQueryKey(options),
  });

export const getApiV1FullArticleLineRangeCommentThreadsInfiniteQueryKey = (
  options?: Options<GetApiV1FullArticleLineRangeCommentThreadsData>,
): QueryKey<Options<GetApiV1FullArticleLineRangeCommentThreadsData>> =>
  createQueryKey(
    "get_api_v1_full_article_line_range_comment_threads",
    options,
    true,
  );

/**
 * Get Full Article Line Range Comment Threads V1
 */
export const getApiV1FullArticleLineRangeCommentThreadsInfiniteOptions = (
  options?: Options<GetApiV1FullArticleLineRangeCommentThreadsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullArticleLineRangeCommentThreadsResponse,
    GetApiV1FullArticleLineRangeCommentThreadsError,
    InfiniteData<GetApiV1FullArticleLineRangeCommentThreadsResponse>,
    QueryKey<Options<GetApiV1FullArticleLineRangeCommentThreadsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullArticleLineRangeCommentThreadsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullArticleLineRangeCommentThreadsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_article_line_range_comment_threads_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1FullArticleLineRangeCommentThreadsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Article Line Range Comment Thread V1
 */
export const deleteApiV1ArticleLineRangeCommentThreadsByThreadIdMutation = (
  options?: Partial<
    Options<DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdData>
  >,
): UseMutationOptions<
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdError,
  Options<DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
    DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdError,
    Options<DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_article_line_range_comment_thread_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ArticleLineRangeCommentThreadsByThreadIdQueryKey = (
  options: Options<GetApiV1ArticleLineRangeCommentThreadsByThreadIdData>,
) =>
  createQueryKey(
    "get_api_v1_article_line_range_comment_threads_by_thread_id",
    options,
  );

/**
 * Get Article Line Range Comment Thread V1
 */
export const getApiV1ArticleLineRangeCommentThreadsByThreadIdOptions = (
  options: Options<GetApiV1ArticleLineRangeCommentThreadsByThreadIdData>,
) =>
  queryOptions<
    GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
    GetApiV1ArticleLineRangeCommentThreadsByThreadIdError,
    GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
    ReturnType<typeof getApiV1ArticleLineRangeCommentThreadsByThreadIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_article_line_range_comment_thread_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ArticleLineRangeCommentThreadsByThreadIdQueryKey(options),
  });

/**
 * Update Article Line Range Comment Thread V1
 */
export const patchApiV1ArticleLineRangeCommentThreadsByThreadIdMutation = (
  options?: Partial<
    Options<PatchApiV1ArticleLineRangeCommentThreadsByThreadIdData>
  >,
): UseMutationOptions<
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdError,
  Options<PatchApiV1ArticleLineRangeCommentThreadsByThreadIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
    PatchApiV1ArticleLineRangeCommentThreadsByThreadIdError,
    Options<PatchApiV1ArticleLineRangeCommentThreadsByThreadIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_article_line_range_comment_thread_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Article Line Range Comment Thread V1
 */
export const postApiV1ArticleLineRangeCommentThreadsMutation = (
  options?: Partial<Options<PostApiV1ArticleLineRangeCommentThreadsData>>,
): UseMutationOptions<
  PostApiV1ArticleLineRangeCommentThreadsResponse,
  PostApiV1ArticleLineRangeCommentThreadsError,
  Options<PostApiV1ArticleLineRangeCommentThreadsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ArticleLineRangeCommentThreadsResponse,
    PostApiV1ArticleLineRangeCommentThreadsError,
    Options<PostApiV1ArticleLineRangeCommentThreadsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_article_line_range_comment_thread_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Article Line Range Comment Thread Comment V1
 */
export const postApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsMutation =
  (
    options?: Partial<
      Options<PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsData>
    >,
  ): UseMutationOptions<
    PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponse,
    PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsError,
    Options<PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponse,
      PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsError,
      Options<PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await create_article_line_range_comment_thread_comment_v1({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Restore Article Line Range Comment Thread V1
 */
export const postApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreMutation =
  (
    options?: Partial<
      Options<PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreData>
    >,
  ): UseMutationOptions<
    PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponse,
    PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreError,
    Options<PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponse,
      PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreError,
      Options<PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await restore_article_line_range_comment_thread_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Create Upload Url V1
 */
export const postApiV1AttachmentsUploadUrlMutation = (
  options?: Partial<Options<PostApiV1AttachmentsUploadUrlData>>,
): UseMutationOptions<
  PostApiV1AttachmentsUploadUrlResponse,
  PostApiV1AttachmentsUploadUrlError,
  Options<PostApiV1AttachmentsUploadUrlData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1AttachmentsUploadUrlResponse,
    PostApiV1AttachmentsUploadUrlError,
    Options<PostApiV1AttachmentsUploadUrlData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_upload_url_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Upload Url V2
 */
export const postApiV2AttachmentsUploadUrlMutation = (
  options?: Partial<Options<PostApiV2AttachmentsUploadUrlData>>,
): UseMutationOptions<
  PostApiV2AttachmentsUploadUrlResponse,
  PostApiV2AttachmentsUploadUrlError,
  Options<PostApiV2AttachmentsUploadUrlData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2AttachmentsUploadUrlResponse,
    PostApiV2AttachmentsUploadUrlError,
    Options<PostApiV2AttachmentsUploadUrlData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_upload_url_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1AttachmentsDataByFilePathQueryKey = (
  options: Options<GetApiV1AttachmentsDataByFilePathData>,
) => createQueryKey("get_api_v1_attachments_data_by_file_path", options);

/**
 * Get Attachment Data V1
 */
export const getApiV1AttachmentsDataByFilePathOptions = (
  options: Options<GetApiV1AttachmentsDataByFilePathData>,
) =>
  queryOptions<
    unknown,
    GetApiV1AttachmentsDataByFilePathError,
    unknown,
    ReturnType<typeof getApiV1AttachmentsDataByFilePathQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_attachment_data_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AttachmentsDataByFilePathQueryKey(options),
  });

export const getApiV2AttachmentsDataByAttachmentIdByFilenameQueryKey = (
  options: Options<GetApiV2AttachmentsDataByAttachmentIdByFilenameData>,
) =>
  createQueryKey(
    "get_api_v2_attachments_data_by_attachment_id_by_filename",
    options,
  );

/**
 * Get Attachment Data V2
 */
export const getApiV2AttachmentsDataByAttachmentIdByFilenameOptions = (
  options: Options<GetApiV2AttachmentsDataByAttachmentIdByFilenameData>,
) =>
  queryOptions<
    unknown,
    GetApiV2AttachmentsDataByAttachmentIdByFilenameError,
    unknown,
    ReturnType<typeof getApiV2AttachmentsDataByAttachmentIdByFilenameQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_attachment_data_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2AttachmentsDataByAttachmentIdByFilenameQueryKey(options),
  });

export const getApiV1AuthzOrganizationsQueryKey = (
  options?: Options<GetApiV1AuthzOrganizationsData>,
) => createQueryKey("get_api_v1_authz_organizations", options);

/**
 * Get Organizations V1
 */
export const getApiV1AuthzOrganizationsOptions = (
  options?: Options<GetApiV1AuthzOrganizationsData>,
) =>
  queryOptions<
    GetApiV1AuthzOrganizationsResponse,
    GetApiV1AuthzOrganizationsError,
    GetApiV1AuthzOrganizationsResponse,
    ReturnType<typeof getApiV1AuthzOrganizationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_organizations_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AuthzOrganizationsQueryKey(options),
  });

export const getApiV1AuthzOrganizationsInfiniteQueryKey = (
  options?: Options<GetApiV1AuthzOrganizationsData>,
): QueryKey<Options<GetApiV1AuthzOrganizationsData>> =>
  createQueryKey("get_api_v1_authz_organizations", options, true);

/**
 * Get Organizations V1
 */
export const getApiV1AuthzOrganizationsInfiniteOptions = (
  options?: Options<GetApiV1AuthzOrganizationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1AuthzOrganizationsResponse,
    GetApiV1AuthzOrganizationsError,
    InfiniteData<GetApiV1AuthzOrganizationsResponse>,
    QueryKey<Options<GetApiV1AuthzOrganizationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1AuthzOrganizationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1AuthzOrganizationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_organizations_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1AuthzOrganizationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1AuthzOrganizationsByOrgIdQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdData>,
) => createQueryKey("get_api_v1_authz_organizations_by_org_id", options);

/**
 * Get Organization V1
 */
export const getApiV1AuthzOrganizationsByOrgIdOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdData>,
) =>
  queryOptions<
    GetApiV1AuthzOrganizationsByOrgIdResponse,
    GetApiV1AuthzOrganizationsByOrgIdError,
    GetApiV1AuthzOrganizationsByOrgIdResponse,
    ReturnType<typeof getApiV1AuthzOrganizationsByOrgIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_organization_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AuthzOrganizationsByOrgIdQueryKey(options),
  });

/**
 * Update Organization V1
 */
export const patchApiV1AuthzOrganizationsByOrgIdMutation = (
  options?: Partial<Options<PatchApiV1AuthzOrganizationsByOrgIdData>>,
): UseMutationOptions<
  PatchApiV1AuthzOrganizationsByOrgIdResponse,
  PatchApiV1AuthzOrganizationsByOrgIdError,
  Options<PatchApiV1AuthzOrganizationsByOrgIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1AuthzOrganizationsByOrgIdResponse,
    PatchApiV1AuthzOrganizationsByOrgIdError,
    Options<PatchApiV1AuthzOrganizationsByOrgIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_organization_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upsert Organization V1
 */
export const putApiV1AuthzOrganizationsByExternalIdMutation = (
  options?: Partial<Options<PutApiV1AuthzOrganizationsByExternalIdData>>,
): UseMutationOptions<
  PutApiV1AuthzOrganizationsByExternalIdResponse,
  PutApiV1AuthzOrganizationsByExternalIdError,
  Options<PutApiV1AuthzOrganizationsByExternalIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiV1AuthzOrganizationsByExternalIdResponse,
    PutApiV1AuthzOrganizationsByExternalIdError,
    Options<PutApiV1AuthzOrganizationsByExternalIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsert_organization_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1AuthzOrganizationsByOrgIdMembersQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdMembersData>,
) =>
  createQueryKey("get_api_v1_authz_organizations_by_org_id_members", options);

/**
 * Get Org Members V1
 */
export const getApiV1AuthzOrganizationsByOrgIdMembersOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdMembersData>,
) =>
  queryOptions<
    GetApiV1AuthzOrganizationsByOrgIdMembersResponse,
    GetApiV1AuthzOrganizationsByOrgIdMembersError,
    GetApiV1AuthzOrganizationsByOrgIdMembersResponse,
    ReturnType<typeof getApiV1AuthzOrganizationsByOrgIdMembersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_org_members_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AuthzOrganizationsByOrgIdMembersQueryKey(options),
  });

export const getApiV1AuthzOrganizationsByOrgIdMembersInfiniteQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdMembersData>,
): QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdMembersData>> =>
  createQueryKey(
    "get_api_v1_authz_organizations_by_org_id_members",
    options,
    true,
  );

/**
 * Get Org Members V1
 */
export const getApiV1AuthzOrganizationsByOrgIdMembersInfiniteOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdMembersData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1AuthzOrganizationsByOrgIdMembersResponse,
    GetApiV1AuthzOrganizationsByOrgIdMembersError,
    InfiniteData<GetApiV1AuthzOrganizationsByOrgIdMembersResponse>,
    QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdMembersData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdMembersData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdMembersData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_org_members_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AuthzOrganizationsByOrgIdMembersInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Org Member V1
 */
export const deleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdMutation = (
  options?: Partial<
    Options<DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdData>
  >,
): UseMutationOptions<
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponse,
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdError,
  Options<DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponse,
    DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdError,
    Options<DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_org_member_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Org Member V1
 */
export const patchApiV1AuthzOrganizationsByOrgIdMembersByUserIdMutation = (
  options?: Partial<
    Options<PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdData>
  >,
): UseMutationOptions<
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponse,
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdError,
  Options<PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponse,
    PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdError,
    Options<PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_org_member_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1AuthzOrganizationsByOrgIdRolesQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdRolesData>,
) => createQueryKey("get_api_v1_authz_organizations_by_org_id_roles", options);

/**
 * Get Roles V1
 */
export const getApiV1AuthzOrganizationsByOrgIdRolesOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdRolesData>,
) =>
  queryOptions<
    GetApiV1AuthzOrganizationsByOrgIdRolesResponse,
    GetApiV1AuthzOrganizationsByOrgIdRolesError,
    GetApiV1AuthzOrganizationsByOrgIdRolesResponse,
    ReturnType<typeof getApiV1AuthzOrganizationsByOrgIdRolesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_roles_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AuthzOrganizationsByOrgIdRolesQueryKey(options),
  });

export const getApiV1AuthzOrganizationsByOrgIdTeamsQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdTeamsData>,
) => createQueryKey("get_api_v1_authz_organizations_by_org_id_teams", options);

/**
 * Get Teams V1
 */
export const getApiV1AuthzOrganizationsByOrgIdTeamsOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdTeamsData>,
) =>
  queryOptions<
    GetApiV1AuthzOrganizationsByOrgIdTeamsResponse,
    GetApiV1AuthzOrganizationsByOrgIdTeamsError,
    GetApiV1AuthzOrganizationsByOrgIdTeamsResponse,
    ReturnType<typeof getApiV1AuthzOrganizationsByOrgIdTeamsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_teams_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AuthzOrganizationsByOrgIdTeamsQueryKey(options),
  });

export const getApiV1AuthzOrganizationsByOrgIdTeamsInfiniteQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdTeamsData>,
): QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdTeamsData>> =>
  createQueryKey(
    "get_api_v1_authz_organizations_by_org_id_teams",
    options,
    true,
  );

/**
 * Get Teams V1
 */
export const getApiV1AuthzOrganizationsByOrgIdTeamsInfiniteOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdTeamsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1AuthzOrganizationsByOrgIdTeamsResponse,
    GetApiV1AuthzOrganizationsByOrgIdTeamsError,
    InfiniteData<GetApiV1AuthzOrganizationsByOrgIdTeamsResponse>,
    QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdTeamsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdTeamsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdTeamsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_teams_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1AuthzOrganizationsByOrgIdTeamsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Team V1
 */
export const postApiV1AuthzOrganizationsByOrgIdTeamsMutation = (
  options?: Partial<Options<PostApiV1AuthzOrganizationsByOrgIdTeamsData>>,
): UseMutationOptions<
  PostApiV1AuthzOrganizationsByOrgIdTeamsResponse,
  PostApiV1AuthzOrganizationsByOrgIdTeamsError,
  Options<PostApiV1AuthzOrganizationsByOrgIdTeamsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1AuthzOrganizationsByOrgIdTeamsResponse,
    PostApiV1AuthzOrganizationsByOrgIdTeamsError,
    Options<PostApiV1AuthzOrganizationsByOrgIdTeamsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_team_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Team V1
 */
export const deleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdMutation = (
  options?: Partial<
    Options<DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData>
  >,
): UseMutationOptions<
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError,
  Options<DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
    DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError,
    Options<DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_team_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData>,
) =>
  createQueryKey(
    "get_api_v1_authz_organizations_by_org_id_teams_by_team_id",
    options,
  );

/**
 * Get Team V1
 */
export const getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData>,
) =>
  queryOptions<
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError,
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
    ReturnType<typeof getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_team_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdQueryKey(options),
  });

/**
 * Update Team V1
 */
export const patchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdMutation = (
  options?: Partial<
    Options<PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData>
  >,
): UseMutationOptions<
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError,
  Options<PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
    PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError,
    Options<PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_team_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sync Articles To Openfga V1
 */
export const postApiV1AuthzSyncArticlesToOpenfgaMutation = (
  options?: Partial<Options<PostApiV1AuthzSyncArticlesToOpenfgaData>>,
): UseMutationOptions<
  PostApiV1AuthzSyncArticlesToOpenfgaResponse,
  PostApiV1AuthzSyncArticlesToOpenfgaError,
  Options<PostApiV1AuthzSyncArticlesToOpenfgaData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1AuthzSyncArticlesToOpenfgaResponse,
    PostApiV1AuthzSyncArticlesToOpenfgaError,
    Options<PostApiV1AuthzSyncArticlesToOpenfgaData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sync_articles_to_openfga_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sync Kb Owners V1
 */
export const postApiV1AuthzKbOwnersSyncMutation = (
  options?: Partial<Options<PostApiV1AuthzKbOwnersSyncData>>,
): UseMutationOptions<
  PostApiV1AuthzKbOwnersSyncResponse,
  DefaultError,
  Options<PostApiV1AuthzKbOwnersSyncData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1AuthzKbOwnersSyncResponse,
    DefaultError,
    Options<PostApiV1AuthzKbOwnersSyncData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sync_kb_owners_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Team Kb Role V1
 */
export const putApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdMutation =
  (
    options?: Partial<
      Options<PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdData>
    >,
  ): UseMutationOptions<
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponse,
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdError,
    Options<PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponse,
      PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdError,
      Options<PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await set_team_kb_role_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesQueryKey =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesData>,
  ) =>
    createQueryKey(
      "get_api_v1_authz_organizations_by_org_id_teams_by_team_id_knowledge_bases",
      options,
    );

/**
 * Get Team Kb Assignments V1
 */
export const getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesOptions =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesData>,
  ) =>
    queryOptions<
      GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponse,
      GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesError,
      GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponse,
      ReturnType<
        typeof getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_team_kb_assignments_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesQueryKey(
          options,
        ),
    });

export const getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData>,
) =>
  createQueryKey(
    "get_api_v1_authz_organizations_by_org_id_teams_by_team_id_articles",
    options,
  );

/**
 * Get Team Article Permissions V1
 */
export const getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData>,
) =>
  queryOptions<
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponse,
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesError,
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponse,
    ReturnType<
      typeof getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_team_article_permissions_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesQueryKey(options),
  });

/**
 * Set Team Article Permissions V1
 */
export const putApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesMutation = (
  options?: Partial<
    Options<PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData>
  >,
): UseMutationOptions<
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponse,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesError,
  Options<PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponse,
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesError,
    Options<PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await set_team_article_permissions_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Team Article Permission V1
 */
export const putApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdMutation =
  (
    options?: Partial<
      Options<PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdData>
    >,
  ): UseMutationOptions<
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponse,
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdError,
    Options<PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponse,
      PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdError,
      Options<PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await set_team_article_permission_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1AuthzOrganizationsByOrgIdInvitationsQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdInvitationsData>,
) =>
  createQueryKey(
    "get_api_v1_authz_organizations_by_org_id_invitations",
    options,
  );

/**
 * Get Invitations V1
 */
export const getApiV1AuthzOrganizationsByOrgIdInvitationsOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdInvitationsData>,
) =>
  queryOptions<
    GetApiV1AuthzOrganizationsByOrgIdInvitationsResponse,
    GetApiV1AuthzOrganizationsByOrgIdInvitationsError,
    GetApiV1AuthzOrganizationsByOrgIdInvitationsResponse,
    ReturnType<typeof getApiV1AuthzOrganizationsByOrgIdInvitationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_invitations_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AuthzOrganizationsByOrgIdInvitationsQueryKey(options),
  });

export const getApiV1AuthzOrganizationsByOrgIdInvitationsInfiniteQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdInvitationsData>,
): QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdInvitationsData>> =>
  createQueryKey(
    "get_api_v1_authz_organizations_by_org_id_invitations",
    options,
    true,
  );

/**
 * Get Invitations V1
 */
export const getApiV1AuthzOrganizationsByOrgIdInvitationsInfiniteOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdInvitationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1AuthzOrganizationsByOrgIdInvitationsResponse,
    GetApiV1AuthzOrganizationsByOrgIdInvitationsError,
    InfiniteData<GetApiV1AuthzOrganizationsByOrgIdInvitationsResponse>,
    QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdInvitationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdInvitationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiV1AuthzOrganizationsByOrgIdInvitationsData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_invitations_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AuthzOrganizationsByOrgIdInvitationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Invitation V1
 */
export const postApiV1AuthzOrganizationsByOrgIdInvitationsMutation = (
  options?: Partial<Options<PostApiV1AuthzOrganizationsByOrgIdInvitationsData>>,
): UseMutationOptions<
  PostApiV1AuthzOrganizationsByOrgIdInvitationsResponse,
  PostApiV1AuthzOrganizationsByOrgIdInvitationsError,
  Options<PostApiV1AuthzOrganizationsByOrgIdInvitationsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1AuthzOrganizationsByOrgIdInvitationsResponse,
    PostApiV1AuthzOrganizationsByOrgIdInvitationsError,
    Options<PostApiV1AuthzOrganizationsByOrgIdInvitationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_invitation_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1AuthzOrganizationsByOrgIdFullInvitationsQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData>,
) =>
  createQueryKey(
    "get_api_v1_authz_organizations_by_org_id_full_invitations",
    options,
  );

/**
 * Get Full Invitations V1
 */
export const getApiV1AuthzOrganizationsByOrgIdFullInvitationsOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData>,
) =>
  queryOptions<
    GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponse,
    GetApiV1AuthzOrganizationsByOrgIdFullInvitationsError,
    GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponse,
    ReturnType<typeof getApiV1AuthzOrganizationsByOrgIdFullInvitationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_invitations_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1AuthzOrganizationsByOrgIdFullInvitationsQueryKey(options),
  });

export const getApiV1AuthzOrganizationsByOrgIdFullInvitationsInfiniteQueryKey =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData>,
  ): QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData>> =>
    createQueryKey(
      "get_api_v1_authz_organizations_by_org_id_full_invitations",
      options,
      true,
    );

/**
 * Get Full Invitations V1
 */
export const getApiV1AuthzOrganizationsByOrgIdFullInvitationsInfiniteOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponse,
    GetApiV1AuthzOrganizationsByOrgIdFullInvitationsError,
    InfiniteData<GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponse>,
    QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData>>,
    | number
    | Pick<
        QueryKey<
          Options<GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData>
        >[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_invitations_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AuthzOrganizationsByOrgIdFullInvitationsInfiniteQueryKey(
          options,
        ),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Invitation V1
 */
export const deleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdMutation =
  (
    options?: Partial<
      Options<DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData>
    >,
  ): UseMutationOptions<
    DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
    DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError,
    Options<DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
      DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError,
      Options<DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await delete_invitation_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdQueryKey =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData>,
  ) =>
    createQueryKey(
      "get_api_v1_authz_organizations_by_org_id_invitations_by_invitation_id",
      options,
    );

/**
 * Get Invitation V1
 */
export const getApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdOptions =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData>,
  ) =>
    queryOptions<
      GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
      GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError,
      GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
      ReturnType<
        typeof getApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_invitation_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdQueryKey(
          options,
        ),
    });

/**
 * Update Invitation V1
 */
export const patchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdMutation =
  (
    options?: Partial<
      Options<PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData>
    >,
  ): UseMutationOptions<
    PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
    PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError,
    Options<PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
      PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError,
      Options<PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await update_invitation_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1BrandingQueryKey = (
  options?: Options<GetApiV1BrandingData>,
) => createQueryKey("get_api_v1_branding", options);

/**
 * Get Branding V1
 */
export const getApiV1BrandingOptions = (
  options?: Options<GetApiV1BrandingData>,
) =>
  queryOptions<
    GetApiV1BrandingResponse,
    DefaultError,
    GetApiV1BrandingResponse,
    ReturnType<typeof getApiV1BrandingQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_branding_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1BrandingQueryKey(options),
  });

/**
 * Create Branding Logo Upload Url V1
 */
export const postApiV1BrandingLogoUploadUrlMutation = (
  options?: Partial<Options<PostApiV1BrandingLogoUploadUrlData>>,
): UseMutationOptions<
  PostApiV1BrandingLogoUploadUrlResponse,
  PostApiV1BrandingLogoUploadUrlError,
  Options<PostApiV1BrandingLogoUploadUrlData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1BrandingLogoUploadUrlResponse,
    PostApiV1BrandingLogoUploadUrlError,
    Options<PostApiV1BrandingLogoUploadUrlData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_branding_logo_upload_url_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1FullChangeRequestLineRangeCommentThreadsQueryKey = (
  options?: Options<GetApiV1FullChangeRequestLineRangeCommentThreadsData>,
) =>
  createQueryKey(
    "get_api_v1_full_change_request_line_range_comment_threads",
    options,
  );

/**
 * Get Full Change Request Line Range Comment Threads V1
 */
export const getApiV1FullChangeRequestLineRangeCommentThreadsOptions = (
  options?: Options<GetApiV1FullChangeRequestLineRangeCommentThreadsData>,
) =>
  queryOptions<
    GetApiV1FullChangeRequestLineRangeCommentThreadsResponse,
    GetApiV1FullChangeRequestLineRangeCommentThreadsError,
    GetApiV1FullChangeRequestLineRangeCommentThreadsResponse,
    ReturnType<typeof getApiV1FullChangeRequestLineRangeCommentThreadsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await get_full_change_request_line_range_comment_threads_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey: getApiV1FullChangeRequestLineRangeCommentThreadsQueryKey(options),
  });

export const getApiV1FullChangeRequestLineRangeCommentThreadsInfiniteQueryKey =
  (
    options?: Options<GetApiV1FullChangeRequestLineRangeCommentThreadsData>,
  ): QueryKey<Options<GetApiV1FullChangeRequestLineRangeCommentThreadsData>> =>
    createQueryKey(
      "get_api_v1_full_change_request_line_range_comment_threads",
      options,
      true,
    );

/**
 * Get Full Change Request Line Range Comment Threads V1
 */
export const getApiV1FullChangeRequestLineRangeCommentThreadsInfiniteOptions = (
  options?: Options<GetApiV1FullChangeRequestLineRangeCommentThreadsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullChangeRequestLineRangeCommentThreadsResponse,
    GetApiV1FullChangeRequestLineRangeCommentThreadsError,
    InfiniteData<GetApiV1FullChangeRequestLineRangeCommentThreadsResponse>,
    QueryKey<Options<GetApiV1FullChangeRequestLineRangeCommentThreadsData>>,
    | number
    | Pick<
        QueryKey<
          Options<GetApiV1FullChangeRequestLineRangeCommentThreadsData>
        >[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiV1FullChangeRequestLineRangeCommentThreadsData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } =
          await get_full_change_request_line_range_comment_threads_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
        return data;
      },
      queryKey:
        getApiV1FullChangeRequestLineRangeCommentThreadsInfiniteQueryKey(
          options,
        ),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Change Request Line Range Comment Thread V1
 */
export const deleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdMutation =
  (
    options?: Partial<
      Options<DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData>
    >,
  ): UseMutationOptions<
    DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
    DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError,
    Options<DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
      DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError,
      Options<DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await delete_change_request_line_range_comment_thread_v1({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1ChangeRequestLineRangeCommentThreadsByThreadIdQueryKey = (
  options: Options<GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData>,
) =>
  createQueryKey(
    "get_api_v1_change_request_line_range_comment_threads_by_thread_id",
    options,
  );

/**
 * Get Change Request Line Range Comment Thread V1
 */
export const getApiV1ChangeRequestLineRangeCommentThreadsByThreadIdOptions = (
  options: Options<GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData>,
) =>
  queryOptions<
    GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
    GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError,
    GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
    ReturnType<
      typeof getApiV1ChangeRequestLineRangeCommentThreadsByThreadIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_change_request_line_range_comment_thread_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ChangeRequestLineRangeCommentThreadsByThreadIdQueryKey(options),
  });

/**
 * Update Change Request Line Range Comment Thread V1
 */
export const patchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdMutation =
  (
    options?: Partial<
      Options<PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData>
    >,
  ): UseMutationOptions<
    PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
    PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError,
    Options<PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
      PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError,
      Options<PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await update_change_request_line_range_comment_thread_v1({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Create Change Request Line Range Comment Thread V1
 */
export const postApiV1ChangeRequestLineRangeCommentThreadsMutation = (
  options?: Partial<Options<PostApiV1ChangeRequestLineRangeCommentThreadsData>>,
): UseMutationOptions<
  PostApiV1ChangeRequestLineRangeCommentThreadsResponse,
  PostApiV1ChangeRequestLineRangeCommentThreadsError,
  Options<PostApiV1ChangeRequestLineRangeCommentThreadsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ChangeRequestLineRangeCommentThreadsResponse,
    PostApiV1ChangeRequestLineRangeCommentThreadsError,
    Options<PostApiV1ChangeRequestLineRangeCommentThreadsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_change_request_line_range_comment_thread_v1(
        {
          ...options,
          ...fnOptions,
          throwOnError: true,
        },
      );
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Change Request Line Range Comment Thread Comment V1
 */
export const postApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsMutation =
  (
    options?: Partial<
      Options<PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsData>
    >,
  ): UseMutationOptions<
    PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponse,
    PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsError,
    Options<PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponse,
      PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsError,
      Options<PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await create_change_request_line_range_comment_thread_comment_v1({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Restore Change Request Line Range Comment Thread V1
 */
export const postApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreMutation =
  (
    options?: Partial<
      Options<PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreData>
    >,
  ): UseMutationOptions<
    PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponse,
    PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreError,
    Options<PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponse,
      PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreError,
      Options<PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await restore_change_request_line_range_comment_thread_v1({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1ChangeRequestTagsQueryKey = (
  options?: Options<GetApiV1ChangeRequestTagsData>,
) => createQueryKey("get_api_v1_change_request_tags", options);

/**
 * Get Change Request Tags V1
 */
export const getApiV1ChangeRequestTagsOptions = (
  options?: Options<GetApiV1ChangeRequestTagsData>,
) =>
  queryOptions<
    GetApiV1ChangeRequestTagsResponse,
    GetApiV1ChangeRequestTagsError,
    GetApiV1ChangeRequestTagsResponse,
    ReturnType<typeof getApiV1ChangeRequestTagsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_change_request_tags_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ChangeRequestTagsQueryKey(options),
  });

export const getApiV1ChangeRequestTagsInfiniteQueryKey = (
  options?: Options<GetApiV1ChangeRequestTagsData>,
): QueryKey<Options<GetApiV1ChangeRequestTagsData>> =>
  createQueryKey("get_api_v1_change_request_tags", options, true);

/**
 * Get Change Request Tags V1
 */
export const getApiV1ChangeRequestTagsInfiniteOptions = (
  options?: Options<GetApiV1ChangeRequestTagsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ChangeRequestTagsResponse,
    GetApiV1ChangeRequestTagsError,
    InfiniteData<GetApiV1ChangeRequestTagsResponse>,
    QueryKey<Options<GetApiV1ChangeRequestTagsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ChangeRequestTagsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ChangeRequestTagsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_change_request_tags_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1ChangeRequestTagsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1ChangeRequestsQueryKey = (
  options?: Options<GetApiV1ChangeRequestsData>,
) => createQueryKey("get_api_v1_change_requests", options);

/**
 * Get Change Requests V1
 */
export const getApiV1ChangeRequestsOptions = (
  options?: Options<GetApiV1ChangeRequestsData>,
) =>
  queryOptions<
    GetApiV1ChangeRequestsResponse,
    GetApiV1ChangeRequestsError,
    GetApiV1ChangeRequestsResponse,
    ReturnType<typeof getApiV1ChangeRequestsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_change_requests_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ChangeRequestsQueryKey(options),
  });

export const getApiV1ChangeRequestsInfiniteQueryKey = (
  options?: Options<GetApiV1ChangeRequestsData>,
): QueryKey<Options<GetApiV1ChangeRequestsData>> =>
  createQueryKey("get_api_v1_change_requests", options, true);

/**
 * Get Change Requests V1
 */
export const getApiV1ChangeRequestsInfiniteOptions = (
  options?: Options<GetApiV1ChangeRequestsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ChangeRequestsResponse,
    GetApiV1ChangeRequestsError,
    InfiniteData<GetApiV1ChangeRequestsResponse>,
    QueryKey<Options<GetApiV1ChangeRequestsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ChangeRequestsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ChangeRequestsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_change_requests_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1ChangeRequestsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Change Request V1
 */
export const postApiV1ChangeRequestsMutation = (
  options?: Partial<Options<PostApiV1ChangeRequestsData>>,
): UseMutationOptions<
  PostApiV1ChangeRequestsResponse,
  PostApiV1ChangeRequestsError,
  Options<PostApiV1ChangeRequestsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ChangeRequestsResponse,
    PostApiV1ChangeRequestsError,
    Options<PostApiV1ChangeRequestsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_change_request_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1FullChangeRequestsQueryKey = (
  options?: Options<GetApiV1FullChangeRequestsData>,
) => createQueryKey("get_api_v1_full_change_requests", options);

/**
 * Get Full Change Requests V1
 */
export const getApiV1FullChangeRequestsOptions = (
  options?: Options<GetApiV1FullChangeRequestsData>,
) =>
  queryOptions<
    GetApiV1FullChangeRequestsResponse,
    GetApiV1FullChangeRequestsError,
    GetApiV1FullChangeRequestsResponse,
    ReturnType<typeof getApiV1FullChangeRequestsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_change_requests_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullChangeRequestsQueryKey(options),
  });

export const getApiV1FullChangeRequestsInfiniteQueryKey = (
  options?: Options<GetApiV1FullChangeRequestsData>,
): QueryKey<Options<GetApiV1FullChangeRequestsData>> =>
  createQueryKey("get_api_v1_full_change_requests", options, true);

/**
 * Get Full Change Requests V1
 */
export const getApiV1FullChangeRequestsInfiniteOptions = (
  options?: Options<GetApiV1FullChangeRequestsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullChangeRequestsResponse,
    GetApiV1FullChangeRequestsError,
    InfiniteData<GetApiV1FullChangeRequestsResponse>,
    QueryKey<Options<GetApiV1FullChangeRequestsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullChangeRequestsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullChangeRequestsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_change_requests_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullChangeRequestsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Change Request V1
 */
export const deleteApiV1ChangeRequestsByChangeRequestIdMutation = (
  options?: Partial<Options<DeleteApiV1ChangeRequestsByChangeRequestIdData>>,
): UseMutationOptions<
  DeleteApiV1ChangeRequestsByChangeRequestIdResponse,
  DeleteApiV1ChangeRequestsByChangeRequestIdError,
  Options<DeleteApiV1ChangeRequestsByChangeRequestIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1ChangeRequestsByChangeRequestIdResponse,
    DeleteApiV1ChangeRequestsByChangeRequestIdError,
    Options<DeleteApiV1ChangeRequestsByChangeRequestIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_change_request_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ChangeRequestsByChangeRequestIdQueryKey = (
  options: Options<GetApiV1ChangeRequestsByChangeRequestIdData>,
) => createQueryKey("get_api_v1_change_requests_by_change_request_id", options);

/**
 * Get Change Request V1
 */
export const getApiV1ChangeRequestsByChangeRequestIdOptions = (
  options: Options<GetApiV1ChangeRequestsByChangeRequestIdData>,
) =>
  queryOptions<
    GetApiV1ChangeRequestsByChangeRequestIdResponse,
    GetApiV1ChangeRequestsByChangeRequestIdError,
    GetApiV1ChangeRequestsByChangeRequestIdResponse,
    ReturnType<typeof getApiV1ChangeRequestsByChangeRequestIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_change_request_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ChangeRequestsByChangeRequestIdQueryKey(options),
  });

/**
 * Update Change Request V1
 */
export const patchApiV1ChangeRequestsByChangeRequestIdMutation = (
  options?: Partial<Options<PatchApiV1ChangeRequestsByChangeRequestIdData>>,
): UseMutationOptions<
  PatchApiV1ChangeRequestsByChangeRequestIdResponse,
  PatchApiV1ChangeRequestsByChangeRequestIdError,
  Options<PatchApiV1ChangeRequestsByChangeRequestIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1ChangeRequestsByChangeRequestIdResponse,
    PatchApiV1ChangeRequestsByChangeRequestIdError,
    Options<PatchApiV1ChangeRequestsByChangeRequestIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_change_request_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Change Request V1
 */
export const postApiV1ChangeRequestsByChangeRequestIdRestoreMutation = (
  options?: Partial<
    Options<PostApiV1ChangeRequestsByChangeRequestIdRestoreData>
  >,
): UseMutationOptions<
  PostApiV1ChangeRequestsByChangeRequestIdRestoreResponse,
  PostApiV1ChangeRequestsByChangeRequestIdRestoreError,
  Options<PostApiV1ChangeRequestsByChangeRequestIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ChangeRequestsByChangeRequestIdRestoreResponse,
    PostApiV1ChangeRequestsByChangeRequestIdRestoreError,
    Options<PostApiV1ChangeRequestsByChangeRequestIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_change_request_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesQueryKey =
  (
    options: Options<GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesData>,
  ) =>
    createQueryKey(
      "get_api_v1_change_requests_by_change_request_id_possible_assignees",
      options,
    );

/**
 * Get Change Request Possible Assignees V1
 */
export const getApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesOptions = (
  options: Options<GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesData>,
) =>
  queryOptions<
    GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponse,
    GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesError,
    GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponse,
    ReturnType<
      typeof getApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_change_request_possible_assignees_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesQueryKey(options),
  });

export const getApiV1FullCommentsQueryKey = (
  options?: Options<GetApiV1FullCommentsData>,
) => createQueryKey("get_api_v1_full_comments", options);

/**
 * Get Full Comments V1
 */
export const getApiV1FullCommentsOptions = (
  options?: Options<GetApiV1FullCommentsData>,
) =>
  queryOptions<
    GetApiV1FullCommentsResponse,
    GetApiV1FullCommentsError,
    GetApiV1FullCommentsResponse,
    ReturnType<typeof getApiV1FullCommentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_comments_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullCommentsQueryKey(options),
  });

export const getApiV1FullCommentsInfiniteQueryKey = (
  options?: Options<GetApiV1FullCommentsData>,
): QueryKey<Options<GetApiV1FullCommentsData>> =>
  createQueryKey("get_api_v1_full_comments", options, true);

/**
 * Get Full Comments V1
 */
export const getApiV1FullCommentsInfiniteOptions = (
  options?: Options<GetApiV1FullCommentsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullCommentsResponse,
    GetApiV1FullCommentsError,
    InfiniteData<GetApiV1FullCommentsResponse>,
    QueryKey<Options<GetApiV1FullCommentsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullCommentsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullCommentsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_comments_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullCommentsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Comment V1
 */
export const deleteApiV1CommentsByCommentIdMutation = (
  options?: Partial<Options<DeleteApiV1CommentsByCommentIdData>>,
): UseMutationOptions<
  DeleteApiV1CommentsByCommentIdResponse,
  DeleteApiV1CommentsByCommentIdError,
  Options<DeleteApiV1CommentsByCommentIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1CommentsByCommentIdResponse,
    DeleteApiV1CommentsByCommentIdError,
    Options<DeleteApiV1CommentsByCommentIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_comment_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1CommentsByCommentIdQueryKey = (
  options: Options<GetApiV1CommentsByCommentIdData>,
) => createQueryKey("get_api_v1_comments_by_comment_id", options);

/**
 * Get Comment V1
 */
export const getApiV1CommentsByCommentIdOptions = (
  options: Options<GetApiV1CommentsByCommentIdData>,
) =>
  queryOptions<
    GetApiV1CommentsByCommentIdResponse,
    GetApiV1CommentsByCommentIdError,
    GetApiV1CommentsByCommentIdResponse,
    ReturnType<typeof getApiV1CommentsByCommentIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_comment_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1CommentsByCommentIdQueryKey(options),
  });

/**
 * Update Comment V1
 */
export const patchApiV1CommentsByCommentIdMutation = (
  options?: Partial<Options<PatchApiV1CommentsByCommentIdData>>,
): UseMutationOptions<
  PatchApiV1CommentsByCommentIdResponse,
  PatchApiV1CommentsByCommentIdError,
  Options<PatchApiV1CommentsByCommentIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1CommentsByCommentIdResponse,
    PatchApiV1CommentsByCommentIdError,
    Options<PatchApiV1CommentsByCommentIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_comment_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Comment V1
 */
export const postApiV1CommentsByCommentIdRestoreMutation = (
  options?: Partial<Options<PostApiV1CommentsByCommentIdRestoreData>>,
): UseMutationOptions<
  PostApiV1CommentsByCommentIdRestoreResponse,
  PostApiV1CommentsByCommentIdRestoreError,
  Options<PostApiV1CommentsByCommentIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1CommentsByCommentIdRestoreResponse,
    PostApiV1CommentsByCommentIdRestoreError,
    Options<PostApiV1CommentsByCommentIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_comment_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiConfluenceV1TenantsByTenantIdActionsSpacesQueryKey = (
  options: Options<GetApiConfluenceV1TenantsByTenantIdActionsSpacesData>,
) =>
  createQueryKey(
    "get_api_confluence_v1_tenants_by_tenant_id_actions_spaces",
    options,
  );

/**
 * Confluence Get Spaces V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsSpacesOptions = (
  options: Options<GetApiConfluenceV1TenantsByTenantIdActionsSpacesData>,
) =>
  queryOptions<
    GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponse,
    GetApiConfluenceV1TenantsByTenantIdActionsSpacesError,
    GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponse,
    ReturnType<typeof getApiConfluenceV1TenantsByTenantIdActionsSpacesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await confluence_get_spaces_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiConfluenceV1TenantsByTenantIdActionsSpacesQueryKey(options),
  });

export const getApiConfluenceV1TenantsByTenantIdActionsSpacesInfiniteQueryKey =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsSpacesData>,
  ): QueryKey<Options<GetApiConfluenceV1TenantsByTenantIdActionsSpacesData>> =>
    createQueryKey(
      "get_api_confluence_v1_tenants_by_tenant_id_actions_spaces",
      options,
      true,
    );

/**
 * Confluence Get Spaces V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsSpacesInfiniteOptions = (
  options: Options<GetApiConfluenceV1TenantsByTenantIdActionsSpacesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponse,
    GetApiConfluenceV1TenantsByTenantIdActionsSpacesError,
    InfiniteData<GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponse>,
    QueryKey<Options<GetApiConfluenceV1TenantsByTenantIdActionsSpacesData>>,
    | string
    | null
    | Pick<
        QueryKey<
          Options<GetApiConfluenceV1TenantsByTenantIdActionsSpacesData>
        >[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiConfluenceV1TenantsByTenantIdActionsSpacesData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await confluence_get_spaces_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiConfluenceV1TenantsByTenantIdActionsSpacesInfiniteQueryKey(
          options,
        ),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiConfluenceV1TenantsByTenantIdActionsPagesQueryKey = (
  options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesData>,
) =>
  createQueryKey(
    "get_api_confluence_v1_tenants_by_tenant_id_actions_pages",
    options,
  );

/**
 * Confluence Get Pages V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsPagesOptions = (
  options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesData>,
) =>
  queryOptions<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesResponse,
    GetApiConfluenceV1TenantsByTenantIdActionsPagesError,
    GetApiConfluenceV1TenantsByTenantIdActionsPagesResponse,
    ReturnType<typeof getApiConfluenceV1TenantsByTenantIdActionsPagesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await confluence_get_pages_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiConfluenceV1TenantsByTenantIdActionsPagesQueryKey(options),
  });

export const getApiConfluenceV1TenantsByTenantIdActionsPagesInfiniteQueryKey = (
  options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesData>,
): QueryKey<Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesData>> =>
  createQueryKey(
    "get_api_confluence_v1_tenants_by_tenant_id_actions_pages",
    options,
    true,
  );

/**
 * Confluence Get Pages V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsPagesInfiniteOptions = (
  options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesResponse,
    GetApiConfluenceV1TenantsByTenantIdActionsPagesError,
    InfiniteData<GetApiConfluenceV1TenantsByTenantIdActionsPagesResponse>,
    QueryKey<Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesData>>,
    | string
    | null
    | Pick<
        QueryKey<
          Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesData>
        >[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await confluence_get_pages_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiConfluenceV1TenantsByTenantIdActionsPagesInfiniteQueryKey(
          options,
        ),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Confluence Create Page V1
 */
export const postApiConfluenceV1TenantsByTenantIdActionsPagesMutation = (
  options?: Partial<
    Options<PostApiConfluenceV1TenantsByTenantIdActionsPagesData>
  >,
): UseMutationOptions<
  PostApiConfluenceV1TenantsByTenantIdActionsPagesResponse,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesError,
  Options<PostApiConfluenceV1TenantsByTenantIdActionsPagesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiConfluenceV1TenantsByTenantIdActionsPagesResponse,
    PostApiConfluenceV1TenantsByTenantIdActionsPagesError,
    Options<PostApiConfluenceV1TenantsByTenantIdActionsPagesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await confluence_create_page_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentQueryKey =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentData>,
  ) =>
    createQueryKey(
      "get_api_confluence_v1_tenants_by_tenant_id_actions_pages_by_page_id_content",
      options,
    );

/**
 * Confluence Get Page Content V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentOptions =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentData>,
  ) =>
    queryOptions<
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponse,
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentError,
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponse,
      ReturnType<
        typeof getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await confluence_get_page_content_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentQueryKey(
          options,
        ),
    });

export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsQueryKey =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData>,
  ) =>
    createQueryKey(
      "get_api_confluence_v1_tenants_by_tenant_id_actions_pages_by_page_id_comments",
      options,
    );

/**
 * Confluence Get Comments V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsOptions =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData>,
  ) =>
    queryOptions<
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
      ReturnType<
        typeof getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await confluence_get_comments_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsQueryKey(
          options,
        ),
    });

export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsInfiniteQueryKey =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData>,
  ): QueryKey<
    Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData>
  > =>
    createQueryKey(
      "get_api_confluence_v1_tenants_by_tenant_id_actions_pages_by_page_id_comments",
      options,
      true,
    );

/**
 * Confluence Get Comments V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsInfiniteOptions =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
      InfiniteData<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse>,
      QueryKey<
        Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await confluence_get_comments_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

/**
 * Confluence Add Comment V1
 */
export const postApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsMutation =
  (
    options?: Partial<
      Options<PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData>
    >,
  ): UseMutationOptions<
    PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
    PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
    Options<PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
      PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
      Options<PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await confluence_add_comment_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsQueryKey =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData>,
  ) =>
    createQueryKey(
      "get_api_confluence_v1_tenants_by_tenant_id_actions_pages_by_page_id_labels",
      options,
    );

/**
 * Confluence Get Page Labels V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsOptions =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData>,
  ) =>
    queryOptions<
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponse,
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsError,
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponse,
      ReturnType<
        typeof getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await confluence_get_page_labels_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsQueryKey(
          options,
        ),
    });

export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsInfiniteQueryKey =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData>,
  ): QueryKey<
    Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData>
  > =>
    createQueryKey(
      "get_api_confluence_v1_tenants_by_tenant_id_actions_pages_by_page_id_labels",
      options,
      true,
    );

/**
 * Confluence Get Page Labels V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsInfiniteOptions =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponse,
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsError,
      InfiniteData<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponse>,
      QueryKey<
        Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await confluence_get_page_labels_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsQueryKey =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData>,
  ) =>
    createQueryKey(
      "get_api_confluence_v1_tenants_by_tenant_id_actions_pages_by_page_id_attachments",
      options,
    );

/**
 * Confluence Get Page Attachments V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsOptions =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData>,
  ) =>
    queryOptions<
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponse,
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsError,
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponse,
      ReturnType<
        typeof getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await confluence_get_page_attachments_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsQueryKey(
          options,
        ),
    });

export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsInfiniteQueryKey =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData>,
  ): QueryKey<
    Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData>
  > =>
    createQueryKey(
      "get_api_confluence_v1_tenants_by_tenant_id_actions_pages_by_page_id_attachments",
      options,
      true,
    );

/**
 * Confluence Get Page Attachments V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsInfiniteOptions =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponse,
      GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsError,
      InfiniteData<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponse>,
      QueryKey<
        Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await confluence_get_page_attachments_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentQueryKey =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentData>,
  ) =>
    createQueryKey(
      "get_api_confluence_v1_tenants_by_tenant_id_actions_attachments_by_attachment_id_content",
      options,
    );

/**
 * Confluence Get Attachment Content V1
 */
export const getApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentOptions =
  (
    options: Options<GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentData>,
  ) =>
    queryOptions<
      GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponse,
      GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentError,
      GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponse,
      ReturnType<
        typeof getApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await confluence_get_attachment_content_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentQueryKey(
          options,
        ),
    });

/**
 * Confluence Update Page V1
 */
export const patchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdMutation =
  (
    options?: Partial<
      Options<PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdData>
    >,
  ): UseMutationOptions<
    PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponse,
    PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdError,
    Options<PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponse,
      PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdError,
      Options<PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await confluence_update_page_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiConfluenceV1OauthScopesQueryKey = (
  options?: Options<GetApiConfluenceV1OauthScopesData>,
) => createQueryKey("get_api_confluence_v1_oauth_scopes", options);

/**
 * Confluence Get Oauth Scopes V1
 */
export const getApiConfluenceV1OauthScopesOptions = (
  options?: Options<GetApiConfluenceV1OauthScopesData>,
) =>
  queryOptions<
    GetApiConfluenceV1OauthScopesResponse,
    DefaultError,
    GetApiConfluenceV1OauthScopesResponse,
    ReturnType<typeof getApiConfluenceV1OauthScopesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await confluence_get_oauth_scopes_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiConfluenceV1OauthScopesQueryKey(options),
  });

export const getApiConfluenceV1TenantsQueryKey = (
  options?: Options<GetApiConfluenceV1TenantsData>,
) => createQueryKey("get_api_confluence_v1_tenants", options);

/**
 * Confluence Get Tenants V1
 */
export const getApiConfluenceV1TenantsOptions = (
  options?: Options<GetApiConfluenceV1TenantsData>,
) =>
  queryOptions<
    GetApiConfluenceV1TenantsResponse,
    GetApiConfluenceV1TenantsError,
    GetApiConfluenceV1TenantsResponse,
    ReturnType<typeof getApiConfluenceV1TenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await confluence_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiConfluenceV1TenantsQueryKey(options),
  });

export const getApiConfluenceV1TenantsInfiniteQueryKey = (
  options?: Options<GetApiConfluenceV1TenantsData>,
): QueryKey<Options<GetApiConfluenceV1TenantsData>> =>
  createQueryKey("get_api_confluence_v1_tenants", options, true);

/**
 * Confluence Get Tenants V1
 */
export const getApiConfluenceV1TenantsInfiniteOptions = (
  options?: Options<GetApiConfluenceV1TenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiConfluenceV1TenantsResponse,
    GetApiConfluenceV1TenantsError,
    InfiniteData<GetApiConfluenceV1TenantsResponse>,
    QueryKey<Options<GetApiConfluenceV1TenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiConfluenceV1TenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiConfluenceV1TenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await confluence_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiConfluenceV1TenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Confluence Create Tenant V1
 */
export const postApiConfluenceV1TenantsMutation = (
  options?: Partial<Options<PostApiConfluenceV1TenantsData>>,
): UseMutationOptions<
  PostApiConfluenceV1TenantsResponse,
  PostApiConfluenceV1TenantsError,
  Options<PostApiConfluenceV1TenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiConfluenceV1TenantsResponse,
    PostApiConfluenceV1TenantsError,
    Options<PostApiConfluenceV1TenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await confluence_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Confluence Delete Tenant V1
 */
export const deleteApiConfluenceV1TenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiConfluenceV1TenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiConfluenceV1TenantsByTenantIdResponse,
  DeleteApiConfluenceV1TenantsByTenantIdError,
  Options<DeleteApiConfluenceV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiConfluenceV1TenantsByTenantIdResponse,
    DeleteApiConfluenceV1TenantsByTenantIdError,
    Options<DeleteApiConfluenceV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await confluence_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiConfluenceV1TenantsByTenantIdQueryKey = (
  options: Options<GetApiConfluenceV1TenantsByTenantIdData>,
) => createQueryKey("get_api_confluence_v1_tenants_by_tenant_id", options);

/**
 * Confluence Get Tenant V1
 */
export const getApiConfluenceV1TenantsByTenantIdOptions = (
  options: Options<GetApiConfluenceV1TenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiConfluenceV1TenantsByTenantIdResponse,
    GetApiConfluenceV1TenantsByTenantIdError,
    GetApiConfluenceV1TenantsByTenantIdResponse,
    ReturnType<typeof getApiConfluenceV1TenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await confluence_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiConfluenceV1TenantsByTenantIdQueryKey(options),
  });

/**
 * Confluence Patch Tenant V1
 */
export const patchApiConfluenceV1TenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiConfluenceV1TenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiConfluenceV1TenantsByTenantIdResponse,
  PatchApiConfluenceV1TenantsByTenantIdError,
  Options<PatchApiConfluenceV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiConfluenceV1TenantsByTenantIdResponse,
    PatchApiConfluenceV1TenantsByTenantIdError,
    Options<PatchApiConfluenceV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await confluence_patch_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Confluence Connect Tenant V1
 */
export const postApiConfluenceV1TenantsByTenantIdConnectMutation = (
  options?: Partial<Options<PostApiConfluenceV1TenantsByTenantIdConnectData>>,
): UseMutationOptions<
  PostApiConfluenceV1TenantsByTenantIdConnectResponse,
  PostApiConfluenceV1TenantsByTenantIdConnectError,
  Options<PostApiConfluenceV1TenantsByTenantIdConnectData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiConfluenceV1TenantsByTenantIdConnectResponse,
    PostApiConfluenceV1TenantsByTenantIdConnectError,
    Options<PostApiConfluenceV1TenantsByTenantIdConnectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await confluence_connect_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Confluence Callback Tenant V1
 */
export const postApiConfluenceV1TenantsByTenantIdCallbackMutation = (
  options?: Partial<Options<PostApiConfluenceV1TenantsByTenantIdCallbackData>>,
): UseMutationOptions<
  PostApiConfluenceV1TenantsByTenantIdCallbackResponse,
  PostApiConfluenceV1TenantsByTenantIdCallbackError,
  Options<PostApiConfluenceV1TenantsByTenantIdCallbackData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiConfluenceV1TenantsByTenantIdCallbackResponse,
    PostApiConfluenceV1TenantsByTenantIdCallbackError,
    Options<PostApiConfluenceV1TenantsByTenantIdCallbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await confluence_callback_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiConfluenceV1TenantsByTenantIdCheckConnectionQueryKey = (
  options: Options<GetApiConfluenceV1TenantsByTenantIdCheckConnectionData>,
) =>
  createQueryKey(
    "get_api_confluence_v1_tenants_by_tenant_id_check_connection",
    options,
  );

/**
 * Confluence Check Connection V1
 */
export const getApiConfluenceV1TenantsByTenantIdCheckConnectionOptions = (
  options: Options<GetApiConfluenceV1TenantsByTenantIdCheckConnectionData>,
) =>
  queryOptions<
    GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponse,
    GetApiConfluenceV1TenantsByTenantIdCheckConnectionError,
    GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponse,
    ReturnType<
      typeof getApiConfluenceV1TenantsByTenantIdCheckConnectionQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await confluence_check_connection_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiConfluenceV1TenantsByTenantIdCheckConnectionQueryKey(options),
  });

export const getApiV1ConversationsQueryKey = (
  options: Options<GetApiV1ConversationsData>,
) => createQueryKey("get_api_v1_conversations", options);

/**
 * Get Conversations V1
 */
export const getApiV1ConversationsOptions = (
  options: Options<GetApiV1ConversationsData>,
) =>
  queryOptions<
    GetApiV1ConversationsResponse,
    GetApiV1ConversationsError,
    GetApiV1ConversationsResponse,
    ReturnType<typeof getApiV1ConversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_conversations_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ConversationsQueryKey(options),
  });

export const getApiV1ConversationsInfiniteQueryKey = (
  options: Options<GetApiV1ConversationsData>,
): QueryKey<Options<GetApiV1ConversationsData>> =>
  createQueryKey("get_api_v1_conversations", options, true);

/**
 * Get Conversations V1
 */
export const getApiV1ConversationsInfiniteOptions = (
  options: Options<GetApiV1ConversationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ConversationsResponse,
    GetApiV1ConversationsError,
    InfiniteData<GetApiV1ConversationsResponse>,
    QueryKey<Options<GetApiV1ConversationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ConversationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ConversationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_conversations_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1ConversationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1ConversationsGroupByExternalIdQueryKey = (
  options: Options<GetApiV1ConversationsGroupByExternalIdData>,
) => createQueryKey("get_api_v1_conversations_group_by_external_id", options);

/**
 * Get Conversations Grouped By External Id V1
 */
export const getApiV1ConversationsGroupByExternalIdOptions = (
  options: Options<GetApiV1ConversationsGroupByExternalIdData>,
) =>
  queryOptions<
    GetApiV1ConversationsGroupByExternalIdResponse,
    GetApiV1ConversationsGroupByExternalIdError,
    GetApiV1ConversationsGroupByExternalIdResponse,
    ReturnType<typeof getApiV1ConversationsGroupByExternalIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_conversations_grouped_by_external_id_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ConversationsGroupByExternalIdQueryKey(options),
  });

export const getApiV1ConversationsGroupByExternalIdInfiniteQueryKey = (
  options: Options<GetApiV1ConversationsGroupByExternalIdData>,
): QueryKey<Options<GetApiV1ConversationsGroupByExternalIdData>> =>
  createQueryKey(
    "get_api_v1_conversations_group_by_external_id",
    options,
    true,
  );

/**
 * Get Conversations Grouped By External Id V1
 */
export const getApiV1ConversationsGroupByExternalIdInfiniteOptions = (
  options: Options<GetApiV1ConversationsGroupByExternalIdData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ConversationsGroupByExternalIdResponse,
    GetApiV1ConversationsGroupByExternalIdError,
    InfiniteData<GetApiV1ConversationsGroupByExternalIdResponse>,
    QueryKey<Options<GetApiV1ConversationsGroupByExternalIdData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ConversationsGroupByExternalIdData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ConversationsGroupByExternalIdData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_conversations_grouped_by_external_id_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1ConversationsGroupByExternalIdInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Update Conversation V2
 */
export const putApiV2ConversationsByExternalIdMutation = (
  options?: Partial<Options<PutApiV2ConversationsByExternalIdData>>,
): UseMutationOptions<
  PutApiV2ConversationsByExternalIdResponse,
  PutApiV2ConversationsByExternalIdError,
  Options<PutApiV2ConversationsByExternalIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiV2ConversationsByExternalIdResponse,
    PutApiV2ConversationsByExternalIdError,
    Options<PutApiV2ConversationsByExternalIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_conversation_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Append Conversation Messages V2
 */
export const postApiV2ConversationsByExternalIdMessagesMutation = (
  options?: Partial<Options<PostApiV2ConversationsByExternalIdMessagesData>>,
): UseMutationOptions<
  PostApiV2ConversationsByExternalIdMessagesResponse,
  PostApiV2ConversationsByExternalIdMessagesError,
  Options<PostApiV2ConversationsByExternalIdMessagesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2ConversationsByExternalIdMessagesResponse,
    PostApiV2ConversationsByExternalIdMessagesError,
    Options<PostApiV2ConversationsByExternalIdMessagesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await append_conversation_messages_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Stateless Conversation Inference V2
 */
export const postApiV2ConversationsByExternalIdStatelessInferenceMutation = (
  options?: Partial<
    Options<PostApiV2ConversationsByExternalIdStatelessInferenceData>
  >,
): UseMutationOptions<
  PostApiV2ConversationsByExternalIdStatelessInferenceResponse,
  PostApiV2ConversationsByExternalIdStatelessInferenceError,
  Options<PostApiV2ConversationsByExternalIdStatelessInferenceData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2ConversationsByExternalIdStatelessInferenceResponse,
    PostApiV2ConversationsByExternalIdStatelessInferenceError,
    Options<PostApiV2ConversationsByExternalIdStatelessInferenceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_stateless_conversation_inference_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Stateful Conversation Inference V2
 */
export const postApiV2ConversationsByExternalIdStatefulInferenceMutation = (
  options?: Partial<
    Options<PostApiV2ConversationsByExternalIdStatefulInferenceData>
  >,
): UseMutationOptions<
  PostApiV2ConversationsByExternalIdStatefulInferenceResponse,
  PostApiV2ConversationsByExternalIdStatefulInferenceError,
  Options<PostApiV2ConversationsByExternalIdStatefulInferenceData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2ConversationsByExternalIdStatefulInferenceResponse,
    PostApiV2ConversationsByExternalIdStatefulInferenceError,
    Options<PostApiV2ConversationsByExternalIdStatefulInferenceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_stateful_conversation_inference_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Conversation Feedback V2
 */
export const postApiV2ConversationsByExternalIdFeedbackMutation = (
  options?: Partial<Options<PostApiV2ConversationsByExternalIdFeedbackData>>,
): UseMutationOptions<
  PostApiV2ConversationsByExternalIdFeedbackResponse,
  PostApiV2ConversationsByExternalIdFeedbackError,
  Options<PostApiV2ConversationsByExternalIdFeedbackData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2ConversationsByExternalIdFeedbackResponse,
    PostApiV2ConversationsByExternalIdFeedbackError,
    Options<PostApiV2ConversationsByExternalIdFeedbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_conversation_feedback_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1DataDumpConversationsQueryKey = (
  options: Options<GetApiV1DataDumpConversationsData>,
) => createQueryKey("get_api_v1_data_dump_conversations", options);

/**
 * Get Data Dump Conversations V1
 */
export const getApiV1DataDumpConversationsOptions = (
  options: Options<GetApiV1DataDumpConversationsData>,
) =>
  queryOptions<
    GetApiV1DataDumpConversationsResponse,
    GetApiV1DataDumpConversationsError,
    GetApiV1DataDumpConversationsResponse,
    ReturnType<typeof getApiV1DataDumpConversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_data_dump_conversations_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1DataDumpConversationsQueryKey(options),
  });

export const getApiV1DataDumpConversationsInfiniteQueryKey = (
  options: Options<GetApiV1DataDumpConversationsData>,
): QueryKey<Options<GetApiV1DataDumpConversationsData>> =>
  createQueryKey("get_api_v1_data_dump_conversations", options, true);

/**
 * Get Data Dump Conversations V1
 */
export const getApiV1DataDumpConversationsInfiniteOptions = (
  options: Options<GetApiV1DataDumpConversationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1DataDumpConversationsResponse,
    GetApiV1DataDumpConversationsError,
    InfiniteData<GetApiV1DataDumpConversationsResponse>,
    QueryKey<Options<GetApiV1DataDumpConversationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1DataDumpConversationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1DataDumpConversationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_data_dump_conversations_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1DataDumpConversationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Data Dump Conversation V1
 */
export const postApiV1DataDumpConversationsMutation = (
  options?: Partial<Options<PostApiV1DataDumpConversationsData>>,
): UseMutationOptions<
  PostApiV1DataDumpConversationsResponse,
  PostApiV1DataDumpConversationsError,
  Options<PostApiV1DataDumpConversationsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1DataDumpConversationsResponse,
    PostApiV1DataDumpConversationsError,
    Options<PostApiV1DataDumpConversationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_data_dump_conversation_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1FullDataDumpConversationsQueryKey = (
  options: Options<GetApiV1FullDataDumpConversationsData>,
) => createQueryKey("get_api_v1_full_data_dump_conversations", options);

/**
 * Get Full Data Dump Conversations V1
 */
export const getApiV1FullDataDumpConversationsOptions = (
  options: Options<GetApiV1FullDataDumpConversationsData>,
) =>
  queryOptions<
    GetApiV1FullDataDumpConversationsResponse,
    GetApiV1FullDataDumpConversationsError,
    GetApiV1FullDataDumpConversationsResponse,
    ReturnType<typeof getApiV1FullDataDumpConversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_data_dump_conversations_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullDataDumpConversationsQueryKey(options),
  });

export const getApiV1FullDataDumpConversationsInfiniteQueryKey = (
  options: Options<GetApiV1FullDataDumpConversationsData>,
): QueryKey<Options<GetApiV1FullDataDumpConversationsData>> =>
  createQueryKey("get_api_v1_full_data_dump_conversations", options, true);

/**
 * Get Full Data Dump Conversations V1
 */
export const getApiV1FullDataDumpConversationsInfiniteOptions = (
  options: Options<GetApiV1FullDataDumpConversationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullDataDumpConversationsResponse,
    GetApiV1FullDataDumpConversationsError,
    InfiniteData<GetApiV1FullDataDumpConversationsResponse>,
    QueryKey<Options<GetApiV1FullDataDumpConversationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullDataDumpConversationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullDataDumpConversationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_data_dump_conversations_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullDataDumpConversationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Data Dump Conversation V1
 */
export const deleteApiV1DataDumpConversationsByDataDumpConversationIdMutation =
  (
    options?: Partial<
      Options<DeleteApiV1DataDumpConversationsByDataDumpConversationIdData>
    >,
  ): UseMutationOptions<
    DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponse,
    DeleteApiV1DataDumpConversationsByDataDumpConversationIdError,
    Options<DeleteApiV1DataDumpConversationsByDataDumpConversationIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponse,
      DeleteApiV1DataDumpConversationsByDataDumpConversationIdError,
      Options<DeleteApiV1DataDumpConversationsByDataDumpConversationIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await delete_data_dump_conversation_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Update Data Dump Conversation V1
 */
export const patchApiV1DataDumpConversationsByDataDumpConversationIdMutation = (
  options?: Partial<
    Options<PatchApiV1DataDumpConversationsByDataDumpConversationIdData>
  >,
): UseMutationOptions<
  PatchApiV1DataDumpConversationsByDataDumpConversationIdResponse,
  PatchApiV1DataDumpConversationsByDataDumpConversationIdError,
  Options<PatchApiV1DataDumpConversationsByDataDumpConversationIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1DataDumpConversationsByDataDumpConversationIdResponse,
    PatchApiV1DataDumpConversationsByDataDumpConversationIdError,
    Options<PatchApiV1DataDumpConversationsByDataDumpConversationIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_data_dump_conversation_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Data Dump Conversation V1
 */
export const postApiV1DataDumpConversationsByDataDumpConversationIdRestoreMutation =
  (
    options?: Partial<
      Options<PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreData>
    >,
  ): UseMutationOptions<
    PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponse,
    PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreError,
    Options<PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponse,
      PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreError,
      Options<PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await restore_data_dump_conversation_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Update Datapoint By External Id V3
 */
export const patchApiV3DatapointsMutation = (
  options?: Partial<Options<PatchApiV3DatapointsData>>,
): UseMutationOptions<
  PatchApiV3DatapointsResponse,
  PatchApiV3DatapointsError,
  Options<PatchApiV3DatapointsData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV3DatapointsResponse,
    PatchApiV3DatapointsError,
    Options<PatchApiV3DatapointsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_datapoint_by_external_id_v3({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Datapoints V3
 */
export const postApiV3DatapointsMutation = (
  options?: Partial<Options<PostApiV3DatapointsData>>,
): UseMutationOptions<
  PostApiV3DatapointsResponse,
  PostApiV3DatapointsError,
  Options<PostApiV3DatapointsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV3DatapointsResponse,
    PostApiV3DatapointsError,
    Options<PostApiV3DatapointsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_datapoints_v3({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Embed Datapoints V1
 */
export const postApiV1DatapointsEmbedMutation = (
  options?: Partial<Options<PostApiV1DatapointsEmbedData>>,
): UseMutationOptions<
  PostApiV1DatapointsEmbedResponse,
  PostApiV1DatapointsEmbedError,
  Options<PostApiV1DatapointsEmbedData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1DatapointsEmbedResponse,
    PostApiV1DatapointsEmbedError,
    Options<PostApiV1DatapointsEmbedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await embed_datapoints_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Backfill Index V1
 */
export const postApiV1DatapointsBackfillIndexMutation = (
  options?: Partial<Options<PostApiV1DatapointsBackfillIndexData>>,
): UseMutationOptions<
  PostApiV1DatapointsBackfillIndexResponse,
  PostApiV1DatapointsBackfillIndexError,
  Options<PostApiV1DatapointsBackfillIndexData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1DatapointsBackfillIndexResponse,
    PostApiV1DatapointsBackfillIndexError,
    Options<PostApiV1DatapointsBackfillIndexData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await backfill_index_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Search Datapoints V1
 */
export const postApiV1DatapointsSearchMutation = (
  options?: Partial<Options<PostApiV1DatapointsSearchData>>,
): UseMutationOptions<
  PostApiV1DatapointsSearchResponse,
  PostApiV1DatapointsSearchError,
  Options<PostApiV1DatapointsSearchData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1DatapointsSearchResponse,
    PostApiV1DatapointsSearchError,
    Options<PostApiV1DatapointsSearchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await search_datapoints_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Regex Search Datapoints V1
 */
export const postApiV1DatapointsRegexSearchMutation = (
  options?: Partial<Options<PostApiV1DatapointsRegexSearchData>>,
): UseMutationOptions<
  PostApiV1DatapointsRegexSearchResponse,
  PostApiV1DatapointsRegexSearchError,
  Options<PostApiV1DatapointsRegexSearchData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1DatapointsRegexSearchResponse,
    PostApiV1DatapointsRegexSearchError,
    Options<PostApiV1DatapointsRegexSearchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await regex_search_datapoints_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Search Datapoint Evidence V1
 */
export const postApiV1DatapointEvidenceSearchMutation = (
  options?: Partial<Options<PostApiV1DatapointEvidenceSearchData>>,
): UseMutationOptions<
  PostApiV1DatapointEvidenceSearchResponse,
  PostApiV1DatapointEvidenceSearchError,
  Options<PostApiV1DatapointEvidenceSearchData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1DatapointEvidenceSearchResponse,
    PostApiV1DatapointEvidenceSearchError,
    Options<PostApiV1DatapointEvidenceSearchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await search_datapoint_evidence_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV3DatapointsByDatapointIdQueryKey = (
  options: Options<GetApiV3DatapointsByDatapointIdData>,
) => createQueryKey("get_api_v3_datapoints_by_datapoint_id", options);

/**
 * Get Datapoint V3
 */
export const getApiV3DatapointsByDatapointIdOptions = (
  options: Options<GetApiV3DatapointsByDatapointIdData>,
) =>
  queryOptions<
    GetApiV3DatapointsByDatapointIdResponse,
    GetApiV3DatapointsByDatapointIdError,
    GetApiV3DatapointsByDatapointIdResponse,
    ReturnType<typeof getApiV3DatapointsByDatapointIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_datapoint_v3({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV3DatapointsByDatapointIdQueryKey(options),
  });

/**
 * Update Datapoint V3
 */
export const patchApiV3DatapointsByDatapointIdMutation = (
  options?: Partial<Options<PatchApiV3DatapointsByDatapointIdData>>,
): UseMutationOptions<
  PatchApiV3DatapointsByDatapointIdResponse,
  PatchApiV3DatapointsByDatapointIdError,
  Options<PatchApiV3DatapointsByDatapointIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV3DatapointsByDatapointIdResponse,
    PatchApiV3DatapointsByDatapointIdError,
    Options<PatchApiV3DatapointsByDatapointIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_datapoint_v3({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1FullDatapointsQueryKey = (
  options?: Options<GetApiV1FullDatapointsData>,
) => createQueryKey("get_api_v1_full_datapoints", options);

/**
 * Get Full Datapoints V1
 */
export const getApiV1FullDatapointsOptions = (
  options?: Options<GetApiV1FullDatapointsData>,
) =>
  queryOptions<
    GetApiV1FullDatapointsResponse,
    GetApiV1FullDatapointsError,
    GetApiV1FullDatapointsResponse,
    ReturnType<typeof getApiV1FullDatapointsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_datapoints_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullDatapointsQueryKey(options),
  });

export const getApiV1FullDatapointsInfiniteQueryKey = (
  options?: Options<GetApiV1FullDatapointsData>,
): QueryKey<Options<GetApiV1FullDatapointsData>> =>
  createQueryKey("get_api_v1_full_datapoints", options, true);

/**
 * Get Full Datapoints V1
 */
export const getApiV1FullDatapointsInfiniteOptions = (
  options?: Options<GetApiV1FullDatapointsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullDatapointsResponse,
    GetApiV1FullDatapointsError,
    InfiniteData<GetApiV1FullDatapointsResponse>,
    QueryKey<Options<GetApiV1FullDatapointsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullDatapointsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullDatapointsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_datapoints_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullDatapointsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1DatapointEvidenceQueryKey = (
  options?: Options<GetApiV1DatapointEvidenceData>,
) => createQueryKey("get_api_v1_datapoint_evidence", options);

/**
 * Get Datapoint Evidence V1
 */
export const getApiV1DatapointEvidenceOptions = (
  options?: Options<GetApiV1DatapointEvidenceData>,
) =>
  queryOptions<
    GetApiV1DatapointEvidenceResponse,
    GetApiV1DatapointEvidenceError,
    GetApiV1DatapointEvidenceResponse,
    ReturnType<typeof getApiV1DatapointEvidenceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_datapoint_evidence_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1DatapointEvidenceQueryKey(options),
  });

export const getApiV1DatapointEvidenceInfiniteQueryKey = (
  options?: Options<GetApiV1DatapointEvidenceData>,
): QueryKey<Options<GetApiV1DatapointEvidenceData>> =>
  createQueryKey("get_api_v1_datapoint_evidence", options, true);

/**
 * Get Datapoint Evidence V1
 */
export const getApiV1DatapointEvidenceInfiniteOptions = (
  options?: Options<GetApiV1DatapointEvidenceData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1DatapointEvidenceResponse,
    GetApiV1DatapointEvidenceError,
    InfiniteData<GetApiV1DatapointEvidenceResponse>,
    QueryKey<Options<GetApiV1DatapointEvidenceData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1DatapointEvidenceData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1DatapointEvidenceData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_datapoint_evidence_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1DatapointEvidenceInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Datapoint V2
 */
export const deleteApiV2DatapointsByDatapointIdMutation = (
  options?: Partial<Options<DeleteApiV2DatapointsByDatapointIdData>>,
): UseMutationOptions<
  DeleteApiV2DatapointsByDatapointIdResponse,
  DeleteApiV2DatapointsByDatapointIdError,
  Options<DeleteApiV2DatapointsByDatapointIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV2DatapointsByDatapointIdResponse,
    DeleteApiV2DatapointsByDatapointIdError,
    Options<DeleteApiV2DatapointsByDatapointIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_datapoint_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Datapoint V2
 */
export const postApiV2DatapointsByDatapointIdRestoreMutation = (
  options?: Partial<Options<PostApiV2DatapointsByDatapointIdRestoreData>>,
): UseMutationOptions<
  PostApiV2DatapointsByDatapointIdRestoreResponse,
  PostApiV2DatapointsByDatapointIdRestoreError,
  Options<PostApiV2DatapointsByDatapointIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2DatapointsByDatapointIdRestoreResponse,
    PostApiV2DatapointsByDatapointIdRestoreError,
    Options<PostApiV2DatapointsByDatapointIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_datapoint_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Openfga Write Tuples V1
 */
export const postApiDebugV1OpenfgaWriteTuplesMutation = (
  options?: Partial<Options<PostApiDebugV1OpenfgaWriteTuplesData>>,
): UseMutationOptions<
  PostApiDebugV1OpenfgaWriteTuplesResponse,
  PostApiDebugV1OpenfgaWriteTuplesError,
  Options<PostApiDebugV1OpenfgaWriteTuplesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiDebugV1OpenfgaWriteTuplesResponse,
    PostApiDebugV1OpenfgaWriteTuplesError,
    Options<PostApiDebugV1OpenfgaWriteTuplesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await openfga_write_tuples_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Openfga Read Tuples V1
 */
export const postApiDebugV1OpenfgaReadTuplesMutation = (
  options?: Partial<Options<PostApiDebugV1OpenfgaReadTuplesData>>,
): UseMutationOptions<
  PostApiDebugV1OpenfgaReadTuplesResponse,
  PostApiDebugV1OpenfgaReadTuplesError,
  Options<PostApiDebugV1OpenfgaReadTuplesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiDebugV1OpenfgaReadTuplesResponse,
    PostApiDebugV1OpenfgaReadTuplesError,
    Options<PostApiDebugV1OpenfgaReadTuplesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await openfga_read_tuples_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Openfga Check V1
 */
export const postApiDebugV1OpenfgaCheckMutation = (
  options?: Partial<Options<PostApiDebugV1OpenfgaCheckData>>,
): UseMutationOptions<
  PostApiDebugV1OpenfgaCheckResponse,
  PostApiDebugV1OpenfgaCheckError,
  Options<PostApiDebugV1OpenfgaCheckData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiDebugV1OpenfgaCheckResponse,
    PostApiDebugV1OpenfgaCheckError,
    Options<PostApiDebugV1OpenfgaCheckData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await openfga_check_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiDebugV1GetPoolStatsQueryKey = (
  options?: Options<GetApiDebugV1GetPoolStatsData>,
) => createQueryKey("get_api_debug_v1_get_pool_stats", options);

/**
 * Get Pool Stats V1
 */
export const getApiDebugV1GetPoolStatsOptions = (
  options?: Options<GetApiDebugV1GetPoolStatsData>,
) =>
  queryOptions<
    GetApiDebugV1GetPoolStatsResponse,
    DefaultError,
    GetApiDebugV1GetPoolStatsResponse,
    ReturnType<typeof getApiDebugV1GetPoolStatsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_pool_stats_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiDebugV1GetPoolStatsQueryKey(options),
  });

export const getApiDebugV1ReaderPoolCheckQueryKey = (
  options?: Options<GetApiDebugV1ReaderPoolCheckData>,
) => createQueryKey("get_api_debug_v1_reader_pool_check", options);

/**
 * Reader Pool Check V1
 */
export const getApiDebugV1ReaderPoolCheckOptions = (
  options?: Options<GetApiDebugV1ReaderPoolCheckData>,
) =>
  queryOptions<
    GetApiDebugV1ReaderPoolCheckResponse,
    DefaultError,
    GetApiDebugV1ReaderPoolCheckResponse,
    ReturnType<typeof getApiDebugV1ReaderPoolCheckQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reader_pool_check_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiDebugV1ReaderPoolCheckQueryKey(options),
  });

export const getApiDebugV1LogErrorQueryKey = (
  options?: Options<GetApiDebugV1LogErrorData>,
) => createQueryKey("get_api_debug_v1_log_error", options);

/**
 * Log Error V1
 */
export const getApiDebugV1LogErrorOptions = (
  options?: Options<GetApiDebugV1LogErrorData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getApiDebugV1LogErrorQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await log_error_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiDebugV1LogErrorQueryKey(options),
  });

export const getApiDebugV1LogSentryAlertQueryKey = (
  options?: Options<GetApiDebugV1LogSentryAlertData>,
) => createQueryKey("get_api_debug_v1_log_sentry_alert", options);

/**
 * Log Sentry Alert V1
 */
export const getApiDebugV1LogSentryAlertOptions = (
  options?: Options<GetApiDebugV1LogSentryAlertData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getApiDebugV1LogSentryAlertQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await log_sentry_alert_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiDebugV1LogSentryAlertQueryKey(options),
  });

export const getApiDebugV1Return500QueryKey = (
  options?: Options<GetApiDebugV1Return500Data>,
) => createQueryKey("get_api_debug_v1_return_500", options);

/**
 * Return 500 V1
 */
export const getApiDebugV1Return500Options = (
  options?: Options<GetApiDebugV1Return500Data>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getApiDebugV1Return500QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await return_500_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiDebugV1Return500QueryKey(options),
  });

export const getApiDebugV1KeyErrorQueryKey = (
  options?: Options<GetApiDebugV1KeyErrorData>,
) => createQueryKey("get_api_debug_v1_key_error", options);

/**
 * Key Error V1
 */
export const getApiDebugV1KeyErrorOptions = (
  options?: Options<GetApiDebugV1KeyErrorData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getApiDebugV1KeyErrorQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await key_error_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiDebugV1KeyErrorQueryKey(options),
  });

export const getApiDebugV1PrintLogsQueryKey = (
  options?: Options<GetApiDebugV1PrintLogsData>,
) => createQueryKey("get_api_debug_v1_print_logs", options);

/**
 * Print Logs V1
 */
export const getApiDebugV1PrintLogsOptions = (
  options?: Options<GetApiDebugV1PrintLogsData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getApiDebugV1PrintLogsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await print_logs_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiDebugV1PrintLogsQueryKey(options),
  });

export const getApiDebugV1UnwrapErrorQueryKey = (
  options?: Options<GetApiDebugV1UnwrapErrorData>,
) => createQueryKey("get_api_debug_v1_unwrap_error", options);

/**
 * Unwrap Error V1
 */
export const getApiDebugV1UnwrapErrorOptions = (
  options?: Options<GetApiDebugV1UnwrapErrorData>,
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof getApiDebugV1UnwrapErrorQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await unwrap_error_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiDebugV1UnwrapErrorQueryKey(options),
  });

/**
 * Background Task Error V1
 */
export const postApiDebugV1BackgroundTaskErrorMutation = (
  options?: Partial<Options<PostApiDebugV1BackgroundTaskErrorData>>,
): UseMutationOptions<
  PostApiDebugV1BackgroundTaskErrorResponse,
  DefaultError,
  Options<PostApiDebugV1BackgroundTaskErrorData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiDebugV1BackgroundTaskErrorResponse,
    DefaultError,
    Options<PostApiDebugV1BackgroundTaskErrorData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await background_task_error_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Search Reindex V1
 */
export const postApiDebugV1SearchReindexMutation = (
  options?: Partial<Options<PostApiDebugV1SearchReindexData>>,
): UseMutationOptions<
  PostApiDebugV1SearchReindexResponse,
  PostApiDebugV1SearchReindexError,
  Options<PostApiDebugV1SearchReindexData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiDebugV1SearchReindexResponse,
    PostApiDebugV1SearchReindexError,
    Options<PostApiDebugV1SearchReindexData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await search_reindex_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiDebugV1ValkeyPingQueryKey = (
  options?: Options<GetApiDebugV1ValkeyPingData>,
) => createQueryKey("get_api_debug_v1_valkey_ping", options);

/**
 * Valkey Ping V1
 */
export const getApiDebugV1ValkeyPingOptions = (
  options?: Options<GetApiDebugV1ValkeyPingData>,
) =>
  queryOptions<
    GetApiDebugV1ValkeyPingResponse,
    DefaultError,
    GetApiDebugV1ValkeyPingResponse,
    ReturnType<typeof getApiDebugV1ValkeyPingQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await valkey_ping_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiDebugV1ValkeyPingQueryKey(options),
  });

export const getApiDebugV1ValkeyValuesByKeyQueryKey = (
  options: Options<GetApiDebugV1ValkeyValuesByKeyData>,
) => createQueryKey("get_api_debug_v1_valkey_values_by_key", options);

/**
 * Get Valkey Value V1
 */
export const getApiDebugV1ValkeyValuesByKeyOptions = (
  options: Options<GetApiDebugV1ValkeyValuesByKeyData>,
) =>
  queryOptions<
    GetApiDebugV1ValkeyValuesByKeyResponse,
    GetApiDebugV1ValkeyValuesByKeyError,
    GetApiDebugV1ValkeyValuesByKeyResponse,
    ReturnType<typeof getApiDebugV1ValkeyValuesByKeyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_valkey_value_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiDebugV1ValkeyValuesByKeyQueryKey(options),
  });

/**
 * Set Valkey Value V1
 */
export const putApiDebugV1ValkeyValuesByKeyMutation = (
  options?: Partial<Options<PutApiDebugV1ValkeyValuesByKeyData>>,
): UseMutationOptions<
  PutApiDebugV1ValkeyValuesByKeyResponse,
  PutApiDebugV1ValkeyValuesByKeyError,
  Options<PutApiDebugV1ValkeyValuesByKeyData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiDebugV1ValkeyValuesByKeyResponse,
    PutApiDebugV1ValkeyValuesByKeyError,
    Options<PutApiDebugV1ValkeyValuesByKeyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await set_valkey_value_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiEntraV1TenantsByTenantIdActionsUsersQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersData>,
) =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_actions_users",
    options,
  );

/**
 * Entra Get Users V1
 */
export const getApiEntraV1TenantsByTenantIdActionsUsersOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsByTenantIdActionsUsersResponse,
    GetApiEntraV1TenantsByTenantIdActionsUsersError,
    GetApiEntraV1TenantsByTenantIdActionsUsersResponse,
    ReturnType<typeof getApiEntraV1TenantsByTenantIdActionsUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_get_users_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiEntraV1TenantsByTenantIdActionsUsersQueryKey(options),
  });

export const getApiEntraV1TenantsByTenantIdActionsUsersInfiniteQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersData>,
): QueryKey<Options<GetApiEntraV1TenantsByTenantIdActionsUsersData>> =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_actions_users",
    options,
    true,
  );

/**
 * Entra Get Users V1
 */
export const getApiEntraV1TenantsByTenantIdActionsUsersInfiniteOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiEntraV1TenantsByTenantIdActionsUsersResponse,
    GetApiEntraV1TenantsByTenantIdActionsUsersError,
    InfiniteData<GetApiEntraV1TenantsByTenantIdActionsUsersResponse>,
    QueryKey<Options<GetApiEntraV1TenantsByTenantIdActionsUsersData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetApiEntraV1TenantsByTenantIdActionsUsersData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiEntraV1TenantsByTenantIdActionsUsersData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await entra_get_users_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiEntraV1TenantsByTenantIdActionsUsersInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyData>,
) =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_actions_users_by_user_key",
    options,
  );

/**
 * Entra Get User V1
 */
export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponse,
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyError,
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponse,
    ReturnType<
      typeof getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_get_user_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyQueryKey(options),
  });

export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesQueryKey =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesData>,
  ) =>
    createQueryKey(
      "get_api_entra_v1_tenants_by_tenant_id_actions_users_by_user_key_licenses",
      options,
    );

/**
 * Entra Get User Licenses V1
 */
export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesOptions =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesData>,
  ) =>
    queryOptions<
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponse,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesError,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponse,
      ReturnType<
        typeof getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await entra_get_user_licenses_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesQueryKey(
          options,
        ),
    });

export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerQueryKey =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerData>,
  ) =>
    createQueryKey(
      "get_api_entra_v1_tenants_by_tenant_id_actions_users_by_user_key_manager",
      options,
    );

/**
 * Entra Get User Manager V1
 */
export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerOptions =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerData>,
  ) =>
    queryOptions<
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponse,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerError,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponse,
      ReturnType<
        typeof getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await entra_get_user_manager_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerQueryKey(
          options,
        ),
    });

export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsQueryKey =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData>,
  ) =>
    createQueryKey(
      "get_api_entra_v1_tenants_by_tenant_id_actions_users_by_user_key_direct_reports",
      options,
    );

/**
 * Entra Get User Direct Reports V1
 */
export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsOptions =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData>,
  ) =>
    queryOptions<
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponse,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsError,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponse,
      ReturnType<
        typeof getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await entra_get_user_direct_reports_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsQueryKey(
          options,
        ),
    });

export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsInfiniteQueryKey =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData>,
  ): QueryKey<
    Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData>
  > =>
    createQueryKey(
      "get_api_entra_v1_tenants_by_tenant_id_actions_users_by_user_key_direct_reports",
      options,
      true,
    );

/**
 * Entra Get User Direct Reports V1
 */
export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsInfiniteOptions =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponse,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsError,
      InfiniteData<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponse>,
      QueryKey<
        Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await entra_get_user_direct_reports_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsQueryKey =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData>,
  ) =>
    createQueryKey(
      "get_api_entra_v1_tenants_by_tenant_id_actions_users_by_user_key_groups",
      options,
    );

/**
 * Entra Get User Groups V1
 */
export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsOptions =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData>,
  ) =>
    queryOptions<
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponse,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsError,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponse,
      ReturnType<
        typeof getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await entra_get_user_groups_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsQueryKey(
          options,
        ),
    });

export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsInfiniteQueryKey =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData>,
  ): QueryKey<
    Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData>
  > =>
    createQueryKey(
      "get_api_entra_v1_tenants_by_tenant_id_actions_users_by_user_key_groups",
      options,
      true,
    );

/**
 * Entra Get User Groups V1
 */
export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsInfiniteOptions =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponse,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsError,
      InfiniteData<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponse>,
      QueryKey<
        Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await entra_get_user_groups_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateQueryKey =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateData>,
  ) =>
    createQueryKey(
      "get_api_entra_v1_tenants_by_tenant_id_actions_users_by_user_key_sign_in_state",
      options,
    );

/**
 * Entra Get User Sign In State V1
 */
export const getApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateOptions =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateData>,
  ) =>
    queryOptions<
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponse,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateError,
      GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponse,
      ReturnType<
        typeof getApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await entra_get_user_sign_in_state_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateQueryKey(
          options,
        ),
    });

export const getApiEntraV1TenantsByTenantIdActionsGroupsQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsGroupsData>,
) =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_actions_groups",
    options,
  );

/**
 * Entra Get Groups V1
 */
export const getApiEntraV1TenantsByTenantIdActionsGroupsOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsGroupsData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsByTenantIdActionsGroupsResponse,
    GetApiEntraV1TenantsByTenantIdActionsGroupsError,
    GetApiEntraV1TenantsByTenantIdActionsGroupsResponse,
    ReturnType<typeof getApiEntraV1TenantsByTenantIdActionsGroupsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_get_groups_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiEntraV1TenantsByTenantIdActionsGroupsQueryKey(options),
  });

export const getApiEntraV1TenantsByTenantIdActionsGroupsInfiniteQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsGroupsData>,
): QueryKey<Options<GetApiEntraV1TenantsByTenantIdActionsGroupsData>> =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_actions_groups",
    options,
    true,
  );

/**
 * Entra Get Groups V1
 */
export const getApiEntraV1TenantsByTenantIdActionsGroupsInfiniteOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsGroupsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiEntraV1TenantsByTenantIdActionsGroupsResponse,
    GetApiEntraV1TenantsByTenantIdActionsGroupsError,
    InfiniteData<GetApiEntraV1TenantsByTenantIdActionsGroupsResponse>,
    QueryKey<Options<GetApiEntraV1TenantsByTenantIdActionsGroupsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetApiEntraV1TenantsByTenantIdActionsGroupsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiEntraV1TenantsByTenantIdActionsGroupsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await entra_get_groups_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiEntraV1TenantsByTenantIdActionsGroupsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdData>,
) =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_actions_groups_by_group_id",
    options,
  );

/**
 * Entra Get Group V1
 */
export const getApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponse,
    GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdError,
    GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponse,
    ReturnType<
      typeof getApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_get_group_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdQueryKey(options),
  });

export const getApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersQueryKey =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData>,
  ) =>
    createQueryKey(
      "get_api_entra_v1_tenants_by_tenant_id_actions_groups_by_group_id_members",
      options,
    );

/**
 * Entra Get Group Members V1
 */
export const getApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersOptions =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData>,
  ) =>
    queryOptions<
      GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponse,
      GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersError,
      GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponse,
      ReturnType<
        typeof getApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await entra_get_group_members_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersQueryKey(
          options,
        ),
    });

export const getApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersInfiniteQueryKey =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData>,
  ): QueryKey<
    Options<GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData>
  > =>
    createQueryKey(
      "get_api_entra_v1_tenants_by_tenant_id_actions_groups_by_group_id_members",
      options,
      true,
    );

/**
 * Entra Get Group Members V1
 */
export const getApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersInfiniteOptions =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponse,
      GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersError,
      InfiniteData<GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponse>,
      QueryKey<
        Options<GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await entra_get_group_members_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiEntraV1TenantsByTenantIdActionsSubscribedSkusQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusData>,
) =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_actions_subscribed_skus",
    options,
  );

/**
 * Entra Get Subscribed Skus V1
 */
export const getApiEntraV1TenantsByTenantIdActionsSubscribedSkusOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponse,
    GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusError,
    GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponse,
    ReturnType<
      typeof getApiEntraV1TenantsByTenantIdActionsSubscribedSkusQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_get_subscribed_skus_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiEntraV1TenantsByTenantIdActionsSubscribedSkusQueryKey(options),
  });

export const getApiEntraV1TenantsByTenantIdActionsDirectoryRolesQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesData>,
) =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_actions_directory_roles",
    options,
  );

/**
 * Entra Get Directory Roles V1
 */
export const getApiEntraV1TenantsByTenantIdActionsDirectoryRolesOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponse,
    GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesError,
    GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponse,
    ReturnType<
      typeof getApiEntraV1TenantsByTenantIdActionsDirectoryRolesQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_get_directory_roles_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiEntraV1TenantsByTenantIdActionsDirectoryRolesQueryKey(options),
  });

export const getApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersQueryKey =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData>,
  ) =>
    createQueryKey(
      "get_api_entra_v1_tenants_by_tenant_id_actions_directory_roles_by_role_id_members",
      options,
    );

/**
 * Entra Get Directory Role Members V1
 */
export const getApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersOptions =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData>,
  ) =>
    queryOptions<
      GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponse,
      GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersError,
      GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponse,
      ReturnType<
        typeof getApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await entra_get_directory_role_members_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersQueryKey(
          options,
        ),
    });

export const getApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersInfiniteQueryKey =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData>,
  ): QueryKey<
    Options<GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData>
  > =>
    createQueryKey(
      "get_api_entra_v1_tenants_by_tenant_id_actions_directory_roles_by_role_id_members",
      options,
      true,
    );

/**
 * Entra Get Directory Role Members V1
 */
export const getApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersInfiniteOptions =
  (
    options: Options<GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponse,
      GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersError,
      InfiniteData<GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponse>,
      QueryKey<
        Options<GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await entra_get_directory_role_members_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

/**
 * Entra Resolve Caller V1
 */
export const postApiEntraV1TenantsByTenantIdActionsResolveCallerMutation = (
  options?: Partial<
    Options<PostApiEntraV1TenantsByTenantIdActionsResolveCallerData>
  >,
): UseMutationOptions<
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponse,
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerError,
  Options<PostApiEntraV1TenantsByTenantIdActionsResolveCallerData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponse,
    PostApiEntraV1TenantsByTenantIdActionsResolveCallerError,
    Options<PostApiEntraV1TenantsByTenantIdActionsResolveCallerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await entra_resolve_caller_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiEntraV1TenantsQueryKey = (
  options?: Options<GetApiEntraV1TenantsData>,
) => createQueryKey("get_api_entra_v1_tenants", options);

/**
 * Entra Get Tenants V1
 */
export const getApiEntraV1TenantsOptions = (
  options?: Options<GetApiEntraV1TenantsData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsResponse,
    GetApiEntraV1TenantsError,
    GetApiEntraV1TenantsResponse,
    ReturnType<typeof getApiEntraV1TenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiEntraV1TenantsQueryKey(options),
  });

export const getApiEntraV1TenantsInfiniteQueryKey = (
  options?: Options<GetApiEntraV1TenantsData>,
): QueryKey<Options<GetApiEntraV1TenantsData>> =>
  createQueryKey("get_api_entra_v1_tenants", options, true);

/**
 * Entra Get Tenants V1
 */
export const getApiEntraV1TenantsInfiniteOptions = (
  options?: Options<GetApiEntraV1TenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiEntraV1TenantsResponse,
    GetApiEntraV1TenantsError,
    InfiniteData<GetApiEntraV1TenantsResponse>,
    QueryKey<Options<GetApiEntraV1TenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiEntraV1TenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiEntraV1TenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await entra_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiEntraV1TenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Entra Create Tenant V1
 */
export const postApiEntraV1TenantsMutation = (
  options?: Partial<Options<PostApiEntraV1TenantsData>>,
): UseMutationOptions<
  PostApiEntraV1TenantsResponse,
  PostApiEntraV1TenantsError,
  Options<PostApiEntraV1TenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiEntraV1TenantsResponse,
    PostApiEntraV1TenantsError,
    Options<PostApiEntraV1TenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await entra_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Entra Delete Tenant V1
 */
export const deleteApiEntraV1TenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiEntraV1TenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiEntraV1TenantsByTenantIdResponse,
  DeleteApiEntraV1TenantsByTenantIdError,
  Options<DeleteApiEntraV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiEntraV1TenantsByTenantIdResponse,
    DeleteApiEntraV1TenantsByTenantIdError,
    Options<DeleteApiEntraV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await entra_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiEntraV1TenantsByTenantIdQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdData>,
) => createQueryKey("get_api_entra_v1_tenants_by_tenant_id", options);

/**
 * Entra Get Tenant V1
 */
export const getApiEntraV1TenantsByTenantIdOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsByTenantIdResponse,
    GetApiEntraV1TenantsByTenantIdError,
    GetApiEntraV1TenantsByTenantIdResponse,
    ReturnType<typeof getApiEntraV1TenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiEntraV1TenantsByTenantIdQueryKey(options),
  });

/**
 * Entra Patch Tenant V1
 */
export const patchApiEntraV1TenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiEntraV1TenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiEntraV1TenantsByTenantIdResponse,
  PatchApiEntraV1TenantsByTenantIdError,
  Options<PatchApiEntraV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiEntraV1TenantsByTenantIdResponse,
    PatchApiEntraV1TenantsByTenantIdError,
    Options<PatchApiEntraV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await entra_patch_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiEntraV1FullTenantsQueryKey = (
  options?: Options<GetApiEntraV1FullTenantsData>,
) => createQueryKey("get_api_entra_v1_full_tenants", options);

/**
 * Entra Get Full Tenants V1
 */
export const getApiEntraV1FullTenantsOptions = (
  options?: Options<GetApiEntraV1FullTenantsData>,
) =>
  queryOptions<
    GetApiEntraV1FullTenantsResponse,
    GetApiEntraV1FullTenantsError,
    GetApiEntraV1FullTenantsResponse,
    ReturnType<typeof getApiEntraV1FullTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_get_full_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiEntraV1FullTenantsQueryKey(options),
  });

export const getApiEntraV1FullTenantsInfiniteQueryKey = (
  options?: Options<GetApiEntraV1FullTenantsData>,
): QueryKey<Options<GetApiEntraV1FullTenantsData>> =>
  createQueryKey("get_api_entra_v1_full_tenants", options, true);

/**
 * Entra Get Full Tenants V1
 */
export const getApiEntraV1FullTenantsInfiniteOptions = (
  options?: Options<GetApiEntraV1FullTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiEntraV1FullTenantsResponse,
    GetApiEntraV1FullTenantsError,
    InfiniteData<GetApiEntraV1FullTenantsResponse>,
    QueryKey<Options<GetApiEntraV1FullTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiEntraV1FullTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiEntraV1FullTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await entra_get_full_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiEntraV1FullTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiEntraV1TenantsByTenantIdCheckConnectionQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdCheckConnectionData>,
) =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_check_connection",
    options,
  );

/**
 * Entra Check Connection V1
 */
export const getApiEntraV1TenantsByTenantIdCheckConnectionOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdCheckConnectionData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsByTenantIdCheckConnectionResponse,
    GetApiEntraV1TenantsByTenantIdCheckConnectionError,
    GetApiEntraV1TenantsByTenantIdCheckConnectionResponse,
    ReturnType<typeof getApiEntraV1TenantsByTenantIdCheckConnectionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_check_connection_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiEntraV1TenantsByTenantIdCheckConnectionQueryKey(options),
  });

export const getApiEntraV1TenantsByTenantIdPermissionPreflightQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdPermissionPreflightData>,
) =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_permission_preflight",
    options,
  );

/**
 * Entra Permission Preflight V1
 */
export const getApiEntraV1TenantsByTenantIdPermissionPreflightOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdPermissionPreflightData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsByTenantIdPermissionPreflightResponse,
    GetApiEntraV1TenantsByTenantIdPermissionPreflightError,
    GetApiEntraV1TenantsByTenantIdPermissionPreflightResponse,
    ReturnType<typeof getApiEntraV1TenantsByTenantIdPermissionPreflightQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_permission_preflight_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiEntraV1TenantsByTenantIdPermissionPreflightQueryKey(options),
  });

export const getApiEntraV1TenantsByTenantIdProposedActionsQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdProposedActionsData>,
) =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_proposed_actions",
    options,
  );

/**
 * Entra Get Proposed Actions V1
 */
export const getApiEntraV1TenantsByTenantIdProposedActionsOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdProposedActionsData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsByTenantIdProposedActionsResponse,
    GetApiEntraV1TenantsByTenantIdProposedActionsError,
    GetApiEntraV1TenantsByTenantIdProposedActionsResponse,
    ReturnType<typeof getApiEntraV1TenantsByTenantIdProposedActionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_get_proposed_actions_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiEntraV1TenantsByTenantIdProposedActionsQueryKey(options),
  });

export const getApiEntraV1TenantsByTenantIdProposedActionsInfiniteQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdProposedActionsData>,
): QueryKey<Options<GetApiEntraV1TenantsByTenantIdProposedActionsData>> =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_proposed_actions",
    options,
    true,
  );

/**
 * Entra Get Proposed Actions V1
 */
export const getApiEntraV1TenantsByTenantIdProposedActionsInfiniteOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdProposedActionsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiEntraV1TenantsByTenantIdProposedActionsResponse,
    GetApiEntraV1TenantsByTenantIdProposedActionsError,
    InfiniteData<GetApiEntraV1TenantsByTenantIdProposedActionsResponse>,
    QueryKey<Options<GetApiEntraV1TenantsByTenantIdProposedActionsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiEntraV1TenantsByTenantIdProposedActionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiEntraV1TenantsByTenantIdProposedActionsData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await entra_get_proposed_actions_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiEntraV1TenantsByTenantIdProposedActionsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Entra Create Proposed Action V1
 */
export const postApiEntraV1TenantsByTenantIdProposedActionsMutation = (
  options?: Partial<
    Options<PostApiEntraV1TenantsByTenantIdProposedActionsData>
  >,
): UseMutationOptions<
  PostApiEntraV1TenantsByTenantIdProposedActionsResponse,
  PostApiEntraV1TenantsByTenantIdProposedActionsError,
  Options<PostApiEntraV1TenantsByTenantIdProposedActionsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiEntraV1TenantsByTenantIdProposedActionsResponse,
    PostApiEntraV1TenantsByTenantIdProposedActionsError,
    Options<PostApiEntraV1TenantsByTenantIdProposedActionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await entra_create_proposed_action_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiEntraV1TenantsByTenantIdProposedActionsByActionIdQueryKey = (
  options: Options<GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdData>,
) =>
  createQueryKey(
    "get_api_entra_v1_tenants_by_tenant_id_proposed_actions_by_action_id",
    options,
  );

/**
 * Entra Get Proposed Action V1
 */
export const getApiEntraV1TenantsByTenantIdProposedActionsByActionIdOptions = (
  options: Options<GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdData>,
) =>
  queryOptions<
    GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponse,
    GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdError,
    GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponse,
    ReturnType<
      typeof getApiEntraV1TenantsByTenantIdProposedActionsByActionIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await entra_get_proposed_action_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiEntraV1TenantsByTenantIdProposedActionsByActionIdQueryKey(options),
  });

/**
 * Entra Approve Proposed Action V1
 */
export const postApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveMutation =
  (
    options?: Partial<
      Options<PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveData>
    >,
  ): UseMutationOptions<
    PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponse,
    PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveError,
    Options<PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponse,
      PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveError,
      Options<PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await entra_approve_proposed_action_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Entra Reject Proposed Action V1
 */
export const postApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectMutation =
  (
    options?: Partial<
      Options<PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectData>
    >,
  ): UseMutationOptions<
    PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponse,
    PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectError,
    Options<PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponse,
      PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectError,
      Options<PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await entra_reject_proposed_action_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1JudgesQueryKey = (options: Options<GetApiV1JudgesData>) =>
  createQueryKey("get_api_v1_judges", options);

/**
 * Get Judges V1
 */
export const getApiV1JudgesOptions = (options: Options<GetApiV1JudgesData>) =>
  queryOptions<
    GetApiV1JudgesResponse,
    GetApiV1JudgesError,
    GetApiV1JudgesResponse,
    ReturnType<typeof getApiV1JudgesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_judges_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1JudgesQueryKey(options),
  });

export const getApiV1JudgesInfiniteQueryKey = (
  options: Options<GetApiV1JudgesData>,
): QueryKey<Options<GetApiV1JudgesData>> =>
  createQueryKey("get_api_v1_judges", options, true);

/**
 * Get Judges V1
 */
export const getApiV1JudgesInfiniteOptions = (
  options: Options<GetApiV1JudgesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1JudgesResponse,
    GetApiV1JudgesError,
    InfiniteData<GetApiV1JudgesResponse>,
    QueryKey<Options<GetApiV1JudgesData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1JudgesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1JudgesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_judges_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1JudgesInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Judge V1
 */
export const postApiV1JudgesMutation = (
  options?: Partial<Options<PostApiV1JudgesData>>,
): UseMutationOptions<
  PostApiV1JudgesResponse,
  PostApiV1JudgesError,
  Options<PostApiV1JudgesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1JudgesResponse,
    PostApiV1JudgesError,
    Options<PostApiV1JudgesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_judge_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Judge V1
 */
export const deleteApiV1JudgesByJudgeIdMutation = (
  options?: Partial<Options<DeleteApiV1JudgesByJudgeIdData>>,
): UseMutationOptions<
  DeleteApiV1JudgesByJudgeIdResponse,
  DeleteApiV1JudgesByJudgeIdError,
  Options<DeleteApiV1JudgesByJudgeIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1JudgesByJudgeIdResponse,
    DeleteApiV1JudgesByJudgeIdError,
    Options<DeleteApiV1JudgesByJudgeIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_judge_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1JudgesByJudgeIdQueryKey = (
  options: Options<GetApiV1JudgesByJudgeIdData>,
) => createQueryKey("get_api_v1_judges_by_judge_id", options);

/**
 * Get Judge V1
 */
export const getApiV1JudgesByJudgeIdOptions = (
  options: Options<GetApiV1JudgesByJudgeIdData>,
) =>
  queryOptions<
    GetApiV1JudgesByJudgeIdResponse,
    GetApiV1JudgesByJudgeIdError,
    GetApiV1JudgesByJudgeIdResponse,
    ReturnType<typeof getApiV1JudgesByJudgeIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_judge_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1JudgesByJudgeIdQueryKey(options),
  });

/**
 * Update Judge V1
 */
export const patchApiV1JudgesByJudgeIdMutation = (
  options?: Partial<Options<PatchApiV1JudgesByJudgeIdData>>,
): UseMutationOptions<
  PatchApiV1JudgesByJudgeIdResponse,
  PatchApiV1JudgesByJudgeIdError,
  Options<PatchApiV1JudgesByJudgeIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1JudgesByJudgeIdResponse,
    PatchApiV1JudgesByJudgeIdError,
    Options<PatchApiV1JudgesByJudgeIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_judge_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Judge V1
 */
export const postApiV1JudgesByJudgeIdRestoreMutation = (
  options?: Partial<Options<PostApiV1JudgesByJudgeIdRestoreData>>,
): UseMutationOptions<
  PostApiV1JudgesByJudgeIdRestoreResponse,
  PostApiV1JudgesByJudgeIdRestoreError,
  Options<PostApiV1JudgesByJudgeIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1JudgesByJudgeIdRestoreResponse,
    PostApiV1JudgesByJudgeIdRestoreError,
    Options<PostApiV1JudgesByJudgeIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_judge_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ExternalInferencesQueryKey = (
  options?: Options<GetApiV1ExternalInferencesData>,
) => createQueryKey("get_api_v1_external_inferences", options);

/**
 * Get External Inferences V1
 */
export const getApiV1ExternalInferencesOptions = (
  options?: Options<GetApiV1ExternalInferencesData>,
) =>
  queryOptions<
    GetApiV1ExternalInferencesResponse,
    GetApiV1ExternalInferencesError,
    GetApiV1ExternalInferencesResponse,
    ReturnType<typeof getApiV1ExternalInferencesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_external_inferences_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ExternalInferencesQueryKey(options),
  });

export const getApiV1ExternalInferencesInfiniteQueryKey = (
  options?: Options<GetApiV1ExternalInferencesData>,
): QueryKey<Options<GetApiV1ExternalInferencesData>> =>
  createQueryKey("get_api_v1_external_inferences", options, true);

/**
 * Get External Inferences V1
 */
export const getApiV1ExternalInferencesInfiniteOptions = (
  options?: Options<GetApiV1ExternalInferencesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ExternalInferencesResponse,
    GetApiV1ExternalInferencesError,
    InfiniteData<GetApiV1ExternalInferencesResponse>,
    QueryKey<Options<GetApiV1ExternalInferencesData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ExternalInferencesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ExternalInferencesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_external_inferences_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1ExternalInferencesInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create External Inferences V1
 */
export const postApiV1ExternalInferencesMutation = (
  options?: Partial<Options<PostApiV1ExternalInferencesData>>,
): UseMutationOptions<
  PostApiV1ExternalInferencesResponse,
  PostApiV1ExternalInferencesError,
  Options<PostApiV1ExternalInferencesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ExternalInferencesResponse,
    PostApiV1ExternalInferencesError,
    Options<PostApiV1ExternalInferencesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_external_inferences_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete External Inference V1
 */
export const deleteApiV1ExternalInferencesByInferenceIdMutation = (
  options?: Partial<Options<DeleteApiV1ExternalInferencesByInferenceIdData>>,
): UseMutationOptions<
  DeleteApiV1ExternalInferencesByInferenceIdResponse,
  DeleteApiV1ExternalInferencesByInferenceIdError,
  Options<DeleteApiV1ExternalInferencesByInferenceIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1ExternalInferencesByInferenceIdResponse,
    DeleteApiV1ExternalInferencesByInferenceIdError,
    Options<DeleteApiV1ExternalInferencesByInferenceIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_external_inference_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ExternalInferencesByInferenceIdQueryKey = (
  options: Options<GetApiV1ExternalInferencesByInferenceIdData>,
) => createQueryKey("get_api_v1_external_inferences_by_inference_id", options);

/**
 * Get External Inference V1
 */
export const getApiV1ExternalInferencesByInferenceIdOptions = (
  options: Options<GetApiV1ExternalInferencesByInferenceIdData>,
) =>
  queryOptions<
    GetApiV1ExternalInferencesByInferenceIdResponse,
    GetApiV1ExternalInferencesByInferenceIdError,
    GetApiV1ExternalInferencesByInferenceIdResponse,
    ReturnType<typeof getApiV1ExternalInferencesByInferenceIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_external_inference_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ExternalInferencesByInferenceIdQueryKey(options),
  });

/**
 * Update External Inference V1
 */
export const patchApiV1ExternalInferencesByInferenceIdMutation = (
  options?: Partial<Options<PatchApiV1ExternalInferencesByInferenceIdData>>,
): UseMutationOptions<
  PatchApiV1ExternalInferencesByInferenceIdResponse,
  PatchApiV1ExternalInferencesByInferenceIdError,
  Options<PatchApiV1ExternalInferencesByInferenceIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1ExternalInferencesByInferenceIdResponse,
    PatchApiV1ExternalInferencesByInferenceIdError,
    Options<PatchApiV1ExternalInferencesByInferenceIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_external_inference_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV2FinalizedConversationsQueryKey = (
  options: Options<GetApiV2FinalizedConversationsData>,
) => createQueryKey("get_api_v2_finalized_conversations", options);

/**
 * Get Finalized Conversations V2
 */
export const getApiV2FinalizedConversationsOptions = (
  options: Options<GetApiV2FinalizedConversationsData>,
) =>
  queryOptions<
    GetApiV2FinalizedConversationsResponse,
    GetApiV2FinalizedConversationsError,
    GetApiV2FinalizedConversationsResponse,
    ReturnType<typeof getApiV2FinalizedConversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_finalized_conversations_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2FinalizedConversationsQueryKey(options),
  });

export const getApiV2FinalizedConversationsInfiniteQueryKey = (
  options: Options<GetApiV2FinalizedConversationsData>,
): QueryKey<Options<GetApiV2FinalizedConversationsData>> =>
  createQueryKey("get_api_v2_finalized_conversations", options, true);

/**
 * Get Finalized Conversations V2
 */
export const getApiV2FinalizedConversationsInfiniteOptions = (
  options: Options<GetApiV2FinalizedConversationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV2FinalizedConversationsResponse,
    GetApiV2FinalizedConversationsError,
    InfiniteData<GetApiV2FinalizedConversationsResponse>,
    QueryKey<Options<GetApiV2FinalizedConversationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV2FinalizedConversationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV2FinalizedConversationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_finalized_conversations_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV2FinalizedConversationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Finalized Conversations V2
 */
export const postApiV2FinalizedConversationsMutation = (
  options?: Partial<Options<PostApiV2FinalizedConversationsData>>,
): UseMutationOptions<
  PostApiV2FinalizedConversationsResponse,
  PostApiV2FinalizedConversationsError,
  Options<PostApiV2FinalizedConversationsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2FinalizedConversationsResponse,
    PostApiV2FinalizedConversationsError,
    Options<PostApiV2FinalizedConversationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_finalized_conversations_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV2FullFinalizedConversationsQueryKey = (
  options?: Options<GetApiV2FullFinalizedConversationsData>,
) => createQueryKey("get_api_v2_full_finalized_conversations", options);

/**
 * Get Full Finalized Conversations V2
 */
export const getApiV2FullFinalizedConversationsOptions = (
  options?: Options<GetApiV2FullFinalizedConversationsData>,
) =>
  queryOptions<
    GetApiV2FullFinalizedConversationsResponse,
    GetApiV2FullFinalizedConversationsError,
    GetApiV2FullFinalizedConversationsResponse,
    ReturnType<typeof getApiV2FullFinalizedConversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_finalized_conversations_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2FullFinalizedConversationsQueryKey(options),
  });

export const getApiV2FullFinalizedConversationsInfiniteQueryKey = (
  options?: Options<GetApiV2FullFinalizedConversationsData>,
): QueryKey<Options<GetApiV2FullFinalizedConversationsData>> =>
  createQueryKey("get_api_v2_full_finalized_conversations", options, true);

/**
 * Get Full Finalized Conversations V2
 */
export const getApiV2FullFinalizedConversationsInfiniteOptions = (
  options?: Options<GetApiV2FullFinalizedConversationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV2FullFinalizedConversationsResponse,
    GetApiV2FullFinalizedConversationsError,
    InfiniteData<GetApiV2FullFinalizedConversationsResponse>,
    QueryKey<Options<GetApiV2FullFinalizedConversationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV2FullFinalizedConversationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV2FullFinalizedConversationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_finalized_conversations_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV2FullFinalizedConversationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV2FullFinalizedConversationsByFinalizedConversationIdQueryKey =
  (
    options: Options<GetApiV2FullFinalizedConversationsByFinalizedConversationIdData>,
  ) =>
    createQueryKey(
      "get_api_v2_full_finalized_conversations_by_finalized_conversation_id",
      options,
    );

/**
 * Get Full Finalized Conversation V2
 */
export const getApiV2FullFinalizedConversationsByFinalizedConversationIdOptions =
  (
    options: Options<GetApiV2FullFinalizedConversationsByFinalizedConversationIdData>,
  ) =>
    queryOptions<
      GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponse,
      GetApiV2FullFinalizedConversationsByFinalizedConversationIdError,
      GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponse,
      ReturnType<
        typeof getApiV2FullFinalizedConversationsByFinalizedConversationIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_full_finalized_conversation_v2({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV2FullFinalizedConversationsByFinalizedConversationIdQueryKey(
          options,
        ),
    });

/**
 * Delete Finalized Conversation V1
 */
export const deleteApiV1FinalizedConversationsByFinalizedConversationIdMutation =
  (
    options?: Partial<
      Options<DeleteApiV1FinalizedConversationsByFinalizedConversationIdData>
    >,
  ): UseMutationOptions<
    DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponse,
    DeleteApiV1FinalizedConversationsByFinalizedConversationIdError,
    Options<DeleteApiV1FinalizedConversationsByFinalizedConversationIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponse,
      DeleteApiV1FinalizedConversationsByFinalizedConversationIdError,
      Options<DeleteApiV1FinalizedConversationsByFinalizedConversationIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await delete_finalized_conversation_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Update Finalized Conversation V1
 */
export const patchApiV1FinalizedConversationsByFinalizedConversationIdMutation =
  (
    options?: Partial<
      Options<PatchApiV1FinalizedConversationsByFinalizedConversationIdData>
    >,
  ): UseMutationOptions<
    PatchApiV1FinalizedConversationsByFinalizedConversationIdResponse,
    PatchApiV1FinalizedConversationsByFinalizedConversationIdError,
    Options<PatchApiV1FinalizedConversationsByFinalizedConversationIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiV1FinalizedConversationsByFinalizedConversationIdResponse,
      PatchApiV1FinalizedConversationsByFinalizedConversationIdError,
      Options<PatchApiV1FinalizedConversationsByFinalizedConversationIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await update_finalized_conversation_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Restore Finalized Conversation V1
 */
export const postApiV1FinalizedConversationsByFinalizedConversationIdRestoreMutation =
  (
    options?: Partial<
      Options<PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreData>
    >,
  ): UseMutationOptions<
    PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponse,
    PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreError,
    Options<PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponse,
      PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreError,
      Options<PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await restore_finalized_conversation_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Append Finalized Conversation Messages V1
 */
export const postApiV1FinalizedConversationsByFinalizedConversationIdMessagesMutation =
  (
    options?: Partial<
      Options<PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesData>
    >,
  ): UseMutationOptions<
    PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponse,
    PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesError,
    Options<PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponse,
      PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesError,
      Options<PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await append_finalized_conversation_messages_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Update Finalized Conversation Message V1
 */
export const patchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdMutation =
  (
    options?: Partial<
      Options<PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdData>
    >,
  ): UseMutationOptions<
    PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponse,
    PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdError,
    Options<PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponse,
      PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdError,
      Options<PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await update_finalized_conversation_message_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiFreshserviceV1TenantsByTenantIdActionsTicketsQueryKey = (
  options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData>,
) =>
  createQueryKey(
    "get_api_freshservice_v1_tenants_by_tenant_id_actions_tickets",
    options,
  );

/**
 * Freshservice Get Tickets V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsTicketsOptions = (
  options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData>,
) =>
  queryOptions<
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse,
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsError,
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse,
    ReturnType<
      typeof getApiFreshserviceV1TenantsByTenantIdActionsTicketsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await freshservice_get_tickets_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiFreshserviceV1TenantsByTenantIdActionsTicketsQueryKey(options),
  });

export const getApiFreshserviceV1TenantsByTenantIdActionsTicketsInfiniteQueryKey =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData>,
  ): QueryKey<
    Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData>
  > =>
    createQueryKey(
      "get_api_freshservice_v1_tenants_by_tenant_id_actions_tickets",
      options,
      true,
    );

/**
 * Freshservice Get Tickets V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsTicketsInfiniteOptions =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse,
      GetApiFreshserviceV1TenantsByTenantIdActionsTicketsError,
      InfiniteData<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse>,
      QueryKey<
        Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData>
      >,
      | number
      | null
      | Pick<
          QueryKey<
            Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    page: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await freshservice_get_tickets_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiFreshserviceV1TenantsByTenantIdActionsTicketsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

/**
 * Freshservice Create Ticket V1
 */
export const postApiFreshserviceV1TenantsByTenantIdActionsTicketsMutation = (
  options?: Partial<
    Options<PostApiFreshserviceV1TenantsByTenantIdActionsTicketsData>
  >,
): UseMutationOptions<
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsError,
  Options<PostApiFreshserviceV1TenantsByTenantIdActionsTicketsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse,
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsError,
    Options<PostApiFreshserviceV1TenantsByTenantIdActionsTicketsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await freshservice_create_ticket_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdQueryKey =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData>,
  ) =>
    createQueryKey(
      "get_api_freshservice_v1_tenants_by_tenant_id_actions_tickets_by_ticket_id",
      options,
    );

/**
 * Freshservice Get Ticket V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdOptions =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData>,
  ) =>
    queryOptions<
      GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponse,
      GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdError,
      GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponse,
      ReturnType<
        typeof getApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await freshservice_get_ticket_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdQueryKey(
          options,
        ),
    });

/**
 * Freshservice Update Ticket V1
 */
export const patchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdMutation =
  (
    options?: Partial<
      Options<PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData>
    >,
  ): UseMutationOptions<
    PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponse,
    PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdError,
    Options<PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponse,
      PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdError,
      Options<PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await freshservice_update_ticket_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsQueryKey =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsData>,
  ) =>
    createQueryKey(
      "get_api_freshservice_v1_tenants_by_tenant_id_actions_tickets_by_ticket_id_conversations",
      options,
    );

/**
 * Freshservice Get Ticket Conversations V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsOptions =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsData>,
  ) =>
    queryOptions<
      GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponse,
      GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsError,
      GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponse,
      ReturnType<
        typeof getApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await freshservice_get_ticket_conversations_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsQueryKey(
          options,
        ),
    });

/**
 * Freshservice Reply To Ticket V1
 */
export const postApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyMutation =
  (
    options?: Partial<
      Options<PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyData>
    >,
  ): UseMutationOptions<
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponse,
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyError,
    Options<PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponse,
      PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyError,
      Options<PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await freshservice_reply_to_ticket_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Freshservice Add Note To Ticket V1
 */
export const postApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesMutation =
  (
    options?: Partial<
      Options<PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesData>
    >,
  ): UseMutationOptions<
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponse,
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesError,
    Options<PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponse,
      PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesError,
      Options<PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await freshservice_add_note_to_ticket_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesQueryKey =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesData>,
  ) =>
    createQueryKey(
      "get_api_freshservice_v1_tenants_by_tenant_id_actions_solutions_categories",
      options,
    );

/**
 * Freshservice Get Categories V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesOptions =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesData>,
  ) =>
    queryOptions<
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponse,
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesError,
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponse,
      ReturnType<
        typeof getApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await freshservice_get_categories_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesQueryKey(
          options,
        ),
    });

export const getApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersQueryKey =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData>,
  ) =>
    createQueryKey(
      "get_api_freshservice_v1_tenants_by_tenant_id_actions_solutions_folders",
      options,
    );

/**
 * Freshservice Get Folders V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersOptions =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData>,
  ) =>
    queryOptions<
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponse,
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersError,
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponse,
      ReturnType<
        typeof getApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await freshservice_get_folders_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersQueryKey(
          options,
        ),
    });

/**
 * Freshservice Create Folder V1
 */
export const postApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersMutation =
  (
    options?: Partial<
      Options<PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData>
    >,
  ): UseMutationOptions<
    PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponse,
    PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersError,
    Options<PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponse,
      PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersError,
      Options<PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await freshservice_create_folder_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesQueryKey =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData>,
  ) =>
    createQueryKey(
      "get_api_freshservice_v1_tenants_by_tenant_id_actions_solutions_articles",
      options,
    );

/**
 * Freshservice Get Articles V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesOptions =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData>,
  ) =>
    queryOptions<
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponse,
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesError,
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponse,
      ReturnType<
        typeof getApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await freshservice_get_articles_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesQueryKey(
          options,
        ),
    });

/**
 * Freshservice Create Article V1
 */
export const postApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesMutation =
  (
    options?: Partial<
      Options<PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData>
    >,
  ): UseMutationOptions<
    PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponse,
    PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesError,
    Options<PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponse,
      PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesError,
      Options<PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await freshservice_create_article_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdQueryKey =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData>,
  ) =>
    createQueryKey(
      "get_api_freshservice_v1_tenants_by_tenant_id_actions_solutions_articles_by_article_id",
      options,
    );

/**
 * Freshservice Get Article V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdOptions =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData>,
  ) =>
    queryOptions<
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponse,
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdError,
      GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponse,
      ReturnType<
        typeof getApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await freshservice_get_article_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdQueryKey(
          options,
        ),
    });

/**
 * Freshservice Update Article V1
 */
export const patchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdMutation =
  (
    options?: Partial<
      Options<PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData>
    >,
  ): UseMutationOptions<
    PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponse,
    PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdError,
    Options<PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponse,
      PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdError,
      Options<PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await freshservice_update_article_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiFreshserviceV1TenantsByTenantIdActionsRequestersQueryKey = (
  options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData>,
) =>
  createQueryKey(
    "get_api_freshservice_v1_tenants_by_tenant_id_actions_requesters",
    options,
  );

/**
 * Freshservice Get Requesters V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsRequestersOptions = (
  options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData>,
) =>
  queryOptions<
    GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponse,
    GetApiFreshserviceV1TenantsByTenantIdActionsRequestersError,
    GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponse,
    ReturnType<
      typeof getApiFreshserviceV1TenantsByTenantIdActionsRequestersQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await freshservice_get_requesters_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiFreshserviceV1TenantsByTenantIdActionsRequestersQueryKey(options),
  });

export const getApiFreshserviceV1TenantsByTenantIdActionsRequestersInfiniteQueryKey =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData>,
  ): QueryKey<
    Options<GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData>
  > =>
    createQueryKey(
      "get_api_freshservice_v1_tenants_by_tenant_id_actions_requesters",
      options,
      true,
    );

/**
 * Freshservice Get Requesters V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsRequestersInfiniteOptions =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponse,
      GetApiFreshserviceV1TenantsByTenantIdActionsRequestersError,
      InfiniteData<GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponse>,
      QueryKey<
        Options<GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData>
      >,
      | number
      | null
      | Pick<
          QueryKey<
            Options<GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    page: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await freshservice_get_requesters_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiFreshserviceV1TenantsByTenantIdActionsRequestersInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdQueryKey =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdData>,
  ) =>
    createQueryKey(
      "get_api_freshservice_v1_tenants_by_tenant_id_actions_requesters_by_requester_id",
      options,
    );

/**
 * Freshservice Get Requester V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdOptions =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdData>,
  ) =>
    queryOptions<
      GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponse,
      GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdError,
      GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponse,
      ReturnType<
        typeof getApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await freshservice_get_requester_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdQueryKey(
          options,
        ),
    });

export const getApiFreshserviceV1TenantsByTenantIdActionsAgentsQueryKey = (
  options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData>,
) =>
  createQueryKey(
    "get_api_freshservice_v1_tenants_by_tenant_id_actions_agents",
    options,
  );

/**
 * Freshservice Get Agents V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsAgentsOptions = (
  options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData>,
) =>
  queryOptions<
    GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponse,
    GetApiFreshserviceV1TenantsByTenantIdActionsAgentsError,
    GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponse,
    ReturnType<
      typeof getApiFreshserviceV1TenantsByTenantIdActionsAgentsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await freshservice_get_agents_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiFreshserviceV1TenantsByTenantIdActionsAgentsQueryKey(options),
  });

export const getApiFreshserviceV1TenantsByTenantIdActionsAgentsInfiniteQueryKey =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData>,
  ): QueryKey<
    Options<GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData>
  > =>
    createQueryKey(
      "get_api_freshservice_v1_tenants_by_tenant_id_actions_agents",
      options,
      true,
    );

/**
 * Freshservice Get Agents V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsAgentsInfiniteOptions =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponse,
      GetApiFreshserviceV1TenantsByTenantIdActionsAgentsError,
      InfiniteData<GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponse>,
      QueryKey<Options<GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData>>,
      | number
      | null
      | Pick<
          QueryKey<
            Options<GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    page: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await freshservice_get_agents_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiFreshserviceV1TenantsByTenantIdActionsAgentsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdQueryKey =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdData>,
  ) =>
    createQueryKey(
      "get_api_freshservice_v1_tenants_by_tenant_id_actions_agents_by_agent_id",
      options,
    );

/**
 * Freshservice Get Agent V1
 */
export const getApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdOptions =
  (
    options: Options<GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdData>,
  ) =>
    queryOptions<
      GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponse,
      GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdError,
      GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponse,
      ReturnType<
        typeof getApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await freshservice_get_agent_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdQueryKey(
          options,
        ),
    });

export const getApiFreshserviceV1TenantsQueryKey = (
  options?: Options<GetApiFreshserviceV1TenantsData>,
) => createQueryKey("get_api_freshservice_v1_tenants", options);

/**
 * Freshservice Get Tenants V1
 */
export const getApiFreshserviceV1TenantsOptions = (
  options?: Options<GetApiFreshserviceV1TenantsData>,
) =>
  queryOptions<
    GetApiFreshserviceV1TenantsResponse,
    GetApiFreshserviceV1TenantsError,
    GetApiFreshserviceV1TenantsResponse,
    ReturnType<typeof getApiFreshserviceV1TenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await freshservice_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiFreshserviceV1TenantsQueryKey(options),
  });

export const getApiFreshserviceV1TenantsInfiniteQueryKey = (
  options?: Options<GetApiFreshserviceV1TenantsData>,
): QueryKey<Options<GetApiFreshserviceV1TenantsData>> =>
  createQueryKey("get_api_freshservice_v1_tenants", options, true);

/**
 * Freshservice Get Tenants V1
 */
export const getApiFreshserviceV1TenantsInfiniteOptions = (
  options?: Options<GetApiFreshserviceV1TenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiFreshserviceV1TenantsResponse,
    GetApiFreshserviceV1TenantsError,
    InfiniteData<GetApiFreshserviceV1TenantsResponse>,
    QueryKey<Options<GetApiFreshserviceV1TenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiFreshserviceV1TenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiFreshserviceV1TenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await freshservice_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiFreshserviceV1TenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Freshservice Create Tenant V1
 */
export const postApiFreshserviceV1TenantsMutation = (
  options?: Partial<Options<PostApiFreshserviceV1TenantsData>>,
): UseMutationOptions<
  PostApiFreshserviceV1TenantsResponse,
  PostApiFreshserviceV1TenantsError,
  Options<PostApiFreshserviceV1TenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiFreshserviceV1TenantsResponse,
    PostApiFreshserviceV1TenantsError,
    Options<PostApiFreshserviceV1TenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await freshservice_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiFreshserviceV1FullTenantsQueryKey = (
  options?: Options<GetApiFreshserviceV1FullTenantsData>,
) => createQueryKey("get_api_freshservice_v1_full_tenants", options);

/**
 * Freshservice Get Full Tenants V1
 */
export const getApiFreshserviceV1FullTenantsOptions = (
  options?: Options<GetApiFreshserviceV1FullTenantsData>,
) =>
  queryOptions<
    GetApiFreshserviceV1FullTenantsResponse,
    GetApiFreshserviceV1FullTenantsError,
    GetApiFreshserviceV1FullTenantsResponse,
    ReturnType<typeof getApiFreshserviceV1FullTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await freshservice_get_full_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiFreshserviceV1FullTenantsQueryKey(options),
  });

export const getApiFreshserviceV1FullTenantsInfiniteQueryKey = (
  options?: Options<GetApiFreshserviceV1FullTenantsData>,
): QueryKey<Options<GetApiFreshserviceV1FullTenantsData>> =>
  createQueryKey("get_api_freshservice_v1_full_tenants", options, true);

/**
 * Freshservice Get Full Tenants V1
 */
export const getApiFreshserviceV1FullTenantsInfiniteOptions = (
  options?: Options<GetApiFreshserviceV1FullTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiFreshserviceV1FullTenantsResponse,
    GetApiFreshserviceV1FullTenantsError,
    InfiniteData<GetApiFreshserviceV1FullTenantsResponse>,
    QueryKey<Options<GetApiFreshserviceV1FullTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiFreshserviceV1FullTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiFreshserviceV1FullTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await freshservice_get_full_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiFreshserviceV1FullTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Freshservice Delete Tenant V1
 */
export const deleteApiFreshserviceV1TenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiFreshserviceV1TenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiFreshserviceV1TenantsByTenantIdResponse,
  DeleteApiFreshserviceV1TenantsByTenantIdError,
  Options<DeleteApiFreshserviceV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiFreshserviceV1TenantsByTenantIdResponse,
    DeleteApiFreshserviceV1TenantsByTenantIdError,
    Options<DeleteApiFreshserviceV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await freshservice_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiFreshserviceV1TenantsByTenantIdQueryKey = (
  options: Options<GetApiFreshserviceV1TenantsByTenantIdData>,
) => createQueryKey("get_api_freshservice_v1_tenants_by_tenant_id", options);

/**
 * Freshservice Get Tenant V1
 */
export const getApiFreshserviceV1TenantsByTenantIdOptions = (
  options: Options<GetApiFreshserviceV1TenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiFreshserviceV1TenantsByTenantIdResponse,
    GetApiFreshserviceV1TenantsByTenantIdError,
    GetApiFreshserviceV1TenantsByTenantIdResponse,
    ReturnType<typeof getApiFreshserviceV1TenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await freshservice_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiFreshserviceV1TenantsByTenantIdQueryKey(options),
  });

/**
 * Freshservice Patch Tenant V1
 */
export const patchApiFreshserviceV1TenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiFreshserviceV1TenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiFreshserviceV1TenantsByTenantIdResponse,
  PatchApiFreshserviceV1TenantsByTenantIdError,
  Options<PatchApiFreshserviceV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiFreshserviceV1TenantsByTenantIdResponse,
    PatchApiFreshserviceV1TenantsByTenantIdError,
    Options<PatchApiFreshserviceV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await freshservice_patch_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Freshservice Provision Webhook V1
 */
export const postApiFreshserviceV1TenantsByTenantIdProvisionWebhookMutation = (
  options?: Partial<
    Options<PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookData>
  >,
): UseMutationOptions<
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponse,
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookError,
  Options<PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponse,
    PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookError,
    Options<PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await freshservice_provision_webhook_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiFreshserviceV1TenantsByTenantIdCheckConnectionQueryKey = (
  options: Options<GetApiFreshserviceV1TenantsByTenantIdCheckConnectionData>,
) =>
  createQueryKey(
    "get_api_freshservice_v1_tenants_by_tenant_id_check_connection",
    options,
  );

/**
 * Freshservice Check Connection V1
 */
export const getApiFreshserviceV1TenantsByTenantIdCheckConnectionOptions = (
  options: Options<GetApiFreshserviceV1TenantsByTenantIdCheckConnectionData>,
) =>
  queryOptions<
    GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponse,
    GetApiFreshserviceV1TenantsByTenantIdCheckConnectionError,
    GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponse,
    ReturnType<
      typeof getApiFreshserviceV1TenantsByTenantIdCheckConnectionQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await freshservice_check_connection_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiFreshserviceV1TenantsByTenantIdCheckConnectionQueryKey(options),
  });

export const getApiV1FrontendConfigQueryKey = (
  options?: Options<GetApiV1FrontendConfigData>,
) => createQueryKey("get_api_v1_frontend_config", options);

/**
 * Get Frontend Config V1
 */
export const getApiV1FrontendConfigOptions = (
  options?: Options<GetApiV1FrontendConfigData>,
) =>
  queryOptions<
    GetApiV1FrontendConfigResponse,
    DefaultError,
    GetApiV1FrontendConfigResponse,
    ReturnType<typeof getApiV1FrontendConfigQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_frontend_config_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FrontendConfigQueryKey(options),
  });

/**
 * Hubspot Reply To Thread V1
 */
export const postApiHubspotV1ActionsReplyToThreadMutation = (
  options?: Partial<Options<PostApiHubspotV1ActionsReplyToThreadData>>,
): UseMutationOptions<
  PostApiHubspotV1ActionsReplyToThreadResponse,
  PostApiHubspotV1ActionsReplyToThreadError,
  Options<PostApiHubspotV1ActionsReplyToThreadData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiHubspotV1ActionsReplyToThreadResponse,
    PostApiHubspotV1ActionsReplyToThreadError,
    Options<PostApiHubspotV1ActionsReplyToThreadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await hubspot_reply_to_thread_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Hubspot Create Thread On Ticket V1
 */
export const postApiHubspotV1ActionsCreateThreadOnTicketMutation = (
  options?: Partial<Options<PostApiHubspotV1ActionsCreateThreadOnTicketData>>,
): UseMutationOptions<
  PostApiHubspotV1ActionsCreateThreadOnTicketResponse,
  PostApiHubspotV1ActionsCreateThreadOnTicketError,
  Options<PostApiHubspotV1ActionsCreateThreadOnTicketData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiHubspotV1ActionsCreateThreadOnTicketResponse,
    PostApiHubspotV1ActionsCreateThreadOnTicketError,
    Options<PostApiHubspotV1ActionsCreateThreadOnTicketData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await hubspot_create_thread_on_ticket_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Hubspot Add Note V2
 */
export const postApiHubspotV2TenantsByTenantIdActionsAddNoteMutation = (
  options?: Partial<
    Options<PostApiHubspotV2TenantsByTenantIdActionsAddNoteData>
  >,
): UseMutationOptions<
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponse,
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteError,
  Options<PostApiHubspotV2TenantsByTenantIdActionsAddNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponse,
    PostApiHubspotV2TenantsByTenantIdActionsAddNoteError,
    Options<PostApiHubspotV2TenantsByTenantIdActionsAddNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await hubspot_add_note_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Hubspot Update Note V1
 */
export const postApiHubspotV1ActionsUpdateNoteMutation = (
  options?: Partial<Options<PostApiHubspotV1ActionsUpdateNoteData>>,
): UseMutationOptions<
  PostApiHubspotV1ActionsUpdateNoteResponse,
  PostApiHubspotV1ActionsUpdateNoteError,
  Options<PostApiHubspotV1ActionsUpdateNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiHubspotV1ActionsUpdateNoteResponse,
    PostApiHubspotV1ActionsUpdateNoteError,
    Options<PostApiHubspotV1ActionsUpdateNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await hubspot_update_note_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Hubspot Set Ticket Owner V1
 */
export const postApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerMutation = (
  options?: Partial<
    Options<PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerData>
  >,
): UseMutationOptions<
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponse,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerError,
  Options<PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponse,
    PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerError,
    Options<PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await hubspot_set_ticket_owner_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Hubspot Set Ticket Status V1
 */
export const postApiHubspotV1TenantsByTenantIdActionsSetTicketStatusMutation = (
  options?: Partial<
    Options<PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusData>
  >,
): UseMutationOptions<
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponse,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusError,
  Options<PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponse,
    PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusError,
    Options<PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await hubspot_set_ticket_status_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Hubspot Update Ticket Properties V1
 */
export const postApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesMutation =
  (
    options?: Partial<
      Options<PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesData>
    >,
  ): UseMutationOptions<
    PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponse,
    PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesError,
    Options<PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponse,
      PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesError,
      Options<PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await hubspot_update_ticket_properties_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiHubspotV1TenantsByTenantIdActionsAttachmentContentQueryKey =
  (
    options: Options<GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentData>,
  ) =>
    createQueryKey(
      "get_api_hubspot_v1_tenants_by_tenant_id_actions_attachment_content",
      options,
    );

/**
 * Hubspot Get Attachment Content V1
 */
export const getApiHubspotV1TenantsByTenantIdActionsAttachmentContentOptions = (
  options: Options<GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentData>,
) =>
  queryOptions<
    GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponse,
    GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentError,
    GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponse,
    ReturnType<
      typeof getApiHubspotV1TenantsByTenantIdActionsAttachmentContentQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hubspot_get_attachment_content_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiHubspotV1TenantsByTenantIdActionsAttachmentContentQueryKey(options),
  });

export const getApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataQueryKey =
  (
    options: Options<GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataData>,
  ) =>
    createQueryKey(
      "get_api_hubspot_v1_tenants_by_tenant_id_actions_attachment_metadata",
      options,
    );

/**
 * Hubspot Get Attachment Metadata V1
 */
export const getApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataOptions =
  (
    options: Options<GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataData>,
  ) =>
    queryOptions<
      GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponse,
      GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataError,
      GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponse,
      ReturnType<
        typeof getApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await hubspot_get_attachment_metadata_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataQueryKey(
          options,
        ),
    });

export const getApiV1HubspotTenantsByTenantIdTicketsQueryKey = (
  options: Options<GetApiV1HubspotTenantsByTenantIdTicketsData>,
) => createQueryKey("get_api_v1_hubspot_tenants_by_tenant_id_tickets", options);

/**
 * Hubspot List Tickets V1
 */
export const getApiV1HubspotTenantsByTenantIdTicketsOptions = (
  options: Options<GetApiV1HubspotTenantsByTenantIdTicketsData>,
) =>
  queryOptions<
    GetApiV1HubspotTenantsByTenantIdTicketsResponse,
    GetApiV1HubspotTenantsByTenantIdTicketsError,
    GetApiV1HubspotTenantsByTenantIdTicketsResponse,
    ReturnType<typeof getApiV1HubspotTenantsByTenantIdTicketsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hubspot_list_tickets_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1HubspotTenantsByTenantIdTicketsQueryKey(options),
  });

export const getApiV1HubspotTenantsByTenantIdTicketsByTicketIdQueryKey = (
  options: Options<GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdData>,
) =>
  createQueryKey(
    "get_api_v1_hubspot_tenants_by_tenant_id_tickets_by_ticket_id",
    options,
  );

/**
 * Hubspot Get Ticket V1
 */
export const getApiV1HubspotTenantsByTenantIdTicketsByTicketIdOptions = (
  options: Options<GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdData>,
) =>
  queryOptions<
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponse,
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdError,
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponse,
    ReturnType<typeof getApiV1HubspotTenantsByTenantIdTicketsByTicketIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hubspot_get_ticket_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1HubspotTenantsByTenantIdTicketsByTicketIdQueryKey(options),
  });

export const getApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesQueryKey = (
  options: Options<GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesData>,
) =>
  createQueryKey(
    "get_api_v1_hubspot_tenants_by_tenant_id_tickets_by_ticket_id_notes",
    options,
  );

/**
 * Hubspot List Ticket Notes V1
 */
export const getApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesOptions = (
  options: Options<GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesData>,
) =>
  queryOptions<
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponse,
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesError,
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponse,
    ReturnType<
      typeof getApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hubspot_list_ticket_notes_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesQueryKey(options),
  });

export const getApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdQueryKey = (
  options: Options<GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdData>,
) =>
  createQueryKey(
    "get_api_v1_hubspot_tenants_by_tenant_id_companies_by_company_id",
    options,
  );

/**
 * Hubspot Get Company V1
 */
export const getApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdOptions = (
  options: Options<GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdData>,
) =>
  queryOptions<
    GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponse,
    GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdError,
    GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponse,
    ReturnType<
      typeof getApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hubspot_get_company_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdQueryKey(options),
  });

export const getApiV1HubspotTenantsByTenantIdThreadsByThreadIdQueryKey = (
  options: Options<GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdData>,
) =>
  createQueryKey(
    "get_api_v1_hubspot_tenants_by_tenant_id_threads_by_thread_id",
    options,
  );

/**
 * Hubspot Get Thread V1
 */
export const getApiV1HubspotTenantsByTenantIdThreadsByThreadIdOptions = (
  options: Options<GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdData>,
) =>
  queryOptions<
    GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponse,
    GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdError,
    GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponse,
    ReturnType<typeof getApiV1HubspotTenantsByTenantIdThreadsByThreadIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hubspot_get_thread_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1HubspotTenantsByTenantIdThreadsByThreadIdQueryKey(options),
  });

export const getApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesQueryKey =
  (
    options: Options<GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesData>,
  ) =>
    createQueryKey(
      "get_api_v1_hubspot_tenants_by_tenant_id_threads_by_thread_id_messages",
      options,
    );

/**
 * Hubspot List Thread Messages V1
 */
export const getApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesOptions =
  (
    options: Options<GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesData>,
  ) =>
    queryOptions<
      GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponse,
      GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesError,
      GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponse,
      ReturnType<
        typeof getApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await hubspot_list_thread_messages_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesQueryKey(
          options,
        ),
    });

export const getApiV1HubspotTenantsQueryKey = (
  options?: Options<GetApiV1HubspotTenantsData>,
) => createQueryKey("get_api_v1_hubspot_tenants", options);

/**
 * Hubspot Get Tenants V1
 */
export const getApiV1HubspotTenantsOptions = (
  options?: Options<GetApiV1HubspotTenantsData>,
) =>
  queryOptions<
    GetApiV1HubspotTenantsResponse,
    GetApiV1HubspotTenantsError,
    GetApiV1HubspotTenantsResponse,
    ReturnType<typeof getApiV1HubspotTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hubspot_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1HubspotTenantsQueryKey(options),
  });

export const getApiV1HubspotTenantsInfiniteQueryKey = (
  options?: Options<GetApiV1HubspotTenantsData>,
): QueryKey<Options<GetApiV1HubspotTenantsData>> =>
  createQueryKey("get_api_v1_hubspot_tenants", options, true);

/**
 * Hubspot Get Tenants V1
 */
export const getApiV1HubspotTenantsInfiniteOptions = (
  options?: Options<GetApiV1HubspotTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1HubspotTenantsResponse,
    GetApiV1HubspotTenantsError,
    InfiniteData<GetApiV1HubspotTenantsResponse>,
    QueryKey<Options<GetApiV1HubspotTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1HubspotTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1HubspotTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await hubspot_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1HubspotTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Hubspot Create Tenant V1
 */
export const postApiV1HubspotTenantsMutation = (
  options?: Partial<Options<PostApiV1HubspotTenantsData>>,
): UseMutationOptions<
  PostApiV1HubspotTenantsResponse,
  PostApiV1HubspotTenantsError,
  Options<PostApiV1HubspotTenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1HubspotTenantsResponse,
    PostApiV1HubspotTenantsError,
    Options<PostApiV1HubspotTenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await hubspot_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1HubspotFullTenantsQueryKey = (
  options?: Options<GetApiV1HubspotFullTenantsData>,
) => createQueryKey("get_api_v1_hubspot_full_tenants", options);

/**
 * Hubspot Get Full Tenants V1
 */
export const getApiV1HubspotFullTenantsOptions = (
  options?: Options<GetApiV1HubspotFullTenantsData>,
) =>
  queryOptions<
    GetApiV1HubspotFullTenantsResponse,
    GetApiV1HubspotFullTenantsError,
    GetApiV1HubspotFullTenantsResponse,
    ReturnType<typeof getApiV1HubspotFullTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hubspot_get_full_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1HubspotFullTenantsQueryKey(options),
  });

export const getApiV1HubspotFullTenantsInfiniteQueryKey = (
  options?: Options<GetApiV1HubspotFullTenantsData>,
): QueryKey<Options<GetApiV1HubspotFullTenantsData>> =>
  createQueryKey("get_api_v1_hubspot_full_tenants", options, true);

/**
 * Hubspot Get Full Tenants V1
 */
export const getApiV1HubspotFullTenantsInfiniteOptions = (
  options?: Options<GetApiV1HubspotFullTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1HubspotFullTenantsResponse,
    GetApiV1HubspotFullTenantsError,
    InfiniteData<GetApiV1HubspotFullTenantsResponse>,
    QueryKey<Options<GetApiV1HubspotFullTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1HubspotFullTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1HubspotFullTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await hubspot_get_full_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1HubspotFullTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Hubspot Delete Tenant V1
 */
export const deleteApiV1HubspotTenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiV1HubspotTenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiV1HubspotTenantsByTenantIdResponse,
  DeleteApiV1HubspotTenantsByTenantIdError,
  Options<DeleteApiV1HubspotTenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1HubspotTenantsByTenantIdResponse,
    DeleteApiV1HubspotTenantsByTenantIdError,
    Options<DeleteApiV1HubspotTenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await hubspot_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1HubspotTenantsByTenantIdQueryKey = (
  options: Options<GetApiV1HubspotTenantsByTenantIdData>,
) => createQueryKey("get_api_v1_hubspot_tenants_by_tenant_id", options);

/**
 * Hubspot Get Tenant V1
 */
export const getApiV1HubspotTenantsByTenantIdOptions = (
  options: Options<GetApiV1HubspotTenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiV1HubspotTenantsByTenantIdResponse,
    GetApiV1HubspotTenantsByTenantIdError,
    GetApiV1HubspotTenantsByTenantIdResponse,
    ReturnType<typeof getApiV1HubspotTenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hubspot_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1HubspotTenantsByTenantIdQueryKey(options),
  });

/**
 * Hubspot Patch Tenant V1
 */
export const patchApiV1HubspotTenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiV1HubspotTenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiV1HubspotTenantsByTenantIdResponse,
  PatchApiV1HubspotTenantsByTenantIdError,
  Options<PatchApiV1HubspotTenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1HubspotTenantsByTenantIdResponse,
    PatchApiV1HubspotTenantsByTenantIdError,
    Options<PatchApiV1HubspotTenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await hubspot_patch_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1HubspotTenantsByTenantIdCheckConnectionQueryKey = (
  options: Options<GetApiV1HubspotTenantsByTenantIdCheckConnectionData>,
) =>
  createQueryKey(
    "get_api_v1_hubspot_tenants_by_tenant_id_check_connection",
    options,
  );

/**
 * Hubspot Check Connection V1
 */
export const getApiV1HubspotTenantsByTenantIdCheckConnectionOptions = (
  options: Options<GetApiV1HubspotTenantsByTenantIdCheckConnectionData>,
) =>
  queryOptions<
    GetApiV1HubspotTenantsByTenantIdCheckConnectionResponse,
    GetApiV1HubspotTenantsByTenantIdCheckConnectionError,
    GetApiV1HubspotTenantsByTenantIdCheckConnectionResponse,
    ReturnType<typeof getApiV1HubspotTenantsByTenantIdCheckConnectionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hubspot_check_connection_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1HubspotTenantsByTenantIdCheckConnectionQueryKey(options),
  });

export const getApiV1HubspotTenantsByTenantIdManifestQueryKey = (
  options: Options<GetApiV1HubspotTenantsByTenantIdManifestData>,
) =>
  createQueryKey("get_api_v1_hubspot_tenants_by_tenant_id_manifest", options);

/**
 * Hubspot Download Manifest V1
 */
export const getApiV1HubspotTenantsByTenantIdManifestOptions = (
  options: Options<GetApiV1HubspotTenantsByTenantIdManifestData>,
) =>
  queryOptions<
    unknown,
    GetApiV1HubspotTenantsByTenantIdManifestError,
    unknown,
    ReturnType<typeof getApiV1HubspotTenantsByTenantIdManifestQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hubspot_download_manifest_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1HubspotTenantsByTenantIdManifestQueryKey(options),
  });

export const getApiV2FullInferenceConversationInferencesQueryKey = (
  options: Options<GetApiV2FullInferenceConversationInferencesData>,
) =>
  createQueryKey("get_api_v2_full_inference_conversation_inferences", options);

/**
 * Get Full Inference Conversation Inferences V2
 */
export const getApiV2FullInferenceConversationInferencesOptions = (
  options: Options<GetApiV2FullInferenceConversationInferencesData>,
) =>
  queryOptions<
    GetApiV2FullInferenceConversationInferencesResponse,
    GetApiV2FullInferenceConversationInferencesError,
    GetApiV2FullInferenceConversationInferencesResponse,
    ReturnType<typeof getApiV2FullInferenceConversationInferencesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_inference_conversation_inferences_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2FullInferenceConversationInferencesQueryKey(options),
  });

export const getApiV2FullInferenceConversationInferencesInfiniteQueryKey = (
  options: Options<GetApiV2FullInferenceConversationInferencesData>,
): QueryKey<Options<GetApiV2FullInferenceConversationInferencesData>> =>
  createQueryKey(
    "get_api_v2_full_inference_conversation_inferences",
    options,
    true,
  );

/**
 * Get Full Inference Conversation Inferences V2
 */
export const getApiV2FullInferenceConversationInferencesInfiniteOptions = (
  options: Options<GetApiV2FullInferenceConversationInferencesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV2FullInferenceConversationInferencesResponse,
    GetApiV2FullInferenceConversationInferencesError,
    InfiniteData<GetApiV2FullInferenceConversationInferencesResponse>,
    QueryKey<Options<GetApiV2FullInferenceConversationInferencesData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV2FullInferenceConversationInferencesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV2FullInferenceConversationInferencesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_inference_conversation_inferences_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV2FullInferenceConversationInferencesInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV2InferenceConversationInferencesByInferenceConversationInferenceIdQueryKey =
  (
    options: Options<GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdData>,
  ) =>
    createQueryKey(
      "get_api_v2_inference_conversation_inferences_by_inference_conversation_inference_id",
      options,
    );

/**
 * Get Inference Conversation Inference V2
 */
export const getApiV2InferenceConversationInferencesByInferenceConversationInferenceIdOptions =
  (
    options: Options<GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdData>,
  ) =>
    queryOptions<
      GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponse,
      GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdError,
      GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponse,
      ReturnType<
        typeof getApiV2InferenceConversationInferencesByInferenceConversationInferenceIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_inference_conversation_inference_v2({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV2InferenceConversationInferencesByInferenceConversationInferenceIdQueryKey(
          options,
        ),
    });

/**
 * Update Inference Conversation Inference V1
 */
export const patchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdMutation =
  (
    options?: Partial<
      Options<PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdData>
    >,
  ): UseMutationOptions<
    PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponse,
    PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdError,
    Options<PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponse,
      PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdError,
      Options<PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await update_inference_conversation_inference_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Delete Inference Conversation V2
 */
export const deleteApiV2InferenceConversationsByExternalIdMutation = (
  options?: Partial<Options<DeleteApiV2InferenceConversationsByExternalIdData>>,
): UseMutationOptions<
  DeleteApiV2InferenceConversationsByExternalIdResponse,
  DeleteApiV2InferenceConversationsByExternalIdError,
  Options<DeleteApiV2InferenceConversationsByExternalIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV2InferenceConversationsByExternalIdResponse,
    DeleteApiV2InferenceConversationsByExternalIdError,
    Options<DeleteApiV2InferenceConversationsByExternalIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_inference_conversation_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV2InferenceConversationsByExternalIdQueryKey = (
  options: Options<GetApiV2InferenceConversationsByExternalIdData>,
) =>
  createQueryKey("get_api_v2_inference_conversations_by_external_id", options);

/**
 * Get Inference Conversation V2
 */
export const getApiV2InferenceConversationsByExternalIdOptions = (
  options: Options<GetApiV2InferenceConversationsByExternalIdData>,
) =>
  queryOptions<
    GetApiV2InferenceConversationsByExternalIdResponse,
    GetApiV2InferenceConversationsByExternalIdError,
    GetApiV2InferenceConversationsByExternalIdResponse,
    ReturnType<typeof getApiV2InferenceConversationsByExternalIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_inference_conversation_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2InferenceConversationsByExternalIdQueryKey(options),
  });

/**
 * Upsert Inference Conversation V2
 */
export const putApiV2InferenceConversationsByExternalIdMutation = (
  options?: Partial<Options<PutApiV2InferenceConversationsByExternalIdData>>,
): UseMutationOptions<
  PutApiV2InferenceConversationsByExternalIdResponse,
  PutApiV2InferenceConversationsByExternalIdError,
  Options<PutApiV2InferenceConversationsByExternalIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiV2InferenceConversationsByExternalIdResponse,
    PutApiV2InferenceConversationsByExternalIdError,
    Options<PutApiV2InferenceConversationsByExternalIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsert_inference_conversation_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Append Inference Conversation Messages V2
 */
export const postApiV2InferenceConversationsByExternalIdMessagesMutation = (
  options?: Partial<
    Options<PostApiV2InferenceConversationsByExternalIdMessagesData>
  >,
): UseMutationOptions<
  PostApiV2InferenceConversationsByExternalIdMessagesResponse,
  PostApiV2InferenceConversationsByExternalIdMessagesError,
  Options<PostApiV2InferenceConversationsByExternalIdMessagesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2InferenceConversationsByExternalIdMessagesResponse,
    PostApiV2InferenceConversationsByExternalIdMessagesError,
    Options<PostApiV2InferenceConversationsByExternalIdMessagesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await append_inference_conversation_messages_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Stateless Inference Conversation Inference V2
 */
export const postApiV2InferenceConversationsByExternalIdStatelessInferenceMutation =
  (
    options?: Partial<
      Options<PostApiV2InferenceConversationsByExternalIdStatelessInferenceData>
    >,
  ): UseMutationOptions<
    PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponse,
    PostApiV2InferenceConversationsByExternalIdStatelessInferenceError,
    Options<PostApiV2InferenceConversationsByExternalIdStatelessInferenceData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponse,
      PostApiV2InferenceConversationsByExternalIdStatelessInferenceError,
      Options<PostApiV2InferenceConversationsByExternalIdStatelessInferenceData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await create_stateless_inference_conversation_inference_v2({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Create Stateful Inference Conversation Inference V2
 */
export const postApiV2InferenceConversationsByExternalIdStatefulInferenceMutation =
  (
    options?: Partial<
      Options<PostApiV2InferenceConversationsByExternalIdStatefulInferenceData>
    >,
  ): UseMutationOptions<
    PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponse,
    PostApiV2InferenceConversationsByExternalIdStatefulInferenceError,
    Options<PostApiV2InferenceConversationsByExternalIdStatefulInferenceData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponse,
      PostApiV2InferenceConversationsByExternalIdStatefulInferenceError,
      Options<PostApiV2InferenceConversationsByExternalIdStatefulInferenceData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await create_stateful_inference_conversation_inference_v2({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Restore Inference Conversation V1
 */
export const postApiV1InferenceConversationsByExternalIdRestoreMutation = (
  options?: Partial<
    Options<PostApiV1InferenceConversationsByExternalIdRestoreData>
  >,
): UseMutationOptions<
  PostApiV1InferenceConversationsByExternalIdRestoreResponse,
  PostApiV1InferenceConversationsByExternalIdRestoreError,
  Options<PostApiV1InferenceConversationsByExternalIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1InferenceConversationsByExternalIdRestoreResponse,
    PostApiV1InferenceConversationsByExternalIdRestoreError,
    Options<PostApiV1InferenceConversationsByExternalIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_inference_conversation_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV2FullInferenceConversationsQueryKey = (
  options: Options<GetApiV2FullInferenceConversationsData>,
) => createQueryKey("get_api_v2_full_inference_conversations", options);

/**
 * Get Full Inference Conversations V2
 */
export const getApiV2FullInferenceConversationsOptions = (
  options: Options<GetApiV2FullInferenceConversationsData>,
) =>
  queryOptions<
    GetApiV2FullInferenceConversationsResponse,
    GetApiV2FullInferenceConversationsError,
    GetApiV2FullInferenceConversationsResponse,
    ReturnType<typeof getApiV2FullInferenceConversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_inference_conversations_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2FullInferenceConversationsQueryKey(options),
  });

export const getApiV2FullInferenceConversationsInfiniteQueryKey = (
  options: Options<GetApiV2FullInferenceConversationsData>,
): QueryKey<Options<GetApiV2FullInferenceConversationsData>> =>
  createQueryKey("get_api_v2_full_inference_conversations", options, true);

/**
 * Get Full Inference Conversations V2
 */
export const getApiV2FullInferenceConversationsInfiniteOptions = (
  options: Options<GetApiV2FullInferenceConversationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV2FullInferenceConversationsResponse,
    GetApiV2FullInferenceConversationsError,
    InfiniteData<GetApiV2FullInferenceConversationsResponse>,
    QueryKey<Options<GetApiV2FullInferenceConversationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV2FullInferenceConversationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV2FullInferenceConversationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_inference_conversations_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV2FullInferenceConversationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV2InferenceConversationsQueryKey = (
  options: Options<GetApiV2InferenceConversationsData>,
) => createQueryKey("get_api_v2_inference_conversations", options);

/**
 * Get Inference Conversations V2
 */
export const getApiV2InferenceConversationsOptions = (
  options: Options<GetApiV2InferenceConversationsData>,
) =>
  queryOptions<
    GetApiV2InferenceConversationsResponse,
    GetApiV2InferenceConversationsError,
    GetApiV2InferenceConversationsResponse,
    ReturnType<typeof getApiV2InferenceConversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_inference_conversations_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2InferenceConversationsQueryKey(options),
  });

export const getApiV2InferenceConversationsInfiniteQueryKey = (
  options: Options<GetApiV2InferenceConversationsData>,
): QueryKey<Options<GetApiV2InferenceConversationsData>> =>
  createQueryKey("get_api_v2_inference_conversations", options, true);

/**
 * Get Inference Conversations V2
 */
export const getApiV2InferenceConversationsInfiniteOptions = (
  options: Options<GetApiV2InferenceConversationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV2InferenceConversationsResponse,
    GetApiV2InferenceConversationsError,
    InfiniteData<GetApiV2InferenceConversationsResponse>,
    QueryKey<Options<GetApiV2InferenceConversationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV2InferenceConversationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV2InferenceConversationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_inference_conversations_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV2InferenceConversationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1FullInferenceDatapointsQueryKey = (
  options?: Options<GetApiV1FullInferenceDatapointsData>,
) => createQueryKey("get_api_v1_full_inference_datapoints", options);

/**
 * Get Full Inference Datapoints V1
 */
export const getApiV1FullInferenceDatapointsOptions = (
  options?: Options<GetApiV1FullInferenceDatapointsData>,
) =>
  queryOptions<
    GetApiV1FullInferenceDatapointsResponse,
    GetApiV1FullInferenceDatapointsError,
    GetApiV1FullInferenceDatapointsResponse,
    ReturnType<typeof getApiV1FullInferenceDatapointsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_inference_datapoints_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullInferenceDatapointsQueryKey(options),
  });

export const getApiV1FullInferenceDatapointsInfiniteQueryKey = (
  options?: Options<GetApiV1FullInferenceDatapointsData>,
): QueryKey<Options<GetApiV1FullInferenceDatapointsData>> =>
  createQueryKey("get_api_v1_full_inference_datapoints", options, true);

/**
 * Get Full Inference Datapoints V1
 */
export const getApiV1FullInferenceDatapointsInfiniteOptions = (
  options?: Options<GetApiV1FullInferenceDatapointsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullInferenceDatapointsResponse,
    GetApiV1FullInferenceDatapointsError,
    InfiniteData<GetApiV1FullInferenceDatapointsResponse>,
    QueryKey<Options<GetApiV1FullInferenceDatapointsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullInferenceDatapointsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullInferenceDatapointsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_inference_datapoints_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullInferenceDatapointsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1FullInferenceDatapointsByInferenceDatapointIdQueryKey = (
  options: Options<GetApiV1FullInferenceDatapointsByInferenceDatapointIdData>,
) =>
  createQueryKey(
    "get_api_v1_full_inference_datapoints_by_inference_datapoint_id",
    options,
  );

/**
 * Get Full Inference Datapoint V1
 */
export const getApiV1FullInferenceDatapointsByInferenceDatapointIdOptions = (
  options: Options<GetApiV1FullInferenceDatapointsByInferenceDatapointIdData>,
) =>
  queryOptions<
    GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponse,
    GetApiV1FullInferenceDatapointsByInferenceDatapointIdError,
    GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponse,
    ReturnType<
      typeof getApiV1FullInferenceDatapointsByInferenceDatapointIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_inference_datapoint_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1FullInferenceDatapointsByInferenceDatapointIdQueryKey(options),
  });

/**
 * Search Full Evaluated Inference Datapoints V1
 */
export const postApiV1FullEvaluatedInferenceDatapointsSearchMutation = (
  options?: Partial<
    Options<PostApiV1FullEvaluatedInferenceDatapointsSearchData>
  >,
): UseMutationOptions<
  PostApiV1FullEvaluatedInferenceDatapointsSearchResponse,
  PostApiV1FullEvaluatedInferenceDatapointsSearchError,
  Options<PostApiV1FullEvaluatedInferenceDatapointsSearchData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1FullEvaluatedInferenceDatapointsSearchResponse,
    PostApiV1FullEvaluatedInferenceDatapointsSearchError,
    Options<PostApiV1FullEvaluatedInferenceDatapointsSearchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await search_full_evaluated_inference_datapoints_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Judgement Filter Options V1
 */
export const postApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsMutation =
  (
    options?: Partial<
      Options<PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsData>
    >,
  ): UseMutationOptions<
    PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponse,
    PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsError,
    Options<PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponse,
      PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsError,
      Options<PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await judgement_filter_options_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1EvaluatedInferenceDatapointsQueryKey = (
  options?: Options<GetApiV1EvaluatedInferenceDatapointsData>,
) => createQueryKey("get_api_v1_evaluated_inference_datapoints", options);

/**
 * Get Evaluated Inference Datapoints V1
 */
export const getApiV1EvaluatedInferenceDatapointsOptions = (
  options?: Options<GetApiV1EvaluatedInferenceDatapointsData>,
) =>
  queryOptions<
    GetApiV1EvaluatedInferenceDatapointsResponse,
    GetApiV1EvaluatedInferenceDatapointsError,
    GetApiV1EvaluatedInferenceDatapointsResponse,
    ReturnType<typeof getApiV1EvaluatedInferenceDatapointsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_evaluated_inference_datapoints_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1EvaluatedInferenceDatapointsQueryKey(options),
  });

export const getApiV1EvaluatedInferenceDatapointsInfiniteQueryKey = (
  options?: Options<GetApiV1EvaluatedInferenceDatapointsData>,
): QueryKey<Options<GetApiV1EvaluatedInferenceDatapointsData>> =>
  createQueryKey("get_api_v1_evaluated_inference_datapoints", options, true);

/**
 * Get Evaluated Inference Datapoints V1
 */
export const getApiV1EvaluatedInferenceDatapointsInfiniteOptions = (
  options?: Options<GetApiV1EvaluatedInferenceDatapointsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1EvaluatedInferenceDatapointsResponse,
    GetApiV1EvaluatedInferenceDatapointsError,
    InfiniteData<GetApiV1EvaluatedInferenceDatapointsResponse>,
    QueryKey<Options<GetApiV1EvaluatedInferenceDatapointsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1EvaluatedInferenceDatapointsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1EvaluatedInferenceDatapointsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_evaluated_inference_datapoints_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1EvaluatedInferenceDatapointsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Inference Datapoint V2
 */
export const postApiV2InferenceDatapointsMutation = (
  options?: Partial<Options<PostApiV2InferenceDatapointsData>>,
): UseMutationOptions<
  PostApiV2InferenceDatapointsResponse,
  PostApiV2InferenceDatapointsError,
  Options<PostApiV2InferenceDatapointsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2InferenceDatapointsResponse,
    PostApiV2InferenceDatapointsError,
    Options<PostApiV2InferenceDatapointsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_inference_datapoint_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Inference Datapoint V1
 */
export const deleteApiV1InferenceDatapointsByInferenceDatapointIdMutation = (
  options?: Partial<
    Options<DeleteApiV1InferenceDatapointsByInferenceDatapointIdData>
  >,
): UseMutationOptions<
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponse,
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdError,
  Options<DeleteApiV1InferenceDatapointsByInferenceDatapointIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponse,
    DeleteApiV1InferenceDatapointsByInferenceDatapointIdError,
    Options<DeleteApiV1InferenceDatapointsByInferenceDatapointIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_inference_datapoint_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Inference Datapoint V1
 */
export const patchApiV1InferenceDatapointsByInferenceDatapointIdMutation = (
  options?: Partial<
    Options<PatchApiV1InferenceDatapointsByInferenceDatapointIdData>
  >,
): UseMutationOptions<
  PatchApiV1InferenceDatapointsByInferenceDatapointIdResponse,
  PatchApiV1InferenceDatapointsByInferenceDatapointIdError,
  Options<PatchApiV1InferenceDatapointsByInferenceDatapointIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1InferenceDatapointsByInferenceDatapointIdResponse,
    PatchApiV1InferenceDatapointsByInferenceDatapointIdError,
    Options<PatchApiV1InferenceDatapointsByInferenceDatapointIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_inference_datapoint_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Inference Datapoint V1
 */
export const postApiV1InferenceDatapointsByInferenceDatapointIdRestoreMutation =
  (
    options?: Partial<
      Options<PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreData>
    >,
  ): UseMutationOptions<
    PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponse,
    PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreError,
    Options<PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponse,
      PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreError,
      Options<PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await restore_inference_datapoint_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1InferenceFeedbackQueryKey = (
  options: Options<GetApiV1InferenceFeedbackData>,
) => createQueryKey("get_api_v1_inference_feedback", options);

/**
 * Get Inference Feedback V1
 */
export const getApiV1InferenceFeedbackOptions = (
  options: Options<GetApiV1InferenceFeedbackData>,
) =>
  queryOptions<
    GetApiV1InferenceFeedbackResponse,
    GetApiV1InferenceFeedbackError,
    GetApiV1InferenceFeedbackResponse,
    ReturnType<typeof getApiV1InferenceFeedbackQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_inference_feedback_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1InferenceFeedbackQueryKey(options),
  });

export const getApiV1InferenceFeedbackInfiniteQueryKey = (
  options: Options<GetApiV1InferenceFeedbackData>,
): QueryKey<Options<GetApiV1InferenceFeedbackData>> =>
  createQueryKey("get_api_v1_inference_feedback", options, true);

/**
 * Get Inference Feedback V1
 */
export const getApiV1InferenceFeedbackInfiniteOptions = (
  options: Options<GetApiV1InferenceFeedbackData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1InferenceFeedbackResponse,
    GetApiV1InferenceFeedbackError,
    InfiniteData<GetApiV1InferenceFeedbackResponse>,
    QueryKey<Options<GetApiV1InferenceFeedbackData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1InferenceFeedbackData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1InferenceFeedbackData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_inference_feedback_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1InferenceFeedbackInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1TasksByTaskIdFeedbackLabelsQueryKey = (
  options: Options<GetApiV1TasksByTaskIdFeedbackLabelsData>,
) => createQueryKey("get_api_v1_tasks_by_task_id_feedback_labels", options);

/**
 * Get Feedback Labels V1
 */
export const getApiV1TasksByTaskIdFeedbackLabelsOptions = (
  options: Options<GetApiV1TasksByTaskIdFeedbackLabelsData>,
) =>
  queryOptions<
    GetApiV1TasksByTaskIdFeedbackLabelsResponse,
    GetApiV1TasksByTaskIdFeedbackLabelsError,
    GetApiV1TasksByTaskIdFeedbackLabelsResponse,
    ReturnType<typeof getApiV1TasksByTaskIdFeedbackLabelsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_feedback_labels_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1TasksByTaskIdFeedbackLabelsQueryKey(options),
  });

/**
 * Create Feedback Label V1
 */
export const postApiV1TasksByTaskIdFeedbackLabelsMutation = (
  options?: Partial<Options<PostApiV1TasksByTaskIdFeedbackLabelsData>>,
): UseMutationOptions<
  PostApiV1TasksByTaskIdFeedbackLabelsResponse,
  PostApiV1TasksByTaskIdFeedbackLabelsError,
  Options<PostApiV1TasksByTaskIdFeedbackLabelsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1TasksByTaskIdFeedbackLabelsResponse,
    PostApiV1TasksByTaskIdFeedbackLabelsError,
    Options<PostApiV1TasksByTaskIdFeedbackLabelsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_feedback_label_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Inference Feedback Label V1
 */
export const postApiV1TasksByTaskIdInferencesFeedbackLabelsMutation = (
  options?: Partial<
    Options<PostApiV1TasksByTaskIdInferencesFeedbackLabelsData>
  >,
): UseMutationOptions<
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponse,
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsError,
  Options<PostApiV1TasksByTaskIdInferencesFeedbackLabelsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponse,
    PostApiV1TasksByTaskIdInferencesFeedbackLabelsError,
    Options<PostApiV1TasksByTaskIdInferencesFeedbackLabelsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_inference_feedback_label_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Inference Feedback V1
 */
export const postApiV1TasksByTaskIdInferencesByInferenceIdFeedbackMutation = (
  options?: Partial<
    Options<PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackData>
  >,
): UseMutationOptions<
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponse,
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackError,
  Options<PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponse,
    PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackError,
    Options<PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_inference_feedback_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Kb Ingestion Files V1
 */
export const postApiV1IngestionKnowledgeBasesIngestionFilesMutation = (
  options?: Partial<
    Options<PostApiV1IngestionKnowledgeBasesIngestionFilesData>
  >,
): UseMutationOptions<
  PostApiV1IngestionKnowledgeBasesIngestionFilesResponse,
  PostApiV1IngestionKnowledgeBasesIngestionFilesError,
  Options<PostApiV1IngestionKnowledgeBasesIngestionFilesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1IngestionKnowledgeBasesIngestionFilesResponse,
    PostApiV1IngestionKnowledgeBasesIngestionFilesError,
    Options<PostApiV1IngestionKnowledgeBasesIngestionFilesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_kb_ingestion_files_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Support Ingestion Files V1
 */
export const postApiV1IngestionSupportIngestionFilesMutation = (
  options?: Partial<Options<PostApiV1IngestionSupportIngestionFilesData>>,
): UseMutationOptions<
  PostApiV1IngestionSupportIngestionFilesResponse,
  PostApiV1IngestionSupportIngestionFilesError,
  Options<PostApiV1IngestionSupportIngestionFilesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1IngestionSupportIngestionFilesResponse,
    PostApiV1IngestionSupportIngestionFilesError,
    Options<PostApiV1IngestionSupportIngestionFilesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_support_ingestion_files_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Jira Post Comment V2
 */
export const postApiJiraV2TenantsByTenantIdActionsPostCommentMutation = (
  options?: Partial<
    Options<PostApiJiraV2TenantsByTenantIdActionsPostCommentData>
  >,
): UseMutationOptions<
  PostApiJiraV2TenantsByTenantIdActionsPostCommentResponse,
  PostApiJiraV2TenantsByTenantIdActionsPostCommentError,
  Options<PostApiJiraV2TenantsByTenantIdActionsPostCommentData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiJiraV2TenantsByTenantIdActionsPostCommentResponse,
    PostApiJiraV2TenantsByTenantIdActionsPostCommentError,
    Options<PostApiJiraV2TenantsByTenantIdActionsPostCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await jira_post_comment_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiJiraV2TenantsByTenantIdActionsAttachmentContentQueryKey = (
  options: Options<GetApiJiraV2TenantsByTenantIdActionsAttachmentContentData>,
) =>
  createQueryKey(
    "get_api_jira_v2_tenants_by_tenant_id_actions_attachment_content",
    options,
  );

/**
 * Jira Get Attachment Content V2
 */
export const getApiJiraV2TenantsByTenantIdActionsAttachmentContentOptions = (
  options: Options<GetApiJiraV2TenantsByTenantIdActionsAttachmentContentData>,
) =>
  queryOptions<
    GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponse,
    GetApiJiraV2TenantsByTenantIdActionsAttachmentContentError,
    GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponse,
    ReturnType<
      typeof getApiJiraV2TenantsByTenantIdActionsAttachmentContentQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await jira_get_attachment_content_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiJiraV2TenantsByTenantIdActionsAttachmentContentQueryKey(options),
  });

/**
 * Jira Update Issue Labels V1
 */
export const postApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsMutation = (
  options?: Partial<
    Options<PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsData>
  >,
): UseMutationOptions<
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponse,
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsError,
  Options<PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponse,
    PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsError,
    Options<PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await jira_update_issue_labels_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Jira Set Custom Field V1
 */
export const postApiJiraV1TenantsByTenantIdActionsSetCustomFieldMutation = (
  options?: Partial<
    Options<PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldData>
  >,
): UseMutationOptions<
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponse,
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldError,
  Options<PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponse,
    PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldError,
    Options<PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await jira_set_custom_field_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiJiraV1TenantsByTenantIdActionsGetIssueQueryKey = (
  options: Options<GetApiJiraV1TenantsByTenantIdActionsGetIssueData>,
) =>
  createQueryKey(
    "get_api_jira_v1_tenants_by_tenant_id_actions_get_issue",
    options,
  );

/**
 * Jira Get Issue V1
 */
export const getApiJiraV1TenantsByTenantIdActionsGetIssueOptions = (
  options: Options<GetApiJiraV1TenantsByTenantIdActionsGetIssueData>,
) =>
  queryOptions<
    GetApiJiraV1TenantsByTenantIdActionsGetIssueResponse,
    GetApiJiraV1TenantsByTenantIdActionsGetIssueError,
    GetApiJiraV1TenantsByTenantIdActionsGetIssueResponse,
    ReturnType<typeof getApiJiraV1TenantsByTenantIdActionsGetIssueQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await jira_get_issue_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiJiraV1TenantsByTenantIdActionsGetIssueQueryKey(options),
  });

export const getApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsQueryKey =
  (
    options: Options<GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsData>,
  ) =>
    createQueryKey(
      "get_api_jira_v1_tenants_by_tenant_id_actions_get_custom_field_options",
      options,
    );

/**
 * Jira Get Custom Field Options V1
 */
export const getApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsOptions =
  (
    options: Options<GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsData>,
  ) =>
    queryOptions<
      GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponse,
      GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsError,
      GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponse,
      ReturnType<
        typeof getApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await jira_get_custom_field_options_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsQueryKey(
          options,
        ),
    });

export const getApiJiraV1TenantsByTenantIdActionsGetIssuesQueryKey = (
  options: Options<GetApiJiraV1TenantsByTenantIdActionsGetIssuesData>,
) =>
  createQueryKey(
    "get_api_jira_v1_tenants_by_tenant_id_actions_get_issues",
    options,
  );

/**
 * Jira Get Issues V1
 */
export const getApiJiraV1TenantsByTenantIdActionsGetIssuesOptions = (
  options: Options<GetApiJiraV1TenantsByTenantIdActionsGetIssuesData>,
) =>
  queryOptions<
    GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponse,
    GetApiJiraV1TenantsByTenantIdActionsGetIssuesError,
    GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponse,
    ReturnType<typeof getApiJiraV1TenantsByTenantIdActionsGetIssuesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await jira_get_issues_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiJiraV1TenantsByTenantIdActionsGetIssuesQueryKey(options),
  });

export const getApiJiraV1TenantsQueryKey = (
  options?: Options<GetApiJiraV1TenantsData>,
) => createQueryKey("get_api_jira_v1_tenants", options);

/**
 * Jira Get Tenants V1
 */
export const getApiJiraV1TenantsOptions = (
  options?: Options<GetApiJiraV1TenantsData>,
) =>
  queryOptions<
    GetApiJiraV1TenantsResponse,
    GetApiJiraV1TenantsError,
    GetApiJiraV1TenantsResponse,
    ReturnType<typeof getApiJiraV1TenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await jira_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiJiraV1TenantsQueryKey(options),
  });

export const getApiJiraV1TenantsInfiniteQueryKey = (
  options?: Options<GetApiJiraV1TenantsData>,
): QueryKey<Options<GetApiJiraV1TenantsData>> =>
  createQueryKey("get_api_jira_v1_tenants", options, true);

/**
 * Jira Get Tenants V1
 */
export const getApiJiraV1TenantsInfiniteOptions = (
  options?: Options<GetApiJiraV1TenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiJiraV1TenantsResponse,
    GetApiJiraV1TenantsError,
    InfiniteData<GetApiJiraV1TenantsResponse>,
    QueryKey<Options<GetApiJiraV1TenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiJiraV1TenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiJiraV1TenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await jira_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiJiraV1TenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Jira Create Tenant V1
 */
export const postApiJiraV1TenantsMutation = (
  options?: Partial<Options<PostApiJiraV1TenantsData>>,
): UseMutationOptions<
  PostApiJiraV1TenantsResponse,
  PostApiJiraV1TenantsError,
  Options<PostApiJiraV1TenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiJiraV1TenantsResponse,
    PostApiJiraV1TenantsError,
    Options<PostApiJiraV1TenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await jira_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiJiraV1FullTenantsQueryKey = (
  options?: Options<GetApiJiraV1FullTenantsData>,
) => createQueryKey("get_api_jira_v1_full_tenants", options);

/**
 * Jira Get Full Tenants V1
 */
export const getApiJiraV1FullTenantsOptions = (
  options?: Options<GetApiJiraV1FullTenantsData>,
) =>
  queryOptions<
    GetApiJiraV1FullTenantsResponse,
    GetApiJiraV1FullTenantsError,
    GetApiJiraV1FullTenantsResponse,
    ReturnType<typeof getApiJiraV1FullTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await jira_get_full_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiJiraV1FullTenantsQueryKey(options),
  });

export const getApiJiraV1FullTenantsInfiniteQueryKey = (
  options?: Options<GetApiJiraV1FullTenantsData>,
): QueryKey<Options<GetApiJiraV1FullTenantsData>> =>
  createQueryKey("get_api_jira_v1_full_tenants", options, true);

/**
 * Jira Get Full Tenants V1
 */
export const getApiJiraV1FullTenantsInfiniteOptions = (
  options?: Options<GetApiJiraV1FullTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiJiraV1FullTenantsResponse,
    GetApiJiraV1FullTenantsError,
    InfiniteData<GetApiJiraV1FullTenantsResponse>,
    QueryKey<Options<GetApiJiraV1FullTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiJiraV1FullTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiJiraV1FullTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await jira_get_full_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiJiraV1FullTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Jira Delete Tenant V1
 */
export const deleteApiJiraV1TenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiJiraV1TenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiJiraV1TenantsByTenantIdResponse,
  DeleteApiJiraV1TenantsByTenantIdError,
  Options<DeleteApiJiraV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiJiraV1TenantsByTenantIdResponse,
    DeleteApiJiraV1TenantsByTenantIdError,
    Options<DeleteApiJiraV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await jira_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiJiraV1TenantsByTenantIdQueryKey = (
  options: Options<GetApiJiraV1TenantsByTenantIdData>,
) => createQueryKey("get_api_jira_v1_tenants_by_tenant_id", options);

/**
 * Jira Get Tenant V1
 */
export const getApiJiraV1TenantsByTenantIdOptions = (
  options: Options<GetApiJiraV1TenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiJiraV1TenantsByTenantIdResponse,
    GetApiJiraV1TenantsByTenantIdError,
    GetApiJiraV1TenantsByTenantIdResponse,
    ReturnType<typeof getApiJiraV1TenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await jira_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiJiraV1TenantsByTenantIdQueryKey(options),
  });

/**
 * Jira Patch Tenant V1
 */
export const patchApiJiraV1TenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiJiraV1TenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiJiraV1TenantsByTenantIdResponse,
  PatchApiJiraV1TenantsByTenantIdError,
  Options<PatchApiJiraV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiJiraV1TenantsByTenantIdResponse,
    PatchApiJiraV1TenantsByTenantIdError,
    Options<PatchApiJiraV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await jira_patch_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiJiraV1TenantsByTenantIdCheckConnectionQueryKey = (
  options: Options<GetApiJiraV1TenantsByTenantIdCheckConnectionData>,
) =>
  createQueryKey(
    "get_api_jira_v1_tenants_by_tenant_id_check_connection",
    options,
  );

/**
 * Jira Check Connection V1
 */
export const getApiJiraV1TenantsByTenantIdCheckConnectionOptions = (
  options: Options<GetApiJiraV1TenantsByTenantIdCheckConnectionData>,
) =>
  queryOptions<
    GetApiJiraV1TenantsByTenantIdCheckConnectionResponse,
    GetApiJiraV1TenantsByTenantIdCheckConnectionError,
    GetApiJiraV1TenantsByTenantIdCheckConnectionResponse,
    ReturnType<typeof getApiJiraV1TenantsByTenantIdCheckConnectionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await jira_check_connection_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiJiraV1TenantsByTenantIdCheckConnectionQueryKey(options),
  });

export const getApiV2JudgementsQueryKey = (
  options?: Options<GetApiV2JudgementsData>,
) => createQueryKey("get_api_v2_judgements", options);

/**
 * Get Judgements V2
 */
export const getApiV2JudgementsOptions = (
  options?: Options<GetApiV2JudgementsData>,
) =>
  queryOptions<
    GetApiV2JudgementsResponse,
    GetApiV2JudgementsError,
    GetApiV2JudgementsResponse,
    ReturnType<typeof getApiV2JudgementsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_judgements_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2JudgementsQueryKey(options),
  });

export const getApiV2JudgementsInfiniteQueryKey = (
  options?: Options<GetApiV2JudgementsData>,
): QueryKey<Options<GetApiV2JudgementsData>> =>
  createQueryKey("get_api_v2_judgements", options, true);

/**
 * Get Judgements V2
 */
export const getApiV2JudgementsInfiniteOptions = (
  options?: Options<GetApiV2JudgementsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV2JudgementsResponse,
    GetApiV2JudgementsError,
    InfiniteData<GetApiV2JudgementsResponse>,
    QueryKey<Options<GetApiV2JudgementsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV2JudgementsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV2JudgementsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_judgements_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV2JudgementsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Judgements V2
 */
export const postApiV2JudgementsMutation = (
  options?: Partial<Options<PostApiV2JudgementsData>>,
): UseMutationOptions<
  PostApiV2JudgementsResponse,
  PostApiV2JudgementsError,
  Options<PostApiV2JudgementsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2JudgementsResponse,
    PostApiV2JudgementsError,
    Options<PostApiV2JudgementsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_judgements_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Judgement V2
 */
export const deleteApiV2JudgementsByJudgementIdMutation = (
  options?: Partial<Options<DeleteApiV2JudgementsByJudgementIdData>>,
): UseMutationOptions<
  DeleteApiV2JudgementsByJudgementIdResponse,
  DeleteApiV2JudgementsByJudgementIdError,
  Options<DeleteApiV2JudgementsByJudgementIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV2JudgementsByJudgementIdResponse,
    DeleteApiV2JudgementsByJudgementIdError,
    Options<DeleteApiV2JudgementsByJudgementIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_judgement_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Judgements V3
 */
export const postApiV3JudgementsMutation = (
  options?: Partial<Options<PostApiV3JudgementsData>>,
): UseMutationOptions<
  PostApiV3JudgementsResponse,
  PostApiV3JudgementsError,
  Options<PostApiV3JudgementsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV3JudgementsResponse,
    PostApiV3JudgementsError,
    Options<PostApiV3JudgementsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_judgements_v3({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV3FullJudgementsQueryKey = (
  options?: Options<GetApiV3FullJudgementsData>,
) => createQueryKey("get_api_v3_full_judgements", options);

/**
 * Get Judgements Full V3
 */
export const getApiV3FullJudgementsOptions = (
  options?: Options<GetApiV3FullJudgementsData>,
) =>
  queryOptions<
    GetApiV3FullJudgementsResponse,
    GetApiV3FullJudgementsError,
    GetApiV3FullJudgementsResponse,
    ReturnType<typeof getApiV3FullJudgementsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_judgements_full_v3({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV3FullJudgementsQueryKey(options),
  });

export const getApiV3FullJudgementsInfiniteQueryKey = (
  options?: Options<GetApiV3FullJudgementsData>,
): QueryKey<Options<GetApiV3FullJudgementsData>> =>
  createQueryKey("get_api_v3_full_judgements", options, true);

/**
 * Get Judgements Full V3
 */
export const getApiV3FullJudgementsInfiniteOptions = (
  options?: Options<GetApiV3FullJudgementsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV3FullJudgementsResponse,
    GetApiV3FullJudgementsError,
    InfiniteData<GetApiV3FullJudgementsResponse>,
    QueryKey<Options<GetApiV3FullJudgementsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV3FullJudgementsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV3FullJudgementsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_judgements_full_v3({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV3FullJudgementsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Judgement V3
 */
export const deleteApiV3JudgementsByJudgementIdMutation = (
  options?: Partial<Options<DeleteApiV3JudgementsByJudgementIdData>>,
): UseMutationOptions<
  DeleteApiV3JudgementsByJudgementIdResponse,
  DeleteApiV3JudgementsByJudgementIdError,
  Options<DeleteApiV3JudgementsByJudgementIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV3JudgementsByJudgementIdResponse,
    DeleteApiV3JudgementsByJudgementIdError,
    Options<DeleteApiV3JudgementsByJudgementIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_judgement_v3({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV2JudgesQueryKey = (options?: Options<GetApiV2JudgesData>) =>
  createQueryKey("get_api_v2_judges", options);

/**
 * Get Judges V2
 */
export const getApiV2JudgesOptions = (options?: Options<GetApiV2JudgesData>) =>
  queryOptions<
    GetApiV2JudgesResponse,
    GetApiV2JudgesError,
    GetApiV2JudgesResponse,
    ReturnType<typeof getApiV2JudgesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_judges_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2JudgesQueryKey(options),
  });

export const getApiV2JudgesInfiniteQueryKey = (
  options?: Options<GetApiV2JudgesData>,
): QueryKey<Options<GetApiV2JudgesData>> =>
  createQueryKey("get_api_v2_judges", options, true);

/**
 * Get Judges V2
 */
export const getApiV2JudgesInfiniteOptions = (
  options?: Options<GetApiV2JudgesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV2JudgesResponse,
    GetApiV2JudgesError,
    InfiniteData<GetApiV2JudgesResponse>,
    QueryKey<Options<GetApiV2JudgesData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV2JudgesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV2JudgesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_judges_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV2JudgesInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Judge V2
 */
export const postApiV2JudgesMutation = (
  options?: Partial<Options<PostApiV2JudgesData>>,
): UseMutationOptions<
  PostApiV2JudgesResponse,
  PostApiV2JudgesError,
  Options<PostApiV2JudgesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2JudgesResponse,
    PostApiV2JudgesError,
    Options<PostApiV2JudgesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_judge_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Judges V2
 */
export const postApiV2JudgesBulkMutation = (
  options?: Partial<Options<PostApiV2JudgesBulkData>>,
): UseMutationOptions<
  PostApiV2JudgesBulkResponse,
  PostApiV2JudgesBulkError,
  Options<PostApiV2JudgesBulkData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2JudgesBulkResponse,
    PostApiV2JudgesBulkError,
    Options<PostApiV2JudgesBulkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_judges_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sync Judges V1
 */
export const postApiV1JudgesSyncMutation = (
  options?: Partial<Options<PostApiV1JudgesSyncData>>,
): UseMutationOptions<
  PostApiV1JudgesSyncResponse,
  DefaultError,
  Options<PostApiV1JudgesSyncData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1JudgesSyncResponse,
    DefaultError,
    Options<PostApiV1JudgesSyncData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sync_judges_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Judge V2
 */
export const deleteApiV2JudgesByJudgeIdMutation = (
  options?: Partial<Options<DeleteApiV2JudgesByJudgeIdData>>,
): UseMutationOptions<
  DeleteApiV2JudgesByJudgeIdResponse,
  DeleteApiV2JudgesByJudgeIdError,
  Options<DeleteApiV2JudgesByJudgeIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV2JudgesByJudgeIdResponse,
    DeleteApiV2JudgesByJudgeIdError,
    Options<DeleteApiV2JudgesByJudgeIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_judge_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV2JudgesByJudgeIdQueryKey = (
  options: Options<GetApiV2JudgesByJudgeIdData>,
) => createQueryKey("get_api_v2_judges_by_judge_id", options);

/**
 * Get Judge V2
 */
export const getApiV2JudgesByJudgeIdOptions = (
  options: Options<GetApiV2JudgesByJudgeIdData>,
) =>
  queryOptions<
    GetApiV2JudgesByJudgeIdResponse,
    GetApiV2JudgesByJudgeIdError,
    GetApiV2JudgesByJudgeIdResponse,
    ReturnType<typeof getApiV2JudgesByJudgeIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_judge_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2JudgesByJudgeIdQueryKey(options),
  });

/**
 * Patch Judge V2
 */
export const patchApiV2JudgesByJudgeIdMutation = (
  options?: Partial<Options<PatchApiV2JudgesByJudgeIdData>>,
): UseMutationOptions<
  PatchApiV2JudgesByJudgeIdResponse,
  PatchApiV2JudgesByJudgeIdError,
  Options<PatchApiV2JudgesByJudgeIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV2JudgesByJudgeIdResponse,
    PatchApiV2JudgesByJudgeIdError,
    Options<PatchApiV2JudgesByJudgeIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patch_judge_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV2KanonicalDatapointsQueryKey = (
  options?: Options<GetApiV2KanonicalDatapointsData>,
) => createQueryKey("get_api_v2_kanonical_datapoints", options);

/**
 * Get Kanonical Datapoints V2
 */
export const getApiV2KanonicalDatapointsOptions = (
  options?: Options<GetApiV2KanonicalDatapointsData>,
) =>
  queryOptions<
    GetApiV2KanonicalDatapointsResponse,
    GetApiV2KanonicalDatapointsError,
    GetApiV2KanonicalDatapointsResponse,
    ReturnType<typeof getApiV2KanonicalDatapointsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kanonical_datapoints_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2KanonicalDatapointsQueryKey(options),
  });

export const getApiV2KanonicalDatapointsInfiniteQueryKey = (
  options?: Options<GetApiV2KanonicalDatapointsData>,
): QueryKey<Options<GetApiV2KanonicalDatapointsData>> =>
  createQueryKey("get_api_v2_kanonical_datapoints", options, true);

/**
 * Get Kanonical Datapoints V2
 */
export const getApiV2KanonicalDatapointsInfiniteOptions = (
  options?: Options<GetApiV2KanonicalDatapointsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV2KanonicalDatapointsResponse,
    GetApiV2KanonicalDatapointsError,
    InfiniteData<GetApiV2KanonicalDatapointsResponse>,
    QueryKey<Options<GetApiV2KanonicalDatapointsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV2KanonicalDatapointsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV2KanonicalDatapointsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_kanonical_datapoints_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV2KanonicalDatapointsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Kanonical Datapoints V2
 */
export const postApiV2KanonicalDatapointsMutation = (
  options?: Partial<Options<PostApiV2KanonicalDatapointsData>>,
): UseMutationOptions<
  PostApiV2KanonicalDatapointsResponse,
  PostApiV2KanonicalDatapointsError,
  Options<PostApiV2KanonicalDatapointsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2KanonicalDatapointsResponse,
    PostApiV2KanonicalDatapointsError,
    Options<PostApiV2KanonicalDatapointsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_kanonical_datapoints_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV2KanonicalDatapointsByKanonicalDatapointIdQueryKey = (
  options: Options<GetApiV2KanonicalDatapointsByKanonicalDatapointIdData>,
) =>
  createQueryKey(
    "get_api_v2_kanonical_datapoints_by_kanonical_datapoint_id",
    options,
  );

/**
 * Get Kanonical Datapoint V2
 */
export const getApiV2KanonicalDatapointsByKanonicalDatapointIdOptions = (
  options: Options<GetApiV2KanonicalDatapointsByKanonicalDatapointIdData>,
) =>
  queryOptions<
    GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponse,
    GetApiV2KanonicalDatapointsByKanonicalDatapointIdError,
    GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponse,
    ReturnType<typeof getApiV2KanonicalDatapointsByKanonicalDatapointIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kanonical_datapoint_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV2KanonicalDatapointsByKanonicalDatapointIdQueryKey(options),
  });

/**
 * Delete Kanonical Datapoint V1
 */
export const deleteApiV1KanonicalDatapointsByKanonicalDatapointIdMutation = (
  options?: Partial<
    Options<DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdData>
  >,
): UseMutationOptions<
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponse,
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdError,
  Options<DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponse,
    DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdError,
    Options<DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_kanonical_datapoint_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Kanonical Datapoint V1
 */
export const patchApiV1KanonicalDatapointsByKanonicalDatapointIdMutation = (
  options?: Partial<
    Options<PatchApiV1KanonicalDatapointsByKanonicalDatapointIdData>
  >,
): UseMutationOptions<
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponse,
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdError,
  Options<PatchApiV1KanonicalDatapointsByKanonicalDatapointIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponse,
    PatchApiV1KanonicalDatapointsByKanonicalDatapointIdError,
    Options<PatchApiV1KanonicalDatapointsByKanonicalDatapointIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_kanonical_datapoint_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Kanonical Datapoint V1
 */
export const postApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreMutation =
  (
    options?: Partial<
      Options<PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreData>
    >,
  ): UseMutationOptions<
    PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponse,
    PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreError,
    Options<PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponse,
      PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreError,
      Options<PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await restore_kanonical_datapoint_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Create Image Upload Url V1
 */
export const postApiV1ImageAttachmentsUploadUrlMutation = (
  options?: Partial<Options<PostApiV1ImageAttachmentsUploadUrlData>>,
): UseMutationOptions<
  PostApiV1ImageAttachmentsUploadUrlResponse,
  PostApiV1ImageAttachmentsUploadUrlError,
  Options<PostApiV1ImageAttachmentsUploadUrlData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ImageAttachmentsUploadUrlResponse,
    PostApiV1ImageAttachmentsUploadUrlError,
    Options<PostApiV1ImageAttachmentsUploadUrlData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_image_upload_url_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ImageAttachmentsDownloadByFilePathQueryKey = (
  options: Options<GetApiV1ImageAttachmentsDownloadByFilePathData>,
) =>
  createQueryKey("get_api_v1_image_attachments_download_by_file_path", options);

/**
 * Download Image Attachment V1
 */
export const getApiV1ImageAttachmentsDownloadByFilePathOptions = (
  options: Options<GetApiV1ImageAttachmentsDownloadByFilePathData>,
) =>
  queryOptions<
    unknown,
    GetApiV1ImageAttachmentsDownloadByFilePathError,
    unknown,
    ReturnType<typeof getApiV1ImageAttachmentsDownloadByFilePathQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await download_image_attachment_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ImageAttachmentsDownloadByFilePathQueryKey(options),
  });

export const getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsQueryKey = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData>,
) =>
  createQueryKey(
    "get_api_v1_authz_organizations_by_org_id_kb_access_requests",
    options,
  );

/**
 * Get Kb Access Requests V1
 */
export const getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsOptions = (
  options: Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData>,
) =>
  queryOptions<
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse,
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsError,
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse,
    ReturnType<typeof getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kb_access_requests_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsQueryKey(options),
  });

export const getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsInfiniteQueryKey =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData>,
  ): QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData>> =>
    createQueryKey(
      "get_api_v1_authz_organizations_by_org_id_kb_access_requests",
      options,
      true,
    );

/**
 * Get Kb Access Requests V1
 */
export const getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsInfiniteOptions =
  (options: Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData>) => {
    const opts = infiniteQueryOptions<
      GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse,
      GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsError,
      InfiniteData<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse>,
      QueryKey<Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData>>,
      | number
      | Pick<
          QueryKey<
            Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    offset: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await get_kb_access_requests_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

/**
 * Create Kb Access Request V1
 */
export const postApiV1AuthzOrganizationsByOrgIdKbAccessRequestsMutation = (
  options?: Partial<
    Options<PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData>
  >,
): UseMutationOptions<
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsError,
  Options<PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse,
    PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsError,
    Options<PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_kb_access_request_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineQueryKey =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineData>,
  ) =>
    createQueryKey(
      "get_api_v1_authz_organizations_by_org_id_knowledge_bases_by_kb_id_kb_access_requests_mine",
      options,
    );

/**
 * Get My Kb Access Request V1
 */
export const getApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineOptions =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineData>,
  ) =>
    queryOptions<
      GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponse,
      GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineError,
      GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponse,
      ReturnType<
        typeof getApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_my_kb_access_request_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineQueryKey(
          options,
        ),
    });

export const getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsQueryKey =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsData>,
  ) =>
    createQueryKey(
      "get_api_v1_authz_organizations_by_org_id_kb_access_requests_by_request_id_requester_teams",
      options,
    );

/**
 * Get Requester Teams V1
 */
export const getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsOptions =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsData>,
  ) =>
    queryOptions<
      GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponse,
      GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsError,
      GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponse,
      ReturnType<
        typeof getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_requester_teams_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsQueryKey(
          options,
        ),
    });

export const getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessQueryKey =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessData>,
  ) =>
    createQueryKey(
      "get_api_v1_authz_organizations_by_org_id_kb_access_requests_by_request_id_teams_with_access",
      options,
    );

/**
 * Get Teams With Access V1
 */
export const getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessOptions =
  (
    options: Options<GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessData>,
  ) =>
    queryOptions<
      GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponse,
      GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessError,
      GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponse,
      ReturnType<
        typeof getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_teams_with_access_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessQueryKey(
          options,
        ),
    });

/**
 * Resolve Kb Access Request V1
 */
export const postApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveMutation =
  (
    options?: Partial<
      Options<PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveData>
    >,
  ): UseMutationOptions<
    PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponse,
    PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveError,
    Options<PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponse,
      PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveError,
      Options<PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await resolve_kb_access_request_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Create Kb Upload Url V1
 */
export const postApiV1KbAttachmentsUploadUrlMutation = (
  options?: Partial<Options<PostApiV1KbAttachmentsUploadUrlData>>,
): UseMutationOptions<
  PostApiV1KbAttachmentsUploadUrlResponse,
  PostApiV1KbAttachmentsUploadUrlError,
  Options<PostApiV1KbAttachmentsUploadUrlData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1KbAttachmentsUploadUrlResponse,
    PostApiV1KbAttachmentsUploadUrlError,
    Options<PostApiV1KbAttachmentsUploadUrlData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_kb_upload_url_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1KbAttachmentsDownloadByFilePathQueryKey = (
  options: Options<GetApiV1KbAttachmentsDownloadByFilePathData>,
) => createQueryKey("get_api_v1_kb_attachments_download_by_file_path", options);

/**
 * Download Kb Attachment V1
 */
export const getApiV1KbAttachmentsDownloadByFilePathOptions = (
  options: Options<GetApiV1KbAttachmentsDownloadByFilePathData>,
) =>
  queryOptions<
    unknown,
    GetApiV1KbAttachmentsDownloadByFilePathError,
    unknown,
    ReturnType<typeof getApiV1KbAttachmentsDownloadByFilePathQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await download_kb_attachment_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1KbAttachmentsDownloadByFilePathQueryKey(options),
  });

export const getApiV1FullKbSimulationDatapointsQueryKey = (
  options?: Options<GetApiV1FullKbSimulationDatapointsData>,
) => createQueryKey("get_api_v1_full_kb_simulation_datapoints", options);

/**
 * Get Full Kb Simulation Datapoints V1
 */
export const getApiV1FullKbSimulationDatapointsOptions = (
  options?: Options<GetApiV1FullKbSimulationDatapointsData>,
) =>
  queryOptions<
    GetApiV1FullKbSimulationDatapointsResponse,
    GetApiV1FullKbSimulationDatapointsError,
    GetApiV1FullKbSimulationDatapointsResponse,
    ReturnType<typeof getApiV1FullKbSimulationDatapointsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_kb_simulation_datapoints_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullKbSimulationDatapointsQueryKey(options),
  });

export const getApiV1FullKbSimulationDatapointsInfiniteQueryKey = (
  options?: Options<GetApiV1FullKbSimulationDatapointsData>,
): QueryKey<Options<GetApiV1FullKbSimulationDatapointsData>> =>
  createQueryKey("get_api_v1_full_kb_simulation_datapoints", options, true);

/**
 * Get Full Kb Simulation Datapoints V1
 */
export const getApiV1FullKbSimulationDatapointsInfiniteOptions = (
  options?: Options<GetApiV1FullKbSimulationDatapointsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullKbSimulationDatapointsResponse,
    GetApiV1FullKbSimulationDatapointsError,
    InfiniteData<GetApiV1FullKbSimulationDatapointsResponse>,
    QueryKey<Options<GetApiV1FullKbSimulationDatapointsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullKbSimulationDatapointsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullKbSimulationDatapointsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_kb_simulation_datapoints_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullKbSimulationDatapointsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1FullKbSimulationDatapointsBySimulationDatapointIdQueryKey =
  (
    options: Options<GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdData>,
  ) =>
    createQueryKey(
      "get_api_v1_full_kb_simulation_datapoints_by_simulation_datapoint_id",
      options,
    );

/**
 * Get Full Kb Simulation Datapoint V1
 */
export const getApiV1FullKbSimulationDatapointsBySimulationDatapointIdOptions =
  (
    options: Options<GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdData>,
  ) =>
    queryOptions<
      GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponse,
      GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdError,
      GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponse,
      ReturnType<
        typeof getApiV1FullKbSimulationDatapointsBySimulationDatapointIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_full_kb_simulation_datapoint_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1FullKbSimulationDatapointsBySimulationDatapointIdQueryKey(
          options,
        ),
    });

export const getApiV1KbSimulationDatapointsQueryKey = (
  options?: Options<GetApiV1KbSimulationDatapointsData>,
) => createQueryKey("get_api_v1_kb_simulation_datapoints", options);

/**
 * Get Kb Simulation Datapoints V1
 */
export const getApiV1KbSimulationDatapointsOptions = (
  options?: Options<GetApiV1KbSimulationDatapointsData>,
) =>
  queryOptions<
    GetApiV1KbSimulationDatapointsResponse,
    GetApiV1KbSimulationDatapointsError,
    GetApiV1KbSimulationDatapointsResponse,
    ReturnType<typeof getApiV1KbSimulationDatapointsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kb_simulation_datapoints_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1KbSimulationDatapointsQueryKey(options),
  });

export const getApiV1KbSimulationDatapointsInfiniteQueryKey = (
  options?: Options<GetApiV1KbSimulationDatapointsData>,
): QueryKey<Options<GetApiV1KbSimulationDatapointsData>> =>
  createQueryKey("get_api_v1_kb_simulation_datapoints", options, true);

/**
 * Get Kb Simulation Datapoints V1
 */
export const getApiV1KbSimulationDatapointsInfiniteOptions = (
  options?: Options<GetApiV1KbSimulationDatapointsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1KbSimulationDatapointsResponse,
    GetApiV1KbSimulationDatapointsError,
    InfiniteData<GetApiV1KbSimulationDatapointsResponse>,
    QueryKey<Options<GetApiV1KbSimulationDatapointsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1KbSimulationDatapointsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1KbSimulationDatapointsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_kb_simulation_datapoints_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1KbSimulationDatapointsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Kb Simulation Datapoint V1
 */
export const postApiV1KbSimulationDatapointsMutation = (
  options?: Partial<Options<PostApiV1KbSimulationDatapointsData>>,
): UseMutationOptions<
  PostApiV1KbSimulationDatapointsResponse,
  PostApiV1KbSimulationDatapointsError,
  Options<PostApiV1KbSimulationDatapointsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1KbSimulationDatapointsResponse,
    PostApiV1KbSimulationDatapointsError,
    Options<PostApiV1KbSimulationDatapointsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_kb_simulation_datapoint_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Kb Simulation Datapoints V1
 */
export const postApiV1KbSimulationDatapointsBatchMutation = (
  options?: Partial<Options<PostApiV1KbSimulationDatapointsBatchData>>,
): UseMutationOptions<
  PostApiV1KbSimulationDatapointsBatchResponse,
  PostApiV1KbSimulationDatapointsBatchError,
  Options<PostApiV1KbSimulationDatapointsBatchData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1KbSimulationDatapointsBatchResponse,
    PostApiV1KbSimulationDatapointsBatchError,
    Options<PostApiV1KbSimulationDatapointsBatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_kb_simulation_datapoints_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Kb Simulation Datapoint V1
 */
export const deleteApiV1KbSimulationDatapointsBySimulationDatapointIdMutation =
  (
    options?: Partial<
      Options<DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdData>
    >,
  ): UseMutationOptions<
    DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
    DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdError,
    Options<DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
      DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdError,
      Options<DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await delete_kb_simulation_datapoint_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1KbSimulationDatapointsBySimulationDatapointIdQueryKey = (
  options: Options<GetApiV1KbSimulationDatapointsBySimulationDatapointIdData>,
) =>
  createQueryKey(
    "get_api_v1_kb_simulation_datapoints_by_simulation_datapoint_id",
    options,
  );

/**
 * Get Kb Simulation Datapoint V1
 */
export const getApiV1KbSimulationDatapointsBySimulationDatapointIdOptions = (
  options: Options<GetApiV1KbSimulationDatapointsBySimulationDatapointIdData>,
) =>
  queryOptions<
    GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
    GetApiV1KbSimulationDatapointsBySimulationDatapointIdError,
    GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
    ReturnType<
      typeof getApiV1KbSimulationDatapointsBySimulationDatapointIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kb_simulation_datapoint_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1KbSimulationDatapointsBySimulationDatapointIdQueryKey(options),
  });

/**
 * Update Kb Simulation Datapoint V1
 */
export const patchApiV1KbSimulationDatapointsBySimulationDatapointIdMutation = (
  options?: Partial<
    Options<PatchApiV1KbSimulationDatapointsBySimulationDatapointIdData>
  >,
): UseMutationOptions<
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdError,
  Options<PatchApiV1KbSimulationDatapointsBySimulationDatapointIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
    PatchApiV1KbSimulationDatapointsBySimulationDatapointIdError,
    Options<PatchApiV1KbSimulationDatapointsBySimulationDatapointIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_kb_simulation_datapoint_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Kb Simulation Datapoint V1
 */
export const postApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreMutation =
  (
    options?: Partial<
      Options<PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreData>
    >,
  ): UseMutationOptions<
    PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponse,
    PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreError,
    Options<PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponse,
      PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreError,
      Options<PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await restore_kb_simulation_datapoint_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1FullKbSimulationResultsQueryKey = (
  options?: Options<GetApiV1FullKbSimulationResultsData>,
) => createQueryKey("get_api_v1_full_kb_simulation_results", options);

/**
 * Get Full Kb Simulation Results V1
 */
export const getApiV1FullKbSimulationResultsOptions = (
  options?: Options<GetApiV1FullKbSimulationResultsData>,
) =>
  queryOptions<
    GetApiV1FullKbSimulationResultsResponse,
    GetApiV1FullKbSimulationResultsError,
    GetApiV1FullKbSimulationResultsResponse,
    ReturnType<typeof getApiV1FullKbSimulationResultsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_kb_simulation_results_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullKbSimulationResultsQueryKey(options),
  });

export const getApiV1FullKbSimulationResultsInfiniteQueryKey = (
  options?: Options<GetApiV1FullKbSimulationResultsData>,
): QueryKey<Options<GetApiV1FullKbSimulationResultsData>> =>
  createQueryKey("get_api_v1_full_kb_simulation_results", options, true);

/**
 * Get Full Kb Simulation Results V1
 */
export const getApiV1FullKbSimulationResultsInfiniteOptions = (
  options?: Options<GetApiV1FullKbSimulationResultsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullKbSimulationResultsResponse,
    GetApiV1FullKbSimulationResultsError,
    InfiniteData<GetApiV1FullKbSimulationResultsResponse>,
    QueryKey<Options<GetApiV1FullKbSimulationResultsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullKbSimulationResultsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullKbSimulationResultsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_kb_simulation_results_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullKbSimulationResultsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1FullKbSimulationResultsBySimulationResultIdQueryKey = (
  options: Options<GetApiV1FullKbSimulationResultsBySimulationResultIdData>,
) =>
  createQueryKey(
    "get_api_v1_full_kb_simulation_results_by_simulation_result_id",
    options,
  );

/**
 * Get Full Kb Simulation Result V1
 */
export const getApiV1FullKbSimulationResultsBySimulationResultIdOptions = (
  options: Options<GetApiV1FullKbSimulationResultsBySimulationResultIdData>,
) =>
  queryOptions<
    GetApiV1FullKbSimulationResultsBySimulationResultIdResponse,
    GetApiV1FullKbSimulationResultsBySimulationResultIdError,
    GetApiV1FullKbSimulationResultsBySimulationResultIdResponse,
    ReturnType<
      typeof getApiV1FullKbSimulationResultsBySimulationResultIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_kb_simulation_result_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1FullKbSimulationResultsBySimulationResultIdQueryKey(options),
  });

export const getApiV1KbSimulationResultsQueryKey = (
  options?: Options<GetApiV1KbSimulationResultsData>,
) => createQueryKey("get_api_v1_kb_simulation_results", options);

/**
 * Get Kb Simulation Results V1
 */
export const getApiV1KbSimulationResultsOptions = (
  options?: Options<GetApiV1KbSimulationResultsData>,
) =>
  queryOptions<
    GetApiV1KbSimulationResultsResponse,
    GetApiV1KbSimulationResultsError,
    GetApiV1KbSimulationResultsResponse,
    ReturnType<typeof getApiV1KbSimulationResultsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kb_simulation_results_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1KbSimulationResultsQueryKey(options),
  });

export const getApiV1KbSimulationResultsInfiniteQueryKey = (
  options?: Options<GetApiV1KbSimulationResultsData>,
): QueryKey<Options<GetApiV1KbSimulationResultsData>> =>
  createQueryKey("get_api_v1_kb_simulation_results", options, true);

/**
 * Get Kb Simulation Results V1
 */
export const getApiV1KbSimulationResultsInfiniteOptions = (
  options?: Options<GetApiV1KbSimulationResultsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1KbSimulationResultsResponse,
    GetApiV1KbSimulationResultsError,
    InfiniteData<GetApiV1KbSimulationResultsResponse>,
    QueryKey<Options<GetApiV1KbSimulationResultsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1KbSimulationResultsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1KbSimulationResultsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_kb_simulation_results_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1KbSimulationResultsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Kb Simulation Result V1
 */
export const postApiV1KbSimulationResultsMutation = (
  options?: Partial<Options<PostApiV1KbSimulationResultsData>>,
): UseMutationOptions<
  PostApiV1KbSimulationResultsResponse,
  PostApiV1KbSimulationResultsError,
  Options<PostApiV1KbSimulationResultsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1KbSimulationResultsResponse,
    PostApiV1KbSimulationResultsError,
    Options<PostApiV1KbSimulationResultsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_kb_simulation_result_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Kb Simulation Results V1
 */
export const postApiV1KbSimulationResultsBatchMutation = (
  options?: Partial<Options<PostApiV1KbSimulationResultsBatchData>>,
): UseMutationOptions<
  PostApiV1KbSimulationResultsBatchResponse,
  PostApiV1KbSimulationResultsBatchError,
  Options<PostApiV1KbSimulationResultsBatchData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1KbSimulationResultsBatchResponse,
    PostApiV1KbSimulationResultsBatchError,
    Options<PostApiV1KbSimulationResultsBatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_kb_simulation_results_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Kb Simulation Result Judgements Batch V1
 */
export const postApiV1KbSimulationResultJudgementsBatchMutation = (
  options?: Partial<Options<PostApiV1KbSimulationResultJudgementsBatchData>>,
): UseMutationOptions<
  PostApiV1KbSimulationResultJudgementsBatchResponse,
  PostApiV1KbSimulationResultJudgementsBatchError,
  Options<PostApiV1KbSimulationResultJudgementsBatchData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1KbSimulationResultJudgementsBatchResponse,
    PostApiV1KbSimulationResultJudgementsBatchError,
    Options<PostApiV1KbSimulationResultJudgementsBatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_kb_simulation_result_judgements_batch_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1FullKbSimulationResultJudgementsQueryKey = (
  options?: Options<GetApiV1FullKbSimulationResultJudgementsData>,
) => createQueryKey("get_api_v1_full_kb_simulation_result_judgements", options);

/**
 * Get Full Kb Simulation Result Judgements V1
 */
export const getApiV1FullKbSimulationResultJudgementsOptions = (
  options?: Options<GetApiV1FullKbSimulationResultJudgementsData>,
) =>
  queryOptions<
    GetApiV1FullKbSimulationResultJudgementsResponse,
    GetApiV1FullKbSimulationResultJudgementsError,
    GetApiV1FullKbSimulationResultJudgementsResponse,
    ReturnType<typeof getApiV1FullKbSimulationResultJudgementsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_kb_simulation_result_judgements_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullKbSimulationResultJudgementsQueryKey(options),
  });

export const getApiV1FullKbSimulationResultJudgementsInfiniteQueryKey = (
  options?: Options<GetApiV1FullKbSimulationResultJudgementsData>,
): QueryKey<Options<GetApiV1FullKbSimulationResultJudgementsData>> =>
  createQueryKey(
    "get_api_v1_full_kb_simulation_result_judgements",
    options,
    true,
  );

/**
 * Get Full Kb Simulation Result Judgements V1
 */
export const getApiV1FullKbSimulationResultJudgementsInfiniteOptions = (
  options?: Options<GetApiV1FullKbSimulationResultJudgementsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullKbSimulationResultJudgementsResponse,
    GetApiV1FullKbSimulationResultJudgementsError,
    InfiniteData<GetApiV1FullKbSimulationResultJudgementsResponse>,
    QueryKey<Options<GetApiV1FullKbSimulationResultJudgementsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullKbSimulationResultJudgementsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullKbSimulationResultJudgementsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_kb_simulation_result_judgements_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1FullKbSimulationResultJudgementsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1FullKbSimulationRunQueryKey = (
  options: Options<GetApiV1FullKbSimulationRunData>,
) => createQueryKey("get_api_v1_full_kb_simulation_run", options);

/**
 * Get Full Kb Simulation Run V1
 */
export const getApiV1FullKbSimulationRunOptions = (
  options: Options<GetApiV1FullKbSimulationRunData>,
) =>
  queryOptions<
    GetApiV1FullKbSimulationRunResponse,
    GetApiV1FullKbSimulationRunError,
    GetApiV1FullKbSimulationRunResponse,
    ReturnType<typeof getApiV1FullKbSimulationRunQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_kb_simulation_run_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullKbSimulationRunQueryKey(options),
  });

export const getApiV1FullKbSimulationRunInfiniteQueryKey = (
  options: Options<GetApiV1FullKbSimulationRunData>,
): QueryKey<Options<GetApiV1FullKbSimulationRunData>> =>
  createQueryKey("get_api_v1_full_kb_simulation_run", options, true);

/**
 * Get Full Kb Simulation Run V1
 */
export const getApiV1FullKbSimulationRunInfiniteOptions = (
  options: Options<GetApiV1FullKbSimulationRunData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullKbSimulationRunResponse,
    GetApiV1FullKbSimulationRunError,
    InfiniteData<GetApiV1FullKbSimulationRunResponse>,
    QueryKey<Options<GetApiV1FullKbSimulationRunData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetApiV1FullKbSimulationRunData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullKbSimulationRunData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_kb_simulation_run_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullKbSimulationRunInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1FullKbSimulationCompareQueryKey = (
  options: Options<GetApiV1FullKbSimulationCompareData>,
) => createQueryKey("get_api_v1_full_kb_simulation_compare", options);

/**
 * Get Full Kb Simulation Compare V1
 */
export const getApiV1FullKbSimulationCompareOptions = (
  options: Options<GetApiV1FullKbSimulationCompareData>,
) =>
  queryOptions<
    GetApiV1FullKbSimulationCompareResponse,
    GetApiV1FullKbSimulationCompareError,
    GetApiV1FullKbSimulationCompareResponse,
    ReturnType<typeof getApiV1FullKbSimulationCompareQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_kb_simulation_compare_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullKbSimulationCompareQueryKey(options),
  });

export const getApiV1FullKbSimulationCompareInfiniteQueryKey = (
  options: Options<GetApiV1FullKbSimulationCompareData>,
): QueryKey<Options<GetApiV1FullKbSimulationCompareData>> =>
  createQueryKey("get_api_v1_full_kb_simulation_compare", options, true);

/**
 * Get Full Kb Simulation Compare V1
 */
export const getApiV1FullKbSimulationCompareInfiniteOptions = (
  options: Options<GetApiV1FullKbSimulationCompareData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullKbSimulationCompareResponse,
    GetApiV1FullKbSimulationCompareError,
    InfiniteData<GetApiV1FullKbSimulationCompareResponse>,
    QueryKey<Options<GetApiV1FullKbSimulationCompareData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetApiV1FullKbSimulationCompareData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullKbSimulationCompareData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_kb_simulation_compare_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullKbSimulationCompareInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Kb Simulation Result V1
 */
export const deleteApiV1KbSimulationResultsBySimulationResultIdMutation = (
  options?: Partial<
    Options<DeleteApiV1KbSimulationResultsBySimulationResultIdData>
  >,
): UseMutationOptions<
  DeleteApiV1KbSimulationResultsBySimulationResultIdResponse,
  DeleteApiV1KbSimulationResultsBySimulationResultIdError,
  Options<DeleteApiV1KbSimulationResultsBySimulationResultIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1KbSimulationResultsBySimulationResultIdResponse,
    DeleteApiV1KbSimulationResultsBySimulationResultIdError,
    Options<DeleteApiV1KbSimulationResultsBySimulationResultIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_kb_simulation_result_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1KbSimulationResultsBySimulationResultIdQueryKey = (
  options: Options<GetApiV1KbSimulationResultsBySimulationResultIdData>,
) =>
  createQueryKey(
    "get_api_v1_kb_simulation_results_by_simulation_result_id",
    options,
  );

/**
 * Get Kb Simulation Result V1
 */
export const getApiV1KbSimulationResultsBySimulationResultIdOptions = (
  options: Options<GetApiV1KbSimulationResultsBySimulationResultIdData>,
) =>
  queryOptions<
    GetApiV1KbSimulationResultsBySimulationResultIdResponse,
    GetApiV1KbSimulationResultsBySimulationResultIdError,
    GetApiV1KbSimulationResultsBySimulationResultIdResponse,
    ReturnType<typeof getApiV1KbSimulationResultsBySimulationResultIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kb_simulation_result_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1KbSimulationResultsBySimulationResultIdQueryKey(options),
  });

/**
 * Update Kb Simulation Result V1
 */
export const patchApiV1KbSimulationResultsBySimulationResultIdMutation = (
  options?: Partial<
    Options<PatchApiV1KbSimulationResultsBySimulationResultIdData>
  >,
): UseMutationOptions<
  PatchApiV1KbSimulationResultsBySimulationResultIdResponse,
  PatchApiV1KbSimulationResultsBySimulationResultIdError,
  Options<PatchApiV1KbSimulationResultsBySimulationResultIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1KbSimulationResultsBySimulationResultIdResponse,
    PatchApiV1KbSimulationResultsBySimulationResultIdError,
    Options<PatchApiV1KbSimulationResultsBySimulationResultIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_kb_simulation_result_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Kb Simulation Result V1
 */
export const postApiV1KbSimulationResultsBySimulationResultIdRestoreMutation = (
  options?: Partial<
    Options<PostApiV1KbSimulationResultsBySimulationResultIdRestoreData>
  >,
): UseMutationOptions<
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponse,
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreError,
  Options<PostApiV1KbSimulationResultsBySimulationResultIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponse,
    PostApiV1KbSimulationResultsBySimulationResultIdRestoreError,
    Options<PostApiV1KbSimulationResultsBySimulationResultIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_kb_simulation_result_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Kb Simulation Result Judgements V1
 */
export const postApiV1KbSimulationResultsBySimulationResultIdJudgementsMutation =
  (
    options?: Partial<
      Options<PostApiV1KbSimulationResultsBySimulationResultIdJudgementsData>
    >,
  ): UseMutationOptions<
    PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponse,
    PostApiV1KbSimulationResultsBySimulationResultIdJudgementsError,
    Options<PostApiV1KbSimulationResultsBySimulationResultIdJudgementsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponse,
      PostApiV1KbSimulationResultsBySimulationResultIdJudgementsError,
      Options<PostApiV1KbSimulationResultsBySimulationResultIdJudgementsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await create_kb_simulation_result_judgements_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1KbSimulationBranchBreakdownStatsQueryKey = (
  options: Options<GetApiV1KbSimulationBranchBreakdownStatsData>,
) => createQueryKey("get_api_v1_kb_simulation_branch_breakdown_stats", options);

/**
 * Get Kb Simulation Branch Breakdown Stats V1
 */
export const getApiV1KbSimulationBranchBreakdownStatsOptions = (
  options: Options<GetApiV1KbSimulationBranchBreakdownStatsData>,
) =>
  queryOptions<
    GetApiV1KbSimulationBranchBreakdownStatsResponse,
    GetApiV1KbSimulationBranchBreakdownStatsError,
    GetApiV1KbSimulationBranchBreakdownStatsResponse,
    ReturnType<typeof getApiV1KbSimulationBranchBreakdownStatsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kb_simulation_branch_breakdown_stats_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1KbSimulationBranchBreakdownStatsQueryKey(options),
  });

export const getApiV1KbSimulationCompareSummaryQueryKey = (
  options: Options<GetApiV1KbSimulationCompareSummaryData>,
) => createQueryKey("get_api_v1_kb_simulation_compare_summary", options);

/**
 * Get Kb Simulation Compare Summary V1
 */
export const getApiV1KbSimulationCompareSummaryOptions = (
  options: Options<GetApiV1KbSimulationCompareSummaryData>,
) =>
  queryOptions<
    GetApiV1KbSimulationCompareSummaryResponse,
    GetApiV1KbSimulationCompareSummaryError,
    GetApiV1KbSimulationCompareSummaryResponse,
    ReturnType<typeof getApiV1KbSimulationCompareSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kb_simulation_compare_summary_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1KbSimulationCompareSummaryQueryKey(options),
  });

export const getApiV1KbSimulationCommitsQueryKey = (
  options: Options<GetApiV1KbSimulationCommitsData>,
) => createQueryKey("get_api_v1_kb_simulation_commits", options);

/**
 * Get Kb Simulation Commits V1
 */
export const getApiV1KbSimulationCommitsOptions = (
  options: Options<GetApiV1KbSimulationCommitsData>,
) =>
  queryOptions<
    GetApiV1KbSimulationCommitsResponse,
    GetApiV1KbSimulationCommitsError,
    GetApiV1KbSimulationCommitsResponse,
    ReturnType<typeof getApiV1KbSimulationCommitsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kb_simulation_commits_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1KbSimulationCommitsQueryKey(options),
  });

export const getApiV1ArticleTagsQueryKey = (
  options?: Options<GetApiV1ArticleTagsData>,
) => createQueryKey("get_api_v1_article_tags", options);

/**
 * Get Article Tags V1
 */
export const getApiV1ArticleTagsOptions = (
  options?: Options<GetApiV1ArticleTagsData>,
) =>
  queryOptions<
    GetApiV1ArticleTagsResponse,
    GetApiV1ArticleTagsError,
    GetApiV1ArticleTagsResponse,
    ReturnType<typeof getApiV1ArticleTagsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_article_tags_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ArticleTagsQueryKey(options),
  });

export const getApiV1ArticleTagsInfiniteQueryKey = (
  options?: Options<GetApiV1ArticleTagsData>,
): QueryKey<Options<GetApiV1ArticleTagsData>> =>
  createQueryKey("get_api_v1_article_tags", options, true);

/**
 * Get Article Tags V1
 */
export const getApiV1ArticleTagsInfiniteOptions = (
  options?: Options<GetApiV1ArticleTagsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ArticleTagsResponse,
    GetApiV1ArticleTagsError,
    InfiniteData<GetApiV1ArticleTagsResponse>,
    QueryKey<Options<GetApiV1ArticleTagsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ArticleTagsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ArticleTagsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_article_tags_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1ArticleTagsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV4KbsQueryKey = (options?: Options<GetApiV4KbsData>) =>
  createQueryKey("get_api_v4_kbs", options);

/**
 * Get Knowledge Bases V4
 */
export const getApiV4KbsOptions = (options?: Options<GetApiV4KbsData>) =>
  queryOptions<
    GetApiV4KbsResponse,
    GetApiV4KbsError,
    GetApiV4KbsResponse,
    ReturnType<typeof getApiV4KbsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_knowledge_bases_v4({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV4KbsQueryKey(options),
  });

export const getApiV4KbsInfiniteQueryKey = (
  options?: Options<GetApiV4KbsData>,
): QueryKey<Options<GetApiV4KbsData>> =>
  createQueryKey("get_api_v4_kbs", options, true);

/**
 * Get Knowledge Bases V4
 */
export const getApiV4KbsInfiniteOptions = (
  options?: Options<GetApiV4KbsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV4KbsResponse,
    GetApiV4KbsError,
    InfiniteData<GetApiV4KbsResponse>,
    QueryKey<Options<GetApiV4KbsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV4KbsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV4KbsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_knowledge_bases_v4({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV4KbsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV2KbsByKbIdQueryKey = (
  options: Options<GetApiV2KbsByKbIdData>,
) => createQueryKey("get_api_v2_kbs_by_kb_id", options);

/**
 * Get Knowledge Base V2
 */
export const getApiV2KbsByKbIdOptions = (
  options: Options<GetApiV2KbsByKbIdData>,
) =>
  queryOptions<
    GetApiV2KbsByKbIdResponse,
    GetApiV2KbsByKbIdError,
    GetApiV2KbsByKbIdResponse,
    ReturnType<typeof getApiV2KbsByKbIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_knowledge_base_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2KbsByKbIdQueryKey(options),
  });

/**
 * Delete Knowledge Base V3
 */
export const deleteApiV3KbsByKbIdMutation = (
  options?: Partial<Options<DeleteApiV3KbsByKbIdData>>,
): UseMutationOptions<
  DeleteApiV3KbsByKbIdResponse,
  DeleteApiV3KbsByKbIdError,
  Options<DeleteApiV3KbsByKbIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV3KbsByKbIdResponse,
    DeleteApiV3KbsByKbIdError,
    Options<DeleteApiV3KbsByKbIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_knowledge_base_v3({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Patch Knowledge Base V3
 */
export const patchApiV3KbsByKbIdMutation = (
  options?: Partial<Options<PatchApiV3KbsByKbIdData>>,
): UseMutationOptions<
  PatchApiV3KbsByKbIdResponse,
  PatchApiV3KbsByKbIdError,
  Options<PatchApiV3KbsByKbIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV3KbsByKbIdResponse,
    PatchApiV3KbsByKbIdError,
    Options<PatchApiV3KbsByKbIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patch_knowledge_base_v3({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Patch Knowledge Base Review Sla V3
 */
export const patchApiV3KbsByKbIdCrReviewSlaMutation = (
  options?: Partial<Options<PatchApiV3KbsByKbIdCrReviewSlaData>>,
): UseMutationOptions<
  PatchApiV3KbsByKbIdCrReviewSlaResponse,
  PatchApiV3KbsByKbIdCrReviewSlaError,
  Options<PatchApiV3KbsByKbIdCrReviewSlaData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV3KbsByKbIdCrReviewSlaResponse,
    PatchApiV3KbsByKbIdCrReviewSlaError,
    Options<PatchApiV3KbsByKbIdCrReviewSlaData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patch_knowledge_base_review_sla_v3({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Knowledge Base V3
 */
export const postApiV3KbsByKbIdRestoreMutation = (
  options?: Partial<Options<PostApiV3KbsByKbIdRestoreData>>,
): UseMutationOptions<
  PostApiV3KbsByKbIdRestoreResponse,
  PostApiV3KbsByKbIdRestoreError,
  Options<PostApiV3KbsByKbIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV3KbsByKbIdRestoreResponse,
    PostApiV3KbsByKbIdRestoreError,
    Options<PostApiV3KbsByKbIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_knowledge_base_v3({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Embed V2
 */
export const postApiV2KbsByKbIdEmbedMutation = (
  options?: Partial<Options<PostApiV2KbsByKbIdEmbedData>>,
): UseMutationOptions<
  PostApiV2KbsByKbIdEmbedResponse,
  PostApiV2KbsByKbIdEmbedError,
  Options<PostApiV2KbsByKbIdEmbedData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2KbsByKbIdEmbedResponse,
    PostApiV2KbsByKbIdEmbedError,
    Options<PostApiV2KbsByKbIdEmbedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await embed_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV2KbsByKbIdEmbeddingSummaryQueryKey = (
  options: Options<GetApiV2KbsByKbIdEmbeddingSummaryData>,
) => createQueryKey("get_api_v2_kbs_by_kb_id_embedding_summary", options);

/**
 * Get Embedding Summary V2
 */
export const getApiV2KbsByKbIdEmbeddingSummaryOptions = (
  options: Options<GetApiV2KbsByKbIdEmbeddingSummaryData>,
) =>
  queryOptions<
    GetApiV2KbsByKbIdEmbeddingSummaryResponse,
    GetApiV2KbsByKbIdEmbeddingSummaryError,
    GetApiV2KbsByKbIdEmbeddingSummaryResponse,
    ReturnType<typeof getApiV2KbsByKbIdEmbeddingSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_embedding_summary_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2KbsByKbIdEmbeddingSummaryQueryKey(options),
  });

/**
 * Embedding Search V1
 */
export const postApiV1KbsByKbIdEmbeddingSearchMutation = (
  options?: Partial<Options<PostApiV1KbsByKbIdEmbeddingSearchData>>,
): UseMutationOptions<
  PostApiV1KbsByKbIdEmbeddingSearchResponse,
  PostApiV1KbsByKbIdEmbeddingSearchError,
  Options<PostApiV1KbsByKbIdEmbeddingSearchData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1KbsByKbIdEmbeddingSearchResponse,
    PostApiV1KbsByKbIdEmbeddingSearchError,
    Options<PostApiV1KbsByKbIdEmbeddingSearchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await embedding_search_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Hybrid Search V1
 */
export const postApiV1KbsByKbIdHybridSearchMutation = (
  options?: Partial<Options<PostApiV1KbsByKbIdHybridSearchData>>,
): UseMutationOptions<
  PostApiV1KbsByKbIdHybridSearchResponse,
  PostApiV1KbsByKbIdHybridSearchError,
  Options<PostApiV1KbsByKbIdHybridSearchData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1KbsByKbIdHybridSearchResponse,
    PostApiV1KbsByKbIdHybridSearchError,
    Options<PostApiV1KbsByKbIdHybridSearchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await hybrid_search_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Regex Search Articles V1
 */
export const postApiV1KbsByKbIdRegexSearchMutation = (
  options?: Partial<Options<PostApiV1KbsByKbIdRegexSearchData>>,
): UseMutationOptions<
  PostApiV1KbsByKbIdRegexSearchResponse,
  PostApiV1KbsByKbIdRegexSearchError,
  Options<PostApiV1KbsByKbIdRegexSearchData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1KbsByKbIdRegexSearchResponse,
    PostApiV1KbsByKbIdRegexSearchError,
    Options<PostApiV1KbsByKbIdRegexSearchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await regex_search_articles_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ObjectArticleByObjectArticleIdQueryKey = (
  options: Options<GetApiV1ObjectArticleByObjectArticleIdData>,
) => createQueryKey("get_api_v1_object_article_by_object_article_id", options);

/**
 * Get Object Article V1
 */
export const getApiV1ObjectArticleByObjectArticleIdOptions = (
  options: Options<GetApiV1ObjectArticleByObjectArticleIdData>,
) =>
  queryOptions<
    GetApiV1ObjectArticleByObjectArticleIdResponse,
    GetApiV1ObjectArticleByObjectArticleIdError,
    GetApiV1ObjectArticleByObjectArticleIdResponse,
    ReturnType<typeof getApiV1ObjectArticleByObjectArticleIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_object_article_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ObjectArticleByObjectArticleIdQueryKey(options),
  });

/**
 * Patch Article V1
 */
export const patchApiV1KbsByKbIdArticlesByArticleIdMutation = (
  options?: Partial<Options<PatchApiV1KbsByKbIdArticlesByArticleIdData>>,
): UseMutationOptions<
  PatchApiV1KbsByKbIdArticlesByArticleIdResponse,
  PatchApiV1KbsByKbIdArticlesByArticleIdError,
  Options<PatchApiV1KbsByKbIdArticlesByArticleIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1KbsByKbIdArticlesByArticleIdResponse,
    PatchApiV1KbsByKbIdArticlesByArticleIdError,
    Options<PatchApiV1KbsByKbIdArticlesByArticleIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patch_article_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1KbsOwnedQueryKey = (
  options?: Options<GetApiV1KbsOwnedData>,
) => createQueryKey("get_api_v1_kbs_owned", options);

/**
 * Get Owned Knowledge Bases V1
 */
export const getApiV1KbsOwnedOptions = (
  options?: Options<GetApiV1KbsOwnedData>,
) =>
  queryOptions<
    GetApiV1KbsOwnedResponse,
    GetApiV1KbsOwnedError,
    GetApiV1KbsOwnedResponse,
    ReturnType<typeof getApiV1KbsOwnedQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_owned_knowledge_bases_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1KbsOwnedQueryKey(options),
  });

export const getApiV1KbsOwnedInfiniteQueryKey = (
  options?: Options<GetApiV1KbsOwnedData>,
): QueryKey<Options<GetApiV1KbsOwnedData>> =>
  createQueryKey("get_api_v1_kbs_owned", options, true);

/**
 * Get Owned Knowledge Bases V1
 */
export const getApiV1KbsOwnedInfiniteOptions = (
  options?: Options<GetApiV1KbsOwnedData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1KbsOwnedResponse,
    GetApiV1KbsOwnedError,
    InfiniteData<GetApiV1KbsOwnedResponse>,
    QueryKey<Options<GetApiV1KbsOwnedData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1KbsOwnedData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1KbsOwnedData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_owned_knowledge_bases_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1KbsOwnedInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Knowledge Base V1
 */
export const postApiV1KbsMutation = (
  options?: Partial<Options<PostApiV1KbsData>>,
): UseMutationOptions<
  PostApiV1KbsResponse,
  PostApiV1KbsError,
  Options<PostApiV1KbsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1KbsResponse,
    PostApiV1KbsError,
    Options<PostApiV1KbsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_knowledge_base_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Index Text V3
 */
export const putApiV3KbsByKbIdArticleByRefByArticleIdIndexTextMutation = (
  options?: Partial<
    Options<PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextData>
  >,
): UseMutationOptions<
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponse,
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextError,
  Options<PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponse,
    PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextError,
    Options<PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_index_text_v3({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1MachineUsersQueryKey = (
  options?: Options<GetApiV1MachineUsersData>,
) => createQueryKey("get_api_v1_machine_users", options);

/**
 * Get Machine Users V1
 */
export const getApiV1MachineUsersOptions = (
  options?: Options<GetApiV1MachineUsersData>,
) =>
  queryOptions<
    GetApiV1MachineUsersResponse,
    GetApiV1MachineUsersError,
    GetApiV1MachineUsersResponse,
    ReturnType<typeof getApiV1MachineUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_machine_users_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1MachineUsersQueryKey(options),
  });

export const getApiV1MachineUsersInfiniteQueryKey = (
  options?: Options<GetApiV1MachineUsersData>,
): QueryKey<Options<GetApiV1MachineUsersData>> =>
  createQueryKey("get_api_v1_machine_users", options, true);

/**
 * Get Machine Users V1
 */
export const getApiV1MachineUsersInfiniteOptions = (
  options?: Options<GetApiV1MachineUsersData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1MachineUsersResponse,
    GetApiV1MachineUsersError,
    InfiniteData<GetApiV1MachineUsersResponse>,
    QueryKey<Options<GetApiV1MachineUsersData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1MachineUsersData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1MachineUsersData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_machine_users_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1MachineUsersInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Machine User V1
 */
export const postApiV1MachineUsersMutation = (
  options?: Partial<Options<PostApiV1MachineUsersData>>,
): UseMutationOptions<
  PostApiV1MachineUsersResponse,
  PostApiV1MachineUsersError,
  Options<PostApiV1MachineUsersData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1MachineUsersResponse,
    PostApiV1MachineUsersError,
    Options<PostApiV1MachineUsersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_machine_user_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Machine User V1
 */
export const deleteApiV1MachineUsersByMachineUserIdMutation = (
  options?: Partial<Options<DeleteApiV1MachineUsersByMachineUserIdData>>,
): UseMutationOptions<
  DeleteApiV1MachineUsersByMachineUserIdResponse,
  DeleteApiV1MachineUsersByMachineUserIdError,
  Options<DeleteApiV1MachineUsersByMachineUserIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1MachineUsersByMachineUserIdResponse,
    DeleteApiV1MachineUsersByMachineUserIdError,
    Options<DeleteApiV1MachineUsersByMachineUserIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_machine_user_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1MachineUsersByMachineUserIdQueryKey = (
  options: Options<GetApiV1MachineUsersByMachineUserIdData>,
) => createQueryKey("get_api_v1_machine_users_by_machine_user_id", options);

/**
 * Get Machine User V1
 */
export const getApiV1MachineUsersByMachineUserIdOptions = (
  options: Options<GetApiV1MachineUsersByMachineUserIdData>,
) =>
  queryOptions<
    GetApiV1MachineUsersByMachineUserIdResponse,
    GetApiV1MachineUsersByMachineUserIdError,
    GetApiV1MachineUsersByMachineUserIdResponse,
    ReturnType<typeof getApiV1MachineUsersByMachineUserIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_machine_user_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1MachineUsersByMachineUserIdQueryKey(options),
  });

/**
 * Update Machine User V1
 */
export const patchApiV1MachineUsersByMachineUserIdMutation = (
  options?: Partial<Options<PatchApiV1MachineUsersByMachineUserIdData>>,
): UseMutationOptions<
  PatchApiV1MachineUsersByMachineUserIdResponse,
  PatchApiV1MachineUsersByMachineUserIdError,
  Options<PatchApiV1MachineUsersByMachineUserIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1MachineUsersByMachineUserIdResponse,
    PatchApiV1MachineUsersByMachineUserIdError,
    Options<PatchApiV1MachineUsersByMachineUserIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_machine_user_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1MachineUsersByMachineUserIdApiKeysQueryKey = (
  options: Options<GetApiV1MachineUsersByMachineUserIdApiKeysData>,
) =>
  createQueryKey(
    "get_api_v1_machine_users_by_machine_user_id_api_keys",
    options,
  );

/**
 * Get Machine User Api Keys V1
 */
export const getApiV1MachineUsersByMachineUserIdApiKeysOptions = (
  options: Options<GetApiV1MachineUsersByMachineUserIdApiKeysData>,
) =>
  queryOptions<
    GetApiV1MachineUsersByMachineUserIdApiKeysResponse,
    GetApiV1MachineUsersByMachineUserIdApiKeysError,
    GetApiV1MachineUsersByMachineUserIdApiKeysResponse,
    ReturnType<typeof getApiV1MachineUsersByMachineUserIdApiKeysQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_machine_user_api_keys_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1MachineUsersByMachineUserIdApiKeysQueryKey(options),
  });

export const getApiV1MachineUsersByMachineUserIdApiKeysInfiniteQueryKey = (
  options: Options<GetApiV1MachineUsersByMachineUserIdApiKeysData>,
): QueryKey<Options<GetApiV1MachineUsersByMachineUserIdApiKeysData>> =>
  createQueryKey(
    "get_api_v1_machine_users_by_machine_user_id_api_keys",
    options,
    true,
  );

/**
 * Get Machine User Api Keys V1
 */
export const getApiV1MachineUsersByMachineUserIdApiKeysInfiniteOptions = (
  options: Options<GetApiV1MachineUsersByMachineUserIdApiKeysData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1MachineUsersByMachineUserIdApiKeysResponse,
    GetApiV1MachineUsersByMachineUserIdApiKeysError,
    InfiniteData<GetApiV1MachineUsersByMachineUserIdApiKeysResponse>,
    QueryKey<Options<GetApiV1MachineUsersByMachineUserIdApiKeysData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1MachineUsersByMachineUserIdApiKeysData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1MachineUsersByMachineUserIdApiKeysData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_machine_user_api_keys_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1MachineUsersByMachineUserIdApiKeysInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Machine User Api Key V1
 */
export const postApiV1MachineUsersByMachineUserIdApiKeysMutation = (
  options?: Partial<Options<PostApiV1MachineUsersByMachineUserIdApiKeysData>>,
): UseMutationOptions<
  PostApiV1MachineUsersByMachineUserIdApiKeysResponse,
  PostApiV1MachineUsersByMachineUserIdApiKeysError,
  Options<PostApiV1MachineUsersByMachineUserIdApiKeysData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1MachineUsersByMachineUserIdApiKeysResponse,
    PostApiV1MachineUsersByMachineUserIdApiKeysError,
    Options<PostApiV1MachineUsersByMachineUserIdApiKeysData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_machine_user_api_key_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Machine User Api Key V1
 */
export const deleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdMutation = (
  options?: Partial<
    Options<DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdData>
  >,
): UseMutationOptions<
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponse,
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdError,
  Options<DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponse,
    DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdError,
    Options<DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_machine_user_api_key_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV2MetricsVerificationQueryKey = (
  options: Options<GetApiV2MetricsVerificationData>,
) => createQueryKey("get_api_v2_metrics_verification", options);

/**
 * Get Verification Metrics V2
 */
export const getApiV2MetricsVerificationOptions = (
  options: Options<GetApiV2MetricsVerificationData>,
) =>
  queryOptions<
    GetApiV2MetricsVerificationResponse,
    GetApiV2MetricsVerificationError,
    GetApiV2MetricsVerificationResponse,
    ReturnType<typeof getApiV2MetricsVerificationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_verification_metrics_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2MetricsVerificationQueryKey(options),
  });

export const getApiV2MetricsChangeCountsQueryKey = (
  options: Options<GetApiV2MetricsChangeCountsData>,
) => createQueryKey("get_api_v2_metrics_change_counts", options);

/**
 * Get Change Counts V2
 */
export const getApiV2MetricsChangeCountsOptions = (
  options: Options<GetApiV2MetricsChangeCountsData>,
) =>
  queryOptions<
    GetApiV2MetricsChangeCountsResponse,
    GetApiV2MetricsChangeCountsError,
    GetApiV2MetricsChangeCountsResponse,
    ReturnType<typeof getApiV2MetricsChangeCountsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_change_counts_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2MetricsChangeCountsQueryKey(options),
  });

export const getApiV2MetricsChangeUsersQueryKey = (
  options: Options<GetApiV2MetricsChangeUsersData>,
) => createQueryKey("get_api_v2_metrics_change_users", options);

/**
 * Get Change Users V2
 */
export const getApiV2MetricsChangeUsersOptions = (
  options: Options<GetApiV2MetricsChangeUsersData>,
) =>
  queryOptions<
    GetApiV2MetricsChangeUsersResponse,
    GetApiV2MetricsChangeUsersError,
    GetApiV2MetricsChangeUsersResponse,
    ReturnType<typeof getApiV2MetricsChangeUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_change_users_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2MetricsChangeUsersQueryKey(options),
  });

export const getApiV1MetricsChildJudgementQueryKey = (
  options: Options<GetApiV1MetricsChildJudgementData>,
) => createQueryKey("get_api_v1_metrics_child_judgement", options);

/**
 * Get Kb Child Judgement Metrics V1
 */
export const getApiV1MetricsChildJudgementOptions = (
  options: Options<GetApiV1MetricsChildJudgementData>,
) =>
  queryOptions<
    GetApiV1MetricsChildJudgementResponse,
    GetApiV1MetricsChildJudgementError,
    GetApiV1MetricsChildJudgementResponse,
    ReturnType<typeof getApiV1MetricsChildJudgementQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kb_child_judgement_metrics_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1MetricsChildJudgementQueryKey(options),
  });

export const getApiV2MetricsTopArticleJudgementQueryKey = (
  options: Options<GetApiV2MetricsTopArticleJudgementData>,
) => createQueryKey("get_api_v2_metrics_top_article_judgement", options);

/**
 * Get Kb Top Article Judgement Metrics V2
 */
export const getApiV2MetricsTopArticleJudgementOptions = (
  options: Options<GetApiV2MetricsTopArticleJudgementData>,
) =>
  queryOptions<
    GetApiV2MetricsTopArticleJudgementResponse,
    GetApiV2MetricsTopArticleJudgementError,
    GetApiV2MetricsTopArticleJudgementResponse,
    ReturnType<typeof getApiV2MetricsTopArticleJudgementQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_kb_top_article_judgement_metrics_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2MetricsTopArticleJudgementQueryKey(options),
  });

export const getApiV2MetricsTopArticleJudgementInfiniteQueryKey = (
  options: Options<GetApiV2MetricsTopArticleJudgementData>,
): QueryKey<Options<GetApiV2MetricsTopArticleJudgementData>> =>
  createQueryKey("get_api_v2_metrics_top_article_judgement", options, true);

/**
 * Get Kb Top Article Judgement Metrics V2
 */
export const getApiV2MetricsTopArticleJudgementInfiniteOptions = (
  options: Options<GetApiV2MetricsTopArticleJudgementData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV2MetricsTopArticleJudgementResponse,
    GetApiV2MetricsTopArticleJudgementError,
    InfiniteData<GetApiV2MetricsTopArticleJudgementResponse>,
    QueryKey<Options<GetApiV2MetricsTopArticleJudgementData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV2MetricsTopArticleJudgementData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV2MetricsTopArticleJudgementData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_kb_top_article_judgement_metrics_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV2MetricsTopArticleJudgementInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1UsersByUserIdNotificationSettingsQueryKey = (
  options: Options<GetApiV1UsersByUserIdNotificationSettingsData>,
) =>
  createQueryKey("get_api_v1_users_by_user_id_notification_settings", options);

/**
 * Get Notification Settings V1
 */
export const getApiV1UsersByUserIdNotificationSettingsOptions = (
  options: Options<GetApiV1UsersByUserIdNotificationSettingsData>,
) =>
  queryOptions<
    GetApiV1UsersByUserIdNotificationSettingsResponse,
    GetApiV1UsersByUserIdNotificationSettingsError,
    GetApiV1UsersByUserIdNotificationSettingsResponse,
    ReturnType<typeof getApiV1UsersByUserIdNotificationSettingsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_notification_settings_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1UsersByUserIdNotificationSettingsQueryKey(options),
  });

/**
 * Patch Notification Settings V1
 */
export const patchApiV1UsersByUserIdNotificationSettingsMutation = (
  options?: Partial<Options<PatchApiV1UsersByUserIdNotificationSettingsData>>,
): UseMutationOptions<
  PatchApiV1UsersByUserIdNotificationSettingsResponse,
  PatchApiV1UsersByUserIdNotificationSettingsError,
  Options<PatchApiV1UsersByUserIdNotificationSettingsData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1UsersByUserIdNotificationSettingsResponse,
    PatchApiV1UsersByUserIdNotificationSettingsError,
    Options<PatchApiV1UsersByUserIdNotificationSettingsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patch_notification_settings_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiNotionV1TenantsByTenantIdActionsPagesQueryKey = (
  options: Options<GetApiNotionV1TenantsByTenantIdActionsPagesData>,
) =>
  createQueryKey(
    "get_api_notion_v1_tenants_by_tenant_id_actions_pages",
    options,
  );

/**
 * Notion Get Pages V1
 */
export const getApiNotionV1TenantsByTenantIdActionsPagesOptions = (
  options: Options<GetApiNotionV1TenantsByTenantIdActionsPagesData>,
) =>
  queryOptions<
    GetApiNotionV1TenantsByTenantIdActionsPagesResponse,
    GetApiNotionV1TenantsByTenantIdActionsPagesError,
    GetApiNotionV1TenantsByTenantIdActionsPagesResponse,
    ReturnType<typeof getApiNotionV1TenantsByTenantIdActionsPagesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await notion_get_pages_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiNotionV1TenantsByTenantIdActionsPagesQueryKey(options),
  });

export const getApiNotionV1TenantsByTenantIdActionsPagesInfiniteQueryKey = (
  options: Options<GetApiNotionV1TenantsByTenantIdActionsPagesData>,
): QueryKey<Options<GetApiNotionV1TenantsByTenantIdActionsPagesData>> =>
  createQueryKey(
    "get_api_notion_v1_tenants_by_tenant_id_actions_pages",
    options,
    true,
  );

/**
 * Notion Get Pages V1
 */
export const getApiNotionV1TenantsByTenantIdActionsPagesInfiniteOptions = (
  options: Options<GetApiNotionV1TenantsByTenantIdActionsPagesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiNotionV1TenantsByTenantIdActionsPagesResponse,
    GetApiNotionV1TenantsByTenantIdActionsPagesError,
    InfiniteData<GetApiNotionV1TenantsByTenantIdActionsPagesResponse>,
    QueryKey<Options<GetApiNotionV1TenantsByTenantIdActionsPagesData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetApiNotionV1TenantsByTenantIdActionsPagesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiNotionV1TenantsByTenantIdActionsPagesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await notion_get_pages_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiNotionV1TenantsByTenantIdActionsPagesInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Notion Create Page V1
 */
export const postApiNotionV1TenantsByTenantIdActionsPagesMutation = (
  options?: Partial<Options<PostApiNotionV1TenantsByTenantIdActionsPagesData>>,
): UseMutationOptions<
  PostApiNotionV1TenantsByTenantIdActionsPagesResponse,
  PostApiNotionV1TenantsByTenantIdActionsPagesError,
  Options<PostApiNotionV1TenantsByTenantIdActionsPagesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiNotionV1TenantsByTenantIdActionsPagesResponse,
    PostApiNotionV1TenantsByTenantIdActionsPagesError,
    Options<PostApiNotionV1TenantsByTenantIdActionsPagesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await notion_create_page_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiNotionV1TenantsByTenantIdActionsDatabasesQueryKey = (
  options: Options<GetApiNotionV1TenantsByTenantIdActionsDatabasesData>,
) =>
  createQueryKey(
    "get_api_notion_v1_tenants_by_tenant_id_actions_databases",
    options,
  );

/**
 * Notion Get Databases V1
 */
export const getApiNotionV1TenantsByTenantIdActionsDatabasesOptions = (
  options: Options<GetApiNotionV1TenantsByTenantIdActionsDatabasesData>,
) =>
  queryOptions<
    GetApiNotionV1TenantsByTenantIdActionsDatabasesResponse,
    GetApiNotionV1TenantsByTenantIdActionsDatabasesError,
    GetApiNotionV1TenantsByTenantIdActionsDatabasesResponse,
    ReturnType<typeof getApiNotionV1TenantsByTenantIdActionsDatabasesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await notion_get_databases_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiNotionV1TenantsByTenantIdActionsDatabasesQueryKey(options),
  });

export const getApiNotionV1TenantsByTenantIdActionsDatabasesInfiniteQueryKey = (
  options: Options<GetApiNotionV1TenantsByTenantIdActionsDatabasesData>,
): QueryKey<Options<GetApiNotionV1TenantsByTenantIdActionsDatabasesData>> =>
  createQueryKey(
    "get_api_notion_v1_tenants_by_tenant_id_actions_databases",
    options,
    true,
  );

/**
 * Notion Get Databases V1
 */
export const getApiNotionV1TenantsByTenantIdActionsDatabasesInfiniteOptions = (
  options: Options<GetApiNotionV1TenantsByTenantIdActionsDatabasesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiNotionV1TenantsByTenantIdActionsDatabasesResponse,
    GetApiNotionV1TenantsByTenantIdActionsDatabasesError,
    InfiniteData<GetApiNotionV1TenantsByTenantIdActionsDatabasesResponse>,
    QueryKey<Options<GetApiNotionV1TenantsByTenantIdActionsDatabasesData>>,
    | string
    | null
    | Pick<
        QueryKey<
          Options<GetApiNotionV1TenantsByTenantIdActionsDatabasesData>
        >[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiNotionV1TenantsByTenantIdActionsDatabasesData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await notion_get_databases_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiNotionV1TenantsByTenantIdActionsDatabasesInfiniteQueryKey(
          options,
        ),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryKey =
  (
    options: Options<GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdData>,
  ) =>
    createQueryKey(
      "get_api_notion_v1_tenants_by_tenant_id_actions_databases_by_database_id",
      options,
    );

/**
 * Notion Get Database V1
 */
export const getApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdOptions =
  (
    options: Options<GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdData>,
  ) =>
    queryOptions<
      GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponse,
      GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdError,
      GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponse,
      ReturnType<
        typeof getApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await notion_get_database_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryKey(
          options,
        ),
    });

/**
 * Notion Query Database V1
 */
export const postApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryMutation =
  (
    options?: Partial<
      Options<PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryData>
    >,
  ): UseMutationOptions<
    PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponse,
    PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryError,
    Options<PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponse,
      PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryError,
      Options<PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await notion_query_database_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentQueryKey =
  (
    options: Options<GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentData>,
  ) =>
    createQueryKey(
      "get_api_notion_v1_tenants_by_tenant_id_actions_pages_by_page_id_content",
      options,
    );

/**
 * Notion Get Page Content V1
 */
export const getApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentOptions =
  (
    options: Options<GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentData>,
  ) =>
    queryOptions<
      GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponse,
      GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentError,
      GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponse,
      ReturnType<
        typeof getApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await notion_get_page_content_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentQueryKey(
          options,
        ),
    });

export const getApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsQueryKey =
  (
    options: Options<GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData>,
  ) =>
    createQueryKey(
      "get_api_notion_v1_tenants_by_tenant_id_actions_pages_by_page_id_comments",
      options,
    );

/**
 * Notion Get Comments V1
 */
export const getApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsOptions =
  (
    options: Options<GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData>,
  ) =>
    queryOptions<
      GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
      GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
      GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
      ReturnType<
        typeof getApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await notion_get_comments_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsQueryKey(
          options,
        ),
    });

export const getApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsInfiniteQueryKey =
  (
    options: Options<GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData>,
  ): QueryKey<
    Options<GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData>
  > =>
    createQueryKey(
      "get_api_notion_v1_tenants_by_tenant_id_actions_pages_by_page_id_comments",
      options,
      true,
    );

/**
 * Notion Get Comments V1
 */
export const getApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsInfiniteOptions =
  (
    options: Options<GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
      GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
      InfiniteData<GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse>,
      QueryKey<
        Options<GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await notion_get_comments_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

/**
 * Notion Create Blocks V1
 */
export const postApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksMutation =
  (
    options?: Partial<
      Options<PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksData>
    >,
  ): UseMutationOptions<
    PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponse,
    PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksError,
    Options<PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponse,
      PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksError,
      Options<PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await notion_create_blocks_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Notion Delete Page V1
 */
export const deleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdMutation = (
  options?: Partial<
    Options<DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdData>
  >,
): UseMutationOptions<
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponse,
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdError,
  Options<DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponse,
    DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdError,
    Options<DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await notion_delete_page_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Notion Update Page V1
 */
export const patchApiNotionV1TenantsByTenantIdActionsPagesByPageIdMutation = (
  options?: Partial<
    Options<PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdData>
  >,
): UseMutationOptions<
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponse,
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdError,
  Options<PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponse,
    PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdError,
    Options<PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await notion_update_page_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Notion Delete Block V1
 */
export const deleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdMutation =
  (
    options?: Partial<
      Options<DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData>
    >,
  ): UseMutationOptions<
    DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponse,
    DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdError,
    Options<DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponse,
      DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdError,
      Options<DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await notion_delete_block_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Notion Update Block V1
 */
export const patchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdMutation = (
  options?: Partial<
    Options<PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData>
  >,
): UseMutationOptions<
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponse,
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdError,
  Options<PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponse,
    PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdError,
    Options<PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await notion_update_block_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiNotionV1TenantsQueryKey = (
  options?: Options<GetApiNotionV1TenantsData>,
) => createQueryKey("get_api_notion_v1_tenants", options);

/**
 * Notion Get Tenants V1
 */
export const getApiNotionV1TenantsOptions = (
  options?: Options<GetApiNotionV1TenantsData>,
) =>
  queryOptions<
    GetApiNotionV1TenantsResponse,
    GetApiNotionV1TenantsError,
    GetApiNotionV1TenantsResponse,
    ReturnType<typeof getApiNotionV1TenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await notion_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiNotionV1TenantsQueryKey(options),
  });

export const getApiNotionV1TenantsInfiniteQueryKey = (
  options?: Options<GetApiNotionV1TenantsData>,
): QueryKey<Options<GetApiNotionV1TenantsData>> =>
  createQueryKey("get_api_notion_v1_tenants", options, true);

/**
 * Notion Get Tenants V1
 */
export const getApiNotionV1TenantsInfiniteOptions = (
  options?: Options<GetApiNotionV1TenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiNotionV1TenantsResponse,
    GetApiNotionV1TenantsError,
    InfiniteData<GetApiNotionV1TenantsResponse>,
    QueryKey<Options<GetApiNotionV1TenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiNotionV1TenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiNotionV1TenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await notion_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiNotionV1TenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Notion Create Tenant V1
 */
export const postApiNotionV1TenantsMutation = (
  options?: Partial<Options<PostApiNotionV1TenantsData>>,
): UseMutationOptions<
  PostApiNotionV1TenantsResponse,
  PostApiNotionV1TenantsError,
  Options<PostApiNotionV1TenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiNotionV1TenantsResponse,
    PostApiNotionV1TenantsError,
    Options<PostApiNotionV1TenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await notion_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Notion Delete Tenant V1
 */
export const deleteApiNotionV1TenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiNotionV1TenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiNotionV1TenantsByTenantIdResponse,
  DeleteApiNotionV1TenantsByTenantIdError,
  Options<DeleteApiNotionV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiNotionV1TenantsByTenantIdResponse,
    DeleteApiNotionV1TenantsByTenantIdError,
    Options<DeleteApiNotionV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await notion_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiNotionV1TenantsByTenantIdQueryKey = (
  options: Options<GetApiNotionV1TenantsByTenantIdData>,
) => createQueryKey("get_api_notion_v1_tenants_by_tenant_id", options);

/**
 * Notion Get Tenant V1
 */
export const getApiNotionV1TenantsByTenantIdOptions = (
  options: Options<GetApiNotionV1TenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiNotionV1TenantsByTenantIdResponse,
    GetApiNotionV1TenantsByTenantIdError,
    GetApiNotionV1TenantsByTenantIdResponse,
    ReturnType<typeof getApiNotionV1TenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await notion_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiNotionV1TenantsByTenantIdQueryKey(options),
  });

/**
 * Notion Connect Tenant V1
 */
export const postApiNotionV1TenantsByTenantIdConnectMutation = (
  options?: Partial<Options<PostApiNotionV1TenantsByTenantIdConnectData>>,
): UseMutationOptions<
  PostApiNotionV1TenantsByTenantIdConnectResponse,
  PostApiNotionV1TenantsByTenantIdConnectError,
  Options<PostApiNotionV1TenantsByTenantIdConnectData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiNotionV1TenantsByTenantIdConnectResponse,
    PostApiNotionV1TenantsByTenantIdConnectError,
    Options<PostApiNotionV1TenantsByTenantIdConnectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await notion_connect_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Notion Callback Tenant V1
 */
export const postApiNotionV1TenantsByTenantIdCallbackMutation = (
  options?: Partial<Options<PostApiNotionV1TenantsByTenantIdCallbackData>>,
): UseMutationOptions<
  PostApiNotionV1TenantsByTenantIdCallbackResponse,
  PostApiNotionV1TenantsByTenantIdCallbackError,
  Options<PostApiNotionV1TenantsByTenantIdCallbackData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiNotionV1TenantsByTenantIdCallbackResponse,
    PostApiNotionV1TenantsByTenantIdCallbackError,
    Options<PostApiNotionV1TenantsByTenantIdCallbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await notion_callback_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Notion Reveal Webhook Token V1
 */
export const postApiNotionV1TenantsByTenantIdRevealWebhookTokenMutation = (
  options?: Partial<
    Options<PostApiNotionV1TenantsByTenantIdRevealWebhookTokenData>
  >,
): UseMutationOptions<
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponse,
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenError,
  Options<PostApiNotionV1TenantsByTenantIdRevealWebhookTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponse,
    PostApiNotionV1TenantsByTenantIdRevealWebhookTokenError,
    Options<PostApiNotionV1TenantsByTenantIdRevealWebhookTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await notion_reveal_webhook_token_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiNotionV1TenantsByTenantIdCheckConnectionQueryKey = (
  options: Options<GetApiNotionV1TenantsByTenantIdCheckConnectionData>,
) =>
  createQueryKey(
    "get_api_notion_v1_tenants_by_tenant_id_check_connection",
    options,
  );

/**
 * Notion Check Connection V1
 */
export const getApiNotionV1TenantsByTenantIdCheckConnectionOptions = (
  options: Options<GetApiNotionV1TenantsByTenantIdCheckConnectionData>,
) =>
  queryOptions<
    GetApiNotionV1TenantsByTenantIdCheckConnectionResponse,
    GetApiNotionV1TenantsByTenantIdCheckConnectionError,
    GetApiNotionV1TenantsByTenantIdCheckConnectionResponse,
    ReturnType<typeof getApiNotionV1TenantsByTenantIdCheckConnectionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await notion_check_connection_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiNotionV1TenantsByTenantIdCheckConnectionQueryKey(options),
  });

export const getApiV1OauthApplicationsQueryKey = (
  options?: Options<GetApiV1OauthApplicationsData>,
) => createQueryKey("get_api_v1_oauth_applications", options);

/**
 * Get Oauth Applications V1
 */
export const getApiV1OauthApplicationsOptions = (
  options?: Options<GetApiV1OauthApplicationsData>,
) =>
  queryOptions<
    GetApiV1OauthApplicationsResponse,
    GetApiV1OauthApplicationsError,
    GetApiV1OauthApplicationsResponse,
    ReturnType<typeof getApiV1OauthApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_oauth_applications_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1OauthApplicationsQueryKey(options),
  });

export const getApiV1OauthApplicationsInfiniteQueryKey = (
  options?: Options<GetApiV1OauthApplicationsData>,
): QueryKey<Options<GetApiV1OauthApplicationsData>> =>
  createQueryKey("get_api_v1_oauth_applications", options, true);

/**
 * Get Oauth Applications V1
 */
export const getApiV1OauthApplicationsInfiniteOptions = (
  options?: Options<GetApiV1OauthApplicationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1OauthApplicationsResponse,
    GetApiV1OauthApplicationsError,
    InfiniteData<GetApiV1OauthApplicationsResponse>,
    QueryKey<Options<GetApiV1OauthApplicationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1OauthApplicationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1OauthApplicationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_oauth_applications_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1OauthApplicationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Oauth Application V1
 */
export const postApiV1OauthApplicationsMutation = (
  options?: Partial<Options<PostApiV1OauthApplicationsData>>,
): UseMutationOptions<
  PostApiV1OauthApplicationsResponse,
  PostApiV1OauthApplicationsError,
  Options<PostApiV1OauthApplicationsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1OauthApplicationsResponse,
    PostApiV1OauthApplicationsError,
    Options<PostApiV1OauthApplicationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_oauth_application_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1FullOauthApplicationsQueryKey = (
  options?: Options<GetApiV1FullOauthApplicationsData>,
) => createQueryKey("get_api_v1_full_oauth_applications", options);

/**
 * Get Full Oauth Applications V1
 */
export const getApiV1FullOauthApplicationsOptions = (
  options?: Options<GetApiV1FullOauthApplicationsData>,
) =>
  queryOptions<
    GetApiV1FullOauthApplicationsResponse,
    GetApiV1FullOauthApplicationsError,
    GetApiV1FullOauthApplicationsResponse,
    ReturnType<typeof getApiV1FullOauthApplicationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_oauth_applications_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullOauthApplicationsQueryKey(options),
  });

export const getApiV1FullOauthApplicationsInfiniteQueryKey = (
  options?: Options<GetApiV1FullOauthApplicationsData>,
): QueryKey<Options<GetApiV1FullOauthApplicationsData>> =>
  createQueryKey("get_api_v1_full_oauth_applications", options, true);

/**
 * Get Full Oauth Applications V1
 */
export const getApiV1FullOauthApplicationsInfiniteOptions = (
  options?: Options<GetApiV1FullOauthApplicationsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullOauthApplicationsResponse,
    GetApiV1FullOauthApplicationsError,
    InfiniteData<GetApiV1FullOauthApplicationsResponse>,
    QueryKey<Options<GetApiV1FullOauthApplicationsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullOauthApplicationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullOauthApplicationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_oauth_applications_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullOauthApplicationsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Oauth Application V1
 */
export const deleteApiV1OauthApplicationsByOauthApplicationIdMutation = (
  options?: Partial<
    Options<DeleteApiV1OauthApplicationsByOauthApplicationIdData>
  >,
): UseMutationOptions<
  DeleteApiV1OauthApplicationsByOauthApplicationIdResponse,
  DeleteApiV1OauthApplicationsByOauthApplicationIdError,
  Options<DeleteApiV1OauthApplicationsByOauthApplicationIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1OauthApplicationsByOauthApplicationIdResponse,
    DeleteApiV1OauthApplicationsByOauthApplicationIdError,
    Options<DeleteApiV1OauthApplicationsByOauthApplicationIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_oauth_application_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1OauthApplicationsByOauthApplicationIdQueryKey = (
  options: Options<GetApiV1OauthApplicationsByOauthApplicationIdData>,
) =>
  createQueryKey(
    "get_api_v1_oauth_applications_by_oauth_application_id",
    options,
  );

/**
 * Get Oauth Application V1
 */
export const getApiV1OauthApplicationsByOauthApplicationIdOptions = (
  options: Options<GetApiV1OauthApplicationsByOauthApplicationIdData>,
) =>
  queryOptions<
    GetApiV1OauthApplicationsByOauthApplicationIdResponse,
    GetApiV1OauthApplicationsByOauthApplicationIdError,
    GetApiV1OauthApplicationsByOauthApplicationIdResponse,
    ReturnType<typeof getApiV1OauthApplicationsByOauthApplicationIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_oauth_application_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1OauthApplicationsByOauthApplicationIdQueryKey(options),
  });

/**
 * Update Oauth Application V1
 */
export const patchApiV1OauthApplicationsByOauthApplicationIdMutation = (
  options?: Partial<
    Options<PatchApiV1OauthApplicationsByOauthApplicationIdData>
  >,
): UseMutationOptions<
  PatchApiV1OauthApplicationsByOauthApplicationIdResponse,
  PatchApiV1OauthApplicationsByOauthApplicationIdError,
  Options<PatchApiV1OauthApplicationsByOauthApplicationIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1OauthApplicationsByOauthApplicationIdResponse,
    PatchApiV1OauthApplicationsByOauthApplicationIdError,
    Options<PatchApiV1OauthApplicationsByOauthApplicationIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_oauth_application_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Rotate Oauth Application Secret V1
 */
export const postApiV1OauthApplicationsByOauthApplicationIdRotateSecretMutation =
  (
    options?: Partial<
      Options<PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretData>
    >,
  ): UseMutationOptions<
    PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponse,
    PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretError,
    Options<PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponse,
      PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretError,
      Options<PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await rotate_oauth_application_secret_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Outlook Create Draft V1
 */
export const postApiOutlookV1ActionsCreateDraftMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsCreateDraftData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsCreateDraftResponse,
  PostApiOutlookV1ActionsCreateDraftError,
  Options<PostApiOutlookV1ActionsCreateDraftData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsCreateDraftResponse,
    PostApiOutlookV1ActionsCreateDraftError,
    Options<PostApiOutlookV1ActionsCreateDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_create_draft_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Reply Email V1
 */
export const postApiOutlookV1ActionsReplyEmailMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsReplyEmailData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsReplyEmailResponse,
  PostApiOutlookV1ActionsReplyEmailError,
  Options<PostApiOutlookV1ActionsReplyEmailData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsReplyEmailResponse,
    PostApiOutlookV1ActionsReplyEmailError,
    Options<PostApiOutlookV1ActionsReplyEmailData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_reply_email_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Forward Email V1
 */
export const postApiOutlookV1ActionsForwardEmailMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsForwardEmailData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsForwardEmailResponse,
  PostApiOutlookV1ActionsForwardEmailError,
  Options<PostApiOutlookV1ActionsForwardEmailData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsForwardEmailResponse,
    PostApiOutlookV1ActionsForwardEmailError,
    Options<PostApiOutlookV1ActionsForwardEmailData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_forward_email_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Send Email V1
 */
export const postApiOutlookV1ActionsSendEmailMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsSendEmailData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsSendEmailResponse,
  PostApiOutlookV1ActionsSendEmailError,
  Options<PostApiOutlookV1ActionsSendEmailData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsSendEmailResponse,
    PostApiOutlookV1ActionsSendEmailError,
    Options<PostApiOutlookV1ActionsSendEmailData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_send_email_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Set Email Categories V1
 */
export const postApiOutlookV1ActionsSetEmailCategoriesMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsSetEmailCategoriesData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsSetEmailCategoriesResponse,
  PostApiOutlookV1ActionsSetEmailCategoriesError,
  Options<PostApiOutlookV1ActionsSetEmailCategoriesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsSetEmailCategoriesResponse,
    PostApiOutlookV1ActionsSetEmailCategoriesError,
    Options<PostApiOutlookV1ActionsSetEmailCategoriesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_set_email_categories_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Set Email Importance V1
 */
export const postApiOutlookV1ActionsSetEmailImportanceMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsSetEmailImportanceData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsSetEmailImportanceResponse,
  PostApiOutlookV1ActionsSetEmailImportanceError,
  Options<PostApiOutlookV1ActionsSetEmailImportanceData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsSetEmailImportanceResponse,
    PostApiOutlookV1ActionsSetEmailImportanceError,
    Options<PostApiOutlookV1ActionsSetEmailImportanceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_set_email_importance_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Set Email Flag V1
 */
export const postApiOutlookV1ActionsSetEmailFlagMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsSetEmailFlagData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsSetEmailFlagResponse,
  PostApiOutlookV1ActionsSetEmailFlagError,
  Options<PostApiOutlookV1ActionsSetEmailFlagData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsSetEmailFlagResponse,
    PostApiOutlookV1ActionsSetEmailFlagError,
    Options<PostApiOutlookV1ActionsSetEmailFlagData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_set_email_flag_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Mark Email Read V1
 */
export const postApiOutlookV1ActionsMarkEmailReadMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsMarkEmailReadData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsMarkEmailReadResponse,
  PostApiOutlookV1ActionsMarkEmailReadError,
  Options<PostApiOutlookV1ActionsMarkEmailReadData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsMarkEmailReadResponse,
    PostApiOutlookV1ActionsMarkEmailReadError,
    Options<PostApiOutlookV1ActionsMarkEmailReadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_mark_email_read_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Move Email V1
 */
export const postApiOutlookV1ActionsMoveEmailMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsMoveEmailData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsMoveEmailResponse,
  PostApiOutlookV1ActionsMoveEmailError,
  Options<PostApiOutlookV1ActionsMoveEmailData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsMoveEmailResponse,
    PostApiOutlookV1ActionsMoveEmailError,
    Options<PostApiOutlookV1ActionsMoveEmailData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_move_email_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Copy Email V1
 */
export const postApiOutlookV1ActionsCopyEmailMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsCopyEmailData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsCopyEmailResponse,
  PostApiOutlookV1ActionsCopyEmailError,
  Options<PostApiOutlookV1ActionsCopyEmailData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsCopyEmailResponse,
    PostApiOutlookV1ActionsCopyEmailError,
    Options<PostApiOutlookV1ActionsCopyEmailData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_copy_email_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Delete Email V1
 */
export const postApiOutlookV1ActionsDeleteEmailMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsDeleteEmailData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsDeleteEmailResponse,
  PostApiOutlookV1ActionsDeleteEmailError,
  Options<PostApiOutlookV1ActionsDeleteEmailData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsDeleteEmailResponse,
    PostApiOutlookV1ActionsDeleteEmailError,
    Options<PostApiOutlookV1ActionsDeleteEmailData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_delete_email_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Get Email Attachment V1
 */
export const postApiOutlookV1ActionsGetEmailAttachmentMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsGetEmailAttachmentData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsGetEmailAttachmentResponse,
  PostApiOutlookV1ActionsGetEmailAttachmentError,
  Options<PostApiOutlookV1ActionsGetEmailAttachmentData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsGetEmailAttachmentResponse,
    PostApiOutlookV1ActionsGetEmailAttachmentError,
    Options<PostApiOutlookV1ActionsGetEmailAttachmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_get_email_attachment_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Add Email Attachment V1
 */
export const postApiOutlookV1ActionsAddEmailAttachmentMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsAddEmailAttachmentData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsAddEmailAttachmentResponse,
  PostApiOutlookV1ActionsAddEmailAttachmentError,
  Options<PostApiOutlookV1ActionsAddEmailAttachmentData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsAddEmailAttachmentResponse,
    PostApiOutlookV1ActionsAddEmailAttachmentError,
    Options<PostApiOutlookV1ActionsAddEmailAttachmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_add_email_attachment_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Remove Email Attachment V1
 */
export const postApiOutlookV1ActionsRemoveEmailAttachmentMutation = (
  options?: Partial<Options<PostApiOutlookV1ActionsRemoveEmailAttachmentData>>,
): UseMutationOptions<
  PostApiOutlookV1ActionsRemoveEmailAttachmentResponse,
  PostApiOutlookV1ActionsRemoveEmailAttachmentError,
  Options<PostApiOutlookV1ActionsRemoveEmailAttachmentData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV1ActionsRemoveEmailAttachmentResponse,
    PostApiOutlookV1ActionsRemoveEmailAttachmentError,
    Options<PostApiOutlookV1ActionsRemoveEmailAttachmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_remove_email_attachment_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiOutlookV2SubscriptionsQueryKey = (
  options?: Options<GetApiOutlookV2SubscriptionsData>,
) => createQueryKey("get_api_outlook_v2_subscriptions", options);

/**
 * Outlook Get Subscriptions V2
 */
export const getApiOutlookV2SubscriptionsOptions = (
  options?: Options<GetApiOutlookV2SubscriptionsData>,
) =>
  queryOptions<
    GetApiOutlookV2SubscriptionsResponse,
    GetApiOutlookV2SubscriptionsError,
    GetApiOutlookV2SubscriptionsResponse,
    ReturnType<typeof getApiOutlookV2SubscriptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await outlook_get_subscriptions_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiOutlookV2SubscriptionsQueryKey(options),
  });

export const getApiOutlookV2SubscriptionsInfiniteQueryKey = (
  options?: Options<GetApiOutlookV2SubscriptionsData>,
): QueryKey<Options<GetApiOutlookV2SubscriptionsData>> =>
  createQueryKey("get_api_outlook_v2_subscriptions", options, true);

/**
 * Outlook Get Subscriptions V2
 */
export const getApiOutlookV2SubscriptionsInfiniteOptions = (
  options?: Options<GetApiOutlookV2SubscriptionsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiOutlookV2SubscriptionsResponse,
    GetApiOutlookV2SubscriptionsError,
    InfiniteData<GetApiOutlookV2SubscriptionsResponse>,
    QueryKey<Options<GetApiOutlookV2SubscriptionsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiOutlookV2SubscriptionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiOutlookV2SubscriptionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await outlook_get_subscriptions_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiOutlookV2SubscriptionsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Outlook Create Subscriptions V2
 */
export const postApiOutlookV2SubscriptionsMutation = (
  options?: Partial<Options<PostApiOutlookV2SubscriptionsData>>,
): UseMutationOptions<
  PostApiOutlookV2SubscriptionsResponse,
  PostApiOutlookV2SubscriptionsError,
  Options<PostApiOutlookV2SubscriptionsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiOutlookV2SubscriptionsResponse,
    PostApiOutlookV2SubscriptionsError,
    Options<PostApiOutlookV2SubscriptionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_create_subscriptions_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Delete Subscription V2
 */
export const deleteApiOutlookV2SubscriptionsBySubscriptionIdMutation = (
  options?: Partial<
    Options<DeleteApiOutlookV2SubscriptionsBySubscriptionIdData>
  >,
): UseMutationOptions<
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponse,
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdError,
  Options<DeleteApiOutlookV2SubscriptionsBySubscriptionIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponse,
    DeleteApiOutlookV2SubscriptionsBySubscriptionIdError,
    Options<DeleteApiOutlookV2SubscriptionsBySubscriptionIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_delete_subscription_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Data Dump Conversations Input V1
 */
export const postApiV1PipelinesExtractDataDumpConversationsInputMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesExtractDataDumpConversationsInputData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesExtractDataDumpConversationsInputResponse,
  PostApiV1PipelinesExtractDataDumpConversationsInputError,
  Options<PostApiV1PipelinesExtractDataDumpConversationsInputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractDataDumpConversationsInputResponse,
    PostApiV1PipelinesExtractDataDumpConversationsInputError,
    Options<PostApiV1PipelinesExtractDataDumpConversationsInputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_data_dump_conversations_input_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Data Dump Conversations Output V1
 */
export const postApiV1PipelinesExtractDataDumpConversationsOutputMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesExtractDataDumpConversationsOutputData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesExtractDataDumpConversationsOutputResponse,
  PostApiV1PipelinesExtractDataDumpConversationsOutputError,
  Options<PostApiV1PipelinesExtractDataDumpConversationsOutputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractDataDumpConversationsOutputResponse,
    PostApiV1PipelinesExtractDataDumpConversationsOutputError,
    Options<PostApiV1PipelinesExtractDataDumpConversationsOutputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_data_dump_conversations_output_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Data Dump Conversations Enqueue V1
 */
export const postApiV1PipelinesExtractDataDumpConversationsEnqueueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesExtractDataDumpConversationsEnqueueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponse,
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueError,
  Options<PostApiV1PipelinesExtractDataDumpConversationsEnqueueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponse,
    PostApiV1PipelinesExtractDataDumpConversationsEnqueueError,
    Options<PostApiV1PipelinesExtractDataDumpConversationsEnqueueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_data_dump_conversations_enqueue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Data Dump Conversations Dequeue V1
 */
export const postApiV1PipelinesExtractDataDumpConversationsDequeueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesExtractDataDumpConversationsDequeueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesExtractDataDumpConversationsDequeueResponse,
  PostApiV1PipelinesExtractDataDumpConversationsDequeueError,
  Options<PostApiV1PipelinesExtractDataDumpConversationsDequeueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractDataDumpConversationsDequeueResponse,
    PostApiV1PipelinesExtractDataDumpConversationsDequeueError,
    Options<PostApiV1PipelinesExtractDataDumpConversationsDequeueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_data_dump_conversations_dequeue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Datapoints Input V1
 */
export const postApiV1PipelinesExtractDatapointsInputMutation = (
  options?: Partial<Options<PostApiV1PipelinesExtractDatapointsInputData>>,
): UseMutationOptions<
  PostApiV1PipelinesExtractDatapointsInputResponse,
  PostApiV1PipelinesExtractDatapointsInputError,
  Options<PostApiV1PipelinesExtractDatapointsInputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractDatapointsInputResponse,
    PostApiV1PipelinesExtractDatapointsInputError,
    Options<PostApiV1PipelinesExtractDatapointsInputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_datapoints_input_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Datapoints Output V1
 */
export const postApiV1PipelinesExtractDatapointsOutputMutation = (
  options?: Partial<Options<PostApiV1PipelinesExtractDatapointsOutputData>>,
): UseMutationOptions<
  PostApiV1PipelinesExtractDatapointsOutputResponse,
  PostApiV1PipelinesExtractDatapointsOutputError,
  Options<PostApiV1PipelinesExtractDatapointsOutputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractDatapointsOutputResponse,
    PostApiV1PipelinesExtractDatapointsOutputError,
    Options<PostApiV1PipelinesExtractDatapointsOutputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_datapoints_output_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Datapoints Enqueue V1
 */
export const postApiV1PipelinesExtractDatapointsEnqueueMutation = (
  options?: Partial<Options<PostApiV1PipelinesExtractDatapointsEnqueueData>>,
): UseMutationOptions<
  PostApiV1PipelinesExtractDatapointsEnqueueResponse,
  PostApiV1PipelinesExtractDatapointsEnqueueError,
  Options<PostApiV1PipelinesExtractDatapointsEnqueueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractDatapointsEnqueueResponse,
    PostApiV1PipelinesExtractDatapointsEnqueueError,
    Options<PostApiV1PipelinesExtractDatapointsEnqueueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_datapoints_enqueue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Datapoints Dequeue V1
 */
export const postApiV1PipelinesExtractDatapointsDequeueMutation = (
  options?: Partial<Options<PostApiV1PipelinesExtractDatapointsDequeueData>>,
): UseMutationOptions<
  PostApiV1PipelinesExtractDatapointsDequeueResponse,
  PostApiV1PipelinesExtractDatapointsDequeueError,
  Options<PostApiV1PipelinesExtractDatapointsDequeueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractDatapointsDequeueResponse,
    PostApiV1PipelinesExtractDatapointsDequeueError,
    Options<PostApiV1PipelinesExtractDatapointsDequeueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_datapoints_dequeue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Incoming Knowledge Bases Input V1
 */
export const postApiV1PipelinesExtractIncomingKnowledgeBasesInputMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesInputData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponse,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputError,
  Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesInputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponse,
    PostApiV1PipelinesExtractIncomingKnowledgeBasesInputError,
    Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesInputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_incoming_knowledge_bases_input_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Incoming Knowledge Bases Output V1
 */
export const postApiV1PipelinesExtractIncomingKnowledgeBasesOutputMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponse,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputError,
  Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponse,
    PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputError,
    Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_incoming_knowledge_bases_output_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Incoming Knowledge Bases Enqueue V1
 */
export const postApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponse,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueError,
  Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponse,
    PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueError,
    Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_incoming_knowledge_bases_enqueue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Incoming Knowledge Bases Dequeue V1
 */
export const postApiV1PipelinesExtractIncomingKnowledgeBasesDequeueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponse,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueError,
  Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponse,
    PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueError,
    Options<PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await extract_incoming_knowledge_bases_dequeue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Finalize Conversations Input V1
 */
export const postApiV1PipelinesFinalizeConversationsInputMutation = (
  options?: Partial<Options<PostApiV1PipelinesFinalizeConversationsInputData>>,
): UseMutationOptions<
  PostApiV1PipelinesFinalizeConversationsInputResponse,
  PostApiV1PipelinesFinalizeConversationsInputError,
  Options<PostApiV1PipelinesFinalizeConversationsInputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesFinalizeConversationsInputResponse,
    PostApiV1PipelinesFinalizeConversationsInputError,
    Options<PostApiV1PipelinesFinalizeConversationsInputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await finalize_conversations_input_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Finalize Conversations Output V1
 */
export const postApiV1PipelinesFinalizeConversationsOutputMutation = (
  options?: Partial<Options<PostApiV1PipelinesFinalizeConversationsOutputData>>,
): UseMutationOptions<
  PostApiV1PipelinesFinalizeConversationsOutputResponse,
  PostApiV1PipelinesFinalizeConversationsOutputError,
  Options<PostApiV1PipelinesFinalizeConversationsOutputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesFinalizeConversationsOutputResponse,
    PostApiV1PipelinesFinalizeConversationsOutputError,
    Options<PostApiV1PipelinesFinalizeConversationsOutputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await finalize_conversations_output_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Finalize Conversations Enqueue V1
 */
export const postApiV1PipelinesFinalizeConversationsEnqueueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesFinalizeConversationsEnqueueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesFinalizeConversationsEnqueueResponse,
  PostApiV1PipelinesFinalizeConversationsEnqueueError,
  Options<PostApiV1PipelinesFinalizeConversationsEnqueueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesFinalizeConversationsEnqueueResponse,
    PostApiV1PipelinesFinalizeConversationsEnqueueError,
    Options<PostApiV1PipelinesFinalizeConversationsEnqueueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await finalize_conversations_enqueue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Finalize Conversations Dequeue V1
 */
export const postApiV1PipelinesFinalizeConversationsDequeueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesFinalizeConversationsDequeueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesFinalizeConversationsDequeueResponse,
  PostApiV1PipelinesFinalizeConversationsDequeueError,
  Options<PostApiV1PipelinesFinalizeConversationsDequeueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesFinalizeConversationsDequeueResponse,
    PostApiV1PipelinesFinalizeConversationsDequeueError,
    Options<PostApiV1PipelinesFinalizeConversationsDequeueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await finalize_conversations_dequeue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Kanonicalize Datapoints Input V1
 */
export const postApiV1PipelinesKanonicalizeDatapointsInputMutation = (
  options?: Partial<Options<PostApiV1PipelinesKanonicalizeDatapointsInputData>>,
): UseMutationOptions<
  PostApiV1PipelinesKanonicalizeDatapointsInputResponse,
  PostApiV1PipelinesKanonicalizeDatapointsInputError,
  Options<PostApiV1PipelinesKanonicalizeDatapointsInputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesKanonicalizeDatapointsInputResponse,
    PostApiV1PipelinesKanonicalizeDatapointsInputError,
    Options<PostApiV1PipelinesKanonicalizeDatapointsInputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await kanonicalize_datapoints_input_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Kanonicalize Datapoints Output V1
 */
export const postApiV1PipelinesKanonicalizeDatapointsOutputMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesKanonicalizeDatapointsOutputData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesKanonicalizeDatapointsOutputResponse,
  PostApiV1PipelinesKanonicalizeDatapointsOutputError,
  Options<PostApiV1PipelinesKanonicalizeDatapointsOutputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesKanonicalizeDatapointsOutputResponse,
    PostApiV1PipelinesKanonicalizeDatapointsOutputError,
    Options<PostApiV1PipelinesKanonicalizeDatapointsOutputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await kanonicalize_datapoints_output_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Kanonicalize Datapoints Enqueue V1
 */
export const postApiV1PipelinesKanonicalizeDatapointsEnqueueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesKanonicalizeDatapointsEnqueueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponse,
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueError,
  Options<PostApiV1PipelinesKanonicalizeDatapointsEnqueueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponse,
    PostApiV1PipelinesKanonicalizeDatapointsEnqueueError,
    Options<PostApiV1PipelinesKanonicalizeDatapointsEnqueueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await kanonicalize_datapoints_enqueue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Kanonicalize Datapoints Dequeue V1
 */
export const postApiV1PipelinesKanonicalizeDatapointsDequeueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesKanonicalizeDatapointsDequeueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesKanonicalizeDatapointsDequeueResponse,
  PostApiV1PipelinesKanonicalizeDatapointsDequeueError,
  Options<PostApiV1PipelinesKanonicalizeDatapointsDequeueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesKanonicalizeDatapointsDequeueResponse,
    PostApiV1PipelinesKanonicalizeDatapointsDequeueError,
    Options<PostApiV1PipelinesKanonicalizeDatapointsDequeueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await kanonicalize_datapoints_dequeue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Inference Datapoints Input V1
 */
export const postApiV1PipelinesCreateInferenceDatapointsInputMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesCreateInferenceDatapointsInputData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesCreateInferenceDatapointsInputResponse,
  PostApiV1PipelinesCreateInferenceDatapointsInputError,
  Options<PostApiV1PipelinesCreateInferenceDatapointsInputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesCreateInferenceDatapointsInputResponse,
    PostApiV1PipelinesCreateInferenceDatapointsInputError,
    Options<PostApiV1PipelinesCreateInferenceDatapointsInputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_inference_datapoints_input_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Inference Datapoints Output V1
 */
export const postApiV1PipelinesCreateInferenceDatapointsOutputMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesCreateInferenceDatapointsOutputData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesCreateInferenceDatapointsOutputResponse,
  PostApiV1PipelinesCreateInferenceDatapointsOutputError,
  Options<PostApiV1PipelinesCreateInferenceDatapointsOutputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesCreateInferenceDatapointsOutputResponse,
    PostApiV1PipelinesCreateInferenceDatapointsOutputError,
    Options<PostApiV1PipelinesCreateInferenceDatapointsOutputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_inference_datapoints_output_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Inference Datapoints Enqueue V1
 */
export const postApiV1PipelinesCreateInferenceDatapointsEnqueueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesCreateInferenceDatapointsEnqueueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponse,
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueError,
  Options<PostApiV1PipelinesCreateInferenceDatapointsEnqueueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponse,
    PostApiV1PipelinesCreateInferenceDatapointsEnqueueError,
    Options<PostApiV1PipelinesCreateInferenceDatapointsEnqueueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_inference_datapoints_enqueue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Inference Datapoints Dequeue V1
 */
export const postApiV1PipelinesCreateInferenceDatapointsDequeueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesCreateInferenceDatapointsDequeueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesCreateInferenceDatapointsDequeueResponse,
  PostApiV1PipelinesCreateInferenceDatapointsDequeueError,
  Options<PostApiV1PipelinesCreateInferenceDatapointsDequeueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesCreateInferenceDatapointsDequeueResponse,
    PostApiV1PipelinesCreateInferenceDatapointsDequeueError,
    Options<PostApiV1PipelinesCreateInferenceDatapointsDequeueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_inference_datapoints_dequeue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Prod Evals Input V1
 */
export const postApiV1PipelinesCreateProdEvalsInputMutation = (
  options?: Partial<Options<PostApiV1PipelinesCreateProdEvalsInputData>>,
): UseMutationOptions<
  PostApiV1PipelinesCreateProdEvalsInputResponse,
  PostApiV1PipelinesCreateProdEvalsInputError,
  Options<PostApiV1PipelinesCreateProdEvalsInputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesCreateProdEvalsInputResponse,
    PostApiV1PipelinesCreateProdEvalsInputError,
    Options<PostApiV1PipelinesCreateProdEvalsInputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_prod_evals_input_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Prod Evals Output V1
 */
export const postApiV1PipelinesCreateProdEvalsOutputMutation = (
  options?: Partial<Options<PostApiV1PipelinesCreateProdEvalsOutputData>>,
): UseMutationOptions<
  PostApiV1PipelinesCreateProdEvalsOutputResponse,
  PostApiV1PipelinesCreateProdEvalsOutputError,
  Options<PostApiV1PipelinesCreateProdEvalsOutputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesCreateProdEvalsOutputResponse,
    PostApiV1PipelinesCreateProdEvalsOutputError,
    Options<PostApiV1PipelinesCreateProdEvalsOutputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_prod_evals_output_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Prod Evals Enqueue V1
 */
export const postApiV1PipelinesCreateProdEvalsEnqueueMutation = (
  options?: Partial<Options<PostApiV1PipelinesCreateProdEvalsEnqueueData>>,
): UseMutationOptions<
  PostApiV1PipelinesCreateProdEvalsEnqueueResponse,
  PostApiV1PipelinesCreateProdEvalsEnqueueError,
  Options<PostApiV1PipelinesCreateProdEvalsEnqueueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesCreateProdEvalsEnqueueResponse,
    PostApiV1PipelinesCreateProdEvalsEnqueueError,
    Options<PostApiV1PipelinesCreateProdEvalsEnqueueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_prod_evals_enqueue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Prod Evals Dequeue V1
 */
export const postApiV1PipelinesCreateProdEvalsDequeueMutation = (
  options?: Partial<Options<PostApiV1PipelinesCreateProdEvalsDequeueData>>,
): UseMutationOptions<
  PostApiV1PipelinesCreateProdEvalsDequeueResponse,
  PostApiV1PipelinesCreateProdEvalsDequeueError,
  Options<PostApiV1PipelinesCreateProdEvalsDequeueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesCreateProdEvalsDequeueResponse,
    PostApiV1PipelinesCreateProdEvalsDequeueError,
    Options<PostApiV1PipelinesCreateProdEvalsDequeueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_prod_evals_dequeue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Finetune Knowledge Bases Input V1
 */
export const postApiV1PipelinesFinetuneKnowledgeBasesInputMutation = (
  options?: Partial<Options<PostApiV1PipelinesFinetuneKnowledgeBasesInputData>>,
): UseMutationOptions<
  PostApiV1PipelinesFinetuneKnowledgeBasesInputResponse,
  PostApiV1PipelinesFinetuneKnowledgeBasesInputError,
  Options<PostApiV1PipelinesFinetuneKnowledgeBasesInputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesFinetuneKnowledgeBasesInputResponse,
    PostApiV1PipelinesFinetuneKnowledgeBasesInputError,
    Options<PostApiV1PipelinesFinetuneKnowledgeBasesInputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await finetune_knowledge_bases_input_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Finetune Knowledge Bases Output V1
 */
export const postApiV1PipelinesFinetuneKnowledgeBasesOutputMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesFinetuneKnowledgeBasesOutputData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponse,
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputError,
  Options<PostApiV1PipelinesFinetuneKnowledgeBasesOutputData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponse,
    PostApiV1PipelinesFinetuneKnowledgeBasesOutputError,
    Options<PostApiV1PipelinesFinetuneKnowledgeBasesOutputData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await finetune_knowledge_bases_output_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Finetune Knowledge Bases Enqueue V1
 */
export const postApiV1PipelinesFinetuneKnowledgeBasesEnqueueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponse,
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueError,
  Options<PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponse,
    PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueError,
    Options<PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await finetune_knowledge_bases_enqueue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Finetune Knowledge Bases Dequeue V1
 */
export const postApiV1PipelinesFinetuneKnowledgeBasesDequeueMutation = (
  options?: Partial<
    Options<PostApiV1PipelinesFinetuneKnowledgeBasesDequeueData>
  >,
): UseMutationOptions<
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponse,
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueError,
  Options<PostApiV1PipelinesFinetuneKnowledgeBasesDequeueData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponse,
    PostApiV1PipelinesFinetuneKnowledgeBasesDequeueError,
    Options<PostApiV1PipelinesFinetuneKnowledgeBasesDequeueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await finetune_knowledge_bases_dequeue_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiPlainV1TenantsByTenantIdActionsThreadsQueryKey = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsThreadsData>,
) =>
  createQueryKey(
    "get_api_plain_v1_tenants_by_tenant_id_actions_threads",
    options,
  );

/**
 * Plain Get Threads V1
 */
export const getApiPlainV1TenantsByTenantIdActionsThreadsOptions = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsThreadsData>,
) =>
  queryOptions<
    GetApiPlainV1TenantsByTenantIdActionsThreadsResponse,
    GetApiPlainV1TenantsByTenantIdActionsThreadsError,
    GetApiPlainV1TenantsByTenantIdActionsThreadsResponse,
    ReturnType<typeof getApiPlainV1TenantsByTenantIdActionsThreadsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await plain_get_threads_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPlainV1TenantsByTenantIdActionsThreadsQueryKey(options),
  });

/**
 * Plain Create Thread V1
 */
export const postApiPlainV1TenantsByTenantIdActionsThreadsMutation = (
  options?: Partial<Options<PostApiPlainV1TenantsByTenantIdActionsThreadsData>>,
): UseMutationOptions<
  PostApiPlainV1TenantsByTenantIdActionsThreadsResponse,
  PostApiPlainV1TenantsByTenantIdActionsThreadsError,
  Options<PostApiPlainV1TenantsByTenantIdActionsThreadsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPlainV1TenantsByTenantIdActionsThreadsResponse,
    PostApiPlainV1TenantsByTenantIdActionsThreadsError,
    Options<PostApiPlainV1TenantsByTenantIdActionsThreadsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await plain_create_thread_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdQueryKey = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdData>,
) =>
  createQueryKey(
    "get_api_plain_v1_tenants_by_tenant_id_actions_threads_by_thread_id",
    options,
  );

/**
 * Plain Get Thread V1
 */
export const getApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdOptions = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdData>,
) =>
  queryOptions<
    GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponse,
    GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdError,
    GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponse,
    ReturnType<
      typeof getApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await plain_get_thread_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdQueryKey(options),
  });

export const getApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineQueryKey =
  (
    options: Options<GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineData>,
  ) =>
    createQueryKey(
      "get_api_plain_v1_tenants_by_tenant_id_actions_threads_by_thread_id_timeline",
      options,
    );

/**
 * Plain Get Thread Timeline V1
 */
export const getApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineOptions =
  (
    options: Options<GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineData>,
  ) =>
    queryOptions<
      GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponse,
      GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineError,
      GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponse,
      ReturnType<
        typeof getApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await plain_get_thread_timeline_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineQueryKey(
          options,
        ),
    });

/**
 * Plain Mark Thread As Todo V1
 */
export const postApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoMutation =
  (
    options?: Partial<
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoData>
    >,
  ): UseMutationOptions<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponse,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoError,
    Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponse,
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoError,
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_mark_thread_as_todo_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Snooze Thread V1
 */
export const postApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeMutation =
  (
    options?: Partial<
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeData>
    >,
  ): UseMutationOptions<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponse,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeError,
    Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponse,
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeError,
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_snooze_thread_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Mark Thread As Done V1
 */
export const postApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneMutation =
  (
    options?: Partial<
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneData>
    >,
  ): UseMutationOptions<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponse,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneError,
    Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponse,
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneError,
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_mark_thread_as_done_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Change Thread Priority V1
 */
export const patchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityMutation =
  (
    options?: Partial<
      Options<PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityData>
    >,
  ): UseMutationOptions<
    PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponse,
    PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityError,
    Options<PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponse,
      PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityError,
      Options<PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_change_thread_priority_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Update Thread Agent Status V1
 */
export const patchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusMutation =
  (
    options?: Partial<
      Options<PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusData>
    >,
  ): UseMutationOptions<
    PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponse,
    PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusError,
    Options<PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponse,
      PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusError,
      Options<PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_update_thread_agent_status_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Unassign Thread V1
 */
export const deleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeMutation =
  (
    options?: Partial<
      Options<DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData>
    >,
  ): UseMutationOptions<
    DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponse,
    DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeError,
    Options<DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponse,
      DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeError,
      Options<DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_unassign_thread_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Assign Thread V1
 */
export const putApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeMutation =
  (
    options?: Partial<
      Options<PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData>
    >,
  ): UseMutationOptions<
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponse,
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeError,
    Options<PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData>
  > => {
    const mutationOptions: UseMutationOptions<
      PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponse,
      PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeError,
      Options<PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_assign_thread_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Assign Thread To Self V1
 */
export const putApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfMutation =
  (
    options?: Partial<
      Options<PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfData>
    >,
  ): UseMutationOptions<
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponse,
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfError,
    Options<PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfData>
  > => {
    const mutationOptions: UseMutationOptions<
      PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponse,
      PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfError,
      Options<PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_assign_thread_to_self_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Add Thread Labels V1
 */
export const postApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsMutation =
  (
    options?: Partial<
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsData>
    >,
  ): UseMutationOptions<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponse,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsError,
    Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponse,
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsError,
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_add_thread_labels_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Remove Thread Labels V1
 */
export const postApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteMutation =
  (
    options?: Partial<
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteData>
    >,
  ): UseMutationOptions<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponse,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteError,
    Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponse,
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteError,
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_remove_thread_labels_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Upsert Thread Field V1
 */
export const putApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyMutation =
  (
    options?: Partial<
      Options<PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyData>
    >,
  ): UseMutationOptions<
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponse,
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyError,
    Options<PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyData>
  > => {
    const mutationOptions: UseMutationOptions<
      PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponse,
      PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyError,
      Options<PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_upsert_thread_field_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Send Message V1
 */
export const postApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesMutation =
  (
    options?: Partial<
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesData>
    >,
  ): UseMutationOptions<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponse,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesError,
    Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponse,
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesError,
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_send_message_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Create Note V1
 */
export const postApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesMutation =
  (
    options?: Partial<
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesData>
    >,
  ): UseMutationOptions<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponse,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesError,
    Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponse,
      PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesError,
      Options<PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_create_note_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiPlainV1TenantsByTenantIdActionsCustomersQueryKey = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsCustomersData>,
) =>
  createQueryKey(
    "get_api_plain_v1_tenants_by_tenant_id_actions_customers",
    options,
  );

/**
 * Plain Get Customers V1
 */
export const getApiPlainV1TenantsByTenantIdActionsCustomersOptions = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsCustomersData>,
) =>
  queryOptions<
    GetApiPlainV1TenantsByTenantIdActionsCustomersResponse,
    GetApiPlainV1TenantsByTenantIdActionsCustomersError,
    GetApiPlainV1TenantsByTenantIdActionsCustomersResponse,
    ReturnType<typeof getApiPlainV1TenantsByTenantIdActionsCustomersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await plain_get_customers_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPlainV1TenantsByTenantIdActionsCustomersQueryKey(options),
  });

/**
 * Plain Upsert Customer V1
 */
export const putApiPlainV1TenantsByTenantIdActionsCustomersMutation = (
  options?: Partial<
    Options<PutApiPlainV1TenantsByTenantIdActionsCustomersData>
  >,
): UseMutationOptions<
  PutApiPlainV1TenantsByTenantIdActionsCustomersResponse,
  PutApiPlainV1TenantsByTenantIdActionsCustomersError,
  Options<PutApiPlainV1TenantsByTenantIdActionsCustomersData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiPlainV1TenantsByTenantIdActionsCustomersResponse,
    PutApiPlainV1TenantsByTenantIdActionsCustomersError,
    Options<PutApiPlainV1TenantsByTenantIdActionsCustomersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await plain_upsert_customer_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Plain Delete Customer V1
 */
export const deleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdMutation =
  (
    options?: Partial<
      Options<DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData>
    >,
  ): UseMutationOptions<
    DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponse,
    DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdError,
    Options<DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponse,
      DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdError,
      Options<DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_delete_customer_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdQueryKey =
  (
    options: Options<GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData>,
  ) =>
    createQueryKey(
      "get_api_plain_v1_tenants_by_tenant_id_actions_customers_by_customer_id",
      options,
    );

/**
 * Plain Get Customer V1
 */
export const getApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdOptions =
  (
    options: Options<GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData>,
  ) =>
    queryOptions<
      GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponse,
      GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdError,
      GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponse,
      ReturnType<
        typeof getApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await plain_get_customer_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdQueryKey(
          options,
        ),
    });

export const getApiPlainV1TenantsByTenantIdActionsCompaniesQueryKey = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsCompaniesData>,
) =>
  createQueryKey(
    "get_api_plain_v1_tenants_by_tenant_id_actions_companies",
    options,
  );

/**
 * Plain Get Companies V1
 */
export const getApiPlainV1TenantsByTenantIdActionsCompaniesOptions = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsCompaniesData>,
) =>
  queryOptions<
    GetApiPlainV1TenantsByTenantIdActionsCompaniesResponse,
    GetApiPlainV1TenantsByTenantIdActionsCompaniesError,
    GetApiPlainV1TenantsByTenantIdActionsCompaniesResponse,
    ReturnType<typeof getApiPlainV1TenantsByTenantIdActionsCompaniesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await plain_get_companies_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPlainV1TenantsByTenantIdActionsCompaniesQueryKey(options),
  });

/**
 * Plain Upsert Company V1
 */
export const putApiPlainV1TenantsByTenantIdActionsCompaniesMutation = (
  options?: Partial<
    Options<PutApiPlainV1TenantsByTenantIdActionsCompaniesData>
  >,
): UseMutationOptions<
  PutApiPlainV1TenantsByTenantIdActionsCompaniesResponse,
  PutApiPlainV1TenantsByTenantIdActionsCompaniesError,
  Options<PutApiPlainV1TenantsByTenantIdActionsCompaniesData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiPlainV1TenantsByTenantIdActionsCompaniesResponse,
    PutApiPlainV1TenantsByTenantIdActionsCompaniesError,
    Options<PutApiPlainV1TenantsByTenantIdActionsCompaniesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await plain_upsert_company_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Plain Set Customer Company V1
 */
export const putApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyMutation =
  (
    options?: Partial<
      Options<PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyData>
    >,
  ): UseMutationOptions<
    PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponse,
    PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyError,
    Options<PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyData>
  > => {
    const mutationOptions: UseMutationOptions<
      PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponse,
      PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyError,
      Options<PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_set_customer_company_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiPlainV1TenantsByTenantIdActionsCustomerGroupsQueryKey = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsData>,
) =>
  createQueryKey(
    "get_api_plain_v1_tenants_by_tenant_id_actions_customer_groups",
    options,
  );

/**
 * Plain Get Customer Groups V1
 */
export const getApiPlainV1TenantsByTenantIdActionsCustomerGroupsOptions = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsData>,
) =>
  queryOptions<
    GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponse,
    GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsError,
    GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponse,
    ReturnType<
      typeof getApiPlainV1TenantsByTenantIdActionsCustomerGroupsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await plain_get_customer_groups_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiPlainV1TenantsByTenantIdActionsCustomerGroupsQueryKey(options),
  });

/**
 * Plain Add Customer To Groups V1
 */
export const postApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsMutation =
  (
    options?: Partial<
      Options<PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsData>
    >,
  ): UseMutationOptions<
    PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponse,
    PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsError,
    Options<PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponse,
      PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsError,
      Options<PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_add_customer_to_groups_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiPlainV1TenantsByTenantIdActionsPlainTenantsQueryKey = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsPlainTenantsData>,
) =>
  createQueryKey(
    "get_api_plain_v1_tenants_by_tenant_id_actions_plain_tenants",
    options,
  );

/**
 * Plain Get Plain Tenants V1
 */
export const getApiPlainV1TenantsByTenantIdActionsPlainTenantsOptions = (
  options: Options<GetApiPlainV1TenantsByTenantIdActionsPlainTenantsData>,
) =>
  queryOptions<
    GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponse,
    GetApiPlainV1TenantsByTenantIdActionsPlainTenantsError,
    GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponse,
    ReturnType<typeof getApiPlainV1TenantsByTenantIdActionsPlainTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await plain_get_plain_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiPlainV1TenantsByTenantIdActionsPlainTenantsQueryKey(options),
  });

/**
 * Plain Upsert Plain Tenant V1
 */
export const putApiPlainV1TenantsByTenantIdActionsPlainTenantsMutation = (
  options?: Partial<
    Options<PutApiPlainV1TenantsByTenantIdActionsPlainTenantsData>
  >,
): UseMutationOptions<
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponse,
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsError,
  Options<PutApiPlainV1TenantsByTenantIdActionsPlainTenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponse,
    PutApiPlainV1TenantsByTenantIdActionsPlainTenantsError,
    Options<PutApiPlainV1TenantsByTenantIdActionsPlainTenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await plain_upsert_plain_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Plain Delete Plain Tenant V1
 */
export const deleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdMutation =
  (
    options?: Partial<
      Options<DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdData>
    >,
  ): UseMutationOptions<
    DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponse,
    DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdError,
    Options<DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponse,
      DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdError,
      Options<DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_delete_plain_tenant_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Plain Add Customer To Plain Tenants V1
 */
export const postApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsMutation =
  (
    options?: Partial<
      Options<PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsData>
    >,
  ): UseMutationOptions<
    PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponse,
    PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsError,
    Options<PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponse,
      PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsError,
      Options<PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await plain_add_customer_to_plain_tenants_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiPlainV1TenantsQueryKey = (
  options?: Options<GetApiPlainV1TenantsData>,
) => createQueryKey("get_api_plain_v1_tenants", options);

/**
 * Plain Get Tenants V1
 */
export const getApiPlainV1TenantsOptions = (
  options?: Options<GetApiPlainV1TenantsData>,
) =>
  queryOptions<
    GetApiPlainV1TenantsResponse,
    GetApiPlainV1TenantsError,
    GetApiPlainV1TenantsResponse,
    ReturnType<typeof getApiPlainV1TenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await plain_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPlainV1TenantsQueryKey(options),
  });

export const getApiPlainV1TenantsInfiniteQueryKey = (
  options?: Options<GetApiPlainV1TenantsData>,
): QueryKey<Options<GetApiPlainV1TenantsData>> =>
  createQueryKey("get_api_plain_v1_tenants", options, true);

/**
 * Plain Get Tenants V1
 */
export const getApiPlainV1TenantsInfiniteOptions = (
  options?: Options<GetApiPlainV1TenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiPlainV1TenantsResponse,
    GetApiPlainV1TenantsError,
    InfiniteData<GetApiPlainV1TenantsResponse>,
    QueryKey<Options<GetApiPlainV1TenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiPlainV1TenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiPlainV1TenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await plain_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiPlainV1TenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Plain Create Tenant V1
 */
export const postApiPlainV1TenantsMutation = (
  options?: Partial<Options<PostApiPlainV1TenantsData>>,
): UseMutationOptions<
  PostApiPlainV1TenantsResponse,
  PostApiPlainV1TenantsError,
  Options<PostApiPlainV1TenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPlainV1TenantsResponse,
    PostApiPlainV1TenantsError,
    Options<PostApiPlainV1TenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await plain_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiPlainV1FullTenantsQueryKey = (
  options?: Options<GetApiPlainV1FullTenantsData>,
) => createQueryKey("get_api_plain_v1_full_tenants", options);

/**
 * Plain Get Full Tenants V1
 */
export const getApiPlainV1FullTenantsOptions = (
  options?: Options<GetApiPlainV1FullTenantsData>,
) =>
  queryOptions<
    GetApiPlainV1FullTenantsResponse,
    GetApiPlainV1FullTenantsError,
    GetApiPlainV1FullTenantsResponse,
    ReturnType<typeof getApiPlainV1FullTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await plain_get_full_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPlainV1FullTenantsQueryKey(options),
  });

export const getApiPlainV1FullTenantsInfiniteQueryKey = (
  options?: Options<GetApiPlainV1FullTenantsData>,
): QueryKey<Options<GetApiPlainV1FullTenantsData>> =>
  createQueryKey("get_api_plain_v1_full_tenants", options, true);

/**
 * Plain Get Full Tenants V1
 */
export const getApiPlainV1FullTenantsInfiniteOptions = (
  options?: Options<GetApiPlainV1FullTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiPlainV1FullTenantsResponse,
    GetApiPlainV1FullTenantsError,
    InfiniteData<GetApiPlainV1FullTenantsResponse>,
    QueryKey<Options<GetApiPlainV1FullTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiPlainV1FullTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiPlainV1FullTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await plain_get_full_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiPlainV1FullTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Plain Delete Tenant V1
 */
export const deleteApiPlainV1TenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiPlainV1TenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiPlainV1TenantsByTenantIdResponse,
  DeleteApiPlainV1TenantsByTenantIdError,
  Options<DeleteApiPlainV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiPlainV1TenantsByTenantIdResponse,
    DeleteApiPlainV1TenantsByTenantIdError,
    Options<DeleteApiPlainV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await plain_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiPlainV1TenantsByTenantIdQueryKey = (
  options: Options<GetApiPlainV1TenantsByTenantIdData>,
) => createQueryKey("get_api_plain_v1_tenants_by_tenant_id", options);

/**
 * Plain Get Tenant V1
 */
export const getApiPlainV1TenantsByTenantIdOptions = (
  options: Options<GetApiPlainV1TenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiPlainV1TenantsByTenantIdResponse,
    GetApiPlainV1TenantsByTenantIdError,
    GetApiPlainV1TenantsByTenantIdResponse,
    ReturnType<typeof getApiPlainV1TenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await plain_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPlainV1TenantsByTenantIdQueryKey(options),
  });

/**
 * Plain Patch Tenant V1
 */
export const patchApiPlainV1TenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiPlainV1TenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiPlainV1TenantsByTenantIdResponse,
  PatchApiPlainV1TenantsByTenantIdError,
  Options<PatchApiPlainV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiPlainV1TenantsByTenantIdResponse,
    PatchApiPlainV1TenantsByTenantIdError,
    Options<PatchApiPlainV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await plain_patch_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiPlainV1TenantsByTenantIdCheckConnectionQueryKey = (
  options: Options<GetApiPlainV1TenantsByTenantIdCheckConnectionData>,
) =>
  createQueryKey(
    "get_api_plain_v1_tenants_by_tenant_id_check_connection",
    options,
  );

/**
 * Plain Check Connection V1
 */
export const getApiPlainV1TenantsByTenantIdCheckConnectionOptions = (
  options: Options<GetApiPlainV1TenantsByTenantIdCheckConnectionData>,
) =>
  queryOptions<
    GetApiPlainV1TenantsByTenantIdCheckConnectionResponse,
    GetApiPlainV1TenantsByTenantIdCheckConnectionError,
    GetApiPlainV1TenantsByTenantIdCheckConnectionResponse,
    ReturnType<typeof getApiPlainV1TenantsByTenantIdCheckConnectionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await plain_check_connection_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPlainV1TenantsByTenantIdCheckConnectionQueryKey(options),
  });

export const getApiV1TasksByTaskIdPromptsQueryKey = (
  options: Options<GetApiV1TasksByTaskIdPromptsData>,
) => createQueryKey("get_api_v1_tasks_by_task_id_prompts", options);

/**
 * Get Prompts V1
 */
export const getApiV1TasksByTaskIdPromptsOptions = (
  options: Options<GetApiV1TasksByTaskIdPromptsData>,
) =>
  queryOptions<
    GetApiV1TasksByTaskIdPromptsResponse,
    GetApiV1TasksByTaskIdPromptsError,
    GetApiV1TasksByTaskIdPromptsResponse,
    ReturnType<typeof getApiV1TasksByTaskIdPromptsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_prompts_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1TasksByTaskIdPromptsQueryKey(options),
  });

export const getApiV1TasksByTaskIdPromptsInfiniteQueryKey = (
  options: Options<GetApiV1TasksByTaskIdPromptsData>,
): QueryKey<Options<GetApiV1TasksByTaskIdPromptsData>> =>
  createQueryKey("get_api_v1_tasks_by_task_id_prompts", options, true);

/**
 * Get Prompts V1
 */
export const getApiV1TasksByTaskIdPromptsInfiniteOptions = (
  options: Options<GetApiV1TasksByTaskIdPromptsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1TasksByTaskIdPromptsResponse,
    GetApiV1TasksByTaskIdPromptsError,
    InfiniteData<GetApiV1TasksByTaskIdPromptsResponse>,
    QueryKey<Options<GetApiV1TasksByTaskIdPromptsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1TasksByTaskIdPromptsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1TasksByTaskIdPromptsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_prompts_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1TasksByTaskIdPromptsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Prompt V1
 */
export const postApiV1TasksByTaskIdPromptsMutation = (
  options?: Partial<Options<PostApiV1TasksByTaskIdPromptsData>>,
): UseMutationOptions<
  PostApiV1TasksByTaskIdPromptsResponse,
  PostApiV1TasksByTaskIdPromptsError,
  Options<PostApiV1TasksByTaskIdPromptsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1TasksByTaskIdPromptsResponse,
    PostApiV1TasksByTaskIdPromptsError,
    Options<PostApiV1TasksByTaskIdPromptsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_prompt_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1TasksByTaskIdPromptsByPromptIdQueryKey = (
  options: Options<GetApiV1TasksByTaskIdPromptsByPromptIdData>,
) =>
  createQueryKey("get_api_v1_tasks_by_task_id_prompts_by_prompt_id", options);

/**
 * Get Prompt V1
 */
export const getApiV1TasksByTaskIdPromptsByPromptIdOptions = (
  options: Options<GetApiV1TasksByTaskIdPromptsByPromptIdData>,
) =>
  queryOptions<
    GetApiV1TasksByTaskIdPromptsByPromptIdResponse,
    GetApiV1TasksByTaskIdPromptsByPromptIdError,
    GetApiV1TasksByTaskIdPromptsByPromptIdResponse,
    ReturnType<typeof getApiV1TasksByTaskIdPromptsByPromptIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_prompt_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1TasksByTaskIdPromptsByPromptIdQueryKey(options),
  });

export const getApiV1ReposByRepositoryIdBranchesQueryKey = (
  options: Options<GetApiV1ReposByRepositoryIdBranchesData>,
) => createQueryKey("get_api_v1_repos_by_repository_id_branches", options);

/**
 * Git Branch List V1
 */
export const getApiV1ReposByRepositoryIdBranchesOptions = (
  options: Options<GetApiV1ReposByRepositoryIdBranchesData>,
) =>
  queryOptions<
    GetApiV1ReposByRepositoryIdBranchesResponse,
    GetApiV1ReposByRepositoryIdBranchesError,
    GetApiV1ReposByRepositoryIdBranchesResponse,
    ReturnType<typeof getApiV1ReposByRepositoryIdBranchesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await git_branch_list_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ReposByRepositoryIdBranchesQueryKey(options),
  });

export const getApiV1ReposByRepositoryIdBranchesInfiniteQueryKey = (
  options: Options<GetApiV1ReposByRepositoryIdBranchesData>,
): QueryKey<Options<GetApiV1ReposByRepositoryIdBranchesData>> =>
  createQueryKey("get_api_v1_repos_by_repository_id_branches", options, true);

/**
 * Git Branch List V1
 */
export const getApiV1ReposByRepositoryIdBranchesInfiniteOptions = (
  options: Options<GetApiV1ReposByRepositoryIdBranchesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ReposByRepositoryIdBranchesResponse,
    GetApiV1ReposByRepositoryIdBranchesError,
    InfiniteData<GetApiV1ReposByRepositoryIdBranchesResponse>,
    QueryKey<Options<GetApiV1ReposByRepositoryIdBranchesData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ReposByRepositoryIdBranchesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ReposByRepositoryIdBranchesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await git_branch_list_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1ReposByRepositoryIdBranchesInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Git Branch Create V1
 */
export const postApiV1ReposByRepositoryIdBranchesMutation = (
  options?: Partial<Options<PostApiV1ReposByRepositoryIdBranchesData>>,
): UseMutationOptions<
  PostApiV1ReposByRepositoryIdBranchesResponse,
  PostApiV1ReposByRepositoryIdBranchesError,
  Options<PostApiV1ReposByRepositoryIdBranchesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ReposByRepositoryIdBranchesResponse,
    PostApiV1ReposByRepositoryIdBranchesError,
    Options<PostApiV1ReposByRepositoryIdBranchesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await git_branch_create_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewQueryKey =
  (
    options: Options<GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewData>,
  ) =>
    createQueryKey(
      "get_api_v1_repos_by_repository_id_branches_by_branch_name_rebase_preview",
      options,
    );

/**
 * Git Rebase Preview V1
 */
export const getApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewOptions =
  (
    options: Options<GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewData>,
  ) =>
    queryOptions<
      GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponse,
      GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewError,
      GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponse,
      ReturnType<
        typeof getApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await git_rebase_preview_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewQueryKey(
          options,
        ),
    });

/**
 * Git Branch Delete V1
 */
export const deleteApiV1ReposByRepositoryIdBranchesByNameMutation = (
  options?: Partial<Options<DeleteApiV1ReposByRepositoryIdBranchesByNameData>>,
): UseMutationOptions<
  DeleteApiV1ReposByRepositoryIdBranchesByNameResponse,
  DeleteApiV1ReposByRepositoryIdBranchesByNameError,
  Options<DeleteApiV1ReposByRepositoryIdBranchesByNameData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1ReposByRepositoryIdBranchesByNameResponse,
    DeleteApiV1ReposByRepositoryIdBranchesByNameError,
    Options<DeleteApiV1ReposByRepositoryIdBranchesByNameData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await git_branch_delete_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ReposByRepositoryIdBranchesByNameQueryKey = (
  options: Options<GetApiV1ReposByRepositoryIdBranchesByNameData>,
) =>
  createQueryKey("get_api_v1_repos_by_repository_id_branches_by_name", options);

/**
 * Git Branch Get V1
 */
export const getApiV1ReposByRepositoryIdBranchesByNameOptions = (
  options: Options<GetApiV1ReposByRepositoryIdBranchesByNameData>,
) =>
  queryOptions<
    GetApiV1ReposByRepositoryIdBranchesByNameResponse,
    GetApiV1ReposByRepositoryIdBranchesByNameError,
    GetApiV1ReposByRepositoryIdBranchesByNameResponse,
    ReturnType<typeof getApiV1ReposByRepositoryIdBranchesByNameQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await git_branch_get_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ReposByRepositoryIdBranchesByNameQueryKey(options),
  });

/**
 * Git Branch Update V1
 */
export const patchApiV1ReposByRepositoryIdBranchesByNameMutation = (
  options?: Partial<Options<PatchApiV1ReposByRepositoryIdBranchesByNameData>>,
): UseMutationOptions<
  PatchApiV1ReposByRepositoryIdBranchesByNameResponse,
  PatchApiV1ReposByRepositoryIdBranchesByNameError,
  Options<PatchApiV1ReposByRepositoryIdBranchesByNameData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1ReposByRepositoryIdBranchesByNameResponse,
    PatchApiV1ReposByRepositoryIdBranchesByNameError,
    Options<PatchApiV1ReposByRepositoryIdBranchesByNameData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await git_branch_update_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Git Branch Restore V1
 */
export const postApiV1ReposByRepositoryIdBranchesByNameRestoreMutation = (
  options?: Partial<
    Options<PostApiV1ReposByRepositoryIdBranchesByNameRestoreData>
  >,
): UseMutationOptions<
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponse,
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreError,
  Options<PostApiV1ReposByRepositoryIdBranchesByNameRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponse,
    PostApiV1ReposByRepositoryIdBranchesByNameRestoreError,
    Options<PostApiV1ReposByRepositoryIdBranchesByNameRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await git_branch_restore_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ReposByRepositoryIdCommitsByRefQueryKey = (
  options: Options<GetApiV1ReposByRepositoryIdCommitsByRefData>,
) =>
  createQueryKey("get_api_v1_repos_by_repository_id_commits_by_ref", options);

/**
 * Git Log V1
 */
export const getApiV1ReposByRepositoryIdCommitsByRefOptions = (
  options: Options<GetApiV1ReposByRepositoryIdCommitsByRefData>,
) =>
  queryOptions<
    GetApiV1ReposByRepositoryIdCommitsByRefResponse,
    GetApiV1ReposByRepositoryIdCommitsByRefError,
    GetApiV1ReposByRepositoryIdCommitsByRefResponse,
    ReturnType<typeof getApiV1ReposByRepositoryIdCommitsByRefQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await git_log_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ReposByRepositoryIdCommitsByRefQueryKey(options),
  });

export const getApiV1ReposByRepositoryIdCommitsByRefInfiniteQueryKey = (
  options: Options<GetApiV1ReposByRepositoryIdCommitsByRefData>,
): QueryKey<Options<GetApiV1ReposByRepositoryIdCommitsByRefData>> =>
  createQueryKey(
    "get_api_v1_repos_by_repository_id_commits_by_ref",
    options,
    true,
  );

/**
 * Git Log V1
 */
export const getApiV1ReposByRepositoryIdCommitsByRefInfiniteOptions = (
  options: Options<GetApiV1ReposByRepositoryIdCommitsByRefData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ReposByRepositoryIdCommitsByRefResponse,
    GetApiV1ReposByRepositoryIdCommitsByRefError,
    InfiniteData<GetApiV1ReposByRepositoryIdCommitsByRefResponse>,
    QueryKey<Options<GetApiV1ReposByRepositoryIdCommitsByRefData>>,
    | number
    | null
    | Pick<
        QueryKey<Options<GetApiV1ReposByRepositoryIdCommitsByRefData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ReposByRepositoryIdCommitsByRefData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await git_log_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ReposByRepositoryIdCommitsByRefInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1ReposByRepositoryIdCommitByRefQueryKey = (
  options: Options<GetApiV1ReposByRepositoryIdCommitByRefData>,
) => createQueryKey("get_api_v1_repos_by_repository_id_commit_by_ref", options);

/**
 * Git Show V1
 */
export const getApiV1ReposByRepositoryIdCommitByRefOptions = (
  options: Options<GetApiV1ReposByRepositoryIdCommitByRefData>,
) =>
  queryOptions<
    GetApiV1ReposByRepositoryIdCommitByRefResponse,
    GetApiV1ReposByRepositoryIdCommitByRefError,
    GetApiV1ReposByRepositoryIdCommitByRefResponse,
    ReturnType<typeof getApiV1ReposByRepositoryIdCommitByRefQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await git_show_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ReposByRepositoryIdCommitByRefQueryKey(options),
  });

/**
 * Patch Commit V1
 */
export const patchApiV1ReposByRepositoryIdCommitByCommitIdMutation = (
  options?: Partial<Options<PatchApiV1ReposByRepositoryIdCommitByCommitIdData>>,
): UseMutationOptions<
  PatchApiV1ReposByRepositoryIdCommitByCommitIdResponse,
  PatchApiV1ReposByRepositoryIdCommitByCommitIdError,
  Options<PatchApiV1ReposByRepositoryIdCommitByCommitIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1ReposByRepositoryIdCommitByCommitIdResponse,
    PatchApiV1ReposByRepositoryIdCommitByCommitIdError,
    Options<PatchApiV1ReposByRepositoryIdCommitByCommitIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patch_commit_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Git Commit V1
 */
export const postApiV1ReposByRepositoryIdBranchesByBranchNameCommitMutation = (
  options?: Partial<
    Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitData>
  >,
): UseMutationOptions<
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponse,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitError,
  Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponse,
    PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitError,
    Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await git_commit_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Git Amend V1
 */
export const postApiV1ReposByRepositoryIdBranchesByBranchNameAmendMutation = (
  options?: Partial<
    Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendData>
  >,
): UseMutationOptions<
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponse,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendError,
  Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponse,
    PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendError,
    Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await git_amend_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Git Merge V1
 */
export const postApiV1ReposByRepositoryIdBranchesByBranchNameMergeMutation = (
  options?: Partial<
    Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeData>
  >,
): UseMutationOptions<
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponse,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeError,
  Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponse,
    PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeError,
    Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await git_merge_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Git Rebase V1
 */
export const postApiV1ReposByRepositoryIdBranchesByBranchNameRebaseMutation = (
  options?: Partial<
    Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseData>
  >,
): UseMutationOptions<
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponse,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseError,
  Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponse,
    PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseError,
    Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await git_rebase_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Git Cherry Pick V1
 */
export const postApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickMutation =
  (
    options?: Partial<
      Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickData>
    >,
  ): UseMutationOptions<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponse,
    PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickError,
    Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponse,
      PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickError,
      Options<PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await git_cherry_pick_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1ReposByRepositoryIdCompareByBaseheadQueryKey = (
  options: Options<GetApiV1ReposByRepositoryIdCompareByBaseheadData>,
) =>
  createQueryKey(
    "get_api_v1_repos_by_repository_id_compare_by_basehead",
    options,
  );

/**
 * Git Diff V1
 */
export const getApiV1ReposByRepositoryIdCompareByBaseheadOptions = (
  options: Options<GetApiV1ReposByRepositoryIdCompareByBaseheadData>,
) =>
  queryOptions<
    GetApiV1ReposByRepositoryIdCompareByBaseheadResponse,
    GetApiV1ReposByRepositoryIdCompareByBaseheadError,
    GetApiV1ReposByRepositoryIdCompareByBaseheadResponse,
    ReturnType<typeof getApiV1ReposByRepositoryIdCompareByBaseheadQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await git_diff_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ReposByRepositoryIdCompareByBaseheadQueryKey(options),
  });

export const getApiV1ReposByRepositoryIdGitDiffBlameByBaseheadQueryKey = (
  options: Options<GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadData>,
) =>
  createQueryKey(
    "get_api_v1_repos_by_repository_id_git_diff_blame_by_basehead",
    options,
  );

/**
 * Git Diff Blame V1
 */
export const getApiV1ReposByRepositoryIdGitDiffBlameByBaseheadOptions = (
  options: Options<GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadData>,
) =>
  queryOptions<
    GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponse,
    GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadError,
    GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponse,
    ReturnType<typeof getApiV1ReposByRepositoryIdGitDiffBlameByBaseheadQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await git_diff_blame_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ReposByRepositoryIdGitDiffBlameByBaseheadQueryKey(options),
  });

export const getApiV1ReposByRepositoryIdTreeByRefQueryKey = (
  options: Options<GetApiV1ReposByRepositoryIdTreeByRefData>,
) => createQueryKey("get_api_v1_repos_by_repository_id_tree_by_ref", options);

/**
 * Git Ls Tree V1
 */
export const getApiV1ReposByRepositoryIdTreeByRefOptions = (
  options: Options<GetApiV1ReposByRepositoryIdTreeByRefData>,
) =>
  queryOptions<
    GetApiV1ReposByRepositoryIdTreeByRefResponse,
    GetApiV1ReposByRepositoryIdTreeByRefError,
    GetApiV1ReposByRepositoryIdTreeByRefResponse,
    ReturnType<typeof getApiV1ReposByRepositoryIdTreeByRefQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await git_ls_tree_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ReposByRepositoryIdTreeByRefQueryKey(options),
  });

export const getApiV1ReposByRepositoryIdArticleByRefQueryKey = (
  options: Options<GetApiV1ReposByRepositoryIdArticleByRefData>,
) =>
  createQueryKey("get_api_v1_repos_by_repository_id_article_by_ref", options);

/**
 * Git Show Article V1
 */
export const getApiV1ReposByRepositoryIdArticleByRefOptions = (
  options: Options<GetApiV1ReposByRepositoryIdArticleByRefData>,
) =>
  queryOptions<
    GetApiV1ReposByRepositoryIdArticleByRefResponse,
    GetApiV1ReposByRepositoryIdArticleByRefError,
    GetApiV1ReposByRepositoryIdArticleByRefResponse,
    ReturnType<typeof getApiV1ReposByRepositoryIdArticleByRefQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await git_show_article_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ReposByRepositoryIdArticleByRefQueryKey(options),
  });

export const getApiV1ReposByRepositoryIdBlobByRefQueryKey = (
  options: Options<GetApiV1ReposByRepositoryIdBlobByRefData>,
) => createQueryKey("get_api_v1_repos_by_repository_id_blob_by_ref", options);

/**
 * Git Show Blob V1
 */
export const getApiV1ReposByRepositoryIdBlobByRefOptions = (
  options: Options<GetApiV1ReposByRepositoryIdBlobByRefData>,
) =>
  queryOptions<
    GetApiV1ReposByRepositoryIdBlobByRefResponse,
    GetApiV1ReposByRepositoryIdBlobByRefError,
    GetApiV1ReposByRepositoryIdBlobByRefResponse,
    ReturnType<typeof getApiV1ReposByRepositoryIdBlobByRefQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await git_show_blob_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ReposByRepositoryIdBlobByRefQueryKey(options),
  });

export const getApiSalesforceV1TenantsByTenantIdActionsCasesQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_cases",
    options,
  );

/**
 * Salesforce Get Cases V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsCasesOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsCasesResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsCasesError,
    GetApiSalesforceV1TenantsByTenantIdActionsCasesResponse,
    ReturnType<typeof getApiSalesforceV1TenantsByTenantIdActionsCasesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_cases_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSalesforceV1TenantsByTenantIdActionsCasesQueryKey(options),
  });

export const getApiSalesforceV1TenantsByTenantIdActionsCasesInfiniteQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesData>,
): QueryKey<Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesData>> =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_cases",
    options,
    true,
  );

/**
 * Salesforce Get Cases V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsCasesInfiniteOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsCasesResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsCasesError,
    InfiniteData<GetApiSalesforceV1TenantsByTenantIdActionsCasesResponse>,
    QueryKey<Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesData>>,
    | string
    | null
    | Pick<
        QueryKey<
          Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesData>
        >[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await salesforce_get_cases_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSalesforceV1TenantsByTenantIdActionsCasesInfiniteQueryKey(
          options,
        ),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Salesforce Create Case V1
 */
export const postApiSalesforceV1TenantsByTenantIdActionsCasesMutation = (
  options?: Partial<
    Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesData>
  >,
): UseMutationOptions<
  PostApiSalesforceV1TenantsByTenantIdActionsCasesResponse,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesError,
  Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesResponse,
    PostApiSalesforceV1TenantsByTenantIdActionsCasesError,
    Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await salesforce_create_case_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_cases_by_case_id",
    options,
  );

/**
 * Salesforce Get Case V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdError,
    GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponse,
    ReturnType<
      typeof getApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_case_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdQueryKey(options),
  });

/**
 * Salesforce Update Case V1
 */
export const patchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMutation =
  (
    options?: Partial<
      Options<PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData>
    >,
  ): UseMutationOptions<
    PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponse,
    PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdError,
    Options<PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponse,
      PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdError,
      Options<PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await salesforce_update_case_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Salesforce Post Case Comment V1
 */
export const postApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsMutation =
  (
    options?: Partial<
      Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsData>
    >,
  ): UseMutationOptions<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponse,
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsError,
    Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponse,
      PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsError,
      Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await salesforce_post_case_comment_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Salesforce Send Case Email V1
 */
export const postApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsMutation =
  (
    options?: Partial<
      Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsData>
    >,
  ): UseMutationOptions<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponse,
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsError,
    Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponse,
      PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsError,
      Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await salesforce_send_case_email_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Salesforce Create Case Email Draft V1
 */
export const postApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsMutation =
  (
    options?: Partial<
      Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsData>
    >,
  ): UseMutationOptions<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponse,
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsError,
    Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponse,
      PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsError,
      Options<PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await salesforce_create_case_email_draft_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData>,
  ) =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_cases_by_case_id_messages",
      options,
    );

/**
 * Salesforce Get Case Messages V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData>,
  ) =>
    queryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesError,
      GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponse,
      ReturnType<
        typeof getApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesforce_get_case_messages_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesQueryKey(
          options,
        ),
    });

export const getApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesInfiniteQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData>,
  ): QueryKey<
    Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData>
  > =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_cases_by_case_id_messages",
      options,
      true,
    );

/**
 * Salesforce Get Case Messages V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesInfiniteOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesError,
      InfiniteData<GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponse>,
      QueryKey<
        Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await salesforce_get_case_messages_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageData>,
  ) =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_default_language",
      options,
    );

/**
 * Salesforce Get Default Language V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageData>,
  ) =>
    queryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageError,
      GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponse,
      ReturnType<
        typeof getApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesforce_get_default_language_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageQueryKey(
          options,
        ),
    });

export const getApiSalesforceV1TenantsByTenantIdActionsArticlesQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsArticlesData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_articles",
    options,
  );

/**
 * Salesforce Get Articles V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsArticlesOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsArticlesData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsArticlesError,
    GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponse,
    ReturnType<
      typeof getApiSalesforceV1TenantsByTenantIdActionsArticlesQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_articles_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiSalesforceV1TenantsByTenantIdActionsArticlesQueryKey(options),
  });

export const getApiSalesforceV1TenantsByTenantIdActionsArticlesInfiniteQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsArticlesData>,
  ): QueryKey<
    Options<GetApiSalesforceV1TenantsByTenantIdActionsArticlesData>
  > =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_articles",
      options,
      true,
    );

/**
 * Salesforce Get Articles V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsArticlesInfiniteOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsArticlesData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsArticlesError,
      InfiniteData<GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponse>,
      QueryKey<Options<GetApiSalesforceV1TenantsByTenantIdActionsArticlesData>>,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiSalesforceV1TenantsByTenantIdActionsArticlesData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiSalesforceV1TenantsByTenantIdActionsArticlesData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await salesforce_get_articles_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiSalesforceV1TenantsByTenantIdActionsArticlesInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

/**
 * Salesforce Create Article V1
 */
export const postApiSalesforceV1TenantsByTenantIdActionsArticlesMutation = (
  options?: Partial<
    Options<PostApiSalesforceV1TenantsByTenantIdActionsArticlesData>
  >,
): UseMutationOptions<
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponse,
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesError,
  Options<PostApiSalesforceV1TenantsByTenantIdActionsArticlesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponse,
    PostApiSalesforceV1TenantsByTenantIdActionsArticlesError,
    Options<PostApiSalesforceV1TenantsByTenantIdActionsArticlesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await salesforce_create_article_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Salesforce Update Article V1
 */
export const patchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdMutation =
  (
    options?: Partial<
      Options<PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdData>
    >,
  ): UseMutationOptions<
    PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponse,
    PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdError,
    Options<PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponse,
      PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdError,
      Options<PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await salesforce_update_article_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Salesforce Delete Article V1
 */
export const deleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdMutation =
  (
    options?: Partial<
      Options<DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdData>
    >,
  ): UseMutationOptions<
    DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponse,
    DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdError,
    Options<DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponse,
      DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdError,
      Options<DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await salesforce_delete_article_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiSalesforceV1TenantsByTenantIdActionsRecordTypesQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_record_types",
    options,
  );

/**
 * Salesforce Get Record Types V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsRecordTypesOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesError,
    GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponse,
    ReturnType<
      typeof getApiSalesforceV1TenantsByTenantIdActionsRecordTypesQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_record_types_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiSalesforceV1TenantsByTenantIdActionsRecordTypesQueryKey(options),
  });

export const getApiSalesforceV1TenantsByTenantIdActionsRecordTypesInfiniteQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData>,
  ): QueryKey<
    Options<GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData>
  > =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_record_types",
      options,
      true,
    );

/**
 * Salesforce Get Record Types V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsRecordTypesInfiniteOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesError,
      InfiniteData<GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponse>,
      QueryKey<
        Options<GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await salesforce_get_record_types_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiSalesforceV1TenantsByTenantIdActionsRecordTypesInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdData>,
  ) =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_record_types_by_record_type_id",
      options,
    );

/**
 * Salesforce Get Record Type V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdData>,
  ) =>
    queryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdError,
      GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponse,
      ReturnType<
        typeof getApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesforce_get_record_type_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdQueryKey(
          options,
        ),
    });

export const getApiSalesforceV1TenantsByTenantIdActionsQueuesQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsQueuesData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_queues",
    options,
  );

/**
 * Salesforce Get Queues V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsQueuesOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsQueuesData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsQueuesError,
    GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponse,
    ReturnType<typeof getApiSalesforceV1TenantsByTenantIdActionsQueuesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_queues_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSalesforceV1TenantsByTenantIdActionsQueuesQueryKey(options),
  });

export const getApiSalesforceV1TenantsByTenantIdActionsQueuesInfiniteQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsQueuesData>,
  ): QueryKey<Options<GetApiSalesforceV1TenantsByTenantIdActionsQueuesData>> =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_queues",
      options,
      true,
    );

/**
 * Salesforce Get Queues V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsQueuesInfiniteOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsQueuesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsQueuesError,
    InfiniteData<GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponse>,
    QueryKey<Options<GetApiSalesforceV1TenantsByTenantIdActionsQueuesData>>,
    | string
    | null
    | Pick<
        QueryKey<
          Options<GetApiSalesforceV1TenantsByTenantIdActionsQueuesData>
        >[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiSalesforceV1TenantsByTenantIdActionsQueuesData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await salesforce_get_queues_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSalesforceV1TenantsByTenantIdActionsQueuesInfiniteQueryKey(
          options,
        ),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdData>,
  ) =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_queues_by_queue_id",
      options,
    );

/**
 * Salesforce Get Queue V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdData>,
  ) =>
    queryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdError,
      GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponse,
      ReturnType<
        typeof getApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesforce_get_queue_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdQueryKey(
          options,
        ),
    });

export const getApiSalesforceV1TenantsByTenantIdActionsUsersQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsUsersData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_users",
    options,
  );

/**
 * Salesforce Get Users V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsUsersOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsUsersData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsUsersResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsUsersError,
    GetApiSalesforceV1TenantsByTenantIdActionsUsersResponse,
    ReturnType<typeof getApiSalesforceV1TenantsByTenantIdActionsUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_users_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSalesforceV1TenantsByTenantIdActionsUsersQueryKey(options),
  });

export const getApiSalesforceV1TenantsByTenantIdActionsUsersInfiniteQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsUsersData>,
): QueryKey<Options<GetApiSalesforceV1TenantsByTenantIdActionsUsersData>> =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_users",
    options,
    true,
  );

/**
 * Salesforce Get Users V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsUsersInfiniteOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsUsersData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsUsersResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsUsersError,
    InfiniteData<GetApiSalesforceV1TenantsByTenantIdActionsUsersResponse>,
    QueryKey<Options<GetApiSalesforceV1TenantsByTenantIdActionsUsersData>>,
    | string
    | null
    | Pick<
        QueryKey<
          Options<GetApiSalesforceV1TenantsByTenantIdActionsUsersData>
        >[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiSalesforceV1TenantsByTenantIdActionsUsersData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await salesforce_get_users_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSalesforceV1TenantsByTenantIdActionsUsersInfiniteQueryKey(
          options,
        ),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_users_by_user_id",
    options,
  );

/**
 * Salesforce Get User V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdError,
    GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponse,
    ReturnType<
      typeof getApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_user_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdQueryKey(options),
  });

export const getApiSalesforceV1TenantsByTenantIdActionsAccountsQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsAccountsData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_accounts",
    options,
  );

/**
 * Salesforce Get Accounts V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsAccountsOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsAccountsData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsAccountsError,
    GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponse,
    ReturnType<
      typeof getApiSalesforceV1TenantsByTenantIdActionsAccountsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_accounts_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiSalesforceV1TenantsByTenantIdActionsAccountsQueryKey(options),
  });

export const getApiSalesforceV1TenantsByTenantIdActionsAccountsInfiniteQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsAccountsData>,
  ): QueryKey<
    Options<GetApiSalesforceV1TenantsByTenantIdActionsAccountsData>
  > =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_accounts",
      options,
      true,
    );

/**
 * Salesforce Get Accounts V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsAccountsInfiniteOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsAccountsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsAccountsError,
      InfiniteData<GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponse>,
      QueryKey<Options<GetApiSalesforceV1TenantsByTenantIdActionsAccountsData>>,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiSalesforceV1TenantsByTenantIdActionsAccountsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiSalesforceV1TenantsByTenantIdActionsAccountsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await salesforce_get_accounts_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiSalesforceV1TenantsByTenantIdActionsAccountsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdData>,
  ) =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_accounts_by_account_id",
      options,
    );

/**
 * Salesforce Get Account V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdData>,
  ) =>
    queryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdError,
      GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponse,
      ReturnType<
        typeof getApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesforce_get_account_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdQueryKey(
          options,
        ),
    });

export const getApiSalesforceV1TenantsByTenantIdActionsContactsQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsContactsData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_contacts",
    options,
  );

/**
 * Salesforce Get Contacts V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsContactsOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsContactsData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsContactsResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsContactsError,
    GetApiSalesforceV1TenantsByTenantIdActionsContactsResponse,
    ReturnType<
      typeof getApiSalesforceV1TenantsByTenantIdActionsContactsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_contacts_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiSalesforceV1TenantsByTenantIdActionsContactsQueryKey(options),
  });

export const getApiSalesforceV1TenantsByTenantIdActionsContactsInfiniteQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsContactsData>,
  ): QueryKey<
    Options<GetApiSalesforceV1TenantsByTenantIdActionsContactsData>
  > =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_contacts",
      options,
      true,
    );

/**
 * Salesforce Get Contacts V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsContactsInfiniteOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsContactsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsContactsResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsContactsError,
      InfiniteData<GetApiSalesforceV1TenantsByTenantIdActionsContactsResponse>,
      QueryKey<Options<GetApiSalesforceV1TenantsByTenantIdActionsContactsData>>,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiSalesforceV1TenantsByTenantIdActionsContactsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiSalesforceV1TenantsByTenantIdActionsContactsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await salesforce_get_contacts_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiSalesforceV1TenantsByTenantIdActionsContactsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdData>,
  ) =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_contacts_by_contact_id",
      options,
    );

/**
 * Salesforce Get Contact V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdData>,
  ) =>
    queryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdError,
      GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponse,
      ReturnType<
        typeof getApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesforce_get_contact_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdQueryKey(
          options,
        ),
    });

export const getApiSalesforceV1TenantsByTenantIdActionsEntitlementsQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_actions_entitlements",
    options,
  );

/**
 * Salesforce Get Entitlements V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsEntitlementsOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponse,
    GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsError,
    GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponse,
    ReturnType<
      typeof getApiSalesforceV1TenantsByTenantIdActionsEntitlementsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_entitlements_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiSalesforceV1TenantsByTenantIdActionsEntitlementsQueryKey(options),
  });

export const getApiSalesforceV1TenantsByTenantIdActionsEntitlementsInfiniteQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData>,
  ): QueryKey<
    Options<GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData>
  > =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_entitlements",
      options,
      true,
    );

/**
 * Salesforce Get Entitlements V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsEntitlementsInfiniteOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsError,
      InfiniteData<GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponse>,
      QueryKey<
        Options<GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await salesforce_get_entitlements_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiSalesforceV1TenantsByTenantIdActionsEntitlementsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdQueryKey =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdData>,
  ) =>
    createQueryKey(
      "get_api_salesforce_v1_tenants_by_tenant_id_actions_entitlements_by_entitlement_id",
      options,
    );

/**
 * Salesforce Get Entitlement V1
 */
export const getApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdOptions =
  (
    options: Options<GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdData>,
  ) =>
    queryOptions<
      GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponse,
      GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdError,
      GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponse,
      ReturnType<
        typeof getApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesforce_get_entitlement_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdQueryKey(
          options,
        ),
    });

export const getApiSalesforceV1TenantsQueryKey = (
  options?: Options<GetApiSalesforceV1TenantsData>,
) => createQueryKey("get_api_salesforce_v1_tenants", options);

/**
 * Salesforce Get Tenants V1
 */
export const getApiSalesforceV1TenantsOptions = (
  options?: Options<GetApiSalesforceV1TenantsData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsResponse,
    GetApiSalesforceV1TenantsError,
    GetApiSalesforceV1TenantsResponse,
    ReturnType<typeof getApiSalesforceV1TenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSalesforceV1TenantsQueryKey(options),
  });

export const getApiSalesforceV1TenantsInfiniteQueryKey = (
  options?: Options<GetApiSalesforceV1TenantsData>,
): QueryKey<Options<GetApiSalesforceV1TenantsData>> =>
  createQueryKey("get_api_salesforce_v1_tenants", options, true);

/**
 * Salesforce Get Tenants V1
 */
export const getApiSalesforceV1TenantsInfiniteOptions = (
  options?: Options<GetApiSalesforceV1TenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSalesforceV1TenantsResponse,
    GetApiSalesforceV1TenantsError,
    InfiniteData<GetApiSalesforceV1TenantsResponse>,
    QueryKey<Options<GetApiSalesforceV1TenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiSalesforceV1TenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiSalesforceV1TenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await salesforce_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiSalesforceV1TenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Salesforce Create Tenant V1
 */
export const postApiSalesforceV1TenantsMutation = (
  options?: Partial<Options<PostApiSalesforceV1TenantsData>>,
): UseMutationOptions<
  PostApiSalesforceV1TenantsResponse,
  PostApiSalesforceV1TenantsError,
  Options<PostApiSalesforceV1TenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSalesforceV1TenantsResponse,
    PostApiSalesforceV1TenantsError,
    Options<PostApiSalesforceV1TenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await salesforce_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Salesforce Delete Tenant V1
 */
export const deleteApiSalesforceV1TenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiSalesforceV1TenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiSalesforceV1TenantsByTenantIdResponse,
  DeleteApiSalesforceV1TenantsByTenantIdError,
  Options<DeleteApiSalesforceV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiSalesforceV1TenantsByTenantIdResponse,
    DeleteApiSalesforceV1TenantsByTenantIdError,
    Options<DeleteApiSalesforceV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await salesforce_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSalesforceV1TenantsByTenantIdQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdData>,
) => createQueryKey("get_api_salesforce_v1_tenants_by_tenant_id", options);

/**
 * Salesforce Get Tenant V1
 */
export const getApiSalesforceV1TenantsByTenantIdOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdResponse,
    GetApiSalesforceV1TenantsByTenantIdError,
    GetApiSalesforceV1TenantsByTenantIdResponse,
    ReturnType<typeof getApiSalesforceV1TenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSalesforceV1TenantsByTenantIdQueryKey(options),
  });

/**
 * Salesforce Patch Tenant V1
 */
export const patchApiSalesforceV1TenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiSalesforceV1TenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiSalesforceV1TenantsByTenantIdResponse,
  PatchApiSalesforceV1TenantsByTenantIdError,
  Options<PatchApiSalesforceV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiSalesforceV1TenantsByTenantIdResponse,
    PatchApiSalesforceV1TenantsByTenantIdError,
    Options<PatchApiSalesforceV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await salesforce_patch_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSalesforceV1FullTenantsQueryKey = (
  options?: Options<GetApiSalesforceV1FullTenantsData>,
) => createQueryKey("get_api_salesforce_v1_full_tenants", options);

/**
 * Salesforce Get Full Tenants V1
 */
export const getApiSalesforceV1FullTenantsOptions = (
  options?: Options<GetApiSalesforceV1FullTenantsData>,
) =>
  queryOptions<
    GetApiSalesforceV1FullTenantsResponse,
    GetApiSalesforceV1FullTenantsError,
    GetApiSalesforceV1FullTenantsResponse,
    ReturnType<typeof getApiSalesforceV1FullTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_full_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSalesforceV1FullTenantsQueryKey(options),
  });

export const getApiSalesforceV1FullTenantsInfiniteQueryKey = (
  options?: Options<GetApiSalesforceV1FullTenantsData>,
): QueryKey<Options<GetApiSalesforceV1FullTenantsData>> =>
  createQueryKey("get_api_salesforce_v1_full_tenants", options, true);

/**
 * Salesforce Get Full Tenants V1
 */
export const getApiSalesforceV1FullTenantsInfiniteOptions = (
  options?: Options<GetApiSalesforceV1FullTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSalesforceV1FullTenantsResponse,
    GetApiSalesforceV1FullTenantsError,
    InfiniteData<GetApiSalesforceV1FullTenantsResponse>,
    QueryKey<Options<GetApiSalesforceV1FullTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiSalesforceV1FullTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiSalesforceV1FullTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await salesforce_get_full_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiSalesforceV1FullTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiSalesforceV1TenantsByTenantIdOauthRedirectUriQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_oauth_redirect_uri",
    options,
  );

/**
 * Salesforce Get Oauth Redirect Uri V1
 */
export const getApiSalesforceV1TenantsByTenantIdOauthRedirectUriOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponse,
    GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriError,
    GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponse,
    ReturnType<
      typeof getApiSalesforceV1TenantsByTenantIdOauthRedirectUriQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_get_oauth_redirect_uri_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiSalesforceV1TenantsByTenantIdOauthRedirectUriQueryKey(options),
  });

/**
 * Salesforce Connect Tenant V1
 */
export const postApiSalesforceV1TenantsByTenantIdConnectMutation = (
  options?: Partial<Options<PostApiSalesforceV1TenantsByTenantIdConnectData>>,
): UseMutationOptions<
  PostApiSalesforceV1TenantsByTenantIdConnectResponse,
  PostApiSalesforceV1TenantsByTenantIdConnectError,
  Options<PostApiSalesforceV1TenantsByTenantIdConnectData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSalesforceV1TenantsByTenantIdConnectResponse,
    PostApiSalesforceV1TenantsByTenantIdConnectError,
    Options<PostApiSalesforceV1TenantsByTenantIdConnectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await salesforce_connect_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Salesforce Callback Tenant V1
 */
export const postApiSalesforceV1TenantsByTenantIdCallbackMutation = (
  options?: Partial<Options<PostApiSalesforceV1TenantsByTenantIdCallbackData>>,
): UseMutationOptions<
  PostApiSalesforceV1TenantsByTenantIdCallbackResponse,
  PostApiSalesforceV1TenantsByTenantIdCallbackError,
  Options<PostApiSalesforceV1TenantsByTenantIdCallbackData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSalesforceV1TenantsByTenantIdCallbackResponse,
    PostApiSalesforceV1TenantsByTenantIdCallbackError,
    Options<PostApiSalesforceV1TenantsByTenantIdCallbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await salesforce_callback_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSalesforceV1TenantsByTenantIdCheckConnectionQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdCheckConnectionData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_check_connection",
    options,
  );

/**
 * Salesforce Check Connection V1
 */
export const getApiSalesforceV1TenantsByTenantIdCheckConnectionOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdCheckConnectionData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponse,
    GetApiSalesforceV1TenantsByTenantIdCheckConnectionError,
    GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponse,
    ReturnType<
      typeof getApiSalesforceV1TenantsByTenantIdCheckConnectionQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_check_connection_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiSalesforceV1TenantsByTenantIdCheckConnectionQueryKey(options),
  });

export const getApiSalesforceV1TenantsByTenantIdCheckReadyQueryKey = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdCheckReadyData>,
) =>
  createQueryKey(
    "get_api_salesforce_v1_tenants_by_tenant_id_check_ready",
    options,
  );

/**
 * Salesforce Check Ready V1
 */
export const getApiSalesforceV1TenantsByTenantIdCheckReadyOptions = (
  options: Options<GetApiSalesforceV1TenantsByTenantIdCheckReadyData>,
) =>
  queryOptions<
    GetApiSalesforceV1TenantsByTenantIdCheckReadyResponse,
    GetApiSalesforceV1TenantsByTenantIdCheckReadyError,
    GetApiSalesforceV1TenantsByTenantIdCheckReadyResponse,
    ReturnType<typeof getApiSalesforceV1TenantsByTenantIdCheckReadyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await salesforce_check_ready_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSalesforceV1TenantsByTenantIdCheckReadyQueryKey(options),
  });

/**
 * Salesforce Delete Ingest Client V1
 */
export const deleteApiSalesforceV1TenantsByTenantIdIngestClientMutation = (
  options?: Partial<
    Options<DeleteApiSalesforceV1TenantsByTenantIdIngestClientData>
  >,
): UseMutationOptions<
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponse,
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientError,
  Options<DeleteApiSalesforceV1TenantsByTenantIdIngestClientData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponse,
    DeleteApiSalesforceV1TenantsByTenantIdIngestClientError,
    Options<DeleteApiSalesforceV1TenantsByTenantIdIngestClientData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await salesforce_delete_ingest_client_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Salesforce Put Ingest Client V1
 */
export const putApiSalesforceV1TenantsByTenantIdIngestClientMutation = (
  options?: Partial<
    Options<PutApiSalesforceV1TenantsByTenantIdIngestClientData>
  >,
): UseMutationOptions<
  PutApiSalesforceV1TenantsByTenantIdIngestClientResponse,
  PutApiSalesforceV1TenantsByTenantIdIngestClientError,
  Options<PutApiSalesforceV1TenantsByTenantIdIngestClientData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiSalesforceV1TenantsByTenantIdIngestClientResponse,
    PutApiSalesforceV1TenantsByTenantIdIngestClientError,
    Options<PutApiSalesforceV1TenantsByTenantIdIngestClientData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await salesforce_put_ingest_client_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1SearchQueryKey = (options: Options<GetApiV1SearchData>) =>
  createQueryKey("get_api_v1_search", options);

/**
 * Search V1
 */
export const getApiV1SearchOptions = (options: Options<GetApiV1SearchData>) =>
  queryOptions<
    GetApiV1SearchResponse,
    GetApiV1SearchError,
    GetApiV1SearchResponse,
    ReturnType<typeof getApiV1SearchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await search_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1SearchQueryKey(options),
  });

export const getApiV1SearchInfiniteQueryKey = (
  options: Options<GetApiV1SearchData>,
): QueryKey<Options<GetApiV1SearchData>> =>
  createQueryKey("get_api_v1_search", options, true);

/**
 * Search V1
 */
export const getApiV1SearchInfiniteOptions = (
  options: Options<GetApiV1SearchData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1SearchResponse,
    GetApiV1SearchError,
    InfiniteData<GetApiV1SearchResponse>,
    QueryKey<Options<GetApiV1SearchData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1SearchData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1SearchData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await search_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1SearchInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiSecretsVaultV1SecretsQueryKey = (
  options?: Options<GetApiSecretsVaultV1SecretsData>,
) => createQueryKey("get_api_secrets_vault_v1_secrets", options);

/**
 * Get Secrets Vault Secrets V1
 */
export const getApiSecretsVaultV1SecretsOptions = (
  options?: Options<GetApiSecretsVaultV1SecretsData>,
) =>
  queryOptions<
    GetApiSecretsVaultV1SecretsResponse,
    GetApiSecretsVaultV1SecretsError,
    GetApiSecretsVaultV1SecretsResponse,
    ReturnType<typeof getApiSecretsVaultV1SecretsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_secrets_vault_secrets_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSecretsVaultV1SecretsQueryKey(options),
  });

export const getApiSecretsVaultV1SecretsInfiniteQueryKey = (
  options?: Options<GetApiSecretsVaultV1SecretsData>,
): QueryKey<Options<GetApiSecretsVaultV1SecretsData>> =>
  createQueryKey("get_api_secrets_vault_v1_secrets", options, true);

/**
 * Get Secrets Vault Secrets V1
 */
export const getApiSecretsVaultV1SecretsInfiniteOptions = (
  options?: Options<GetApiSecretsVaultV1SecretsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSecretsVaultV1SecretsResponse,
    GetApiSecretsVaultV1SecretsError,
    InfiniteData<GetApiSecretsVaultV1SecretsResponse>,
    QueryKey<Options<GetApiSecretsVaultV1SecretsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiSecretsVaultV1SecretsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiSecretsVaultV1SecretsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_secrets_vault_secrets_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiSecretsVaultV1SecretsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Secrets Vault Secret V1
 */
export const postApiSecretsVaultV1SecretsMutation = (
  options?: Partial<Options<PostApiSecretsVaultV1SecretsData>>,
): UseMutationOptions<
  PostApiSecretsVaultV1SecretsResponse,
  PostApiSecretsVaultV1SecretsError,
  Options<PostApiSecretsVaultV1SecretsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSecretsVaultV1SecretsResponse,
    PostApiSecretsVaultV1SecretsError,
    Options<PostApiSecretsVaultV1SecretsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_secrets_vault_secret_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSecretsVaultV1FullSecretsQueryKey = (
  options?: Options<GetApiSecretsVaultV1FullSecretsData>,
) => createQueryKey("get_api_secrets_vault_v1_full_secrets", options);

/**
 * Get Secrets Vault Full Secrets V1
 */
export const getApiSecretsVaultV1FullSecretsOptions = (
  options?: Options<GetApiSecretsVaultV1FullSecretsData>,
) =>
  queryOptions<
    GetApiSecretsVaultV1FullSecretsResponse,
    GetApiSecretsVaultV1FullSecretsError,
    GetApiSecretsVaultV1FullSecretsResponse,
    ReturnType<typeof getApiSecretsVaultV1FullSecretsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_secrets_vault_full_secrets_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSecretsVaultV1FullSecretsQueryKey(options),
  });

export const getApiSecretsVaultV1FullSecretsInfiniteQueryKey = (
  options?: Options<GetApiSecretsVaultV1FullSecretsData>,
): QueryKey<Options<GetApiSecretsVaultV1FullSecretsData>> =>
  createQueryKey("get_api_secrets_vault_v1_full_secrets", options, true);

/**
 * Get Secrets Vault Full Secrets V1
 */
export const getApiSecretsVaultV1FullSecretsInfiniteOptions = (
  options?: Options<GetApiSecretsVaultV1FullSecretsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSecretsVaultV1FullSecretsResponse,
    GetApiSecretsVaultV1FullSecretsError,
    InfiniteData<GetApiSecretsVaultV1FullSecretsResponse>,
    QueryKey<Options<GetApiSecretsVaultV1FullSecretsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiSecretsVaultV1FullSecretsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiSecretsVaultV1FullSecretsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_secrets_vault_full_secrets_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiSecretsVaultV1FullSecretsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiSecretsVaultV1SecretsValueQueryKey = (
  options: Options<GetApiSecretsVaultV1SecretsValueData>,
) => createQueryKey("get_api_secrets_vault_v1_secrets_value", options);

/**
 * Get Secrets Vault Secret Value V1
 */
export const getApiSecretsVaultV1SecretsValueOptions = (
  options: Options<GetApiSecretsVaultV1SecretsValueData>,
) =>
  queryOptions<
    GetApiSecretsVaultV1SecretsValueResponse,
    GetApiSecretsVaultV1SecretsValueError,
    GetApiSecretsVaultV1SecretsValueResponse,
    ReturnType<typeof getApiSecretsVaultV1SecretsValueQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_secrets_vault_secret_value_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSecretsVaultV1SecretsValueQueryKey(options),
  });

export const getApiSecretsVaultV2SecretsValueQueryKey = (
  options: Options<GetApiSecretsVaultV2SecretsValueData>,
) => createQueryKey("get_api_secrets_vault_v2_secrets_value", options);

/**
 * Get Secrets Vault Secret Value V2
 */
export const getApiSecretsVaultV2SecretsValueOptions = (
  options: Options<GetApiSecretsVaultV2SecretsValueData>,
) =>
  queryOptions<
    GetApiSecretsVaultV2SecretsValueResponse,
    GetApiSecretsVaultV2SecretsValueError,
    GetApiSecretsVaultV2SecretsValueResponse,
    ReturnType<typeof getApiSecretsVaultV2SecretsValueQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_secrets_vault_secret_value_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSecretsVaultV2SecretsValueQueryKey(options),
  });

/**
 * Delete Secrets Vault Secret V1
 */
export const deleteApiSecretsVaultV1SecretsBySecretIdMutation = (
  options?: Partial<Options<DeleteApiSecretsVaultV1SecretsBySecretIdData>>,
): UseMutationOptions<
  DeleteApiSecretsVaultV1SecretsBySecretIdResponse,
  DeleteApiSecretsVaultV1SecretsBySecretIdError,
  Options<DeleteApiSecretsVaultV1SecretsBySecretIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiSecretsVaultV1SecretsBySecretIdResponse,
    DeleteApiSecretsVaultV1SecretsBySecretIdError,
    Options<DeleteApiSecretsVaultV1SecretsBySecretIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_secrets_vault_secret_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSecretsVaultV1SecretsBySecretIdQueryKey = (
  options: Options<GetApiSecretsVaultV1SecretsBySecretIdData>,
) => createQueryKey("get_api_secrets_vault_v1_secrets_by_secret_id", options);

/**
 * Get Secrets Vault Secret V1
 */
export const getApiSecretsVaultV1SecretsBySecretIdOptions = (
  options: Options<GetApiSecretsVaultV1SecretsBySecretIdData>,
) =>
  queryOptions<
    GetApiSecretsVaultV1SecretsBySecretIdResponse,
    GetApiSecretsVaultV1SecretsBySecretIdError,
    GetApiSecretsVaultV1SecretsBySecretIdResponse,
    ReturnType<typeof getApiSecretsVaultV1SecretsBySecretIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_secrets_vault_secret_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSecretsVaultV1SecretsBySecretIdQueryKey(options),
  });

/**
 * Update Secrets Vault Secret V1
 */
export const patchApiSecretsVaultV1SecretsBySecretIdMutation = (
  options?: Partial<Options<PatchApiSecretsVaultV1SecretsBySecretIdData>>,
): UseMutationOptions<
  PatchApiSecretsVaultV1SecretsBySecretIdResponse,
  PatchApiSecretsVaultV1SecretsBySecretIdError,
  Options<PatchApiSecretsVaultV1SecretsBySecretIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiSecretsVaultV1SecretsBySecretIdResponse,
    PatchApiSecretsVaultV1SecretsBySecretIdError,
    Options<PatchApiSecretsVaultV1SecretsBySecretIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_secrets_vault_secret_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Secrets Vault Secret V2
 */
export const postApiSecretsVaultV2SecretsMutation = (
  options?: Partial<Options<PostApiSecretsVaultV2SecretsData>>,
): UseMutationOptions<
  PostApiSecretsVaultV2SecretsResponse,
  PostApiSecretsVaultV2SecretsError,
  Options<PostApiSecretsVaultV2SecretsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSecretsVaultV2SecretsResponse,
    PostApiSecretsVaultV2SecretsError,
    Options<PostApiSecretsVaultV2SecretsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_secrets_vault_secret_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add Secrets Vault Secret Version V1
 */
export const postApiSecretsVaultV1SecretsBySecretIdVersionsMutation = (
  options?: Partial<
    Options<PostApiSecretsVaultV1SecretsBySecretIdVersionsData>
  >,
): UseMutationOptions<
  PostApiSecretsVaultV1SecretsBySecretIdVersionsResponse,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsError,
  Options<PostApiSecretsVaultV1SecretsBySecretIdVersionsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSecretsVaultV1SecretsBySecretIdVersionsResponse,
    PostApiSecretsVaultV1SecretsBySecretIdVersionsError,
    Options<PostApiSecretsVaultV1SecretsBySecretIdVersionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await add_secrets_vault_secret_version_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add Secrets Vault Secret Version V2
 */
export const postApiSecretsVaultV2SecretsBySecretIdVersionsMutation = (
  options?: Partial<
    Options<PostApiSecretsVaultV2SecretsBySecretIdVersionsData>
  >,
): UseMutationOptions<
  PostApiSecretsVaultV2SecretsBySecretIdVersionsResponse,
  PostApiSecretsVaultV2SecretsBySecretIdVersionsError,
  Options<PostApiSecretsVaultV2SecretsBySecretIdVersionsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSecretsVaultV2SecretsBySecretIdVersionsResponse,
    PostApiSecretsVaultV2SecretsBySecretIdVersionsError,
    Options<PostApiSecretsVaultV2SecretsBySecretIdVersionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await add_secrets_vault_secret_version_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Secrets Vault Secret Version V1
 */
export const deleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdMutation =
  (
    options?: Partial<
      Options<DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData>
    >,
  ): UseMutationOptions<
    DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponse,
    DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdError,
    Options<DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponse,
      DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdError,
      Options<DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await delete_secrets_vault_secret_version_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Update Secrets Vault Secret Version V1
 */
export const patchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdMutation =
  (
    options?: Partial<
      Options<PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData>
    >,
  ): UseMutationOptions<
    PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponse,
    PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdError,
    Options<PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponse,
      PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdError,
      Options<PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await update_secrets_vault_secret_version_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Restore Secrets Vault Secret V1
 */
export const postApiSecretsVaultV1SecretsBySecretIdRestoreMutation = (
  options?: Partial<Options<PostApiSecretsVaultV1SecretsBySecretIdRestoreData>>,
): UseMutationOptions<
  PostApiSecretsVaultV1SecretsBySecretIdRestoreResponse,
  PostApiSecretsVaultV1SecretsBySecretIdRestoreError,
  Options<PostApiSecretsVaultV1SecretsBySecretIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSecretsVaultV1SecretsBySecretIdRestoreResponse,
    PostApiSecretsVaultV1SecretsBySecretIdRestoreError,
    Options<PostApiSecretsVaultV1SecretsBySecretIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_secrets_vault_secret_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Secrets Vault Secret Version V1
 */
export const postApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreMutation =
  (
    options?: Partial<
      Options<PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreData>
    >,
  ): UseMutationOptions<
    PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponse,
    PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreError,
    Options<PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponse,
      PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreError,
      Options<PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await restore_secrets_vault_secret_version_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Reply V1
 */
export const postApiServiceNowV1ActionsReplyMutation = (
  options?: Partial<Options<PostApiServiceNowV1ActionsReplyData>>,
): UseMutationOptions<
  PostApiServiceNowV1ActionsReplyResponse,
  PostApiServiceNowV1ActionsReplyError,
  Options<PostApiServiceNowV1ActionsReplyData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiServiceNowV1ActionsReplyResponse,
    PostApiServiceNowV1ActionsReplyError,
    Options<PostApiServiceNowV1ActionsReplyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_reply_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Change Incident State V1
 */
export const postApiServiceNowV1ActionsChangeIncidentStateMutation = (
  options?: Partial<Options<PostApiServiceNowV1ActionsChangeIncidentStateData>>,
): UseMutationOptions<
  PostApiServiceNowV1ActionsChangeIncidentStateResponse,
  PostApiServiceNowV1ActionsChangeIncidentStateError,
  Options<PostApiServiceNowV1ActionsChangeIncidentStateData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiServiceNowV1ActionsChangeIncidentStateResponse,
    PostApiServiceNowV1ActionsChangeIncidentStateError,
    Options<PostApiServiceNowV1ActionsChangeIncidentStateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_change_incident_state_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Change Assignment Group V1
 */
export const postApiServiceNowV1ActionsChangeAssignmentGroupMutation = (
  options?: Partial<
    Options<PostApiServiceNowV1ActionsChangeAssignmentGroupData>
  >,
): UseMutationOptions<
  PostApiServiceNowV1ActionsChangeAssignmentGroupResponse,
  PostApiServiceNowV1ActionsChangeAssignmentGroupError,
  Options<PostApiServiceNowV1ActionsChangeAssignmentGroupData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiServiceNowV1ActionsChangeAssignmentGroupResponse,
    PostApiServiceNowV1ActionsChangeAssignmentGroupError,
    Options<PostApiServiceNowV1ActionsChangeAssignmentGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_change_assignment_group_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Create Catalog Request V1
 */
export const postApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestMutation =
  (
    options?: Partial<
      Options<PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestData>
    >,
  ): UseMutationOptions<
    PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponse,
    PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestError,
    Options<PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponse,
      PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestError,
      Options<PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_create_catalog_request_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Submit Record Producer V1
 */
export const postApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerMutation =
  (
    options?: Partial<
      Options<PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerData>
    >,
  ): UseMutationOptions<
    PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponse,
    PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerError,
    Options<PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponse,
      PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerError,
      Options<PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_submit_record_producer_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Create Incident V1
 */
export const postApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentMutation =
  (
    options?: Partial<
      Options<PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentData>
    >,
  ): UseMutationOptions<
    PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponse,
    PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentError,
    Options<PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponse,
      PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentError,
      Options<PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_create_incident_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Add Attachment V1
 */
export const postApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentMutation =
  (
    options?: Partial<
      Options<PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentData>
    >,
  ): UseMutationOptions<
    PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponse,
    PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentError,
    Options<PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponse,
      PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentError,
      Options<PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_add_attachment_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Attach Tag V1
 */
export const postApiV1ServiceNowTenantsByTenantIdActionsAttachTagMutation = (
  options?: Partial<
    Options<PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagData>
  >,
): UseMutationOptions<
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponse,
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagError,
  Options<PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponse,
    PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagError,
    Options<PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_attach_tag_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Change Request Item State V2
 */
export const postApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateMutation =
  (
    options?: Partial<
      Options<PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateData>
    >,
  ): UseMutationOptions<
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponse,
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateError,
    Options<PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponse,
      PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateError,
      Options<PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_change_request_item_state_v2({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Change Task State V2
 */
export const postApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateMutation =
  (
    options?: Partial<
      Options<PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateData>
    >,
  ): UseMutationOptions<
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponse,
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateError,
    Options<PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponse,
      PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateError,
      Options<PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_change_task_state_v2({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Change Approval State V1
 */
export const postApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateMutation =
  (
    options?: Partial<
      Options<PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateData>
    >,
  ): UseMutationOptions<
    PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponse,
    PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateError,
    Options<PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponse,
      PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateError,
      Options<PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_change_approval_state_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Reply Tenant V1
 */
export const postApiV1ServiceNowTenantsByTenantIdActionsReplyMutation = (
  options?: Partial<
    Options<PostApiV1ServiceNowTenantsByTenantIdActionsReplyData>
  >,
): UseMutationOptions<
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponse,
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyError,
  Options<PostApiV1ServiceNowTenantsByTenantIdActionsReplyData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponse,
    PostApiV1ServiceNowTenantsByTenantIdActionsReplyError,
    Options<PostApiV1ServiceNowTenantsByTenantIdActionsReplyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_reply_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Change Request State V2
 */
export const postApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateMutation =
  (
    options?: Partial<
      Options<PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateData>
    >,
  ): UseMutationOptions<
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponse,
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateError,
    Options<PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponse,
      PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateError,
      Options<PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_change_request_state_v2({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1ServiceNowTenantsByTenantIdArticlesQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdArticlesData>,
) =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_articles",
    options,
  );

/**
 * Service Now List Articles V1
 */
export const getApiV1ServiceNowTenantsByTenantIdArticlesOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdArticlesData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdArticlesResponse,
    GetApiV1ServiceNowTenantsByTenantIdArticlesError,
    GetApiV1ServiceNowTenantsByTenantIdArticlesResponse,
    ReturnType<typeof getApiV1ServiceNowTenantsByTenantIdArticlesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_list_articles_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ServiceNowTenantsByTenantIdArticlesQueryKey(options),
  });

export const getApiV1ServiceNowTenantsByTenantIdArticlesInfiniteQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdArticlesData>,
): QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdArticlesData>> =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_articles",
    options,
    true,
  );

/**
 * Service Now List Articles V1
 */
export const getApiV1ServiceNowTenantsByTenantIdArticlesInfiniteOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdArticlesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ServiceNowTenantsByTenantIdArticlesResponse,
    GetApiV1ServiceNowTenantsByTenantIdArticlesError,
    InfiniteData<GetApiV1ServiceNowTenantsByTenantIdArticlesResponse>,
    QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdArticlesData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdArticlesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdArticlesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await service_now_list_articles_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ServiceNowTenantsByTenantIdArticlesInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Service Now Create Article V1
 */
export const postApiV1ServiceNowTenantsByTenantIdArticlesMutation = (
  options?: Partial<Options<PostApiV1ServiceNowTenantsByTenantIdArticlesData>>,
): UseMutationOptions<
  PostApiV1ServiceNowTenantsByTenantIdArticlesResponse,
  PostApiV1ServiceNowTenantsByTenantIdArticlesError,
  Options<PostApiV1ServiceNowTenantsByTenantIdArticlesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ServiceNowTenantsByTenantIdArticlesResponse,
    PostApiV1ServiceNowTenantsByTenantIdArticlesError,
    Options<PostApiV1ServiceNowTenantsByTenantIdArticlesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_create_article_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ServiceNowTenantsByTenantIdArticlesBySysIdQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData>,
) =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_articles_by_sys_id",
    options,
  );

/**
 * Service Now Get Article V1
 */
export const getApiV1ServiceNowTenantsByTenantIdArticlesBySysIdOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponse,
    GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdError,
    GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponse,
    ReturnType<
      typeof getApiV1ServiceNowTenantsByTenantIdArticlesBySysIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_get_article_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ServiceNowTenantsByTenantIdArticlesBySysIdQueryKey(options),
  });

/**
 * Service Now Update Article V1
 */
export const patchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdMutation = (
  options?: Partial<
    Options<PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData>
  >,
): UseMutationOptions<
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponse,
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdError,
  Options<PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponse,
    PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdError,
    Options<PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_update_article_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ServiceNowTenantsByTenantIdKnowledgeBasesQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData>,
) =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_knowledge_bases",
    options,
  );

/**
 * Service Now List Knowledge Bases V1
 */
export const getApiV1ServiceNowTenantsByTenantIdKnowledgeBasesOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse,
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesError,
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse,
    ReturnType<typeof getApiV1ServiceNowTenantsByTenantIdKnowledgeBasesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_list_knowledge_bases_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ServiceNowTenantsByTenantIdKnowledgeBasesQueryKey(options),
  });

export const getApiV1ServiceNowTenantsByTenantIdKnowledgeBasesInfiniteQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData>,
  ): QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData>> =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_knowledge_bases",
      options,
      true,
    );

/**
 * Service Now List Knowledge Bases V1
 */
export const getApiV1ServiceNowTenantsByTenantIdKnowledgeBasesInfiniteOptions =
  (options: Options<GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData>) => {
    const opts = infiniteQueryOptions<
      GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse,
      GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesError,
      InfiniteData<GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse>,
      QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData>>,
      | number
      | Pick<
          QueryKey<
            Options<GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    offset: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await service_now_list_knowledge_bases_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiV1ServiceNowTenantsByTenantIdKnowledgeBasesInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

/**
 * Service Now Create Knowledge Base V1
 */
export const postApiV1ServiceNowTenantsByTenantIdKnowledgeBasesMutation = (
  options?: Partial<
    Options<PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData>
  >,
): UseMutationOptions<
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse,
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesError,
  Options<PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse,
    PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesError,
    Options<PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_create_knowledge_base_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData>,
  ) =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_knowledge_bases_by_sys_id",
      options,
    );

/**
 * Service Now Get Knowledge Base V1
 */
export const getApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponse,
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdError,
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponse,
    ReturnType<
      typeof getApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_get_knowledge_base_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdQueryKey(options),
  });

/**
 * Service Now Update Knowledge Base V1
 */
export const patchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdMutation =
  (
    options?: Partial<
      Options<PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData>
    >,
  ): UseMutationOptions<
    PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponse,
    PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdError,
    Options<PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponse,
      PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdError,
      Options<PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_update_knowledge_base_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesData>,
  ) =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_incidents_state_choices",
      options,
    );

/**
 * Service Now Get Incident State Choices V1
 */
export const getApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponse,
    GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesError,
    GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponse,
    ReturnType<
      typeof getApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_get_incident_state_choices_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesQueryKey(options),
  });

export const getApiV1ServiceNowTenantsByTenantIdAssignmentGroupsQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData>,
) =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_assignment_groups",
    options,
  );

/**
 * Service Now List Assignment Groups V1
 */
export const getApiV1ServiceNowTenantsByTenantIdAssignmentGroupsOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponse,
    GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsError,
    GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponse,
    ReturnType<
      typeof getApiV1ServiceNowTenantsByTenantIdAssignmentGroupsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_list_assignment_groups_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ServiceNowTenantsByTenantIdAssignmentGroupsQueryKey(options),
  });

export const getApiV1ServiceNowTenantsByTenantIdAssignmentGroupsInfiniteQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData>,
  ): QueryKey<
    Options<GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData>
  > =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_assignment_groups",
      options,
      true,
    );

/**
 * Service Now List Assignment Groups V1
 */
export const getApiV1ServiceNowTenantsByTenantIdAssignmentGroupsInfiniteOptions =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponse,
      GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsError,
      InfiniteData<GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponse>,
      QueryKey<
        Options<GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData>
      >,
      | number
      | Pick<
          QueryKey<
            Options<GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    offset: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await service_now_list_assignment_groups_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiV1ServiceNowTenantsByTenantIdAssignmentGroupsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiV1ServiceNowTenantsByTenantIdUsersQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdUsersData>,
) =>
  createQueryKey("get_api_v1_service_now_tenants_by_tenant_id_users", options);

/**
 * Service Now List Users V1
 */
export const getApiV1ServiceNowTenantsByTenantIdUsersOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdUsersData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdUsersResponse,
    GetApiV1ServiceNowTenantsByTenantIdUsersError,
    GetApiV1ServiceNowTenantsByTenantIdUsersResponse,
    ReturnType<typeof getApiV1ServiceNowTenantsByTenantIdUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_list_users_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ServiceNowTenantsByTenantIdUsersQueryKey(options),
  });

export const getApiV1ServiceNowTenantsByTenantIdTagsQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdTagsData>,
) =>
  createQueryKey("get_api_v1_service_now_tenants_by_tenant_id_tags", options);

/**
 * Service Now List Tags V1
 */
export const getApiV1ServiceNowTenantsByTenantIdTagsOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdTagsData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdTagsResponse,
    GetApiV1ServiceNowTenantsByTenantIdTagsError,
    GetApiV1ServiceNowTenantsByTenantIdTagsResponse,
    ReturnType<typeof getApiV1ServiceNowTenantsByTenantIdTagsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_list_tags_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ServiceNowTenantsByTenantIdTagsQueryKey(options),
  });

export const getApiV1ServiceNowTenantsByTenantIdTagsInfiniteQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdTagsData>,
): QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdTagsData>> =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_tags",
    options,
    true,
  );

/**
 * Service Now List Tags V1
 */
export const getApiV1ServiceNowTenantsByTenantIdTagsInfiniteOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdTagsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ServiceNowTenantsByTenantIdTagsResponse,
    GetApiV1ServiceNowTenantsByTenantIdTagsError,
    InfiniteData<GetApiV1ServiceNowTenantsByTenantIdTagsResponse>,
    QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdTagsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdTagsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdTagsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await service_now_list_tags_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ServiceNowTenantsByTenantIdTagsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Service Now Create Tag V1
 */
export const postApiV1ServiceNowTenantsByTenantIdTagsMutation = (
  options?: Partial<Options<PostApiV1ServiceNowTenantsByTenantIdTagsData>>,
): UseMutationOptions<
  PostApiV1ServiceNowTenantsByTenantIdTagsResponse,
  PostApiV1ServiceNowTenantsByTenantIdTagsError,
  Options<PostApiV1ServiceNowTenantsByTenantIdTagsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ServiceNowTenantsByTenantIdTagsResponse,
    PostApiV1ServiceNowTenantsByTenantIdTagsError,
    Options<PostApiV1ServiceNowTenantsByTenantIdTagsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_create_tag_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdData>,
) =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_request_items_by_sys_id",
    options,
  );

/**
 * Service Now Get Request Item V1
 */
export const getApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponse,
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdError,
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponse,
    ReturnType<
      typeof getApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_get_request_item_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdQueryKey(options),
  });

export const getApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData>,
  ) =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_requests_by_request_sys_id_request_items",
      options,
    );

/**
 * Service Now List Request Items V1
 */
export const getApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsOptions =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData>,
  ) =>
    queryOptions<
      GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponse,
      GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsError,
      GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponse,
      ReturnType<
        typeof getApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await service_now_list_request_items_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsQueryKey(
          options,
        ),
    });

export const getApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsInfiniteQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData>,
  ): QueryKey<
    Options<GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData>
  > =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_requests_by_request_sys_id_request_items",
      options,
      true,
    );

/**
 * Service Now List Request Items V1
 */
export const getApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsInfiniteOptions =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponse,
      GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsError,
      InfiniteData<GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponse>,
      QueryKey<
        Options<GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData>
      >,
      | number
      | Pick<
          QueryKey<
            Options<GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    offset: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await service_now_list_request_items_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData>,
  ) =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_request_items_by_request_item_sys_id_tasks",
      options,
    );

/**
 * Service Now List Tasks V1
 */
export const getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksOptions =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData>,
  ) =>
    queryOptions<
      GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponse,
      GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksError,
      GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponse,
      ReturnType<
        typeof getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await service_now_list_tasks_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksQueryKey(
          options,
        ),
    });

export const getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksInfiniteQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData>,
  ): QueryKey<
    Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData>
  > =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_request_items_by_request_item_sys_id_tasks",
      options,
      true,
    );

/**
 * Service Now List Tasks V1
 */
export const getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksInfiniteOptions =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponse,
      GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksError,
      InfiniteData<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponse>,
      QueryKey<
        Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData>
      >,
      | number
      | Pick<
          QueryKey<
            Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    offset: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await service_now_list_tasks_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData>,
  ) =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_tickets_by_ticket_sys_id_attachments",
      options,
    );

/**
 * Service Now Get Attachments V1
 */
export const getApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsOptions =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData>,
  ) =>
    queryOptions<
      GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponse,
      GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsError,
      GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponse,
      ReturnType<
        typeof getApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await service_now_get_attachments_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsQueryKey(
          options,
        ),
    });

export const getApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsInfiniteQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData>,
  ): QueryKey<
    Options<GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData>
  > =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_tickets_by_ticket_sys_id_attachments",
      options,
      true,
    );

/**
 * Service Now Get Attachments V1
 */
export const getApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsInfiniteOptions =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponse,
      GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsError,
      InfiniteData<GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponse>,
      QueryKey<
        Options<GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData>
      >,
      | number
      | Pick<
          QueryKey<
            Options<GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    offset: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await service_now_get_attachments_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentData>,
  ) =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_attachments_by_attachment_sys_id_content",
      options,
    );

/**
 * Service Now Get Attachment Content V1
 */
export const getApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentOptions =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentData>,
  ) =>
    queryOptions<
      GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponse,
      GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentError,
      GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponse,
      ReturnType<
        typeof getApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await service_now_get_attachment_content_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentQueryKey(
          options,
        ),
    });

export const getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData>,
  ) =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_request_items_by_request_item_sys_id_approvals",
      options,
    );

/**
 * Service Now List Approvals V1
 */
export const getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsOptions =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData>,
  ) =>
    queryOptions<
      GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponse,
      GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsError,
      GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponse,
      ReturnType<
        typeof getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await service_now_list_approvals_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsQueryKey(
          options,
        ),
    });

export const getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsInfiniteQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData>,
  ): QueryKey<
    Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData>
  > =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_request_items_by_request_item_sys_id_approvals",
      options,
      true,
    );

/**
 * Service Now List Approvals V1
 */
export const getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsInfiniteOptions =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponse,
      GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsError,
      InfiniteData<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponse>,
      QueryKey<
        Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData>
      >,
      | number
      | Pick<
          QueryKey<
            Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    offset: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await service_now_list_approvals_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesQueryKey =
  (
    options: Options<GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesData>,
  ) =>
    createQueryKey(
      "get_api_v1_service_now_tenants_by_tenant_id_approvals_state_choices",
      options,
    );

/**
 * Service Now Get Approval State Choices V1
 */
export const getApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponse,
    GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesError,
    GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponse,
    ReturnType<
      typeof getApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_get_approval_state_choices_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesQueryKey(options),
  });

export const getApiV1ServiceNowTenantsByTenantIdCatalogItemsQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData>,
) =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_catalog_items",
    options,
  );

/**
 * Service Now List Catalog Items V1
 */
export const getApiV1ServiceNowTenantsByTenantIdCatalogItemsOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponse,
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsError,
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponse,
    ReturnType<typeof getApiV1ServiceNowTenantsByTenantIdCatalogItemsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_list_catalog_items_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ServiceNowTenantsByTenantIdCatalogItemsQueryKey(options),
  });

export const getApiV1ServiceNowTenantsByTenantIdCatalogItemsInfiniteQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData>,
): QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData>> =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_catalog_items",
    options,
    true,
  );

/**
 * Service Now List Catalog Items V1
 */
export const getApiV1ServiceNowTenantsByTenantIdCatalogItemsInfiniteOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponse,
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsError,
    InfiniteData<GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponse>,
    QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData>>,
    | number
    | Pick<
        QueryKey<
          Options<GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData>
        >[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await service_now_list_catalog_items_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ServiceNowTenantsByTenantIdCatalogItemsInfiniteQueryKey(
          options,
        ),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdData>,
) =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_catalog_items_by_sys_id",
    options,
  );

/**
 * Service Now Get Catalog Item V1
 */
export const getApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponse,
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdError,
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponse,
    ReturnType<
      typeof getApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_get_catalog_item_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdQueryKey(options),
  });

export const getApiV1ServiceNowTenantsByTenantIdTicketsQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdTicketsData>,
) =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_tickets",
    options,
  );

/**
 * Service Now List Tickets V1
 */
export const getApiV1ServiceNowTenantsByTenantIdTicketsOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdTicketsData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdTicketsResponse,
    GetApiV1ServiceNowTenantsByTenantIdTicketsError,
    GetApiV1ServiceNowTenantsByTenantIdTicketsResponse,
    ReturnType<typeof getApiV1ServiceNowTenantsByTenantIdTicketsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_list_tickets_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ServiceNowTenantsByTenantIdTicketsQueryKey(options),
  });

export const getApiV1ServiceNowTenantsByTenantIdTicketsInfiniteQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdTicketsData>,
): QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdTicketsData>> =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_tickets",
    options,
    true,
  );

/**
 * Service Now List Tickets V1
 */
export const getApiV1ServiceNowTenantsByTenantIdTicketsInfiniteOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdTicketsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ServiceNowTenantsByTenantIdTicketsResponse,
    GetApiV1ServiceNowTenantsByTenantIdTicketsError,
    InfiniteData<GetApiV1ServiceNowTenantsByTenantIdTicketsResponse>,
    QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdTicketsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdTicketsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ServiceNowTenantsByTenantIdTicketsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await service_now_list_tickets_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ServiceNowTenantsByTenantIdTicketsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1ServiceNowTenantsByTenantIdTicketsBySysIdQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdData>,
) =>
  createQueryKey(
    "get_api_v1_service_now_tenants_by_tenant_id_tickets_by_sys_id",
    options,
  );

/**
 * Service Now Get Ticket V1
 */
export const getApiV1ServiceNowTenantsByTenantIdTicketsBySysIdOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponse,
    GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdError,
    GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponse,
    ReturnType<typeof getApiV1ServiceNowTenantsByTenantIdTicketsBySysIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_get_ticket_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ServiceNowTenantsByTenantIdTicketsBySysIdQueryKey(options),
  });

export const getApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesQueryKey =
  (
    options: Options<GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData>,
  ) =>
    createQueryKey(
      "get_api_service_now_v1_tenants_by_tenant_id_actions_catalog_variable_values",
      options,
    );

/**
 * Service Now Get Catalog Variable Values V1
 */
export const getApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesOptions =
  (
    options: Options<GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData>,
  ) =>
    queryOptions<
      GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponse,
      GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesError,
      GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponse,
      ReturnType<
        typeof getApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await service_now_get_catalog_variable_values_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesQueryKey(
          options,
        ),
    });

export const getApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesInfiniteQueryKey =
  (
    options: Options<GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData>,
  ): QueryKey<
    Options<GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData>
  > =>
    createQueryKey(
      "get_api_service_now_v1_tenants_by_tenant_id_actions_catalog_variable_values",
      options,
      true,
    );

/**
 * Service Now Get Catalog Variable Values V1
 */
export const getApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesInfiniteOptions =
  (
    options: Options<GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponse,
      GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesError,
      InfiniteData<GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponse>,
      QueryKey<
        Options<GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData>
      >,
      | number
      | Pick<
          QueryKey<
            Options<GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    offset: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await service_now_get_catalog_variable_values_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiServiceNowV1TenantsByTenantIdActionsUserProfileQueryKey = (
  options: Options<GetApiServiceNowV1TenantsByTenantIdActionsUserProfileData>,
) =>
  createQueryKey(
    "get_api_service_now_v1_tenants_by_tenant_id_actions_user_profile",
    options,
  );

/**
 * Service Now Get User Profile V1
 */
export const getApiServiceNowV1TenantsByTenantIdActionsUserProfileOptions = (
  options: Options<GetApiServiceNowV1TenantsByTenantIdActionsUserProfileData>,
) =>
  queryOptions<
    GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponse,
    GetApiServiceNowV1TenantsByTenantIdActionsUserProfileError,
    GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponse,
    ReturnType<
      typeof getApiServiceNowV1TenantsByTenantIdActionsUserProfileQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_get_user_profile_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiServiceNowV1TenantsByTenantIdActionsUserProfileQueryKey(options),
  });

export const getApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataQueryKey =
  (
    options: Options<GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataData>,
  ) =>
    createQueryKey(
      "get_api_service_now_v1_tenants_by_tenant_id_actions_catalog_variable_lookup_metadata",
      options,
    );

/**
 * Service Now Get Catalog Variable Lookup Metadata V1
 */
export const getApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataOptions =
  (
    options: Options<GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataData>,
  ) =>
    queryOptions<
      GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponse,
      GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataError,
      GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponse,
      ReturnType<
        typeof getApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await service_now_get_catalog_variable_lookup_metadata_v1({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
          });
        return data;
      },
      queryKey:
        getApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataQueryKey(
          options,
        ),
    });

/**
 * Service Now Search Records V1
 */
export const postApiServiceNowV1TenantsByTenantIdActionsSearchRecordsMutation =
  (
    options?: Partial<
      Options<PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsData>
    >,
  ): UseMutationOptions<
    PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponse,
    PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsError,
    Options<PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponse,
      PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsError,
      Options<PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_search_records_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Create Record V1
 */
export const postApiServiceNowV1TenantsByTenantIdActionsRecordsMutation = (
  options?: Partial<
    Options<PostApiServiceNowV1TenantsByTenantIdActionsRecordsData>
  >,
): UseMutationOptions<
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponse,
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsError,
  Options<PostApiServiceNowV1TenantsByTenantIdActionsRecordsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponse,
    PostApiServiceNowV1TenantsByTenantIdActionsRecordsError,
    Options<PostApiServiceNowV1TenantsByTenantIdActionsRecordsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_create_record_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Update Record V1
 */
export const patchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdMutation =
  (
    options?: Partial<
      Options<PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdData>
    >,
  ): UseMutationOptions<
    PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponse,
    PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdError,
    Options<PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponse,
      PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdError,
      Options<PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_update_record_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Aggregate Records V1
 */
export const postApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsMutation =
  (
    options?: Partial<
      Options<PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsData>
    >,
  ): UseMutationOptions<
    PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponse,
    PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsError,
    Options<PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponse,
      PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsError,
      Options<PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_aggregate_records_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Create Change V1
 */
export const postApiServiceNowV1TenantsByTenantIdActionsChangesMutation = (
  options?: Partial<
    Options<PostApiServiceNowV1TenantsByTenantIdActionsChangesData>
  >,
): UseMutationOptions<
  PostApiServiceNowV1TenantsByTenantIdActionsChangesResponse,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesError,
  Options<PostApiServiceNowV1TenantsByTenantIdActionsChangesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiServiceNowV1TenantsByTenantIdActionsChangesResponse,
    PostApiServiceNowV1TenantsByTenantIdActionsChangesError,
    Options<PostApiServiceNowV1TenantsByTenantIdActionsChangesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_create_change_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Update Change V1
 */
export const patchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdMutation =
  (
    options?: Partial<
      Options<PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdData>
    >,
  ): UseMutationOptions<
    PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponse,
    PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdError,
    Options<PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponse,
      PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdError,
      Options<PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_update_change_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Create Change Task V1
 */
export const postApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksMutation =
  (
    options?: Partial<
      Options<PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksData>
    >,
  ): UseMutationOptions<
    PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponse,
    PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksError,
    Options<PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponse,
      PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksError,
      Options<PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_create_change_task_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Service Now Run Batch V1
 */
export const postApiServiceNowV1TenantsByTenantIdActionsBatchMutation = (
  options?: Partial<
    Options<PostApiServiceNowV1TenantsByTenantIdActionsBatchData>
  >,
): UseMutationOptions<
  PostApiServiceNowV1TenantsByTenantIdActionsBatchResponse,
  PostApiServiceNowV1TenantsByTenantIdActionsBatchError,
  Options<PostApiServiceNowV1TenantsByTenantIdActionsBatchData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiServiceNowV1TenantsByTenantIdActionsBatchResponse,
    PostApiServiceNowV1TenantsByTenantIdActionsBatchError,
    Options<PostApiServiceNowV1TenantsByTenantIdActionsBatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_run_batch_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Add Record Attachment V1
 */
export const postApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentMutation =
  (
    options?: Partial<
      Options<PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentData>
    >,
  ): UseMutationOptions<
    PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponse,
    PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentError,
    Options<PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponse,
      PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentError,
      Options<PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await service_now_add_record_attachment_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1ServiceNowTenantsQueryKey = (
  options?: Options<GetApiV1ServiceNowTenantsData>,
) => createQueryKey("get_api_v1_service_now_tenants", options);

/**
 * Service Now Get Tenants V1
 */
export const getApiV1ServiceNowTenantsOptions = (
  options?: Options<GetApiV1ServiceNowTenantsData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsResponse,
    GetApiV1ServiceNowTenantsError,
    GetApiV1ServiceNowTenantsResponse,
    ReturnType<typeof getApiV1ServiceNowTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ServiceNowTenantsQueryKey(options),
  });

export const getApiV1ServiceNowTenantsInfiniteQueryKey = (
  options?: Options<GetApiV1ServiceNowTenantsData>,
): QueryKey<Options<GetApiV1ServiceNowTenantsData>> =>
  createQueryKey("get_api_v1_service_now_tenants", options, true);

/**
 * Service Now Get Tenants V1
 */
export const getApiV1ServiceNowTenantsInfiniteOptions = (
  options?: Options<GetApiV1ServiceNowTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ServiceNowTenantsResponse,
    GetApiV1ServiceNowTenantsError,
    InfiniteData<GetApiV1ServiceNowTenantsResponse>,
    QueryKey<Options<GetApiV1ServiceNowTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ServiceNowTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ServiceNowTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await service_now_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1ServiceNowTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Service Now Create Tenant V1
 */
export const postApiV1ServiceNowTenantsMutation = (
  options?: Partial<Options<PostApiV1ServiceNowTenantsData>>,
): UseMutationOptions<
  PostApiV1ServiceNowTenantsResponse,
  PostApiV1ServiceNowTenantsError,
  Options<PostApiV1ServiceNowTenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ServiceNowTenantsResponse,
    PostApiV1ServiceNowTenantsError,
    Options<PostApiV1ServiceNowTenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Delete Tenant V1
 */
export const deleteApiV1ServiceNowTenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiV1ServiceNowTenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiV1ServiceNowTenantsByTenantIdResponse,
  DeleteApiV1ServiceNowTenantsByTenantIdError,
  Options<DeleteApiV1ServiceNowTenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1ServiceNowTenantsByTenantIdResponse,
    DeleteApiV1ServiceNowTenantsByTenantIdError,
    Options<DeleteApiV1ServiceNowTenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ServiceNowTenantsByTenantIdQueryKey = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdData>,
) => createQueryKey("get_api_v1_service_now_tenants_by_tenant_id", options);

/**
 * Service Now Get Tenant V1
 */
export const getApiV1ServiceNowTenantsByTenantIdOptions = (
  options: Options<GetApiV1ServiceNowTenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiV1ServiceNowTenantsByTenantIdResponse,
    GetApiV1ServiceNowTenantsByTenantIdError,
    GetApiV1ServiceNowTenantsByTenantIdResponse,
    ReturnType<typeof getApiV1ServiceNowTenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await service_now_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ServiceNowTenantsByTenantIdQueryKey(options),
  });

/**
 * Service Now Update Tenant V1
 */
export const patchApiV1ServiceNowTenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiV1ServiceNowTenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiV1ServiceNowTenantsByTenantIdResponse,
  PatchApiV1ServiceNowTenantsByTenantIdError,
  Options<PatchApiV1ServiceNowTenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1ServiceNowTenantsByTenantIdResponse,
    PatchApiV1ServiceNowTenantsByTenantIdError,
    Options<PatchApiV1ServiceNowTenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_update_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Restore Tenant V1
 */
export const postApiV1ServiceNowTenantsByTenantIdRestoreMutation = (
  options?: Partial<Options<PostApiV1ServiceNowTenantsByTenantIdRestoreData>>,
): UseMutationOptions<
  PostApiV1ServiceNowTenantsByTenantIdRestoreResponse,
  PostApiV1ServiceNowTenantsByTenantIdRestoreError,
  Options<PostApiV1ServiceNowTenantsByTenantIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ServiceNowTenantsByTenantIdRestoreResponse,
    PostApiV1ServiceNowTenantsByTenantIdRestoreError,
    Options<PostApiV1ServiceNowTenantsByTenantIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_restore_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Setup Tenant V1
 */
export const postApiV1ServiceNowTenantsByTenantIdSetupMutation = (
  options?: Partial<Options<PostApiV1ServiceNowTenantsByTenantIdSetupData>>,
): UseMutationOptions<
  PostApiV1ServiceNowTenantsByTenantIdSetupResponse,
  PostApiV1ServiceNowTenantsByTenantIdSetupError,
  Options<PostApiV1ServiceNowTenantsByTenantIdSetupData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ServiceNowTenantsByTenantIdSetupResponse,
    PostApiV1ServiceNowTenantsByTenantIdSetupError,
    Options<PostApiV1ServiceNowTenantsByTenantIdSetupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_setup_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesQueryKey =
  (
    options: Options<GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData>,
  ) =>
    createQueryKey(
      "get_api_sharepoint_v1_tenants_by_tenant_id_actions_sites_by_site_id_drives",
      options,
    );

/**
 * Sharepoint Get Drives V1
 */
export const getApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesOptions =
  (
    options: Options<GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData>,
  ) =>
    queryOptions<
      GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponse,
      GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesError,
      GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponse,
      ReturnType<
        typeof getApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await sharepoint_get_drives_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesQueryKey(
          options,
        ),
    });

export const getApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesInfiniteQueryKey =
  (
    options: Options<GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData>,
  ): QueryKey<
    Options<GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData>
  > =>
    createQueryKey(
      "get_api_sharepoint_v1_tenants_by_tenant_id_actions_sites_by_site_id_drives",
      options,
      true,
    );

/**
 * Sharepoint Get Drives V1
 */
export const getApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesInfiniteOptions =
  (
    options: Options<GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponse,
      GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesError,
      InfiniteData<GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponse>,
      QueryKey<
        Options<GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await sharepoint_get_drives_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

export const getApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenQueryKey =
  (
    options: Options<GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData>,
  ) =>
    createQueryKey(
      "get_api_sharepoint_v1_tenants_by_tenant_id_actions_drives_by_drive_id_items_by_item_id_children",
      options,
    );

/**
 * Sharepoint Get Children V1
 */
export const getApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenOptions =
  (
    options: Options<GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData>,
  ) =>
    queryOptions<
      GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponse,
      GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenError,
      GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponse,
      ReturnType<
        typeof getApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await sharepoint_get_children_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenQueryKey(
          options,
        ),
    });

export const getApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenInfiniteQueryKey =
  (
    options: Options<GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData>,
  ): QueryKey<
    Options<GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData>
  > =>
    createQueryKey(
      "get_api_sharepoint_v1_tenants_by_tenant_id_actions_drives_by_drive_id_items_by_item_id_children",
      options,
      true,
    );

/**
 * Sharepoint Get Children V1
 */
export const getApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenInfiniteOptions =
  (
    options: Options<GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponse,
      GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenError,
      InfiniteData<GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponse>,
      QueryKey<
        Options<GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    cursor: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } = await sharepoint_get_children_v1({
            ...options,
            ...params,
            signal,
            throwOnError: true,
          });
          return data;
        },
        queryKey:
          getApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

/**
 * Sharepoint Delete Item V1
 */
export const deleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdMutation =
  (
    options?: Partial<
      Options<DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData>
    >,
  ): UseMutationOptions<
    DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
    DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError,
    Options<DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
      DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError,
      Options<DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await sharepoint_delete_item_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdQueryKey =
  (
    options: Options<GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData>,
  ) =>
    createQueryKey(
      "get_api_sharepoint_v1_tenants_by_tenant_id_actions_drives_by_drive_id_items_by_item_id",
      options,
    );

/**
 * Sharepoint Get Item V1
 */
export const getApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdOptions =
  (
    options: Options<GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData>,
  ) =>
    queryOptions<
      GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
      GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError,
      GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
      ReturnType<
        typeof getApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await sharepoint_get_item_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdQueryKey(
          options,
        ),
    });

/**
 * Sharepoint Update Item V1
 */
export const patchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdMutation =
  (
    options?: Partial<
      Options<PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData>
    >,
  ): UseMutationOptions<
    PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
    PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError,
    Options<PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
      PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError,
      Options<PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await sharepoint_update_item_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Sharepoint Create Download Url V1
 */
export const postApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlMutation =
  (
    options?: Partial<
      Options<PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlData>
    >,
  ): UseMutationOptions<
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponse,
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlError,
    Options<PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponse,
      PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlError,
      Options<PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await sharepoint_create_download_url_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Sharepoint Create Upload Session V1
 */
export const postApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionMutation =
  (
    options?: Partial<
      Options<PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionData>
    >,
  ): UseMutationOptions<
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponse,
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionError,
    Options<PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponse,
      PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionError,
      Options<PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await sharepoint_create_upload_session_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Sharepoint Create Item Upload Session V1
 */
export const postApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionMutation =
  (
    options?: Partial<
      Options<PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionData>
    >,
  ): UseMutationOptions<
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponse,
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionError,
    Options<PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponse,
      PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionError,
      Options<PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await sharepoint_create_item_upload_session_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiSharepointV1TenantsQueryKey = (
  options?: Options<GetApiSharepointV1TenantsData>,
) => createQueryKey("get_api_sharepoint_v1_tenants", options);

/**
 * Sharepoint Get Tenants V1
 */
export const getApiSharepointV1TenantsOptions = (
  options?: Options<GetApiSharepointV1TenantsData>,
) =>
  queryOptions<
    GetApiSharepointV1TenantsResponse,
    GetApiSharepointV1TenantsError,
    GetApiSharepointV1TenantsResponse,
    ReturnType<typeof getApiSharepointV1TenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sharepoint_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSharepointV1TenantsQueryKey(options),
  });

export const getApiSharepointV1TenantsInfiniteQueryKey = (
  options?: Options<GetApiSharepointV1TenantsData>,
): QueryKey<Options<GetApiSharepointV1TenantsData>> =>
  createQueryKey("get_api_sharepoint_v1_tenants", options, true);

/**
 * Sharepoint Get Tenants V1
 */
export const getApiSharepointV1TenantsInfiniteOptions = (
  options?: Options<GetApiSharepointV1TenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSharepointV1TenantsResponse,
    GetApiSharepointV1TenantsError,
    InfiniteData<GetApiSharepointV1TenantsResponse>,
    QueryKey<Options<GetApiSharepointV1TenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiSharepointV1TenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiSharepointV1TenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await sharepoint_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiSharepointV1TenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Sharepoint Create Tenant V1
 */
export const postApiSharepointV1TenantsMutation = (
  options?: Partial<Options<PostApiSharepointV1TenantsData>>,
): UseMutationOptions<
  PostApiSharepointV1TenantsResponse,
  PostApiSharepointV1TenantsError,
  Options<PostApiSharepointV1TenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSharepointV1TenantsResponse,
    PostApiSharepointV1TenantsError,
    Options<PostApiSharepointV1TenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sharepoint_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSharepointV1FullTenantsQueryKey = (
  options?: Options<GetApiSharepointV1FullTenantsData>,
) => createQueryKey("get_api_sharepoint_v1_full_tenants", options);

/**
 * Sharepoint Get Full Tenants V1
 */
export const getApiSharepointV1FullTenantsOptions = (
  options?: Options<GetApiSharepointV1FullTenantsData>,
) =>
  queryOptions<
    GetApiSharepointV1FullTenantsResponse,
    GetApiSharepointV1FullTenantsError,
    GetApiSharepointV1FullTenantsResponse,
    ReturnType<typeof getApiSharepointV1FullTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sharepoint_get_full_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSharepointV1FullTenantsQueryKey(options),
  });

export const getApiSharepointV1FullTenantsInfiniteQueryKey = (
  options?: Options<GetApiSharepointV1FullTenantsData>,
): QueryKey<Options<GetApiSharepointV1FullTenantsData>> =>
  createQueryKey("get_api_sharepoint_v1_full_tenants", options, true);

/**
 * Sharepoint Get Full Tenants V1
 */
export const getApiSharepointV1FullTenantsInfiniteOptions = (
  options?: Options<GetApiSharepointV1FullTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSharepointV1FullTenantsResponse,
    GetApiSharepointV1FullTenantsError,
    InfiniteData<GetApiSharepointV1FullTenantsResponse>,
    QueryKey<Options<GetApiSharepointV1FullTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiSharepointV1FullTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiSharepointV1FullTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await sharepoint_get_full_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiSharepointV1FullTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Sharepoint Delete Tenant V1
 */
export const deleteApiSharepointV1TenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiSharepointV1TenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiSharepointV1TenantsByTenantIdResponse,
  DeleteApiSharepointV1TenantsByTenantIdError,
  Options<DeleteApiSharepointV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiSharepointV1TenantsByTenantIdResponse,
    DeleteApiSharepointV1TenantsByTenantIdError,
    Options<DeleteApiSharepointV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sharepoint_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSharepointV1TenantsByTenantIdQueryKey = (
  options: Options<GetApiSharepointV1TenantsByTenantIdData>,
) => createQueryKey("get_api_sharepoint_v1_tenants_by_tenant_id", options);

/**
 * Sharepoint Get Tenant V1
 */
export const getApiSharepointV1TenantsByTenantIdOptions = (
  options: Options<GetApiSharepointV1TenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiSharepointV1TenantsByTenantIdResponse,
    GetApiSharepointV1TenantsByTenantIdError,
    GetApiSharepointV1TenantsByTenantIdResponse,
    ReturnType<typeof getApiSharepointV1TenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sharepoint_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSharepointV1TenantsByTenantIdQueryKey(options),
  });

/**
 * Sharepoint Patch Tenant V1
 */
export const patchApiSharepointV1TenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiSharepointV1TenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiSharepointV1TenantsByTenantIdResponse,
  PatchApiSharepointV1TenantsByTenantIdError,
  Options<PatchApiSharepointV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiSharepointV1TenantsByTenantIdResponse,
    PatchApiSharepointV1TenantsByTenantIdError,
    Options<PatchApiSharepointV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sharepoint_patch_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sharepoint Connect Tenant V1
 */
export const postApiSharepointV1TenantsByTenantIdConnectMutation = (
  options?: Partial<Options<PostApiSharepointV1TenantsByTenantIdConnectData>>,
): UseMutationOptions<
  PostApiSharepointV1TenantsByTenantIdConnectResponse,
  PostApiSharepointV1TenantsByTenantIdConnectError,
  Options<PostApiSharepointV1TenantsByTenantIdConnectData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSharepointV1TenantsByTenantIdConnectResponse,
    PostApiSharepointV1TenantsByTenantIdConnectError,
    Options<PostApiSharepointV1TenantsByTenantIdConnectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sharepoint_connect_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sharepoint Callback Tenant V1
 */
export const postApiSharepointV1TenantsByTenantIdCallbackMutation = (
  options?: Partial<Options<PostApiSharepointV1TenantsByTenantIdCallbackData>>,
): UseMutationOptions<
  PostApiSharepointV1TenantsByTenantIdCallbackResponse,
  PostApiSharepointV1TenantsByTenantIdCallbackError,
  Options<PostApiSharepointV1TenantsByTenantIdCallbackData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSharepointV1TenantsByTenantIdCallbackResponse,
    PostApiSharepointV1TenantsByTenantIdCallbackError,
    Options<PostApiSharepointV1TenantsByTenantIdCallbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sharepoint_callback_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSharepointV1TenantsByTenantIdCheckConnectionQueryKey = (
  options: Options<GetApiSharepointV1TenantsByTenantIdCheckConnectionData>,
) =>
  createQueryKey(
    "get_api_sharepoint_v1_tenants_by_tenant_id_check_connection",
    options,
  );

/**
 * Sharepoint Check Connection V1
 */
export const getApiSharepointV1TenantsByTenantIdCheckConnectionOptions = (
  options: Options<GetApiSharepointV1TenantsByTenantIdCheckConnectionData>,
) =>
  queryOptions<
    GetApiSharepointV1TenantsByTenantIdCheckConnectionResponse,
    GetApiSharepointV1TenantsByTenantIdCheckConnectionError,
    GetApiSharepointV1TenantsByTenantIdCheckConnectionResponse,
    ReturnType<
      typeof getApiSharepointV1TenantsByTenantIdCheckConnectionQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sharepoint_check_connection_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiSharepointV1TenantsByTenantIdCheckConnectionQueryKey(options),
  });

export const getApiSharepointV1TenantsByTenantIdCheckAccessQueryKey = (
  options: Options<GetApiSharepointV1TenantsByTenantIdCheckAccessData>,
) =>
  createQueryKey(
    "get_api_sharepoint_v1_tenants_by_tenant_id_check_access",
    options,
  );

/**
 * Sharepoint Check Access V1
 */
export const getApiSharepointV1TenantsByTenantIdCheckAccessOptions = (
  options: Options<GetApiSharepointV1TenantsByTenantIdCheckAccessData>,
) =>
  queryOptions<
    GetApiSharepointV1TenantsByTenantIdCheckAccessResponse,
    GetApiSharepointV1TenantsByTenantIdCheckAccessError,
    GetApiSharepointV1TenantsByTenantIdCheckAccessResponse,
    ReturnType<typeof getApiSharepointV1TenantsByTenantIdCheckAccessQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sharepoint_check_access_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSharepointV1TenantsByTenantIdCheckAccessQueryKey(options),
  });

export const getApiSharepointV1TenantsByTenantIdAdminAccessQueryKey = (
  options: Options<GetApiSharepointV1TenantsByTenantIdAdminAccessData>,
) =>
  createQueryKey(
    "get_api_sharepoint_v1_tenants_by_tenant_id_admin_access",
    options,
  );

/**
 * Sharepoint Get Admin Access V1
 */
export const getApiSharepointV1TenantsByTenantIdAdminAccessOptions = (
  options: Options<GetApiSharepointV1TenantsByTenantIdAdminAccessData>,
) =>
  queryOptions<
    GetApiSharepointV1TenantsByTenantIdAdminAccessResponse,
    GetApiSharepointV1TenantsByTenantIdAdminAccessError,
    GetApiSharepointV1TenantsByTenantIdAdminAccessResponse,
    ReturnType<typeof getApiSharepointV1TenantsByTenantIdAdminAccessQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sharepoint_get_admin_access_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSharepointV1TenantsByTenantIdAdminAccessQueryKey(options),
  });

export const getApiSharepointV1TenantsByTenantIdSitesQueryKey = (
  options: Options<GetApiSharepointV1TenantsByTenantIdSitesData>,
) =>
  createQueryKey("get_api_sharepoint_v1_tenants_by_tenant_id_sites", options);

/**
 * Sharepoint Get Sites V1
 */
export const getApiSharepointV1TenantsByTenantIdSitesOptions = (
  options: Options<GetApiSharepointV1TenantsByTenantIdSitesData>,
) =>
  queryOptions<
    GetApiSharepointV1TenantsByTenantIdSitesResponse,
    GetApiSharepointV1TenantsByTenantIdSitesError,
    GetApiSharepointV1TenantsByTenantIdSitesResponse,
    ReturnType<typeof getApiSharepointV1TenantsByTenantIdSitesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sharepoint_get_sites_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSharepointV1TenantsByTenantIdSitesQueryKey(options),
  });

/**
 * Sharepoint Create Site V1
 */
export const postApiSharepointV1TenantsByTenantIdSitesMutation = (
  options?: Partial<Options<PostApiSharepointV1TenantsByTenantIdSitesData>>,
): UseMutationOptions<
  PostApiSharepointV1TenantsByTenantIdSitesResponse,
  PostApiSharepointV1TenantsByTenantIdSitesError,
  Options<PostApiSharepointV1TenantsByTenantIdSitesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSharepointV1TenantsByTenantIdSitesResponse,
    PostApiSharepointV1TenantsByTenantIdSitesError,
    Options<PostApiSharepointV1TenantsByTenantIdSitesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sharepoint_create_site_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sharepoint Grant Site V1
 */
export const postApiSharepointV1TenantsByTenantIdSitesGrantMutation = (
  options?: Partial<
    Options<PostApiSharepointV1TenantsByTenantIdSitesGrantData>
  >,
): UseMutationOptions<
  PostApiSharepointV1TenantsByTenantIdSitesGrantResponse,
  PostApiSharepointV1TenantsByTenantIdSitesGrantError,
  Options<PostApiSharepointV1TenantsByTenantIdSitesGrantData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSharepointV1TenantsByTenantIdSitesGrantResponse,
    PostApiSharepointV1TenantsByTenantIdSitesGrantError,
    Options<PostApiSharepointV1TenantsByTenantIdSitesGrantData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sharepoint_grant_site_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sharepoint Delete Site V1
 */
export const deleteApiSharepointV1TenantsByTenantIdSitesBySiteIdMutation = (
  options?: Partial<
    Options<DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdData>
  >,
): UseMutationOptions<
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponse,
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdError,
  Options<DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponse,
    DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdError,
    Options<DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sharepoint_delete_site_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSharepointV1TenantsByTenantIdFolderScopesQueryKey = (
  options: Options<GetApiSharepointV1TenantsByTenantIdFolderScopesData>,
) =>
  createQueryKey(
    "get_api_sharepoint_v1_tenants_by_tenant_id_folder_scopes",
    options,
  );

/**
 * Sharepoint Get Folder Scopes V1
 */
export const getApiSharepointV1TenantsByTenantIdFolderScopesOptions = (
  options: Options<GetApiSharepointV1TenantsByTenantIdFolderScopesData>,
) =>
  queryOptions<
    GetApiSharepointV1TenantsByTenantIdFolderScopesResponse,
    GetApiSharepointV1TenantsByTenantIdFolderScopesError,
    GetApiSharepointV1TenantsByTenantIdFolderScopesResponse,
    ReturnType<typeof getApiSharepointV1TenantsByTenantIdFolderScopesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sharepoint_get_folder_scopes_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSharepointV1TenantsByTenantIdFolderScopesQueryKey(options),
  });

/**
 * Sharepoint Create Folder Scope V1
 */
export const postApiSharepointV1TenantsByTenantIdFolderScopesMutation = (
  options?: Partial<
    Options<PostApiSharepointV1TenantsByTenantIdFolderScopesData>
  >,
): UseMutationOptions<
  PostApiSharepointV1TenantsByTenantIdFolderScopesResponse,
  PostApiSharepointV1TenantsByTenantIdFolderScopesError,
  Options<PostApiSharepointV1TenantsByTenantIdFolderScopesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSharepointV1TenantsByTenantIdFolderScopesResponse,
    PostApiSharepointV1TenantsByTenantIdFolderScopesError,
    Options<PostApiSharepointV1TenantsByTenantIdFolderScopesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sharepoint_create_folder_scope_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sharepoint Delete Folder Scope V1
 */
export const deleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdMutation =
  (
    options?: Partial<
      Options<DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdData>
    >,
  ): UseMutationOptions<
    DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponse,
    DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdError,
    Options<DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponse,
      DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdError,
      Options<DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await sharepoint_delete_folder_scope_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Slack Post Chat Message V2
 */
export const postApiSlackV2TenantsByTenantIdActionsPostChatMessageMutation = (
  options?: Partial<
    Options<PostApiSlackV2TenantsByTenantIdActionsPostChatMessageData>
  >,
): UseMutationOptions<
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponse,
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageError,
  Options<PostApiSlackV2TenantsByTenantIdActionsPostChatMessageData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponse,
    PostApiSlackV2TenantsByTenantIdActionsPostChatMessageError,
    Options<PostApiSlackV2TenantsByTenantIdActionsPostChatMessageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_post_chat_message_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Update Chat Message V2
 */
export const postApiSlackV2TenantsByTenantIdActionsUpdateChatMessageMutation = (
  options?: Partial<
    Options<PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageData>
  >,
): UseMutationOptions<
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponse,
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageError,
  Options<PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponse,
    PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageError,
    Options<PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_update_chat_message_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Add Reaction V2
 */
export const postApiSlackV2TenantsByTenantIdActionsAddReactionMutation = (
  options?: Partial<
    Options<PostApiSlackV2TenantsByTenantIdActionsAddReactionData>
  >,
): UseMutationOptions<
  PostApiSlackV2TenantsByTenantIdActionsAddReactionResponse,
  PostApiSlackV2TenantsByTenantIdActionsAddReactionError,
  Options<PostApiSlackV2TenantsByTenantIdActionsAddReactionData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV2TenantsByTenantIdActionsAddReactionResponse,
    PostApiSlackV2TenantsByTenantIdActionsAddReactionError,
    Options<PostApiSlackV2TenantsByTenantIdActionsAddReactionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_add_reaction_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Set Channel Topic V2
 */
export const postApiSlackV2TenantsByTenantIdActionsSetChannelTopicMutation = (
  options?: Partial<
    Options<PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicData>
  >,
): UseMutationOptions<
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponse,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicError,
  Options<PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponse,
    PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicError,
    Options<PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_set_channel_topic_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Set Channel Description V2
 */
export const postApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionMutation =
  (
    options?: Partial<
      Options<PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionData>
    >,
  ): UseMutationOptions<
    PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponse,
    PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionError,
    Options<PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponse,
      PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionError,
      Options<PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await slack_set_channel_description_v2({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Slack Set Assistant Status V2
 */
export const postApiSlackV2TenantsByTenantIdActionsSetAssistantStatusMutation =
  (
    options?: Partial<
      Options<PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusData>
    >,
  ): UseMutationOptions<
    PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponse,
    PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusError,
    Options<PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponse,
      PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusError,
      Options<PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await slack_set_assistant_status_v2({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Slack Set Suggested Prompts V1
 */
export const postApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsMutation =
  (
    options?: Partial<
      Options<PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsData>
    >,
  ): UseMutationOptions<
    PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponse,
    PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsError,
    Options<PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponse,
      PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsError,
      Options<PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await slack_set_suggested_prompts_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Slack Set Assistant Title V1
 */
export const postApiSlackV1TenantsByTenantIdActionsSetAssistantTitleMutation = (
  options?: Partial<
    Options<PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleData>
  >,
): UseMutationOptions<
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponse,
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleError,
  Options<PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponse,
    PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleError,
    Options<PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_set_assistant_title_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Open View V1
 */
export const postApiSlackV1TenantsByTenantIdActionsViewsOpenMutation = (
  options?: Partial<
    Options<PostApiSlackV1TenantsByTenantIdActionsViewsOpenData>
  >,
): UseMutationOptions<
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponse,
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenError,
  Options<PostApiSlackV1TenantsByTenantIdActionsViewsOpenData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponse,
    PostApiSlackV1TenantsByTenantIdActionsViewsOpenError,
    Options<PostApiSlackV1TenantsByTenantIdActionsViewsOpenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_open_view_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Update View V1
 */
export const postApiSlackV1TenantsByTenantIdActionsViewsUpdateMutation = (
  options?: Partial<
    Options<PostApiSlackV1TenantsByTenantIdActionsViewsUpdateData>
  >,
): UseMutationOptions<
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponse,
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateError,
  Options<PostApiSlackV1TenantsByTenantIdActionsViewsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponse,
    PostApiSlackV1TenantsByTenantIdActionsViewsUpdateError,
    Options<PostApiSlackV1TenantsByTenantIdActionsViewsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_update_view_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Push View V1
 */
export const postApiSlackV1TenantsByTenantIdActionsViewsPushMutation = (
  options?: Partial<
    Options<PostApiSlackV1TenantsByTenantIdActionsViewsPushData>
  >,
): UseMutationOptions<
  PostApiSlackV1TenantsByTenantIdActionsViewsPushResponse,
  PostApiSlackV1TenantsByTenantIdActionsViewsPushError,
  Options<PostApiSlackV1TenantsByTenantIdActionsViewsPushData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV1TenantsByTenantIdActionsViewsPushResponse,
    PostApiSlackV1TenantsByTenantIdActionsViewsPushError,
    Options<PostApiSlackV1TenantsByTenantIdActionsViewsPushData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_push_view_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Publish Home View V1
 */
export const postApiSlackV1TenantsByTenantIdActionsViewsPublishHomeMutation = (
  options?: Partial<
    Options<PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeData>
  >,
): UseMutationOptions<
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponse,
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeError,
  Options<PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponse,
    PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeError,
    Options<PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_publish_home_view_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Download File V2
 */
export const postApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadMutation =
  (
    options?: Partial<
      Options<PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadData>
    >,
  ): UseMutationOptions<
    unknown,
    PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadError,
    Options<PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadData>
  > => {
    const mutationOptions: UseMutationOptions<
      unknown,
      PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadError,
      Options<PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await slack_download_file_v2({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Slack Upload Files V2
 */
export const postApiSlackV2TenantsByTenantIdActionsFilesUploadMutation = (
  options?: Partial<
    Options<PostApiSlackV2TenantsByTenantIdActionsFilesUploadData>
  >,
): UseMutationOptions<
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponse,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadError,
  Options<PostApiSlackV2TenantsByTenantIdActionsFilesUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponse,
    PostApiSlackV2TenantsByTenantIdActionsFilesUploadError,
    Options<PostApiSlackV2TenantsByTenantIdActionsFilesUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_upload_files_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Upload Content V2
 */
export const postApiSlackV2TenantsByTenantIdActionsFilesUploadContentMutation =
  (
    options?: Partial<
      Options<PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentData>
    >,
  ): UseMutationOptions<
    PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponse,
    PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentError,
    Options<PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponse,
      PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentError,
      Options<PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await slack_upload_content_v2({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiSlackV2TenantsByTenantIdActionsUsersByUserIdQueryKey = (
  options: Options<GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdData>,
) =>
  createQueryKey(
    "get_api_slack_v2_tenants_by_tenant_id_actions_users_by_user_id",
    options,
  );

/**
 * Slack Get User Info V2
 */
export const getApiSlackV2TenantsByTenantIdActionsUsersByUserIdOptions = (
  options: Options<GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdData>,
) =>
  queryOptions<
    GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponse,
    GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdError,
    GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponse,
    ReturnType<
      typeof getApiSlackV2TenantsByTenantIdActionsUsersByUserIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await slack_get_user_info_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiSlackV2TenantsByTenantIdActionsUsersByUserIdQueryKey(options),
  });

export const getApiSlackV2TenantsByTenantIdActionsUsersQueryKey = (
  options: Options<GetApiSlackV2TenantsByTenantIdActionsUsersData>,
) =>
  createQueryKey(
    "get_api_slack_v2_tenants_by_tenant_id_actions_users",
    options,
  );

/**
 * Slack List Users V2
 */
export const getApiSlackV2TenantsByTenantIdActionsUsersOptions = (
  options: Options<GetApiSlackV2TenantsByTenantIdActionsUsersData>,
) =>
  queryOptions<
    GetApiSlackV2TenantsByTenantIdActionsUsersResponse,
    GetApiSlackV2TenantsByTenantIdActionsUsersError,
    GetApiSlackV2TenantsByTenantIdActionsUsersResponse,
    ReturnType<typeof getApiSlackV2TenantsByTenantIdActionsUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await slack_list_users_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSlackV2TenantsByTenantIdActionsUsersQueryKey(options),
  });

export const getApiSlackV2TenantsByTenantIdActionsUsersInfiniteQueryKey = (
  options: Options<GetApiSlackV2TenantsByTenantIdActionsUsersData>,
): QueryKey<Options<GetApiSlackV2TenantsByTenantIdActionsUsersData>> =>
  createQueryKey(
    "get_api_slack_v2_tenants_by_tenant_id_actions_users",
    options,
    true,
  );

/**
 * Slack List Users V2
 */
export const getApiSlackV2TenantsByTenantIdActionsUsersInfiniteOptions = (
  options: Options<GetApiSlackV2TenantsByTenantIdActionsUsersData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSlackV2TenantsByTenantIdActionsUsersResponse,
    GetApiSlackV2TenantsByTenantIdActionsUsersError,
    InfiniteData<GetApiSlackV2TenantsByTenantIdActionsUsersResponse>,
    QueryKey<Options<GetApiSlackV2TenantsByTenantIdActionsUsersData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetApiSlackV2TenantsByTenantIdActionsUsersData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiSlackV2TenantsByTenantIdActionsUsersData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await slack_list_users_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSlackV2TenantsByTenantIdActionsUsersInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesQueryKey =
  (
    options: Options<GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesData>,
  ) =>
    createQueryKey(
      "get_api_slack_v2_tenants_by_tenant_id_actions_channels_by_channel_messages",
      options,
    );

/**
 * Slack Get Channel Messages V2
 */
export const getApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesOptions =
  (
    options: Options<GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesData>,
  ) =>
    queryOptions<
      GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponse,
      GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesError,
      GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponse,
      ReturnType<
        typeof getApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await slack_get_channel_messages_v2({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesQueryKey(
          options,
        ),
    });

export const getApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsQueryKey =
  (
    options: Options<GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsData>,
  ) =>
    createQueryKey(
      "get_api_slack_v2_tenants_by_tenant_id_actions_channels_by_channel_messages_by_ts_reactions",
      options,
    );

/**
 * Slack Get Reactions V2
 */
export const getApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsOptions =
  (
    options: Options<GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsData>,
  ) =>
    queryOptions<
      GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponse,
      GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsError,
      GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponse,
      ReturnType<
        typeof getApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await slack_get_reactions_v2({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsQueryKey(
          options,
        ),
    });

export const getApiSlackV1TenantsByTenantIdActionsUserGroupsQueryKey = (
  options: Options<GetApiSlackV1TenantsByTenantIdActionsUserGroupsData>,
) =>
  createQueryKey(
    "get_api_slack_v1_tenants_by_tenant_id_actions_user_groups",
    options,
  );

/**
 * Slack Get User Groups V1
 */
export const getApiSlackV1TenantsByTenantIdActionsUserGroupsOptions = (
  options: Options<GetApiSlackV1TenantsByTenantIdActionsUserGroupsData>,
) =>
  queryOptions<
    GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponse,
    GetApiSlackV1TenantsByTenantIdActionsUserGroupsError,
    GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponse,
    ReturnType<typeof getApiSlackV1TenantsByTenantIdActionsUserGroupsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await slack_get_user_groups_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSlackV1TenantsByTenantIdActionsUserGroupsQueryKey(options),
  });

export const getApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersQueryKey =
  (
    options: Options<GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersData>,
  ) =>
    createQueryKey(
      "get_api_slack_v1_tenants_by_tenant_id_actions_user_groups_by_usergroup_id_users",
      options,
    );

/**
 * Slack Get User Group Users V1
 */
export const getApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersOptions =
  (
    options: Options<GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersData>,
  ) =>
    queryOptions<
      GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponse,
      GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersError,
      GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponse,
      ReturnType<
        typeof getApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await slack_get_user_group_users_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersQueryKey(
          options,
        ),
    });

/**
 * Slack Update User Group Users V1
 */
export const postApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersMutation =
  (
    options?: Partial<
      Options<PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersData>
    >,
  ): UseMutationOptions<
    PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponse,
    PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersError,
    Options<PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponse,
      PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersError,
      Options<PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await slack_update_user_group_users_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Slack Update User Group V1
 */
export const postApiSlackV1TenantsByTenantIdActionsUpdateUserGroupMutation = (
  options?: Partial<
    Options<PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupData>
  >,
): UseMutationOptions<
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponse,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupError,
  Options<PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponse,
    PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupError,
    Options<PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_update_user_group_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSlackV1OauthScopesQueryKey = (
  options?: Options<GetApiSlackV1OauthScopesData>,
) => createQueryKey("get_api_slack_v1_oauth_scopes", options);

/**
 * Slack Get Oauth Scopes V1
 */
export const getApiSlackV1OauthScopesOptions = (
  options?: Options<GetApiSlackV1OauthScopesData>,
) =>
  queryOptions<
    GetApiSlackV1OauthScopesResponse,
    DefaultError,
    GetApiSlackV1OauthScopesResponse,
    ReturnType<typeof getApiSlackV1OauthScopesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await slack_get_oauth_scopes_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSlackV1OauthScopesQueryKey(options),
  });

export const getApiSlackV1TenantsQueryKey = (
  options?: Options<GetApiSlackV1TenantsData>,
) => createQueryKey("get_api_slack_v1_tenants", options);

/**
 * Slack Get Tenants V1
 */
export const getApiSlackV1TenantsOptions = (
  options?: Options<GetApiSlackV1TenantsData>,
) =>
  queryOptions<
    GetApiSlackV1TenantsResponse,
    GetApiSlackV1TenantsError,
    GetApiSlackV1TenantsResponse,
    ReturnType<typeof getApiSlackV1TenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await slack_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSlackV1TenantsQueryKey(options),
  });

export const getApiSlackV1TenantsInfiniteQueryKey = (
  options?: Options<GetApiSlackV1TenantsData>,
): QueryKey<Options<GetApiSlackV1TenantsData>> =>
  createQueryKey("get_api_slack_v1_tenants", options, true);

/**
 * Slack Get Tenants V1
 */
export const getApiSlackV1TenantsInfiniteOptions = (
  options?: Options<GetApiSlackV1TenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSlackV1TenantsResponse,
    GetApiSlackV1TenantsError,
    InfiniteData<GetApiSlackV1TenantsResponse>,
    QueryKey<Options<GetApiSlackV1TenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiSlackV1TenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiSlackV1TenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await slack_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiSlackV1TenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Slack Create Tenant V1
 */
export const postApiSlackV1TenantsMutation = (
  options?: Partial<Options<PostApiSlackV1TenantsData>>,
): UseMutationOptions<
  PostApiSlackV1TenantsResponse,
  PostApiSlackV1TenantsError,
  Options<PostApiSlackV1TenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV1TenantsResponse,
    PostApiSlackV1TenantsError,
    Options<PostApiSlackV1TenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSlackV1FullTenantsQueryKey = (
  options?: Options<GetApiSlackV1FullTenantsData>,
) => createQueryKey("get_api_slack_v1_full_tenants", options);

/**
 * Slack Get Full Tenants V1
 */
export const getApiSlackV1FullTenantsOptions = (
  options?: Options<GetApiSlackV1FullTenantsData>,
) =>
  queryOptions<
    GetApiSlackV1FullTenantsResponse,
    GetApiSlackV1FullTenantsError,
    GetApiSlackV1FullTenantsResponse,
    ReturnType<typeof getApiSlackV1FullTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await slack_get_full_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSlackV1FullTenantsQueryKey(options),
  });

export const getApiSlackV1FullTenantsInfiniteQueryKey = (
  options?: Options<GetApiSlackV1FullTenantsData>,
): QueryKey<Options<GetApiSlackV1FullTenantsData>> =>
  createQueryKey("get_api_slack_v1_full_tenants", options, true);

/**
 * Slack Get Full Tenants V1
 */
export const getApiSlackV1FullTenantsInfiniteOptions = (
  options?: Options<GetApiSlackV1FullTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiSlackV1FullTenantsResponse,
    GetApiSlackV1FullTenantsError,
    InfiniteData<GetApiSlackV1FullTenantsResponse>,
    QueryKey<Options<GetApiSlackV1FullTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiSlackV1FullTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiSlackV1FullTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await slack_get_full_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiSlackV1FullTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Slack Delete Tenant V1
 */
export const deleteApiSlackV1TenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiSlackV1TenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiSlackV1TenantsByTenantIdResponse,
  DeleteApiSlackV1TenantsByTenantIdError,
  Options<DeleteApiSlackV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiSlackV1TenantsByTenantIdResponse,
    DeleteApiSlackV1TenantsByTenantIdError,
    Options<DeleteApiSlackV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSlackV1TenantsByTenantIdQueryKey = (
  options: Options<GetApiSlackV1TenantsByTenantIdData>,
) => createQueryKey("get_api_slack_v1_tenants_by_tenant_id", options);

/**
 * Slack Get Tenant V1
 */
export const getApiSlackV1TenantsByTenantIdOptions = (
  options: Options<GetApiSlackV1TenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiSlackV1TenantsByTenantIdResponse,
    GetApiSlackV1TenantsByTenantIdError,
    GetApiSlackV1TenantsByTenantIdResponse,
    ReturnType<typeof getApiSlackV1TenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await slack_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSlackV1TenantsByTenantIdQueryKey(options),
  });

/**
 * Slack Patch Tenant V1
 */
export const patchApiSlackV1TenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiSlackV1TenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiSlackV1TenantsByTenantIdResponse,
  PatchApiSlackV1TenantsByTenantIdError,
  Options<PatchApiSlackV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiSlackV1TenantsByTenantIdResponse,
    PatchApiSlackV1TenantsByTenantIdError,
    Options<PatchApiSlackV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_patch_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSlackV1TenantsByTenantIdManifestQueryKey = (
  options: Options<GetApiSlackV1TenantsByTenantIdManifestData>,
) => createQueryKey("get_api_slack_v1_tenants_by_tenant_id_manifest", options);

/**
 * Slack Download Manifest V1
 */
export const getApiSlackV1TenantsByTenantIdManifestOptions = (
  options: Options<GetApiSlackV1TenantsByTenantIdManifestData>,
) =>
  queryOptions<
    GetApiSlackV1TenantsByTenantIdManifestResponse,
    GetApiSlackV1TenantsByTenantIdManifestError,
    GetApiSlackV1TenantsByTenantIdManifestResponse,
    ReturnType<typeof getApiSlackV1TenantsByTenantIdManifestQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await slack_download_manifest_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSlackV1TenantsByTenantIdManifestQueryKey(options),
  });

/**
 * Slack Connect Tenant V1
 */
export const postApiSlackV1TenantsByTenantIdConnectMutation = (
  options?: Partial<Options<PostApiSlackV1TenantsByTenantIdConnectData>>,
): UseMutationOptions<
  PostApiSlackV1TenantsByTenantIdConnectResponse,
  PostApiSlackV1TenantsByTenantIdConnectError,
  Options<PostApiSlackV1TenantsByTenantIdConnectData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV1TenantsByTenantIdConnectResponse,
    PostApiSlackV1TenantsByTenantIdConnectError,
    Options<PostApiSlackV1TenantsByTenantIdConnectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_connect_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Callback Tenant V1
 */
export const postApiSlackV1TenantsByTenantIdCallbackMutation = (
  options?: Partial<Options<PostApiSlackV1TenantsByTenantIdCallbackData>>,
): UseMutationOptions<
  PostApiSlackV1TenantsByTenantIdCallbackResponse,
  PostApiSlackV1TenantsByTenantIdCallbackError,
  Options<PostApiSlackV1TenantsByTenantIdCallbackData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiSlackV1TenantsByTenantIdCallbackResponse,
    PostApiSlackV1TenantsByTenantIdCallbackError,
    Options<PostApiSlackV1TenantsByTenantIdCallbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_callback_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiSlackV1TenantsByTenantIdCheckConnectionQueryKey = (
  options: Options<GetApiSlackV1TenantsByTenantIdCheckConnectionData>,
) =>
  createQueryKey(
    "get_api_slack_v1_tenants_by_tenant_id_check_connection",
    options,
  );

/**
 * Slack Check Connection V1
 */
export const getApiSlackV1TenantsByTenantIdCheckConnectionOptions = (
  options: Options<GetApiSlackV1TenantsByTenantIdCheckConnectionData>,
) =>
  queryOptions<
    GetApiSlackV1TenantsByTenantIdCheckConnectionResponse,
    GetApiSlackV1TenantsByTenantIdCheckConnectionError,
    GetApiSlackV1TenantsByTenantIdCheckConnectionResponse,
    ReturnType<typeof getApiSlackV1TenantsByTenantIdCheckConnectionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await slack_check_connection_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiSlackV1TenantsByTenantIdCheckConnectionQueryKey(options),
  });

export const getApiV2TasksQueryKey = (options?: Options<GetApiV2TasksData>) =>
  createQueryKey("get_api_v2_tasks", options);

/**
 * Get Tasks V2
 */
export const getApiV2TasksOptions = (options?: Options<GetApiV2TasksData>) =>
  queryOptions<
    GetApiV2TasksResponse,
    GetApiV2TasksError,
    GetApiV2TasksResponse,
    ReturnType<typeof getApiV2TasksQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_tasks_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2TasksQueryKey(options),
  });

export const getApiV2TasksInfiniteQueryKey = (
  options?: Options<GetApiV2TasksData>,
): QueryKey<Options<GetApiV2TasksData>> =>
  createQueryKey("get_api_v2_tasks", options, true);

/**
 * Get Tasks V2
 */
export const getApiV2TasksInfiniteOptions = (
  options?: Options<GetApiV2TasksData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV2TasksResponse,
    GetApiV2TasksError,
    InfiniteData<GetApiV2TasksResponse>,
    QueryKey<Options<GetApiV2TasksData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV2TasksData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV2TasksData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_tasks_v2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV2TasksInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Task V2
 */
export const postApiV2TasksMutation = (
  options?: Partial<Options<PostApiV2TasksData>>,
): UseMutationOptions<
  PostApiV2TasksResponse,
  PostApiV2TasksError,
  Options<PostApiV2TasksData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2TasksResponse,
    PostApiV2TasksError,
    Options<PostApiV2TasksData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_task_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Task V2
 */
export const deleteApiV2TasksByTaskIdMutation = (
  options?: Partial<Options<DeleteApiV2TasksByTaskIdData>>,
): UseMutationOptions<
  DeleteApiV2TasksByTaskIdResponse,
  DeleteApiV2TasksByTaskIdError,
  Options<DeleteApiV2TasksByTaskIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV2TasksByTaskIdResponse,
    DeleteApiV2TasksByTaskIdError,
    Options<DeleteApiV2TasksByTaskIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_task_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV2TasksByTaskIdQueryKey = (
  options: Options<GetApiV2TasksByTaskIdData>,
) => createQueryKey("get_api_v2_tasks_by_task_id", options);

/**
 * Get Task V2
 */
export const getApiV2TasksByTaskIdOptions = (
  options: Options<GetApiV2TasksByTaskIdData>,
) =>
  queryOptions<
    GetApiV2TasksByTaskIdResponse,
    GetApiV2TasksByTaskIdError,
    GetApiV2TasksByTaskIdResponse,
    ReturnType<typeof getApiV2TasksByTaskIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_task_v2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV2TasksByTaskIdQueryKey(options),
  });

/**
 * Update Task V2
 */
export const patchApiV2TasksByTaskIdMutation = (
  options?: Partial<Options<PatchApiV2TasksByTaskIdData>>,
): UseMutationOptions<
  PatchApiV2TasksByTaskIdResponse,
  PatchApiV2TasksByTaskIdError,
  Options<PatchApiV2TasksByTaskIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV2TasksByTaskIdResponse,
    PatchApiV2TasksByTaskIdError,
    Options<PatchApiV2TasksByTaskIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_task_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Task V2
 */
export const postApiV2TasksByTaskIdRestoreMutation = (
  options?: Partial<Options<PostApiV2TasksByTaskIdRestoreData>>,
): UseMutationOptions<
  PostApiV2TasksByTaskIdRestoreResponse,
  PostApiV2TasksByTaskIdRestoreError,
  Options<PostApiV2TasksByTaskIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV2TasksByTaskIdRestoreResponse,
    PostApiV2TasksByTaskIdRestoreError,
    Options<PostApiV2TasksByTaskIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_task_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Teams Post Message V1
 */
export const postApiTeamsV1TenantsByTenantIdActionsMessagesPostMutation = (
  options?: Partial<
    Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesPostData>
  >,
): UseMutationOptions<
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponse,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostError,
  Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesPostData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponse,
    PostApiTeamsV1TenantsByTenantIdActionsMessagesPostError,
    Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teams_post_message_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Teams Update Message V1
 */
export const postApiTeamsV1TenantsByTenantIdActionsMessagesUpdateMutation = (
  options?: Partial<
    Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateData>
  >,
): UseMutationOptions<
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponse,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateError,
  Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponse,
    PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateError,
    Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teams_update_message_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Teams Delete Message V1
 */
export const postApiTeamsV1TenantsByTenantIdActionsMessagesDeleteMutation = (
  options?: Partial<
    Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteData>
  >,
): UseMutationOptions<
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponse,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteError,
  Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponse,
    PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteError,
    Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teams_delete_message_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Teams Send Proactive Message V1
 */
export const postApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveMutation =
  (
    options?: Partial<
      Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveData>
    >,
  ): UseMutationOptions<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponse,
    PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveError,
    Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponse,
      PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveError,
      Options<PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await teams_send_proactive_message_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Teams Download File V1
 */
export const postApiTeamsV1TenantsByTenantIdActionsFilesDownloadMutation = (
  options?: Partial<
    Options<PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadData>
  >,
): UseMutationOptions<
  unknown,
  PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadError,
  Options<PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadError,
    Options<PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teams_download_file_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Teams Get Conversation Member V1
 */
export const postApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetMutation =
  (
    options?: Partial<
      Options<PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetData>
    >,
  ): UseMutationOptions<
    PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponse,
    PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetError,
    Options<PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponse,
      PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetError,
      Options<PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await teams_get_conversation_member_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Teams List Conversation Members V1
 */
export const postApiTeamsV1TenantsByTenantIdActionsConversationsMembersListMutation =
  (
    options?: Partial<
      Options<PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListData>
    >,
  ): UseMutationOptions<
    PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponse,
    PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListError,
    Options<PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponse,
      PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListError,
      Options<PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await teams_list_conversation_members_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Teams List Conversation Activities V1
 */
export const postApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListMutation =
  (
    options?: Partial<
      Options<PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListData>
    >,
  ): UseMutationOptions<
    PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponse,
    PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListError,
    Options<PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponse,
      PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListError,
      Options<PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await teams_list_conversation_activities_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiTeamsV1TenantsQueryKey = (
  options?: Options<GetApiTeamsV1TenantsData>,
) => createQueryKey("get_api_teams_v1_tenants", options);

/**
 * Teams Get Tenants V1
 */
export const getApiTeamsV1TenantsOptions = (
  options?: Options<GetApiTeamsV1TenantsData>,
) =>
  queryOptions<
    GetApiTeamsV1TenantsResponse,
    GetApiTeamsV1TenantsError,
    GetApiTeamsV1TenantsResponse,
    ReturnType<typeof getApiTeamsV1TenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await teams_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiTeamsV1TenantsQueryKey(options),
  });

export const getApiTeamsV1TenantsInfiniteQueryKey = (
  options?: Options<GetApiTeamsV1TenantsData>,
): QueryKey<Options<GetApiTeamsV1TenantsData>> =>
  createQueryKey("get_api_teams_v1_tenants", options, true);

/**
 * Teams Get Tenants V1
 */
export const getApiTeamsV1TenantsInfiniteOptions = (
  options?: Options<GetApiTeamsV1TenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiTeamsV1TenantsResponse,
    GetApiTeamsV1TenantsError,
    InfiniteData<GetApiTeamsV1TenantsResponse>,
    QueryKey<Options<GetApiTeamsV1TenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiTeamsV1TenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiTeamsV1TenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await teams_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiTeamsV1TenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Teams Create Tenant V1
 */
export const postApiTeamsV1TenantsMutation = (
  options?: Partial<Options<PostApiTeamsV1TenantsData>>,
): UseMutationOptions<
  PostApiTeamsV1TenantsResponse,
  PostApiTeamsV1TenantsError,
  Options<PostApiTeamsV1TenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiTeamsV1TenantsResponse,
    PostApiTeamsV1TenantsError,
    Options<PostApiTeamsV1TenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teams_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiTeamsV1FullTenantsQueryKey = (
  options?: Options<GetApiTeamsV1FullTenantsData>,
) => createQueryKey("get_api_teams_v1_full_tenants", options);

/**
 * Teams Get Full Tenants V1
 */
export const getApiTeamsV1FullTenantsOptions = (
  options?: Options<GetApiTeamsV1FullTenantsData>,
) =>
  queryOptions<
    GetApiTeamsV1FullTenantsResponse,
    GetApiTeamsV1FullTenantsError,
    GetApiTeamsV1FullTenantsResponse,
    ReturnType<typeof getApiTeamsV1FullTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await teams_get_full_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiTeamsV1FullTenantsQueryKey(options),
  });

export const getApiTeamsV1FullTenantsInfiniteQueryKey = (
  options?: Options<GetApiTeamsV1FullTenantsData>,
): QueryKey<Options<GetApiTeamsV1FullTenantsData>> =>
  createQueryKey("get_api_teams_v1_full_tenants", options, true);

/**
 * Teams Get Full Tenants V1
 */
export const getApiTeamsV1FullTenantsInfiniteOptions = (
  options?: Options<GetApiTeamsV1FullTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiTeamsV1FullTenantsResponse,
    GetApiTeamsV1FullTenantsError,
    InfiniteData<GetApiTeamsV1FullTenantsResponse>,
    QueryKey<Options<GetApiTeamsV1FullTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiTeamsV1FullTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiTeamsV1FullTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await teams_get_full_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiTeamsV1FullTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Teams Delete Tenant V1
 */
export const deleteApiTeamsV1TenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiTeamsV1TenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiTeamsV1TenantsByTenantIdResponse,
  DeleteApiTeamsV1TenantsByTenantIdError,
  Options<DeleteApiTeamsV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiTeamsV1TenantsByTenantIdResponse,
    DeleteApiTeamsV1TenantsByTenantIdError,
    Options<DeleteApiTeamsV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teams_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiTeamsV1TenantsByTenantIdQueryKey = (
  options: Options<GetApiTeamsV1TenantsByTenantIdData>,
) => createQueryKey("get_api_teams_v1_tenants_by_tenant_id", options);

/**
 * Teams Get Tenant V1
 */
export const getApiTeamsV1TenantsByTenantIdOptions = (
  options: Options<GetApiTeamsV1TenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiTeamsV1TenantsByTenantIdResponse,
    GetApiTeamsV1TenantsByTenantIdError,
    GetApiTeamsV1TenantsByTenantIdResponse,
    ReturnType<typeof getApiTeamsV1TenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await teams_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiTeamsV1TenantsByTenantIdQueryKey(options),
  });

/**
 * Teams Patch Tenant V1
 */
export const patchApiTeamsV1TenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiTeamsV1TenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiTeamsV1TenantsByTenantIdResponse,
  PatchApiTeamsV1TenantsByTenantIdError,
  Options<PatchApiTeamsV1TenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiTeamsV1TenantsByTenantIdResponse,
    PatchApiTeamsV1TenantsByTenantIdError,
    Options<PatchApiTeamsV1TenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teams_patch_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Teams Check Connection V1
 */
export const postApiTeamsV1TenantsByTenantIdActionsCheckConnectionMutation = (
  options?: Partial<
    Options<PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionData>
  >,
): UseMutationOptions<
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponse,
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionError,
  Options<PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponse,
    PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionError,
    Options<PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teams_check_connection_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiTeamsV1TenantsByTenantIdIconsQueryKey = (
  options: Options<GetApiTeamsV1TenantsByTenantIdIconsData>,
) => createQueryKey("get_api_teams_v1_tenants_by_tenant_id_icons", options);

/**
 * Teams Get Icon V1
 */
export const getApiTeamsV1TenantsByTenantIdIconsOptions = (
  options: Options<GetApiTeamsV1TenantsByTenantIdIconsData>,
) =>
  queryOptions<
    unknown,
    GetApiTeamsV1TenantsByTenantIdIconsError,
    unknown,
    ReturnType<typeof getApiTeamsV1TenantsByTenantIdIconsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await teams_get_icon_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiTeamsV1TenantsByTenantIdIconsQueryKey(options),
  });

/**
 * Teams Upload Icon V1
 */
export const postApiTeamsV1TenantsByTenantIdIconsMutation = (
  options?: Partial<Options<PostApiTeamsV1TenantsByTenantIdIconsData>>,
): UseMutationOptions<
  PostApiTeamsV1TenantsByTenantIdIconsResponse,
  PostApiTeamsV1TenantsByTenantIdIconsError,
  Options<PostApiTeamsV1TenantsByTenantIdIconsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiTeamsV1TenantsByTenantIdIconsResponse,
    PostApiTeamsV1TenantsByTenantIdIconsError,
    Options<PostApiTeamsV1TenantsByTenantIdIconsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teams_upload_icon_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiTeamsV1TenantsByTenantIdManifestQueryKey = (
  options: Options<GetApiTeamsV1TenantsByTenantIdManifestData>,
) => createQueryKey("get_api_teams_v1_tenants_by_tenant_id_manifest", options);

/**
 * Teams Download Manifest V1
 */
export const getApiTeamsV1TenantsByTenantIdManifestOptions = (
  options: Options<GetApiTeamsV1TenantsByTenantIdManifestData>,
) =>
  queryOptions<
    unknown,
    GetApiTeamsV1TenantsByTenantIdManifestError,
    unknown,
    ReturnType<typeof getApiTeamsV1TenantsByTenantIdManifestQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await teams_download_manifest_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiTeamsV1TenantsByTenantIdManifestQueryKey(options),
  });

export const getApiTeamsV1TenantsByTenantIdInstallsQueryKey = (
  options: Options<GetApiTeamsV1TenantsByTenantIdInstallsData>,
) => createQueryKey("get_api_teams_v1_tenants_by_tenant_id_installs", options);

/**
 * Teams Get Installs V1
 */
export const getApiTeamsV1TenantsByTenantIdInstallsOptions = (
  options: Options<GetApiTeamsV1TenantsByTenantIdInstallsData>,
) =>
  queryOptions<
    GetApiTeamsV1TenantsByTenantIdInstallsResponse,
    GetApiTeamsV1TenantsByTenantIdInstallsError,
    GetApiTeamsV1TenantsByTenantIdInstallsResponse,
    ReturnType<typeof getApiTeamsV1TenantsByTenantIdInstallsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await teams_get_installs_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiTeamsV1TenantsByTenantIdInstallsQueryKey(options),
  });

export const getApiTeamsV1TenantsByTenantIdInstallsInfiniteQueryKey = (
  options: Options<GetApiTeamsV1TenantsByTenantIdInstallsData>,
): QueryKey<Options<GetApiTeamsV1TenantsByTenantIdInstallsData>> =>
  createQueryKey(
    "get_api_teams_v1_tenants_by_tenant_id_installs",
    options,
    true,
  );

/**
 * Teams Get Installs V1
 */
export const getApiTeamsV1TenantsByTenantIdInstallsInfiniteOptions = (
  options: Options<GetApiTeamsV1TenantsByTenantIdInstallsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiTeamsV1TenantsByTenantIdInstallsResponse,
    GetApiTeamsV1TenantsByTenantIdInstallsError,
    InfiniteData<GetApiTeamsV1TenantsByTenantIdInstallsResponse>,
    QueryKey<Options<GetApiTeamsV1TenantsByTenantIdInstallsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiTeamsV1TenantsByTenantIdInstallsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiTeamsV1TenantsByTenantIdInstallsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await teams_get_installs_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiTeamsV1TenantsByTenantIdInstallsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1UsageStatsAgentsQueryKey = (
  options: Options<GetApiV1UsageStatsAgentsData>,
) => createQueryKey("get_api_v1_usage_stats_agents", options);

/**
 * Get Agent Usage Stats V1
 */
export const getApiV1UsageStatsAgentsOptions = (
  options: Options<GetApiV1UsageStatsAgentsData>,
) =>
  queryOptions<
    GetApiV1UsageStatsAgentsResponse,
    GetApiV1UsageStatsAgentsError,
    GetApiV1UsageStatsAgentsResponse,
    ReturnType<typeof getApiV1UsageStatsAgentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_agent_usage_stats_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1UsageStatsAgentsQueryKey(options),
  });

export const getApiV1UsersQueryKey = (options?: Options<GetApiV1UsersData>) =>
  createQueryKey("get_api_v1_users", options);

/**
 * Get Users V1
 */
export const getApiV1UsersOptions = (options?: Options<GetApiV1UsersData>) =>
  queryOptions<
    GetApiV1UsersResponse,
    GetApiV1UsersError,
    GetApiV1UsersResponse,
    ReturnType<typeof getApiV1UsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_users_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1UsersQueryKey(options),
  });

export const getApiV1UsersInfiniteQueryKey = (
  options?: Options<GetApiV1UsersData>,
): QueryKey<Options<GetApiV1UsersData>> =>
  createQueryKey("get_api_v1_users", options, true);

/**
 * Get Users V1
 */
export const getApiV1UsersInfiniteOptions = (
  options?: Options<GetApiV1UsersData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1UsersResponse,
    GetApiV1UsersError,
    InfiniteData<GetApiV1UsersResponse>,
    QueryKey<Options<GetApiV1UsersData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1UsersData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1UsersData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_users_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1UsersInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1UsersMeQueryKey = (
  options?: Options<GetApiV1UsersMeData>,
) => createQueryKey("get_api_v1_users_me", options);

/**
 * Get Current User V1
 */
export const getApiV1UsersMeOptions = (
  options?: Options<GetApiV1UsersMeData>,
) =>
  queryOptions<
    GetApiV1UsersMeResponse,
    DefaultError,
    GetApiV1UsersMeResponse,
    ReturnType<typeof getApiV1UsersMeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_current_user_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1UsersMeQueryKey(options),
  });

/**
 * Update Current User V1
 */
export const patchApiV1UsersMeMutation = (
  options?: Partial<Options<PatchApiV1UsersMeData>>,
): UseMutationOptions<
  PatchApiV1UsersMeResponse,
  PatchApiV1UsersMeError,
  Options<PatchApiV1UsersMeData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1UsersMeResponse,
    PatchApiV1UsersMeError,
    Options<PatchApiV1UsersMeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_current_user_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete User V1
 */
export const deleteApiV1UsersByUserIdMutation = (
  options?: Partial<Options<DeleteApiV1UsersByUserIdData>>,
): UseMutationOptions<
  DeleteApiV1UsersByUserIdResponse,
  DeleteApiV1UsersByUserIdError,
  Options<DeleteApiV1UsersByUserIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1UsersByUserIdResponse,
    DeleteApiV1UsersByUserIdError,
    Options<DeleteApiV1UsersByUserIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_user_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1UsersByUserIdQueryKey = (
  options: Options<GetApiV1UsersByUserIdData>,
) => createQueryKey("get_api_v1_users_by_user_id", options);

/**
 * Get User V1
 */
export const getApiV1UsersByUserIdOptions = (
  options: Options<GetApiV1UsersByUserIdData>,
) =>
  queryOptions<
    GetApiV1UsersByUserIdResponse,
    GetApiV1UsersByUserIdError,
    GetApiV1UsersByUserIdResponse,
    ReturnType<typeof getApiV1UsersByUserIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_user_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1UsersByUserIdQueryKey(options),
  });

/**
 * Create Bot User V1
 */
export const postApiV1UsersBotMutation = (
  options?: Partial<Options<PostApiV1UsersBotData>>,
): UseMutationOptions<
  PostApiV1UsersBotResponse,
  PostApiV1UsersBotError,
  Options<PostApiV1UsersBotData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1UsersBotResponse,
    PostApiV1UsersBotError,
    Options<PostApiV1UsersBotData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_bot_user_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upsert External User V1
 */
export const putApiV1UsersExternalByExternalIdMutation = (
  options?: Partial<Options<PutApiV1UsersExternalByExternalIdData>>,
): UseMutationOptions<
  PutApiV1UsersExternalByExternalIdResponse,
  PutApiV1UsersExternalByExternalIdError,
  Options<PutApiV1UsersExternalByExternalIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiV1UsersExternalByExternalIdResponse,
    PutApiV1UsersExternalByExternalIdError,
    Options<PutApiV1UsersExternalByExternalIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsert_external_user_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore User V1
 */
export const postApiV1UsersByUserIdRestoreMutation = (
  options?: Partial<Options<PostApiV1UsersByUserIdRestoreData>>,
): UseMutationOptions<
  PostApiV1UsersByUserIdRestoreResponse,
  PostApiV1UsersByUserIdRestoreError,
  Options<PostApiV1UsersByUserIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1UsersByUserIdRestoreResponse,
    PostApiV1UsersByUserIdRestoreError,
    Options<PostApiV1UsersByUserIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_user_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Work Claim V1
 */
export const postApiV1WorkClaimsMutation = (
  options?: Partial<Options<PostApiV1WorkClaimsData>>,
): UseMutationOptions<
  PostApiV1WorkClaimsResponse,
  PostApiV1WorkClaimsError,
  Options<PostApiV1WorkClaimsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1WorkClaimsResponse,
    PostApiV1WorkClaimsError,
    Options<PostApiV1WorkClaimsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_work_claim_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Complete Work Claim V1
 */
export const postApiV1WorkClaimsByClaimIdCompleteMutation = (
  options?: Partial<Options<PostApiV1WorkClaimsByClaimIdCompleteData>>,
): UseMutationOptions<
  PostApiV1WorkClaimsByClaimIdCompleteResponse,
  PostApiV1WorkClaimsByClaimIdCompleteError,
  Options<PostApiV1WorkClaimsByClaimIdCompleteData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1WorkClaimsByClaimIdCompleteResponse,
    PostApiV1WorkClaimsByClaimIdCompleteError,
    Options<PostApiV1WorkClaimsByClaimIdCompleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await complete_work_claim_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Work Claim V1
 */
export const deleteApiV1WorkClaimsByClaimIdMutation = (
  options?: Partial<Options<DeleteApiV1WorkClaimsByClaimIdData>>,
): UseMutationOptions<
  DeleteApiV1WorkClaimsByClaimIdResponse,
  DeleteApiV1WorkClaimsByClaimIdError,
  Options<DeleteApiV1WorkClaimsByClaimIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1WorkClaimsByClaimIdResponse,
    DeleteApiV1WorkClaimsByClaimIdError,
    Options<DeleteApiV1WorkClaimsByClaimIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_work_claim_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Work Event V1
 */
export const postApiV1WorkEventsMutation = (
  options?: Partial<Options<PostApiV1WorkEventsData>>,
): UseMutationOptions<
  PostApiV1WorkEventsResponse,
  PostApiV1WorkEventsError,
  Options<PostApiV1WorkEventsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1WorkEventsResponse,
    PostApiV1WorkEventsError,
    Options<PostApiV1WorkEventsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_work_event_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1WorkEventsByEventIdQueryKey = (
  options: Options<GetApiV1WorkEventsByEventIdData>,
) => createQueryKey("get_api_v1_work_events_by_event_id", options);

/**
 * Get Work Event V1
 */
export const getApiV1WorkEventsByEventIdOptions = (
  options: Options<GetApiV1WorkEventsByEventIdData>,
) =>
  queryOptions<
    GetApiV1WorkEventsByEventIdResponse,
    GetApiV1WorkEventsByEventIdError,
    GetApiV1WorkEventsByEventIdResponse,
    ReturnType<typeof getApiV1WorkEventsByEventIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_work_event_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1WorkEventsByEventIdQueryKey(options),
  });

export const getApiV1FullWorkEventsQueryKey = (
  options?: Options<GetApiV1FullWorkEventsData>,
) => createQueryKey("get_api_v1_full_work_events", options);

/**
 * Get Full Work Events V1
 */
export const getApiV1FullWorkEventsOptions = (
  options?: Options<GetApiV1FullWorkEventsData>,
) =>
  queryOptions<
    GetApiV1FullWorkEventsResponse,
    GetApiV1FullWorkEventsError,
    GetApiV1FullWorkEventsResponse,
    ReturnType<typeof getApiV1FullWorkEventsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_work_events_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullWorkEventsQueryKey(options),
  });

export const getApiV1FullWorkEventsInfiniteQueryKey = (
  options?: Options<GetApiV1FullWorkEventsData>,
): QueryKey<Options<GetApiV1FullWorkEventsData>> =>
  createQueryKey("get_api_v1_full_work_events", options, true);

/**
 * Get Full Work Events V1
 */
export const getApiV1FullWorkEventsInfiniteOptions = (
  options?: Options<GetApiV1FullWorkEventsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullWorkEventsResponse,
    GetApiV1FullWorkEventsError,
    InfiniteData<GetApiV1FullWorkEventsResponse>,
    QueryKey<Options<GetApiV1FullWorkEventsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetApiV1FullWorkEventsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullWorkEventsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_work_events_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullWorkEventsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1WorkflowsQueryKey = (
  options?: Options<GetApiV1WorkflowsData>,
) => createQueryKey("get_api_v1_workflows", options);

/**
 * Get Workflows V1
 */
export const getApiV1WorkflowsOptions = (
  options?: Options<GetApiV1WorkflowsData>,
) =>
  queryOptions<
    GetApiV1WorkflowsResponse,
    GetApiV1WorkflowsError,
    GetApiV1WorkflowsResponse,
    ReturnType<typeof getApiV1WorkflowsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_workflows_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1WorkflowsQueryKey(options),
  });

export const getApiV1WorkflowsInfiniteQueryKey = (
  options?: Options<GetApiV1WorkflowsData>,
): QueryKey<Options<GetApiV1WorkflowsData>> =>
  createQueryKey("get_api_v1_workflows", options, true);

/**
 * Get Workflows V1
 */
export const getApiV1WorkflowsInfiniteOptions = (
  options?: Options<GetApiV1WorkflowsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1WorkflowsResponse,
    GetApiV1WorkflowsError,
    InfiniteData<GetApiV1WorkflowsResponse>,
    QueryKey<Options<GetApiV1WorkflowsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1WorkflowsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1WorkflowsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_workflows_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1WorkflowsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1FullWorkflowRunsQueryKey = (
  options?: Options<GetApiV1FullWorkflowRunsData>,
) => createQueryKey("get_api_v1_full_workflow_runs", options);

/**
 * Get Workflow Runs V1
 */
export const getApiV1FullWorkflowRunsOptions = (
  options?: Options<GetApiV1FullWorkflowRunsData>,
) =>
  queryOptions<
    GetApiV1FullWorkflowRunsResponse,
    GetApiV1FullWorkflowRunsError,
    GetApiV1FullWorkflowRunsResponse,
    ReturnType<typeof getApiV1FullWorkflowRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_workflow_runs_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1FullWorkflowRunsQueryKey(options),
  });

export const getApiV1FullWorkflowRunsInfiniteQueryKey = (
  options?: Options<GetApiV1FullWorkflowRunsData>,
): QueryKey<Options<GetApiV1FullWorkflowRunsData>> =>
  createQueryKey("get_api_v1_full_workflow_runs", options, true);

/**
 * Get Workflow Runs V1
 */
export const getApiV1FullWorkflowRunsInfiniteOptions = (
  options?: Options<GetApiV1FullWorkflowRunsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1FullWorkflowRunsResponse,
    GetApiV1FullWorkflowRunsError,
    InfiniteData<GetApiV1FullWorkflowRunsResponse>,
    QueryKey<Options<GetApiV1FullWorkflowRunsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1FullWorkflowRunsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1FullWorkflowRunsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_workflow_runs_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1FullWorkflowRunsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1WorkflowRunsByWorkflowRunIdQueryKey = (
  options: Options<GetApiV1WorkflowRunsByWorkflowRunIdData>,
) => createQueryKey("get_api_v1_workflow_runs_by_workflow_run_id", options);

/**
 * Get Workflow Run V1
 */
export const getApiV1WorkflowRunsByWorkflowRunIdOptions = (
  options: Options<GetApiV1WorkflowRunsByWorkflowRunIdData>,
) =>
  queryOptions<
    GetApiV1WorkflowRunsByWorkflowRunIdResponse,
    GetApiV1WorkflowRunsByWorkflowRunIdError,
    GetApiV1WorkflowRunsByWorkflowRunIdResponse,
    ReturnType<typeof getApiV1WorkflowRunsByWorkflowRunIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_workflow_run_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1WorkflowRunsByWorkflowRunIdQueryKey(options),
  });

/**
 * Update Workflow Run V1
 */
export const patchApiV1WorkflowRunsByWorkflowRunIdMutation = (
  options?: Partial<Options<PatchApiV1WorkflowRunsByWorkflowRunIdData>>,
): UseMutationOptions<
  PatchApiV1WorkflowRunsByWorkflowRunIdResponse,
  PatchApiV1WorkflowRunsByWorkflowRunIdError,
  Options<PatchApiV1WorkflowRunsByWorkflowRunIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1WorkflowRunsByWorkflowRunIdResponse,
    PatchApiV1WorkflowRunsByWorkflowRunIdError,
    Options<PatchApiV1WorkflowRunsByWorkflowRunIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_workflow_run_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1WorkflowAnalyticsEventsQueryKey = (
  options?: Options<GetApiV1WorkflowAnalyticsEventsData>,
) => createQueryKey("get_api_v1_workflow_analytics_events", options);

/**
 * Get Workflow Run Analytics Events V1
 */
export const getApiV1WorkflowAnalyticsEventsOptions = (
  options?: Options<GetApiV1WorkflowAnalyticsEventsData>,
) =>
  queryOptions<
    GetApiV1WorkflowAnalyticsEventsResponse,
    GetApiV1WorkflowAnalyticsEventsError,
    GetApiV1WorkflowAnalyticsEventsResponse,
    ReturnType<typeof getApiV1WorkflowAnalyticsEventsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_workflow_run_analytics_events_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1WorkflowAnalyticsEventsQueryKey(options),
  });

export const getApiV1WorkflowAnalyticsEventsInfiniteQueryKey = (
  options?: Options<GetApiV1WorkflowAnalyticsEventsData>,
): QueryKey<Options<GetApiV1WorkflowAnalyticsEventsData>> =>
  createQueryKey("get_api_v1_workflow_analytics_events", options, true);

/**
 * Get Workflow Run Analytics Events V1
 */
export const getApiV1WorkflowAnalyticsEventsInfiniteOptions = (
  options?: Options<GetApiV1WorkflowAnalyticsEventsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1WorkflowAnalyticsEventsResponse,
    GetApiV1WorkflowAnalyticsEventsError,
    InfiniteData<GetApiV1WorkflowAnalyticsEventsResponse>,
    QueryKey<Options<GetApiV1WorkflowAnalyticsEventsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1WorkflowAnalyticsEventsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1WorkflowAnalyticsEventsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_workflow_run_analytics_events_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1WorkflowAnalyticsEventsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Workflow Analytics Event V1
 */
export const postApiV1WorkflowAnalyticsEventsMutation = (
  options?: Partial<Options<PostApiV1WorkflowAnalyticsEventsData>>,
): UseMutationOptions<
  PostApiV1WorkflowAnalyticsEventsResponse,
  PostApiV1WorkflowAnalyticsEventsError,
  Options<PostApiV1WorkflowAnalyticsEventsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1WorkflowAnalyticsEventsResponse,
    PostApiV1WorkflowAnalyticsEventsError,
    Options<PostApiV1WorkflowAnalyticsEventsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_workflow_analytics_event_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1WorkspacesQueryKey = (
  options?: Options<GetApiV1WorkspacesData>,
) => createQueryKey("get_api_v1_workspaces", options);

/**
 * Get Workspaces V1
 */
export const getApiV1WorkspacesOptions = (
  options?: Options<GetApiV1WorkspacesData>,
) =>
  queryOptions<
    GetApiV1WorkspacesResponse,
    GetApiV1WorkspacesError,
    GetApiV1WorkspacesResponse,
    ReturnType<typeof getApiV1WorkspacesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_workspaces_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1WorkspacesQueryKey(options),
  });

export const getApiV1WorkspacesInfiniteQueryKey = (
  options?: Options<GetApiV1WorkspacesData>,
): QueryKey<Options<GetApiV1WorkspacesData>> =>
  createQueryKey("get_api_v1_workspaces", options, true);

/**
 * Get Workspaces V1
 */
export const getApiV1WorkspacesInfiniteOptions = (
  options?: Options<GetApiV1WorkspacesData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1WorkspacesResponse,
    GetApiV1WorkspacesError,
    InfiniteData<GetApiV1WorkspacesResponse>,
    QueryKey<Options<GetApiV1WorkspacesData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1WorkspacesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1WorkspacesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_workspaces_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1WorkspacesInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Workspace V1
 */
export const postApiV1WorkspacesMutation = (
  options?: Partial<Options<PostApiV1WorkspacesData>>,
): UseMutationOptions<
  PostApiV1WorkspacesResponse,
  DefaultError,
  Options<PostApiV1WorkspacesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1WorkspacesResponse,
    DefaultError,
    Options<PostApiV1WorkspacesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_workspace_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Workspace V1
 */
export const deleteApiV1WorkspacesByWorkspaceIdMutation = (
  options?: Partial<Options<DeleteApiV1WorkspacesByWorkspaceIdData>>,
): UseMutationOptions<
  DeleteApiV1WorkspacesByWorkspaceIdResponse,
  DeleteApiV1WorkspacesByWorkspaceIdError,
  Options<DeleteApiV1WorkspacesByWorkspaceIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1WorkspacesByWorkspaceIdResponse,
    DeleteApiV1WorkspacesByWorkspaceIdError,
    Options<DeleteApiV1WorkspacesByWorkspaceIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_workspace_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1WorkspacesByWorkspaceIdQueryKey = (
  options: Options<GetApiV1WorkspacesByWorkspaceIdData>,
) => createQueryKey("get_api_v1_workspaces_by_workspace_id", options);

/**
 * Get Workspace V1
 */
export const getApiV1WorkspacesByWorkspaceIdOptions = (
  options: Options<GetApiV1WorkspacesByWorkspaceIdData>,
) =>
  queryOptions<
    GetApiV1WorkspacesByWorkspaceIdResponse,
    GetApiV1WorkspacesByWorkspaceIdError,
    GetApiV1WorkspacesByWorkspaceIdResponse,
    ReturnType<typeof getApiV1WorkspacesByWorkspaceIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_workspace_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1WorkspacesByWorkspaceIdQueryKey(options),
  });

/**
 * Restore Workspace V1
 */
export const postApiV1WorkspacesByWorkspaceIdRestoreMutation = (
  options?: Partial<Options<PostApiV1WorkspacesByWorkspaceIdRestoreData>>,
): UseMutationOptions<
  PostApiV1WorkspacesByWorkspaceIdRestoreResponse,
  PostApiV1WorkspacesByWorkspaceIdRestoreError,
  Options<PostApiV1WorkspacesByWorkspaceIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1WorkspacesByWorkspaceIdRestoreResponse,
    PostApiV1WorkspacesByWorkspaceIdRestoreError,
    Options<PostApiV1WorkspacesByWorkspaceIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_workspace_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Zendesk Reply To Ticket V1
 */
export const postApiZendeskV1ActionsReplyToTicketMutation = (
  options?: Partial<Options<PostApiZendeskV1ActionsReplyToTicketData>>,
): UseMutationOptions<
  PostApiZendeskV1ActionsReplyToTicketResponse,
  PostApiZendeskV1ActionsReplyToTicketError,
  Options<PostApiZendeskV1ActionsReplyToTicketData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiZendeskV1ActionsReplyToTicketResponse,
    PostApiZendeskV1ActionsReplyToTicketError,
    Options<PostApiZendeskV1ActionsReplyToTicketData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await zendesk_reply_to_ticket_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Zendesk Update Ticket Tags V1
 */
export const postApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsMutation =
  (
    options?: Partial<
      Options<PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsData>
    >,
  ): UseMutationOptions<
    PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponse,
    PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsError,
    Options<PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponse,
      PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsError,
      Options<PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await zendesk_update_ticket_tags_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdQueryKey =
  (
    options: Options<GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdData>,
  ) =>
    createQueryKey(
      "get_api_zendesk_v1_tenants_by_tenant_id_actions_ticket_attachment_content_by_attachment_id",
      options,
    );

/**
 * Zendesk Get Ticket Attachment Content V1
 */
export const getApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdOptions =
  (
    options: Options<GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdData>,
  ) =>
    queryOptions<
      GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponse,
      GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdError,
      GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponse,
      ReturnType<
        typeof getApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await zendesk_get_ticket_attachment_content_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdQueryKey(
          options,
        ),
    });

export const getApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdQueryKey =
  (
    options: Options<GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdData>,
  ) =>
    createQueryKey(
      "get_api_zendesk_v1_tenants_by_tenant_id_actions_download_ticket_attachment_by_attachment_id",
      options,
    );

/**
 * Zendesk Download Ticket Attachment V1
 */
export const getApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdOptions =
  (
    options: Options<GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdData>,
  ) =>
    queryOptions<
      unknown,
      GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdError,
      unknown,
      ReturnType<
        typeof getApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await zendesk_download_ticket_attachment_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdQueryKey(
          options,
        ),
    });

export const getApiZendeskV1TenantsByTenantIdActionsSectionsQueryKey = (
  options: Options<GetApiZendeskV1TenantsByTenantIdActionsSectionsData>,
) =>
  createQueryKey(
    "get_api_zendesk_v1_tenants_by_tenant_id_actions_sections",
    options,
  );

/**
 * Zendesk Get Sections V1
 */
export const getApiZendeskV1TenantsByTenantIdActionsSectionsOptions = (
  options: Options<GetApiZendeskV1TenantsByTenantIdActionsSectionsData>,
) =>
  queryOptions<
    GetApiZendeskV1TenantsByTenantIdActionsSectionsResponse,
    GetApiZendeskV1TenantsByTenantIdActionsSectionsError,
    GetApiZendeskV1TenantsByTenantIdActionsSectionsResponse,
    ReturnType<typeof getApiZendeskV1TenantsByTenantIdActionsSectionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_get_sections_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiZendeskV1TenantsByTenantIdActionsSectionsQueryKey(options),
  });

export const getApiZendeskV1TenantsByTenantIdActionsCategoriesQueryKey = (
  options: Options<GetApiZendeskV1TenantsByTenantIdActionsCategoriesData>,
) =>
  createQueryKey(
    "get_api_zendesk_v1_tenants_by_tenant_id_actions_categories",
    options,
  );

/**
 * Zendesk Get Categories V1
 */
export const getApiZendeskV1TenantsByTenantIdActionsCategoriesOptions = (
  options: Options<GetApiZendeskV1TenantsByTenantIdActionsCategoriesData>,
) =>
  queryOptions<
    GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponse,
    GetApiZendeskV1TenantsByTenantIdActionsCategoriesError,
    GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponse,
    ReturnType<typeof getApiZendeskV1TenantsByTenantIdActionsCategoriesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_get_categories_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiZendeskV1TenantsByTenantIdActionsCategoriesQueryKey(options),
  });

export const getApiV1ZendeskTenantsByTenantIdTicketsQueryKey = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdTicketsData>,
) => createQueryKey("get_api_v1_zendesk_tenants_by_tenant_id_tickets", options);

/**
 * Zendesk List Tickets V1
 */
export const getApiV1ZendeskTenantsByTenantIdTicketsOptions = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdTicketsData>,
) =>
  queryOptions<
    GetApiV1ZendeskTenantsByTenantIdTicketsResponse,
    GetApiV1ZendeskTenantsByTenantIdTicketsError,
    GetApiV1ZendeskTenantsByTenantIdTicketsResponse,
    ReturnType<typeof getApiV1ZendeskTenantsByTenantIdTicketsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_list_tickets_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ZendeskTenantsByTenantIdTicketsQueryKey(options),
  });

export const getApiZendeskV1TenantsByTenantIdActionsSearchTicketsQueryKey = (
  options: Options<GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsData>,
) =>
  createQueryKey(
    "get_api_zendesk_v1_tenants_by_tenant_id_actions_search_tickets",
    options,
  );

/**
 * Zendesk Search Tickets V1
 */
export const getApiZendeskV1TenantsByTenantIdActionsSearchTicketsOptions = (
  options: Options<GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsData>,
) =>
  queryOptions<
    GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponse,
    GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsError,
    GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponse,
    ReturnType<
      typeof getApiZendeskV1TenantsByTenantIdActionsSearchTicketsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_search_tickets_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiZendeskV1TenantsByTenantIdActionsSearchTicketsQueryKey(options),
  });

export const getApiV1ZendeskTenantsByTenantIdTicketsByTicketIdQueryKey = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdData>,
) =>
  createQueryKey(
    "get_api_v1_zendesk_tenants_by_tenant_id_tickets_by_ticket_id",
    options,
  );

/**
 * Zendesk Get Ticket V1
 */
export const getApiV1ZendeskTenantsByTenantIdTicketsByTicketIdOptions = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdData>,
) =>
  queryOptions<
    GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponse,
    GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdError,
    GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponse,
    ReturnType<typeof getApiV1ZendeskTenantsByTenantIdTicketsByTicketIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_get_ticket_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1ZendeskTenantsByTenantIdTicketsByTicketIdQueryKey(options),
  });

export const getApiV1ZendeskTenantsByTenantIdUsersQueryKey = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdUsersData>,
) => createQueryKey("get_api_v1_zendesk_tenants_by_tenant_id_users", options);

/**
 * Zendesk Get Users V1
 */
export const getApiV1ZendeskTenantsByTenantIdUsersOptions = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdUsersData>,
) =>
  queryOptions<
    GetApiV1ZendeskTenantsByTenantIdUsersResponse,
    GetApiV1ZendeskTenantsByTenantIdUsersError,
    GetApiV1ZendeskTenantsByTenantIdUsersResponse,
    ReturnType<typeof getApiV1ZendeskTenantsByTenantIdUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_get_users_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ZendeskTenantsByTenantIdUsersQueryKey(options),
  });

export const getApiV1ZendeskTenantsByTenantIdUsersByUserIdQueryKey = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdUsersByUserIdData>,
) =>
  createQueryKey(
    "get_api_v1_zendesk_tenants_by_tenant_id_users_by_user_id",
    options,
  );

/**
 * Zendesk Get User V1
 */
export const getApiV1ZendeskTenantsByTenantIdUsersByUserIdOptions = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdUsersByUserIdData>,
) =>
  queryOptions<
    GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponse,
    GetApiV1ZendeskTenantsByTenantIdUsersByUserIdError,
    GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponse,
    ReturnType<typeof getApiV1ZendeskTenantsByTenantIdUsersByUserIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_get_user_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ZendeskTenantsByTenantIdUsersByUserIdQueryKey(options),
  });

export const getApiV1ZendeskTenantsByTenantIdArticlesQueryKey = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdArticlesData>,
) =>
  createQueryKey("get_api_v1_zendesk_tenants_by_tenant_id_articles", options);

/**
 * Zendesk List Articles V1
 */
export const getApiV1ZendeskTenantsByTenantIdArticlesOptions = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdArticlesData>,
) =>
  queryOptions<
    GetApiV1ZendeskTenantsByTenantIdArticlesResponse,
    GetApiV1ZendeskTenantsByTenantIdArticlesError,
    GetApiV1ZendeskTenantsByTenantIdArticlesResponse,
    ReturnType<typeof getApiV1ZendeskTenantsByTenantIdArticlesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_list_articles_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ZendeskTenantsByTenantIdArticlesQueryKey(options),
  });

export const getApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsQueryKey =
  (
    options: Options<GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsData>,
  ) =>
    createQueryKey(
      "get_api_v1_zendesk_tenants_by_tenant_id_articles_by_article_id_attachments",
      options,
    );

/**
 * Zendesk List Article Attachments V1
 */
export const getApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsOptions =
  (
    options: Options<GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsData>,
  ) =>
    queryOptions<
      GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponse,
      GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsError,
      GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponse,
      ReturnType<
        typeof getApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await zendesk_list_article_attachments_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsQueryKey(
          options,
        ),
    });

export const getApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentQueryKey =
  (
    options: Options<GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentData>,
  ) =>
    createQueryKey(
      "get_api_v1_zendesk_tenants_by_tenant_id_article_attachments_by_attachment_id_content",
      options,
    );

/**
 * Zendesk Download Article Attachment V1
 */
export const getApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentOptions =
  (
    options: Options<GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentData>,
  ) =>
    queryOptions<
      unknown,
      GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentError,
      unknown,
      ReturnType<
        typeof getApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await zendesk_download_article_attachment_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentQueryKey(
          options,
        ),
    });

export const getApiV1ZendeskTenantsQueryKey = (
  options?: Options<GetApiV1ZendeskTenantsData>,
) => createQueryKey("get_api_v1_zendesk_tenants", options);

/**
 * Zendesk Get Tenants V1
 */
export const getApiV1ZendeskTenantsOptions = (
  options?: Options<GetApiV1ZendeskTenantsData>,
) =>
  queryOptions<
    GetApiV1ZendeskTenantsResponse,
    GetApiV1ZendeskTenantsError,
    GetApiV1ZendeskTenantsResponse,
    ReturnType<typeof getApiV1ZendeskTenantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_get_tenants_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ZendeskTenantsQueryKey(options),
  });

export const getApiV1ZendeskTenantsInfiniteQueryKey = (
  options?: Options<GetApiV1ZendeskTenantsData>,
): QueryKey<Options<GetApiV1ZendeskTenantsData>> =>
  createQueryKey("get_api_v1_zendesk_tenants", options, true);

/**
 * Zendesk Get Tenants V1
 */
export const getApiV1ZendeskTenantsInfiniteOptions = (
  options?: Options<GetApiV1ZendeskTenantsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1ZendeskTenantsResponse,
    GetApiV1ZendeskTenantsError,
    InfiniteData<GetApiV1ZendeskTenantsResponse>,
    QueryKey<Options<GetApiV1ZendeskTenantsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1ZendeskTenantsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1ZendeskTenantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await zendesk_get_tenants_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1ZendeskTenantsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Zendesk Create Tenant V1
 */
export const postApiV1ZendeskTenantsMutation = (
  options?: Partial<Options<PostApiV1ZendeskTenantsData>>,
): UseMutationOptions<
  PostApiV1ZendeskTenantsResponse,
  PostApiV1ZendeskTenantsError,
  Options<PostApiV1ZendeskTenantsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ZendeskTenantsResponse,
    PostApiV1ZendeskTenantsError,
    Options<PostApiV1ZendeskTenantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await zendesk_create_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ZendeskOauthRedirectUriQueryKey = (
  options?: Options<GetApiV1ZendeskOauthRedirectUriData>,
) => createQueryKey("get_api_v1_zendesk_oauth_redirect_uri", options);

/**
 * Zendesk Get Oauth Redirect Uri V1
 */
export const getApiV1ZendeskOauthRedirectUriOptions = (
  options?: Options<GetApiV1ZendeskOauthRedirectUriData>,
) =>
  queryOptions<
    GetApiV1ZendeskOauthRedirectUriResponse,
    DefaultError,
    GetApiV1ZendeskOauthRedirectUriResponse,
    ReturnType<typeof getApiV1ZendeskOauthRedirectUriQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_get_oauth_redirect_uri_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ZendeskOauthRedirectUriQueryKey(options),
  });

/**
 * Zendesk Delete Tenant V1
 */
export const deleteApiV1ZendeskTenantsByTenantIdMutation = (
  options?: Partial<Options<DeleteApiV1ZendeskTenantsByTenantIdData>>,
): UseMutationOptions<
  DeleteApiV1ZendeskTenantsByTenantIdResponse,
  DeleteApiV1ZendeskTenantsByTenantIdError,
  Options<DeleteApiV1ZendeskTenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1ZendeskTenantsByTenantIdResponse,
    DeleteApiV1ZendeskTenantsByTenantIdError,
    Options<DeleteApiV1ZendeskTenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await zendesk_delete_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ZendeskTenantsByTenantIdQueryKey = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdData>,
) => createQueryKey("get_api_v1_zendesk_tenants_by_tenant_id", options);

/**
 * Zendesk Get Tenant V1
 */
export const getApiV1ZendeskTenantsByTenantIdOptions = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdData>,
) =>
  queryOptions<
    GetApiV1ZendeskTenantsByTenantIdResponse,
    GetApiV1ZendeskTenantsByTenantIdError,
    GetApiV1ZendeskTenantsByTenantIdResponse,
    ReturnType<typeof getApiV1ZendeskTenantsByTenantIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_get_tenant_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ZendeskTenantsByTenantIdQueryKey(options),
  });

/**
 * Zendesk Patch Tenant V1
 */
export const patchApiV1ZendeskTenantsByTenantIdMutation = (
  options?: Partial<Options<PatchApiV1ZendeskTenantsByTenantIdData>>,
): UseMutationOptions<
  PatchApiV1ZendeskTenantsByTenantIdResponse,
  PatchApiV1ZendeskTenantsByTenantIdError,
  Options<PatchApiV1ZendeskTenantsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1ZendeskTenantsByTenantIdResponse,
    PatchApiV1ZendeskTenantsByTenantIdError,
    Options<PatchApiV1ZendeskTenantsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await zendesk_patch_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Zendesk Connect Tenant V1
 */
export const postApiV1ZendeskTenantsByTenantIdConnectMutation = (
  options?: Partial<Options<PostApiV1ZendeskTenantsByTenantIdConnectData>>,
): UseMutationOptions<
  PostApiV1ZendeskTenantsByTenantIdConnectResponse,
  PostApiV1ZendeskTenantsByTenantIdConnectError,
  Options<PostApiV1ZendeskTenantsByTenantIdConnectData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ZendeskTenantsByTenantIdConnectResponse,
    PostApiV1ZendeskTenantsByTenantIdConnectError,
    Options<PostApiV1ZendeskTenantsByTenantIdConnectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await zendesk_connect_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Zendesk Callback Tenant V1
 */
export const postApiV1ZendeskTenantsByTenantIdCallbackMutation = (
  options?: Partial<Options<PostApiV1ZendeskTenantsByTenantIdCallbackData>>,
): UseMutationOptions<
  PostApiV1ZendeskTenantsByTenantIdCallbackResponse,
  PostApiV1ZendeskTenantsByTenantIdCallbackError,
  Options<PostApiV1ZendeskTenantsByTenantIdCallbackData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ZendeskTenantsByTenantIdCallbackResponse,
    PostApiV1ZendeskTenantsByTenantIdCallbackError,
    Options<PostApiV1ZendeskTenantsByTenantIdCallbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await zendesk_callback_tenant_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1ZendeskTenantsByTenantIdCheckConnectionQueryKey = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdCheckConnectionData>,
) =>
  createQueryKey(
    "get_api_v1_zendesk_tenants_by_tenant_id_check_connection",
    options,
  );

/**
 * Zendesk Check Connection V1
 */
export const getApiV1ZendeskTenantsByTenantIdCheckConnectionOptions = (
  options: Options<GetApiV1ZendeskTenantsByTenantIdCheckConnectionData>,
) =>
  queryOptions<
    GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponse,
    GetApiV1ZendeskTenantsByTenantIdCheckConnectionError,
    GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponse,
    ReturnType<typeof getApiV1ZendeskTenantsByTenantIdCheckConnectionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await zendesk_check_connection_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1ZendeskTenantsByTenantIdCheckConnectionQueryKey(options),
  });

/**
 * Zendesk Deprovision Webhook V1
 */
export const deleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionMutation = (
  options?: Partial<
    Options<DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionData>
  >,
): UseMutationOptions<
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponse,
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionError,
  Options<DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponse,
    DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionError,
    Options<DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await zendesk_deprovision_webhook_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Zendesk Provision Webhook V1
 */
export const postApiV1ZendeskTenantsByTenantIdWebhooksProvisionMutation = (
  options?: Partial<
    Options<PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionData>
  >,
): UseMutationOptions<
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponse,
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionError,
  Options<PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponse,
    PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionError,
    Options<PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await zendesk_provision_webhook_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1CalibrationFeedbackInferenceDatapointsQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackInferenceDatapointsData>,
) =>
  createQueryKey(
    "get_api_v1_calibration_feedback_inference_datapoints",
    options,
  );

/**
 * Get Calibration Feedback Inference Datapoints V1
 */
export const getApiV1CalibrationFeedbackInferenceDatapointsOptions = (
  options?: Options<GetApiV1CalibrationFeedbackInferenceDatapointsData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackInferenceDatapointsResponse,
    GetApiV1CalibrationFeedbackInferenceDatapointsError,
    GetApiV1CalibrationFeedbackInferenceDatapointsResponse,
    ReturnType<typeof getApiV1CalibrationFeedbackInferenceDatapointsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_calibration_feedback_inference_datapoints_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1CalibrationFeedbackInferenceDatapointsQueryKey(options),
  });

export const getApiV1CalibrationFeedbackInferenceDatapointsInfiniteQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackInferenceDatapointsData>,
): QueryKey<Options<GetApiV1CalibrationFeedbackInferenceDatapointsData>> =>
  createQueryKey(
    "get_api_v1_calibration_feedback_inference_datapoints",
    options,
    true,
  );

/**
 * Get Calibration Feedback Inference Datapoints V1
 */
export const getApiV1CalibrationFeedbackInferenceDatapointsInfiniteOptions = (
  options?: Options<GetApiV1CalibrationFeedbackInferenceDatapointsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1CalibrationFeedbackInferenceDatapointsResponse,
    GetApiV1CalibrationFeedbackInferenceDatapointsError,
    InfiniteData<GetApiV1CalibrationFeedbackInferenceDatapointsResponse>,
    QueryKey<Options<GetApiV1CalibrationFeedbackInferenceDatapointsData>>,
    | number
    | Pick<
        QueryKey<
          Options<GetApiV1CalibrationFeedbackInferenceDatapointsData>
        >[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<GetApiV1CalibrationFeedbackInferenceDatapointsData>
          >[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_calibration_feedback_inference_datapoints_v1(
          {
            ...options,
            ...params,
            signal,
            throwOnError: true,
          },
        );
        return data;
      },
      queryKey:
        getApiV1CalibrationFeedbackInferenceDatapointsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Calibration Feedback Inference Datapoints V1
 */
export const postApiV1CalibrationFeedbackInferenceDatapointsMutation = (
  options?: Partial<
    Options<PostApiV1CalibrationFeedbackInferenceDatapointsData>
  >,
): UseMutationOptions<
  PostApiV1CalibrationFeedbackInferenceDatapointsResponse,
  PostApiV1CalibrationFeedbackInferenceDatapointsError,
  Options<PostApiV1CalibrationFeedbackInferenceDatapointsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1CalibrationFeedbackInferenceDatapointsResponse,
    PostApiV1CalibrationFeedbackInferenceDatapointsError,
    Options<PostApiV1CalibrationFeedbackInferenceDatapointsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await create_calibration_feedback_inference_datapoints_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1CalibrationFeedbackInferenceDatapointsTagsQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackInferenceDatapointsTagsData>,
) =>
  createQueryKey(
    "get_api_v1_calibration_feedback_inference_datapoints_tags",
    options,
  );

/**
 * Get Calibration Feedback Inference Datapoint Tags V1
 */
export const getApiV1CalibrationFeedbackInferenceDatapointsTagsOptions = (
  options?: Options<GetApiV1CalibrationFeedbackInferenceDatapointsTagsData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponse,
    GetApiV1CalibrationFeedbackInferenceDatapointsTagsError,
    GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponse,
    ReturnType<
      typeof getApiV1CalibrationFeedbackInferenceDatapointsTagsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await get_calibration_feedback_inference_datapoint_tags_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      getApiV1CalibrationFeedbackInferenceDatapointsTagsQueryKey(options),
  });

export const getApiV1CalibrationFeedbackInferenceDatapointsTagsInfiniteQueryKey =
  (
    options?: Options<GetApiV1CalibrationFeedbackInferenceDatapointsTagsData>,
  ): QueryKey<
    Options<GetApiV1CalibrationFeedbackInferenceDatapointsTagsData>
  > =>
    createQueryKey(
      "get_api_v1_calibration_feedback_inference_datapoints_tags",
      options,
      true,
    );

/**
 * Get Calibration Feedback Inference Datapoint Tags V1
 */
export const getApiV1CalibrationFeedbackInferenceDatapointsTagsInfiniteOptions =
  (
    options?: Options<GetApiV1CalibrationFeedbackInferenceDatapointsTagsData>,
  ) => {
    const opts = infiniteQueryOptions<
      GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponse,
      GetApiV1CalibrationFeedbackInferenceDatapointsTagsError,
      InfiniteData<GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponse>,
      QueryKey<Options<GetApiV1CalibrationFeedbackInferenceDatapointsTagsData>>,
      | number
      | Pick<
          QueryKey<
            Options<GetApiV1CalibrationFeedbackInferenceDatapointsTagsData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<GetApiV1CalibrationFeedbackInferenceDatapointsTagsData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    offset: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } =
            await get_calibration_feedback_inference_datapoint_tags_v1({
              ...options,
              ...params,
              signal,
              throwOnError: true,
            });
          return data;
        },
        queryKey:
          getApiV1CalibrationFeedbackInferenceDatapointsTagsInfiniteQueryKey(
            options,
          ),
      },
    );
    return opts as Omit<typeof opts, "initialData">;
  };

/**
 * Delete Calibration Feedback Inference Datapoint V1
 */
export const deleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdMutation =
  (
    options?: Partial<
      Options<DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData>
    >,
  ): UseMutationOptions<
    DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponse,
    DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdError,
    Options<DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponse,
      DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdError,
      Options<DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await delete_calibration_feedback_inference_datapoint_v1({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdQueryKey =
  (
    options: Options<GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData>,
  ) =>
    createQueryKey(
      "get_api_v1_calibration_feedback_inference_datapoints_by_inference_datapoint_id",
      options,
    );

/**
 * Get Calibration Feedback Inference Datapoint V1
 */
export const getApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdOptions =
  (
    options: Options<GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData>,
  ) =>
    queryOptions<
      GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponse,
      GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdError,
      GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponse,
      ReturnType<
        typeof getApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await get_calibration_feedback_inference_datapoint_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdQueryKey(
          options,
        ),
    });

/**
 * Restore Calibration Feedback Inference Datapoint V1
 */
export const postApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreMutation =
  (
    options?: Partial<
      Options<PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreData>
    >,
  ): UseMutationOptions<
    PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponse,
    PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreError,
    Options<PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponse,
      PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreError,
      Options<PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await restore_calibration_feedback_inference_datapoint_v1({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1CalibrationFeedbackDimensionsQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackDimensionsData>,
) => createQueryKey("get_api_v1_calibration_feedback_dimensions", options);

/**
 * Get Calibration Feedback Dimensions V1
 */
export const getApiV1CalibrationFeedbackDimensionsOptions = (
  options?: Options<GetApiV1CalibrationFeedbackDimensionsData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackDimensionsResponse,
    GetApiV1CalibrationFeedbackDimensionsError,
    GetApiV1CalibrationFeedbackDimensionsResponse,
    ReturnType<typeof getApiV1CalibrationFeedbackDimensionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_calibration_feedback_dimensions_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1CalibrationFeedbackDimensionsQueryKey(options),
  });

export const getApiV1CalibrationFeedbackDimensionsInfiniteQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackDimensionsData>,
): QueryKey<Options<GetApiV1CalibrationFeedbackDimensionsData>> =>
  createQueryKey("get_api_v1_calibration_feedback_dimensions", options, true);

/**
 * Get Calibration Feedback Dimensions V1
 */
export const getApiV1CalibrationFeedbackDimensionsInfiniteOptions = (
  options?: Options<GetApiV1CalibrationFeedbackDimensionsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1CalibrationFeedbackDimensionsResponse,
    GetApiV1CalibrationFeedbackDimensionsError,
    InfiniteData<GetApiV1CalibrationFeedbackDimensionsResponse>,
    QueryKey<Options<GetApiV1CalibrationFeedbackDimensionsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1CalibrationFeedbackDimensionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1CalibrationFeedbackDimensionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_calibration_feedback_dimensions_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1CalibrationFeedbackDimensionsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Calibration Feedback Dimension V1
 */
export const postApiV1CalibrationFeedbackDimensionsMutation = (
  options?: Partial<Options<PostApiV1CalibrationFeedbackDimensionsData>>,
): UseMutationOptions<
  PostApiV1CalibrationFeedbackDimensionsResponse,
  PostApiV1CalibrationFeedbackDimensionsError,
  Options<PostApiV1CalibrationFeedbackDimensionsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1CalibrationFeedbackDimensionsResponse,
    PostApiV1CalibrationFeedbackDimensionsError,
    Options<PostApiV1CalibrationFeedbackDimensionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_calibration_feedback_dimension_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1CalibrationFeedbackFullDimensionsQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackFullDimensionsData>,
) => createQueryKey("get_api_v1_calibration_feedback_full_dimensions", options);

/**
 * Get Full Calibration Feedback Dimensions V1
 */
export const getApiV1CalibrationFeedbackFullDimensionsOptions = (
  options?: Options<GetApiV1CalibrationFeedbackFullDimensionsData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackFullDimensionsResponse,
    GetApiV1CalibrationFeedbackFullDimensionsError,
    GetApiV1CalibrationFeedbackFullDimensionsResponse,
    ReturnType<typeof getApiV1CalibrationFeedbackFullDimensionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_calibration_feedback_dimensions_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1CalibrationFeedbackFullDimensionsQueryKey(options),
  });

export const getApiV1CalibrationFeedbackFullDimensionsInfiniteQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackFullDimensionsData>,
): QueryKey<Options<GetApiV1CalibrationFeedbackFullDimensionsData>> =>
  createQueryKey(
    "get_api_v1_calibration_feedback_full_dimensions",
    options,
    true,
  );

/**
 * Get Full Calibration Feedback Dimensions V1
 */
export const getApiV1CalibrationFeedbackFullDimensionsInfiniteOptions = (
  options?: Options<GetApiV1CalibrationFeedbackFullDimensionsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1CalibrationFeedbackFullDimensionsResponse,
    GetApiV1CalibrationFeedbackFullDimensionsError,
    InfiniteData<GetApiV1CalibrationFeedbackFullDimensionsResponse>,
    QueryKey<Options<GetApiV1CalibrationFeedbackFullDimensionsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1CalibrationFeedbackFullDimensionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1CalibrationFeedbackFullDimensionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_calibration_feedback_dimensions_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1CalibrationFeedbackFullDimensionsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Calibration Feedback Dimension V1
 */
export const deleteApiV1CalibrationFeedbackDimensionsByDimensionIdMutation = (
  options?: Partial<
    Options<DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdData>
  >,
): UseMutationOptions<
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponse,
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdError,
  Options<DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponse,
    DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdError,
    Options<DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_calibration_feedback_dimension_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1CalibrationFeedbackDimensionsByDimensionIdQueryKey = (
  options: Options<GetApiV1CalibrationFeedbackDimensionsByDimensionIdData>,
) =>
  createQueryKey(
    "get_api_v1_calibration_feedback_dimensions_by_dimension_id",
    options,
  );

/**
 * Get Calibration Feedback Dimension V1
 */
export const getApiV1CalibrationFeedbackDimensionsByDimensionIdOptions = (
  options: Options<GetApiV1CalibrationFeedbackDimensionsByDimensionIdData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponse,
    GetApiV1CalibrationFeedbackDimensionsByDimensionIdError,
    GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponse,
    ReturnType<
      typeof getApiV1CalibrationFeedbackDimensionsByDimensionIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_calibration_feedback_dimension_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1CalibrationFeedbackDimensionsByDimensionIdQueryKey(options),
  });

/**
 * Restore Calibration Feedback Dimension V1
 */
export const postApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreMutation =
  (
    options?: Partial<
      Options<PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreData>
    >,
  ): UseMutationOptions<
    PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponse,
    PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreError,
    Options<PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponse,
      PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreError,
      Options<PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await restore_calibration_feedback_dimension_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1CalibrationFeedbackQueueItemsQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackQueueItemsData>,
) => createQueryKey("get_api_v1_calibration_feedback_queue_items", options);

/**
 * Get Calibration Feedback Queue Items V1
 */
export const getApiV1CalibrationFeedbackQueueItemsOptions = (
  options?: Options<GetApiV1CalibrationFeedbackQueueItemsData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackQueueItemsResponse,
    GetApiV1CalibrationFeedbackQueueItemsError,
    GetApiV1CalibrationFeedbackQueueItemsResponse,
    ReturnType<typeof getApiV1CalibrationFeedbackQueueItemsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_calibration_feedback_queue_items_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1CalibrationFeedbackQueueItemsQueryKey(options),
  });

export const getApiV1CalibrationFeedbackQueueItemsInfiniteQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackQueueItemsData>,
): QueryKey<Options<GetApiV1CalibrationFeedbackQueueItemsData>> =>
  createQueryKey("get_api_v1_calibration_feedback_queue_items", options, true);

/**
 * Get Calibration Feedback Queue Items V1
 */
export const getApiV1CalibrationFeedbackQueueItemsInfiniteOptions = (
  options?: Options<GetApiV1CalibrationFeedbackQueueItemsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1CalibrationFeedbackQueueItemsResponse,
    GetApiV1CalibrationFeedbackQueueItemsError,
    InfiniteData<GetApiV1CalibrationFeedbackQueueItemsResponse>,
    QueryKey<Options<GetApiV1CalibrationFeedbackQueueItemsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1CalibrationFeedbackQueueItemsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1CalibrationFeedbackQueueItemsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_calibration_feedback_queue_items_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1CalibrationFeedbackQueueItemsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Calibration Feedback Queue Items V1
 */
export const postApiV1CalibrationFeedbackQueueItemsMutation = (
  options?: Partial<Options<PostApiV1CalibrationFeedbackQueueItemsData>>,
): UseMutationOptions<
  PostApiV1CalibrationFeedbackQueueItemsResponse,
  PostApiV1CalibrationFeedbackQueueItemsError,
  Options<PostApiV1CalibrationFeedbackQueueItemsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1CalibrationFeedbackQueueItemsResponse,
    PostApiV1CalibrationFeedbackQueueItemsError,
    Options<PostApiV1CalibrationFeedbackQueueItemsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_calibration_feedback_queue_items_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1CalibrationFeedbackFullQueueItemsQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackFullQueueItemsData>,
) =>
  createQueryKey("get_api_v1_calibration_feedback_full_queue_items", options);

/**
 * Get Full Calibration Feedback Queue Items V1
 */
export const getApiV1CalibrationFeedbackFullQueueItemsOptions = (
  options?: Options<GetApiV1CalibrationFeedbackFullQueueItemsData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackFullQueueItemsResponse,
    GetApiV1CalibrationFeedbackFullQueueItemsError,
    GetApiV1CalibrationFeedbackFullQueueItemsResponse,
    ReturnType<typeof getApiV1CalibrationFeedbackFullQueueItemsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_calibration_feedback_queue_items_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1CalibrationFeedbackFullQueueItemsQueryKey(options),
  });

export const getApiV1CalibrationFeedbackFullQueueItemsInfiniteQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackFullQueueItemsData>,
): QueryKey<Options<GetApiV1CalibrationFeedbackFullQueueItemsData>> =>
  createQueryKey(
    "get_api_v1_calibration_feedback_full_queue_items",
    options,
    true,
  );

/**
 * Get Full Calibration Feedback Queue Items V1
 */
export const getApiV1CalibrationFeedbackFullQueueItemsInfiniteOptions = (
  options?: Options<GetApiV1CalibrationFeedbackFullQueueItemsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1CalibrationFeedbackFullQueueItemsResponse,
    GetApiV1CalibrationFeedbackFullQueueItemsError,
    InfiniteData<GetApiV1CalibrationFeedbackFullQueueItemsResponse>,
    QueryKey<Options<GetApiV1CalibrationFeedbackFullQueueItemsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1CalibrationFeedbackFullQueueItemsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1CalibrationFeedbackFullQueueItemsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_calibration_feedback_queue_items_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1CalibrationFeedbackFullQueueItemsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

export const getApiV1CalibrationFeedbackQueueItemsTagsQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackQueueItemsTagsData>,
) =>
  createQueryKey("get_api_v1_calibration_feedback_queue_items_tags", options);

/**
 * Get Calibration Feedback Queue Item Tags V1
 */
export const getApiV1CalibrationFeedbackQueueItemsTagsOptions = (
  options?: Options<GetApiV1CalibrationFeedbackQueueItemsTagsData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackQueueItemsTagsResponse,
    GetApiV1CalibrationFeedbackQueueItemsTagsError,
    GetApiV1CalibrationFeedbackQueueItemsTagsResponse,
    ReturnType<typeof getApiV1CalibrationFeedbackQueueItemsTagsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_calibration_feedback_queue_item_tags_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1CalibrationFeedbackQueueItemsTagsQueryKey(options),
  });

export const getApiV1CalibrationFeedbackQueueItemsTagsInfiniteQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackQueueItemsTagsData>,
): QueryKey<Options<GetApiV1CalibrationFeedbackQueueItemsTagsData>> =>
  createQueryKey(
    "get_api_v1_calibration_feedback_queue_items_tags",
    options,
    true,
  );

/**
 * Get Calibration Feedback Queue Item Tags V1
 */
export const getApiV1CalibrationFeedbackQueueItemsTagsInfiniteOptions = (
  options?: Options<GetApiV1CalibrationFeedbackQueueItemsTagsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1CalibrationFeedbackQueueItemsTagsResponse,
    GetApiV1CalibrationFeedbackQueueItemsTagsError,
    InfiniteData<GetApiV1CalibrationFeedbackQueueItemsTagsResponse>,
    QueryKey<Options<GetApiV1CalibrationFeedbackQueueItemsTagsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1CalibrationFeedbackQueueItemsTagsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1CalibrationFeedbackQueueItemsTagsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_calibration_feedback_queue_item_tags_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1CalibrationFeedbackQueueItemsTagsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Calibration Feedback Queue Item V1
 */
export const deleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdMutation = (
  options?: Partial<
    Options<DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdData>
  >,
): UseMutationOptions<
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponse,
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdError,
  Options<DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponse,
    DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdError,
    Options<DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_calibration_feedback_queue_item_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1CalibrationFeedbackQueueItemsByQueueItemIdQueryKey = (
  options: Options<GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdData>,
) =>
  createQueryKey(
    "get_api_v1_calibration_feedback_queue_items_by_queue_item_id",
    options,
  );

/**
 * Get Calibration Feedback Queue Item V1
 */
export const getApiV1CalibrationFeedbackQueueItemsByQueueItemIdOptions = (
  options: Options<GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponse,
    GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdError,
    GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponse,
    ReturnType<
      typeof getApiV1CalibrationFeedbackQueueItemsByQueueItemIdQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_calibration_feedback_queue_item_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiV1CalibrationFeedbackQueueItemsByQueueItemIdQueryKey(options),
  });

/**
 * Restore Calibration Feedback Queue Item V1
 */
export const postApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreMutation =
  (
    options?: Partial<
      Options<PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreData>
    >,
  ): UseMutationOptions<
    PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponse,
    PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreError,
    Options<PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreData>
  > => {
    const mutationOptions: UseMutationOptions<
      PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponse,
      PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreError,
      Options<PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } = await restore_calibration_feedback_queue_item_v1({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
        return data;
      },
    };
    return mutationOptions;
  };

export const getApiV1CalibrationFeedbackVerdictsQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackVerdictsData>,
) => createQueryKey("get_api_v1_calibration_feedback_verdicts", options);

/**
 * Get Calibration Feedback Verdicts V1
 */
export const getApiV1CalibrationFeedbackVerdictsOptions = (
  options?: Options<GetApiV1CalibrationFeedbackVerdictsData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackVerdictsResponse,
    GetApiV1CalibrationFeedbackVerdictsError,
    GetApiV1CalibrationFeedbackVerdictsResponse,
    ReturnType<typeof getApiV1CalibrationFeedbackVerdictsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_calibration_feedback_verdicts_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1CalibrationFeedbackVerdictsQueryKey(options),
  });

export const getApiV1CalibrationFeedbackVerdictsInfiniteQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackVerdictsData>,
): QueryKey<Options<GetApiV1CalibrationFeedbackVerdictsData>> =>
  createQueryKey("get_api_v1_calibration_feedback_verdicts", options, true);

/**
 * Get Calibration Feedback Verdicts V1
 */
export const getApiV1CalibrationFeedbackVerdictsInfiniteOptions = (
  options?: Options<GetApiV1CalibrationFeedbackVerdictsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1CalibrationFeedbackVerdictsResponse,
    GetApiV1CalibrationFeedbackVerdictsError,
    InfiniteData<GetApiV1CalibrationFeedbackVerdictsResponse>,
    QueryKey<Options<GetApiV1CalibrationFeedbackVerdictsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1CalibrationFeedbackVerdictsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1CalibrationFeedbackVerdictsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_calibration_feedback_verdicts_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getApiV1CalibrationFeedbackVerdictsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Create Calibration Feedback Verdict V1
 */
export const postApiV1CalibrationFeedbackVerdictsMutation = (
  options?: Partial<Options<PostApiV1CalibrationFeedbackVerdictsData>>,
): UseMutationOptions<
  PostApiV1CalibrationFeedbackVerdictsResponse,
  PostApiV1CalibrationFeedbackVerdictsError,
  Options<PostApiV1CalibrationFeedbackVerdictsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1CalibrationFeedbackVerdictsResponse,
    PostApiV1CalibrationFeedbackVerdictsError,
    Options<PostApiV1CalibrationFeedbackVerdictsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await create_calibration_feedback_verdict_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1CalibrationFeedbackFullVerdictsQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackFullVerdictsData>,
) => createQueryKey("get_api_v1_calibration_feedback_full_verdicts", options);

/**
 * Get Full Calibration Feedback Verdicts V1
 */
export const getApiV1CalibrationFeedbackFullVerdictsOptions = (
  options?: Options<GetApiV1CalibrationFeedbackFullVerdictsData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackFullVerdictsResponse,
    GetApiV1CalibrationFeedbackFullVerdictsError,
    GetApiV1CalibrationFeedbackFullVerdictsResponse,
    ReturnType<typeof getApiV1CalibrationFeedbackFullVerdictsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_full_calibration_feedback_verdicts_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1CalibrationFeedbackFullVerdictsQueryKey(options),
  });

export const getApiV1CalibrationFeedbackFullVerdictsInfiniteQueryKey = (
  options?: Options<GetApiV1CalibrationFeedbackFullVerdictsData>,
): QueryKey<Options<GetApiV1CalibrationFeedbackFullVerdictsData>> =>
  createQueryKey(
    "get_api_v1_calibration_feedback_full_verdicts",
    options,
    true,
  );

/**
 * Get Full Calibration Feedback Verdicts V1
 */
export const getApiV1CalibrationFeedbackFullVerdictsInfiniteOptions = (
  options?: Options<GetApiV1CalibrationFeedbackFullVerdictsData>,
) => {
  const opts = infiniteQueryOptions<
    GetApiV1CalibrationFeedbackFullVerdictsResponse,
    GetApiV1CalibrationFeedbackFullVerdictsError,
    InfiniteData<GetApiV1CalibrationFeedbackFullVerdictsResponse>,
    QueryKey<Options<GetApiV1CalibrationFeedbackFullVerdictsData>>,
    | number
    | Pick<
        QueryKey<Options<GetApiV1CalibrationFeedbackFullVerdictsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetApiV1CalibrationFeedbackFullVerdictsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await get_full_calibration_feedback_verdicts_v1({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiV1CalibrationFeedbackFullVerdictsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, "initialData">;
};

/**
 * Delete Calibration Feedback Verdict V1
 */
export const deleteApiV1CalibrationFeedbackVerdictsByVerdictIdMutation = (
  options?: Partial<
    Options<DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdData>
  >,
): UseMutationOptions<
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdError,
  Options<DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
    DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdError,
    Options<DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await delete_calibration_feedback_verdict_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1CalibrationFeedbackVerdictsByVerdictIdQueryKey = (
  options: Options<GetApiV1CalibrationFeedbackVerdictsByVerdictIdData>,
) =>
  createQueryKey(
    "get_api_v1_calibration_feedback_verdicts_by_verdict_id",
    options,
  );

/**
 * Get Calibration Feedback Verdict V1
 */
export const getApiV1CalibrationFeedbackVerdictsByVerdictIdOptions = (
  options: Options<GetApiV1CalibrationFeedbackVerdictsByVerdictIdData>,
) =>
  queryOptions<
    GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
    GetApiV1CalibrationFeedbackVerdictsByVerdictIdError,
    GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
    ReturnType<typeof getApiV1CalibrationFeedbackVerdictsByVerdictIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_calibration_feedback_verdict_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1CalibrationFeedbackVerdictsByVerdictIdQueryKey(options),
  });

/**
 * Update Calibration Feedback Verdict V1
 */
export const patchApiV1CalibrationFeedbackVerdictsByVerdictIdMutation = (
  options?: Partial<
    Options<PatchApiV1CalibrationFeedbackVerdictsByVerdictIdData>
  >,
): UseMutationOptions<
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdError,
  Options<PatchApiV1CalibrationFeedbackVerdictsByVerdictIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
    PatchApiV1CalibrationFeedbackVerdictsByVerdictIdError,
    Options<PatchApiV1CalibrationFeedbackVerdictsByVerdictIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_calibration_feedback_verdict_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore Calibration Feedback Verdict V1
 */
export const postApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreMutation = (
  options?: Partial<
    Options<PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreData>
  >,
): UseMutationOptions<
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponse,
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreError,
  Options<PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponse,
    PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreError,
    Options<PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restore_calibration_feedback_verdict_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Revoke Edra Access V1
 */
export const deleteApiV1SesameEdraAccessMutation = (
  options?: Partial<Options<DeleteApiV1SesameEdraAccessData>>,
): UseMutationOptions<
  DeleteApiV1SesameEdraAccessResponse,
  DeleteApiV1SesameEdraAccessError,
  Options<DeleteApiV1SesameEdraAccessData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteApiV1SesameEdraAccessResponse,
    DeleteApiV1SesameEdraAccessError,
    Options<DeleteApiV1SesameEdraAccessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revoke_edra_access_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiV1SesameEdraAccessQueryKey = (
  options?: Options<GetApiV1SesameEdraAccessData>,
) => createQueryKey("get_api_v1_sesame_edra_access", options);

/**
 * Get Edra Access V1
 */
export const getApiV1SesameEdraAccessOptions = (
  options?: Options<GetApiV1SesameEdraAccessData>,
) =>
  queryOptions<
    GetApiV1SesameEdraAccessResponse,
    GetApiV1SesameEdraAccessError,
    GetApiV1SesameEdraAccessResponse,
    ReturnType<typeof getApiV1SesameEdraAccessQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_edra_access_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiV1SesameEdraAccessQueryKey(options),
  });

/**
 * Update Edra Access V1
 */
export const patchApiV1SesameEdraAccessMutation = (
  options?: Partial<Options<PatchApiV1SesameEdraAccessData>>,
): UseMutationOptions<
  PatchApiV1SesameEdraAccessResponse,
  PatchApiV1SesameEdraAccessError,
  Options<PatchApiV1SesameEdraAccessData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchApiV1SesameEdraAccessResponse,
    PatchApiV1SesameEdraAccessError,
    Options<PatchApiV1SesameEdraAccessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await update_edra_access_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Grant Edra Access V1
 */
export const postApiV1SesameEdraAccessMutation = (
  options?: Partial<Options<PostApiV1SesameEdraAccessData>>,
): UseMutationOptions<
  PostApiV1SesameEdraAccessResponse,
  PostApiV1SesameEdraAccessError,
  Options<PostApiV1SesameEdraAccessData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiV1SesameEdraAccessResponse,
    PostApiV1SesameEdraAccessError,
    Options<PostApiV1SesameEdraAccessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await grant_edra_access_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Org Membership V1
 */
export const putApiV1SesameOrgMembershipsMutation = (
  options?: Partial<Options<PutApiV1SesameOrgMembershipsData>>,
): UseMutationOptions<
  PutApiV1SesameOrgMembershipsResponse,
  PutApiV1SesameOrgMembershipsError,
  Options<PutApiV1SesameOrgMembershipsData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiV1SesameOrgMembershipsResponse,
    PutApiV1SesameOrgMembershipsError,
    Options<PutApiV1SesameOrgMembershipsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await set_org_membership_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Org Member Role V1
 */
export const putApiV1SesameOrgMemberRolesMutation = (
  options?: Partial<Options<PutApiV1SesameOrgMemberRolesData>>,
): UseMutationOptions<
  PutApiV1SesameOrgMemberRolesResponse,
  PutApiV1SesameOrgMemberRolesError,
  Options<PutApiV1SesameOrgMemberRolesData>
> => {
  const mutationOptions: UseMutationOptions<
    PutApiV1SesameOrgMemberRolesResponse,
    PutApiV1SesameOrgMemberRolesError,
    Options<PutApiV1SesameOrgMemberRolesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await set_org_member_role_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiPublicV1AgentA2aByAgentKeyAgentQueryKey = (
  options: Options<GetApiPublicV1AgentA2aByAgentKeyAgentData>,
) => createQueryKey("get_api_public_v1_agent_a2a_by_agent_key_agent", options);

/**
 * Get A2A Agent Card V1
 */
export const getApiPublicV1AgentA2aByAgentKeyAgentOptions = (
  options: Options<GetApiPublicV1AgentA2aByAgentKeyAgentData>,
) =>
  queryOptions<
    GetApiPublicV1AgentA2aByAgentKeyAgentResponse,
    GetApiPublicV1AgentA2aByAgentKeyAgentError,
    GetApiPublicV1AgentA2aByAgentKeyAgentResponse,
    ReturnType<typeof getApiPublicV1AgentA2aByAgentKeyAgentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_a2a_agent_card_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPublicV1AgentA2aByAgentKeyAgentQueryKey(options),
  });

/**
 * Freshservice Ingest Webhook V1
 */
export const postApiPublicFreshserviceV1WebhooksByTenantIdMutation = (
  options?: Partial<Options<PostApiPublicFreshserviceV1WebhooksByTenantIdData>>,
): UseMutationOptions<
  PostApiPublicFreshserviceV1WebhooksByTenantIdResponse,
  PostApiPublicFreshserviceV1WebhooksByTenantIdError,
  Options<PostApiPublicFreshserviceV1WebhooksByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicFreshserviceV1WebhooksByTenantIdResponse,
    PostApiPublicFreshserviceV1WebhooksByTenantIdError,
    Options<PostApiPublicFreshserviceV1WebhooksByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await freshservice_ingest_webhook_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Hubspot Ingest Webhook V1
 */
export const postApiPublicHubspotV1EventsByTenantIdMutation = (
  options?: Partial<Options<PostApiPublicHubspotV1EventsByTenantIdData>>,
): UseMutationOptions<
  PostApiPublicHubspotV1EventsByTenantIdResponse,
  PostApiPublicHubspotV1EventsByTenantIdError,
  Options<PostApiPublicHubspotV1EventsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicHubspotV1EventsByTenantIdResponse,
    PostApiPublicHubspotV1EventsByTenantIdError,
    Options<PostApiPublicHubspotV1EventsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await hubspot_ingest_webhook_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sharepoint Notifications V1
 */
export const postApiPublicSharepointV1NotificationsByTenantIdMutation = (
  options?: Partial<
    Options<PostApiPublicSharepointV1NotificationsByTenantIdData>
  >,
): UseMutationOptions<
  unknown,
  PostApiPublicSharepointV1NotificationsByTenantIdError,
  Options<PostApiPublicSharepointV1NotificationsByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    PostApiPublicSharepointV1NotificationsByTenantIdError,
    Options<PostApiPublicSharepointV1NotificationsByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sharepoint_notifications_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sharepoint Lifecycle V1
 */
export const postApiPublicSharepointV1LifecycleByTenantIdMutation = (
  options?: Partial<Options<PostApiPublicSharepointV1LifecycleByTenantIdData>>,
): UseMutationOptions<
  unknown,
  PostApiPublicSharepointV1LifecycleByTenantIdError,
  Options<PostApiPublicSharepointV1LifecycleByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    PostApiPublicSharepointV1LifecycleByTenantIdError,
    Options<PostApiPublicSharepointV1LifecycleByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sharepoint_lifecycle_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Jira Handle Webhook Event V1
 */
export const postApiPublicJiraV1EventsMutation = (
  options?: Partial<Options<PostApiPublicJiraV1EventsData>>,
): UseMutationOptions<
  PostApiPublicJiraV1EventsResponse,
  DefaultError,
  Options<PostApiPublicJiraV1EventsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicJiraV1EventsResponse,
    DefaultError,
    Options<PostApiPublicJiraV1EventsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await jira_handle_webhook_event_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Notion Ingest Webhook V1
 */
export const postApiPublicNotionV1WebhooksIngestByTenantIdMutation = (
  options?: Partial<Options<PostApiPublicNotionV1WebhooksIngestByTenantIdData>>,
): UseMutationOptions<
  PostApiPublicNotionV1WebhooksIngestByTenantIdResponse,
  PostApiPublicNotionV1WebhooksIngestByTenantIdError,
  Options<PostApiPublicNotionV1WebhooksIngestByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicNotionV1WebhooksIngestByTenantIdResponse,
    PostApiPublicNotionV1WebhooksIngestByTenantIdError,
    Options<PostApiPublicNotionV1WebhooksIngestByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await notion_ingest_webhook_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiPublicOauthV1WellKnownOauthAuthorizationServerQueryKey = (
  options?: Options<GetApiPublicOauthV1WellKnownOauthAuthorizationServerData>,
) =>
  createQueryKey(
    "get_api_public_oauth_v1_well_known_oauth_authorization_server",
    options,
  );

/**
 * Oauth Authorization Server Metadata V1
 */
export const getApiPublicOauthV1WellKnownOauthAuthorizationServerOptions = (
  options?: Options<GetApiPublicOauthV1WellKnownOauthAuthorizationServerData>,
) =>
  queryOptions<
    GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponse,
    DefaultError,
    GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponse,
    ReturnType<
      typeof getApiPublicOauthV1WellKnownOauthAuthorizationServerQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await oauth_authorization_server_metadata_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiPublicOauthV1WellKnownOauthAuthorizationServerQueryKey(options),
  });

export const getApiPublicOauthV1WellKnownOpenidConfigurationQueryKey = (
  options?: Options<GetApiPublicOauthV1WellKnownOpenidConfigurationData>,
) =>
  createQueryKey(
    "get_api_public_oauth_v1_well_known_openid_configuration",
    options,
  );

/**
 * Oauth Openid Configuration V1
 */
export const getApiPublicOauthV1WellKnownOpenidConfigurationOptions = (
  options?: Options<GetApiPublicOauthV1WellKnownOpenidConfigurationData>,
) =>
  queryOptions<
    GetApiPublicOauthV1WellKnownOpenidConfigurationResponse,
    DefaultError,
    GetApiPublicOauthV1WellKnownOpenidConfigurationResponse,
    ReturnType<typeof getApiPublicOauthV1WellKnownOpenidConfigurationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await oauth_openid_configuration_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPublicOauthV1WellKnownOpenidConfigurationQueryKey(options),
  });

export const getApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyQueryKey =
  (
    options: Options<GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyData>,
  ) =>
    createQueryKey(
      "get_api_public_oauth_v1_well_known_oauth_protected_resource_mcp_by_toolset_key",
      options,
    );

/**
 * Oauth Protected Resource Metadata V1
 */
export const getApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyOptions =
  (
    options: Options<GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyData>,
  ) =>
    queryOptions<
      GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponse,
      GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyError,
      GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponse,
      ReturnType<
        typeof getApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await oauth_protected_resource_metadata_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyQueryKey(
          options,
        ),
    });

export const getApiPublicOauthV1AuthorizeQueryKey = (
  options: Options<GetApiPublicOauthV1AuthorizeData>,
) => createQueryKey("get_api_public_oauth_v1_authorize", options);

/**
 * Oauth Authorize V1
 */
export const getApiPublicOauthV1AuthorizeOptions = (
  options: Options<GetApiPublicOauthV1AuthorizeData>,
) =>
  queryOptions<
    unknown,
    GetApiPublicOauthV1AuthorizeError,
    unknown,
    ReturnType<typeof getApiPublicOauthV1AuthorizeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await oauth_authorize_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPublicOauthV1AuthorizeQueryKey(options),
  });

/**
 * Proxy Oauth Token V1
 */
export const postApiPublicOauthV1TokenMutation = (
  options?: Partial<Options<PostApiPublicOauthV1TokenData>>,
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<PostApiPublicOauthV1TokenData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<PostApiPublicOauthV1TokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await proxy_oauth_token_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationQueryKey =
  (
    options: Options<GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationData>,
  ) =>
    createQueryKey(
      "get_api_public_oauth_v1_by_oauth_application_id_well_known_openid_configuration",
      options,
    );

/**
 * Proxy Oauth Application Openid Configuration V1
 */
export const getApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationOptions =
  (
    options: Options<GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationData>,
  ) =>
    queryOptions<
      unknown,
      GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationError,
      unknown,
      ReturnType<
        typeof getApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await proxy_oauth_application_openid_configuration_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationQueryKey(
          options,
        ),
    });

export const getApiPublicOauthV1ByOauthApplicationIdAuthorizeQueryKey = (
  options: Options<GetApiPublicOauthV1ByOauthApplicationIdAuthorizeData>,
) =>
  createQueryKey(
    "get_api_public_oauth_v1_by_oauth_application_id_authorize",
    options,
  );

/**
 * Oauth Application Authorize V1
 */
export const getApiPublicOauthV1ByOauthApplicationIdAuthorizeOptions = (
  options: Options<GetApiPublicOauthV1ByOauthApplicationIdAuthorizeData>,
) =>
  queryOptions<
    unknown,
    GetApiPublicOauthV1ByOauthApplicationIdAuthorizeError,
    unknown,
    ReturnType<typeof getApiPublicOauthV1ByOauthApplicationIdAuthorizeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await oauth_application_authorize_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPublicOauthV1ByOauthApplicationIdAuthorizeQueryKey(options),
  });

/**
 * Proxy Oauth Application Token V1
 */
export const postApiPublicOauthV1ByOauthApplicationIdTokenMutation = (
  options?: Partial<Options<PostApiPublicOauthV1ByOauthApplicationIdTokenData>>,
): UseMutationOptions<
  unknown,
  PostApiPublicOauthV1ByOauthApplicationIdTokenError,
  Options<PostApiPublicOauthV1ByOauthApplicationIdTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    PostApiPublicOauthV1ByOauthApplicationIdTokenError,
    Options<PostApiPublicOauthV1ByOauthApplicationIdTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await proxy_oauth_application_token_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiPublicOauthV1ByOauthApplicationIdUserinfoQueryKey = (
  options: Options<GetApiPublicOauthV1ByOauthApplicationIdUserinfoData>,
) =>
  createQueryKey(
    "get_api_public_oauth_v1_by_oauth_application_id_userinfo",
    options,
  );

/**
 * Proxy Oauth Application Userinfo V1
 */
export const getApiPublicOauthV1ByOauthApplicationIdUserinfoOptions = (
  options: Options<GetApiPublicOauthV1ByOauthApplicationIdUserinfoData>,
) =>
  queryOptions<
    unknown,
    GetApiPublicOauthV1ByOauthApplicationIdUserinfoError,
    unknown,
    ReturnType<typeof getApiPublicOauthV1ByOauthApplicationIdUserinfoQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await proxy_oauth_application_userinfo_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApiPublicOauthV1ByOauthApplicationIdUserinfoQueryKey(options),
  });

/**
 * Proxy Oauth Application Introspect V1
 */
export const postApiPublicOauthV1ByOauthApplicationIdIntrospectMutation = (
  options?: Partial<
    Options<PostApiPublicOauthV1ByOauthApplicationIdIntrospectData>
  >,
): UseMutationOptions<
  unknown,
  PostApiPublicOauthV1ByOauthApplicationIdIntrospectError,
  Options<PostApiPublicOauthV1ByOauthApplicationIdIntrospectData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    PostApiPublicOauthV1ByOauthApplicationIdIntrospectError,
    Options<PostApiPublicOauthV1ByOauthApplicationIdIntrospectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await proxy_oauth_application_introspect_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Subscription Event V2
 */
export const postApiPublicOutlookV2SubscriptionsEventsMutation = (
  options?: Partial<Options<PostApiPublicOutlookV2SubscriptionsEventsData>>,
): UseMutationOptions<
  unknown,
  PostApiPublicOutlookV2SubscriptionsEventsError,
  Options<PostApiPublicOutlookV2SubscriptionsEventsData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    PostApiPublicOutlookV2SubscriptionsEventsError,
    Options<PostApiPublicOutlookV2SubscriptionsEventsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_subscription_event_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Outlook Subscription Lifecycle V2
 */
export const postApiPublicOutlookV2SubscriptionsLifecycleMutation = (
  options?: Partial<Options<PostApiPublicOutlookV2SubscriptionsLifecycleData>>,
): UseMutationOptions<
  unknown,
  PostApiPublicOutlookV2SubscriptionsLifecycleError,
  Options<PostApiPublicOutlookV2SubscriptionsLifecycleData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    PostApiPublicOutlookV2SubscriptionsLifecycleError,
    Options<PostApiPublicOutlookV2SubscriptionsLifecycleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await outlook_subscription_lifecycle_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Plain Ingest Webhook V1
 */
export const postApiPublicPlainV1WebhooksIngestByTenantIdMutation = (
  options?: Partial<Options<PostApiPublicPlainV1WebhooksIngestByTenantIdData>>,
): UseMutationOptions<
  PostApiPublicPlainV1WebhooksIngestByTenantIdResponse,
  PostApiPublicPlainV1WebhooksIngestByTenantIdError,
  Options<PostApiPublicPlainV1WebhooksIngestByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicPlainV1WebhooksIngestByTenantIdResponse,
    PostApiPublicPlainV1WebhooksIngestByTenantIdError,
    Options<PostApiPublicPlainV1WebhooksIngestByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await plain_ingest_webhook_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Salesforce Oauth Token V1
 */
export const postApiPublicV1SalesforceOauthTokenByTenantIdMutation = (
  options?: Partial<Options<PostApiPublicV1SalesforceOauthTokenByTenantIdData>>,
): UseMutationOptions<
  PostApiPublicV1SalesforceOauthTokenByTenantIdResponse,
  PostApiPublicV1SalesforceOauthTokenByTenantIdError,
  Options<PostApiPublicV1SalesforceOauthTokenByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicV1SalesforceOauthTokenByTenantIdResponse,
    PostApiPublicV1SalesforceOauthTokenByTenantIdError,
    Options<PostApiPublicV1SalesforceOauthTokenByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await salesforce_oauth_token_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Salesforce Ingest Webhook V1
 */
export const postApiPublicV1SalesforceWebhooksIngestByTenantIdMutation = (
  options?: Partial<
    Options<PostApiPublicV1SalesforceWebhooksIngestByTenantIdData>
  >,
): UseMutationOptions<
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponse,
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdError,
  Options<PostApiPublicV1SalesforceWebhooksIngestByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponse,
    PostApiPublicV1SalesforceWebhooksIngestByTenantIdError,
    Options<PostApiPublicV1SalesforceWebhooksIngestByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await salesforce_ingest_webhook_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Service Now Handle Webhook V1
 */
export const postApiPublicServiceNowV1WebhooksMutation = (
  options?: Partial<Options<PostApiPublicServiceNowV1WebhooksData>>,
): UseMutationOptions<
  PostApiPublicServiceNowV1WebhooksResponse,
  PostApiPublicServiceNowV1WebhooksError,
  Options<PostApiPublicServiceNowV1WebhooksData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicServiceNowV1WebhooksResponse,
    PostApiPublicServiceNowV1WebhooksError,
    Options<PostApiPublicServiceNowV1WebhooksData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await service_now_handle_webhook_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Receive Event V2
 */
export const postApiPublicSlackV2TenantsByTenantIdEventsMutation = (
  options?: Partial<Options<PostApiPublicSlackV2TenantsByTenantIdEventsData>>,
): UseMutationOptions<
  PostApiPublicSlackV2TenantsByTenantIdEventsResponse,
  PostApiPublicSlackV2TenantsByTenantIdEventsError,
  Options<PostApiPublicSlackV2TenantsByTenantIdEventsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicSlackV2TenantsByTenantIdEventsResponse,
    PostApiPublicSlackV2TenantsByTenantIdEventsError,
    Options<PostApiPublicSlackV2TenantsByTenantIdEventsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_receive_event_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Slack Receive Interactivity V2
 */
export const postApiPublicSlackV2TenantsByTenantIdInteractivityMutation = (
  options?: Partial<
    Options<PostApiPublicSlackV2TenantsByTenantIdInteractivityData>
  >,
): UseMutationOptions<
  PostApiPublicSlackV2TenantsByTenantIdInteractivityResponse,
  PostApiPublicSlackV2TenantsByTenantIdInteractivityError,
  Options<PostApiPublicSlackV2TenantsByTenantIdInteractivityData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicSlackV2TenantsByTenantIdInteractivityResponse,
    PostApiPublicSlackV2TenantsByTenantIdInteractivityError,
    Options<PostApiPublicSlackV2TenantsByTenantIdInteractivityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await slack_receive_interactivity_v2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Teams Receive Message V1
 */
export const postApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesMutation = (
  options?: Partial<
    Options<PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesData>
  >,
): UseMutationOptions<
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponse,
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesError,
  Options<PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponse,
    PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesError,
    Options<PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teams_receive_message_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationQueryKey =
  (
    options: Options<GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationData>,
  ) =>
    createQueryKey(
      "get_api_public_teams_v1_tenants_by_tenant_id_well_known_openid_configuration",
      options,
    );

/**
 * Teams Openid Configuration V1
 */
export const getApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationOptions =
  (
    options: Options<GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationData>,
  ) =>
    queryOptions<
      GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponse,
      GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationError,
      GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponse,
      ReturnType<
        typeof getApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await teams_openid_configuration_v1({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationQueryKey(
          options,
        ),
    });

export const getApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonQueryKey = (
  options: Options<GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonData>,
) =>
  createQueryKey(
    "get_api_public_teams_v1_tenants_by_tenant_id_well_known_jwks_json",
    options,
  );

/**
 * Teams Jwks V1
 */
export const getApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonOptions = (
  options: Options<GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonData>,
) =>
  queryOptions<
    GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponse,
    GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonError,
    GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponse,
    ReturnType<
      typeof getApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await teams_jwks_v1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      getApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonQueryKey(options),
  });

/**
 * Zendesk Ingest Webhook V1
 */
export const postApiPublicV1ZendeskWebhooksIngestByTenantIdMutation = (
  options?: Partial<
    Options<PostApiPublicV1ZendeskWebhooksIngestByTenantIdData>
  >,
): UseMutationOptions<
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponse,
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdError,
  Options<PostApiPublicV1ZendeskWebhooksIngestByTenantIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponse,
    PostApiPublicV1ZendeskWebhooksIngestByTenantIdError,
    Options<PostApiPublicV1ZendeskWebhooksIngestByTenantIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await zendesk_ingest_webhook_v1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPublicHealthQueryKey = (
  options?: Options<GetPublicHealthData>,
) => createQueryKey("get_public_health", options);

/**
 * Health
 */
export const getPublicHealthOptions = (
  options?: Options<GetPublicHealthData>,
) =>
  queryOptions<
    GetPublicHealthResponse,
    DefaultError,
    GetPublicHealthResponse,
    ReturnType<typeof getPublicHealthQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await health({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPublicHealthQueryKey(options),
  });

export const getEdraPbOpenapiJsonQueryKey = (
  options?: Options<GetEdraPbOpenapiJsonData>,
) => createQueryKey("get_edra_pb_openapi_json", options);

/**
 * Get Edra Pb Openapi
 */
export const getEdraPbOpenapiJsonOptions = (
  options?: Options<GetEdraPbOpenapiJsonData>,
) =>
  queryOptions<
    GetEdraPbOpenapiJsonResponse,
    DefaultError,
    GetEdraPbOpenapiJsonResponse,
    ReturnType<typeof getEdraPbOpenapiJsonQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_edra_pb_openapi({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEdraPbOpenapiJsonQueryKey(options),
  });

export const getSdkOpenapiJsonQueryKey = (
  options?: Options<GetSdkOpenapiJsonData>,
) => createQueryKey("get_sdk_openapi_json", options);

/**
 * Get Sdk Openapi
 */
export const getSdkOpenapiJsonOptions = (
  options?: Options<GetSdkOpenapiJsonData>,
) =>
  queryOptions<
    GetSdkOpenapiJsonResponse,
    DefaultError,
    GetSdkOpenapiJsonResponse,
    ReturnType<typeof getSdkOpenapiJsonQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get_sdk_openapi({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSdkOpenapiJsonQueryKey(options),
  });
